import "react18-json-view/src/style.css";
import { Box as e } from "@stereograph/teia-system-design/components/Box";
import * as t from "react";
import n, { createContext as r, createElement as i, forwardRef as a, useCallback as o, useContext as s, useEffect as c, useId as l, useMemo as u, useRef as d, useState as f, useSyncExternalStore as p } from "react";
import { Fragment as m, jsx as h, jsxs as g } from "react/jsx-runtime";
import { AddClippingPlaneCommand as _, BooleanController as v, CameraFocusObjectsCommand as y, CameraFocusSelectedObjectsCommand as b, CameraModeType as x, CameraZoomInCommand as S, CameraZoomOutCommand as C, ClearSceneObjectControllerCommand as w, ClippingPlaneType as ee, Command as te, Debug as ne, DownloadViewportScreenshotCommand as re, GroupCommand as ie, IsolateObjectCommand as ae, JsHeapMemoryTracker as oe, KeyboardLayoutController as se, KeyboardShortcut as ce, LocalStorageManager as le, NotUndoableCommandError as ue, NotificationCenter as T, NumberController as de, ObservableSet as fe, RenderMode as E, ResetSceneCommand as pe, SelectAllVisibleObjectsCommand as me, SelectObjectsCommand as he, SetCameraModeCommand as ge, SetGizmoModeCommand as _e, SetObjectTransformCommand as ve, SetObjectsVisibilityCommand as ye, SetObjectsXRayStatusCommand as be, SetRenderModeCommand as xe, ViewerBehavior as Se, ViewerPlugin as Ce, ViewerSignal as we, assertNotNull as Te, filterObject as Ee, getDepthObject as De, isAppleLike as Oe, isCtrlEvent as ke, sortRecordKeys as Ae } from "@stereograph/teiaviewer";
import { Box3 as je, Color as Me, Euler as Ne, MathUtils as Pe, Matrix4 as Fe, Quaternion as Ie, Vector3 as D } from "three";
import { CircularProgress as Le, LinearProgress as Re } from "@stereograph/teia-system-design/components/Progress";
import { Stack as O } from "@stereograph/teia-system-design/components/Stack";
import { IconButton as ze } from "@stereograph/teia-system-design/components/IconButton";
import { Icon as Be } from "@stereograph/teia-system-design/components/Icon";
import { Text as Ve } from "@stereograph/teia-system-design/components/Typography";
import { Button as He } from "@stereograph/teia-system-design/components/Button";
import { Select as k } from "@stereograph/teia-system-design/components/Select";
import Ue, { t as A } from "i18next";
import { generateUUID as We } from "three/src/math/MathUtils.js";
import { Alert as Ge } from "@stereograph/teia-system-design/components/Alert";
import { useTranslation as j } from "react-i18next";
import Ke from "react18-json-view";
import { TextField as qe } from "@stereograph/teia-system-design/components/TextField";
import { Divider as Je } from "@stereograph/teia-system-design/components/Divider";
import { Paper as Ye } from "@stereograph/teia-system-design/components/Paper";
import { AppWindow as Xe, Circle as Ze, Lock as Qe, LockOpen as $e, Minus as et, X as tt } from "lucide-react";
import { Tooltip as nt } from "@stereograph/teia-system-design/components/Tooltip";
import { Checkbox as rt } from "@stereograph/teia-system-design/components/Checkbox";
import { Switch as it } from "@stereograph/teia-system-design/components/Switch";
import at from "@mui/material/Grid";
import { Popover as M } from "@stereograph/teia-system-design/components/Popover";
import { CustomPicker as ot } from "react-color";
import { Alpha as st, Hue as ct, Saturation as lt } from "react-color/lib/components/common";
import { Popper as ut } from "@stereograph/teia-system-design/components/Popper";
import dt from "@mui/material/Slider";
import ft from "@mui/material/ButtonGroup";
import { createTheme as pt, darken as N } from "@mui/material/styles";
import { Autocomplete as mt } from "@stereograph/teia-system-design/components/Autocomplete";
import { flexRender as ht, getCoreRowModel as gt, getPaginationRowModel as _t, useReactTable as vt } from "@tanstack/react-table";
import yt from "@mui/material/Table";
import bt from "@mui/material/TableBody";
import xt from "@mui/material/TableCell";
import St from "@mui/material/TableHead";
import Ct from "@mui/material/TableRow";
import wt from "@mui/material/SvgIcon";
import { useTheme as Tt } from "@stereograph/teia-system-design/components/Theme";
import { createPortal as Et } from "react-dom";
import Dt from "@mui/material/InputAdornment";
//#region \0rolldown/runtime.js
var Ot = Object.create, kt = Object.defineProperty, At = Object.getOwnPropertyDescriptor, jt = Object.getOwnPropertyNames, Mt = Object.getPrototypeOf, Nt = Object.prototype.hasOwnProperty, Pt = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Ft = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = jt(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Nt.call(e, s) && s !== n && kt(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = At(t, s)) || r.enumerable
	});
	return e;
}, It = (e, t, n) => (n = e == null ? {} : Ot(Mt(e)), Ft(t || !e || !e.__esModule || !Nt.call(e, "default") ? kt(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Lt = n.createContext(null), Rt = (e) => {
	let { viewer: t, children: r } = e, i = n.useMemo(() => ({ viewer: t }), [t]);
	return /* @__PURE__ */ h(Lt.Provider, {
		value: i,
		children: r
	});
}, P = () => {
	let e = n.useContext(Lt);
	if (!e) throw Error("useViewerContext must be called under a ViewerContextProvider");
	return e;
}, zt = n.createContext(null), Bt = (e) => {
	let { viewport: t, children: n } = e, r = u(() => ({ viewport: t }), [t]);
	return /* @__PURE__ */ h(zt.Provider, {
		value: r,
		children: n
	});
}, Vt = () => {
	let e = n.useContext(zt);
	if (!e) throw Error("useViewport must be called under a ViewportCoreContextProvider");
	return e;
}, Ht = {
	threeAxisCameraGizmo: "_threeAxisCameraGizmo_eisxz_1",
	dragging: "_dragging_eisxz_9",
	inactive: "_inactive_eisxz_13"
}, F = /* @__PURE__ */ new D(), Ut = /* @__PURE__ */ new D(), Wt = /* @__PURE__ */ new Fe(), I = class {
	constructor(e, t, n = {}) {
		this.options = {
			size: 90,
			padding: 10,
			positiveAxisBubbleSize: 10,
			negativeAxisBubbleSize: 6,
			backAxisOpacity: .5,
			axislineWidth: 2,
			fontSize: "12px",
			fontFamily: "arial",
			fontWeight: "bold",
			fontColor: "#222222",
			className: "",
			colors: {
				x: "#f73c3c",
				y: "#6ccb26",
				z: "#178cf0"
			},
			turnRate: 2 * Math.PI
		}, this.signals = { onTargetChanged: new we() }, this.focusPoint = new D(), this._selectedAxis = null, this._axes = [], this._targetPosition = new D(), this._targetQuaternion = new Ie(), this._radius = 1, this._isDragging = !1, this._isPressing = !1, this._center = new D(this.options.size / 2, this.options.size / 2, 0), this._context = null, this.setCamera = (e) => {
			this._camera = e;
		}, this.dispose = () => {
			this.canvas.removeEventListener("pointerdown", this._onPointerDown, !1), this.canvas.removeEventListener("pointermove", this._onPointerMove, !1), this.canvas.removeEventListener("pointerup", this._onPointerUp);
		}, this.update = () => {
			this._camera.updateMatrix(), Wt.extractRotation(this._camera.matrix).invert();
			for (let e of this._axes) {
				Ut.copy(e.direction).applyMatrix4(Wt);
				let t = e.bubbleSize;
				e.position.set(Ut.x * (this._center.x - t / 2 - this.options.padding) + this._center.x, this._center.y - Ut.y * (this._center.y - t / 2 - this.options.padding), Ut.z);
			}
			this._axes.sort((e, t) => e.position.z > t.position.z ? 1 : -1), this._updateSelectedAxis(), this._draw();
		}, this._updateSelectedAxis = () => {
			this._selectedAxis = null;
			for (let e of this._axes) F.distanceTo(e.position) < e.bubbleSize && (this._selectedAxis = e);
		}, this._onPointerDown = (e) => {
			e.stopPropagation(), e.preventDefault(), this._isPressing = !0;
		}, this._onPointerMove = (e) => {
			let t = this.canvas.getBoundingClientRect();
			if (F.set(e.clientX - t.left, e.clientY - t.top, 0), this._isDragging = this._isPressing, this._isDragging) return;
			let n = this._selectedAxis;
			this._updateSelectedAxis(), n !== this._selectedAxis && this._draw();
		}, this._onPointerUp = (e) => {
			let t = this.canvas.getBoundingClientRect();
			F.set(e.clientX - t.left, e.clientY - t.top, 0), e.stopPropagation(), e.preventDefault(), this._isDragging || this._onClick(e), this.canvas.classList.remove("dragging"), this._isDragging = !1, this._isPressing = !1;
		}, this._onClick = (e) => {
			this._selectedAxis && this._prepareAxisRotation(this._selectedAxis);
		}, this._prepareAxisRotation = (e) => {
			let { direction: t, euler: n } = e;
			this._targetPosition.copy(t), this._targetQuaternion.setFromEuler(n), this._radius = this._camera.position.distanceTo(this.focusPoint), this._targetPosition.multiplyScalar(this._radius).add(this.focusPoint), this.signals.onTargetChanged.emit(this._targetPosition, this.focusPoint);
		}, Object.assign(this.options, n), this._camera = e, this.canvas = t, this.canvas.width = this.options.size, this.canvas.height = this.options.size, this.canvas.classList.add(Ht.threeAxisCameraGizmo), this.options.className !== "" && this.canvas.classList.add(this.options.className), this._context = this.canvas.getContext("2d"), this.canvas.addEventListener("pointerdown", this._onPointerDown, !1), this.canvas.addEventListener("pointermove", this._onPointerMove, !1), this.canvas.addEventListener("pointerup", this._onPointerUp, !1), this._setupAxes(), this.update();
	}
	_setupAxes() {
		let { colors: e, axislineWidth: t, positiveAxisBubbleSize: n, negativeAxisBubbleSize: r } = this.options;
		this._axes.push({
			axis: "x",
			direction: new D(1, 0, 0),
			euler: new Ne(0, Math.PI * .5, 0),
			bubbleSize: n,
			color: e.x,
			lineWidth: t,
			bubbleLabel: "X",
			position: new D(0, 0, 0)
		}, {
			axis: "y",
			direction: new D(0, 1, 0),
			euler: new Ne(-Math.PI * .5, 0, 0),
			bubbleSize: n,
			color: e.y,
			lineWidth: t,
			bubbleLabel: "Y",
			position: new D(0, 0, 0)
		}, {
			axis: "z",
			direction: new D(0, 0, 1),
			euler: new Ne(),
			bubbleSize: n,
			color: e.z,
			lineWidth: t,
			bubbleLabel: "Z",
			position: new D(0, 0, 0)
		}, {
			axis: "-x",
			direction: new D(-1, 0, 0),
			euler: new Ne(0, -Math.PI * .5, 0),
			bubbleSize: r,
			color: e.x,
			lineWidth: 0,
			position: new D(0, 0, 0)
		}, {
			axis: "-y",
			direction: new D(0, -1, 0),
			euler: new Ne(Math.PI * .5, 0, 0),
			bubbleSize: r,
			color: e.y,
			lineWidth: 0,
			position: new D(0, 0, 0)
		}, {
			axis: "-z",
			direction: new D(0, 0, -1),
			euler: new Ne(0, Math.PI, 0),
			bubbleSize: r,
			color: e.z,
			lineWidth: 0,
			position: new D(0, 0, 0)
		});
	}
	_draw() {
		if (this._context) {
			this._context.clearRect(0, 0, this.canvas.width, this.canvas.height);
			for (let e = 0, t = this._axes.length; e < t; e++) {
				let t = this._axes[e], { color: n, lineWidth: r, position: i, bubbleSize: a, bubbleLabel: o } = t, s = this._selectedAxis === t, c = 1;
				!s && i.z < -.01 && (c = this.options.backAxisOpacity), t.lineWidth > 0 && Gt(this._context, this._center, i, r, n, c), L(this._context, i, a, s ? "#FFFFFF" : n, c);
				let { fontWeight: l, fontSize: u, fontFamily: d, fontColor: f } = this.options;
				o && (this._context.font = [
					l,
					u,
					d
				].join(" "), this._context.fillStyle = f, this._context.textBaseline = "middle", this._context.textAlign = "center", this._context.fillText(o, i.x, i.y));
			}
		}
	}
};
function L(e, t, n = 10, r = "#FF0000", i = 1) {
	e.beginPath(), e.arc(t.x, t.y, n, 0, 2 * Math.PI, !1), e.globalAlpha = i, e.fillStyle = r, e.lineWidth = 2, e.strokeStyle = "black", e.stroke(), e.fill(), e.closePath();
}
function Gt(e, t, n, r = 1, i = "#FF0000", a = 1) {
	e.beginPath(), e.moveTo(t.x, t.y), e.lineTo(n.x, n.y), e.globalAlpha = a, e.lineWidth = r, e.strokeStyle = i, e.stroke(), e.closePath();
}
//#endregion
//#region src/cameraGizmo/CameraGizmo.tsx
var Kt = (t) => {
	let { size: r = 90, sx: i } = t, { viewport: a } = Vt(), { viewer: o } = P(), s = n.useRef(null), c = n.useRef(null);
	return n.useEffect(() => {
		if (!s.current) throw Error("CameraGizmo canvas has not been initialized");
		let e = (e, t) => {
			a.cameraControls.lookAt(e, t);
		}, t = new I(a.camera, s.current, { size: r }), n = t.signals.onTargetChanged.connect(e);
		return c.current = t, () => {
			n.disconnect(), t.dispose();
		};
	}, []), n.useEffect(() => {
		let e = () => {
			c.current?.setCamera(a.camera);
		};
		return o.signals.onCameraModeChanged.connect(e), () => {
			o.signals.onCameraModeChanged.disconnect(e);
		};
	}, []), n.useEffect(() => {
		let e = o.signals.onCameraMove.connect(() => {
			c.current && (a.cameraControls.getTarget(c.current.focusPoint), c.current.update());
		});
		return () => {
			e.disconnect();
		};
	}, []), /* @__PURE__ */ h(e, {
		sx: i,
		children: /* @__PURE__ */ h("canvas", {
			style: {
				position: "absolute",
				right: "0.5rem",
				bottom: "0.5rem"
			},
			ref: s
		})
	});
}, qt = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 24,
	viewBox: "-1 -7 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.21967 5.03033C-0.0732227 4.73744 -0.0732227 4.26256 0.219671 3.96967L3.96967 0.219671C4.26256 -0.0732226 4.73744 -0.0732225 5.03033 0.219671C5.32322 0.512564 5.32322 0.987437 5.03033 1.28033L1.81066 4.5L5.03033 7.71967C5.32322 8.01256 5.32322 8.48744 5.03033 8.78033C4.73744 9.07322 4.26256 9.07322 3.96967 8.78033L0.21967 5.03033ZM9.81066 4.5L13.0303 7.71967C13.3232 8.01256 13.3232 8.48744 13.0303 8.78033C12.7374 9.07322 12.2626 9.07322 11.9697 8.78033L8.21967 5.03033C7.92678 4.73744 7.92678 4.26256 8.21967 3.96967L11.9697 0.219671C12.2626 -0.0732225 12.7374 -0.0732224 13.0303 0.219671C13.3232 0.512564 13.3232 0.987438 13.0303 1.28033L9.81066 4.5ZM17.8107 4.5L21.0303 7.71967C21.3232 8.01257 21.3232 8.48744 21.0303 8.78033C20.7374 9.07323 20.2626 9.07323 19.9697 8.78033L16.2197 5.03033C15.9268 4.73744 15.9268 4.26256 16.2197 3.96967L19.9697 0.219672C20.2626 -0.0732214 20.7374 -0.0732213 21.0303 0.219672C21.3232 0.512565 21.3232 0.987439 21.0303 1.28033L17.8107 4.5Z"
		}),
		/* @__PURE__ */ h("path", { d: "M12.5 4.25C12.5 3.69772 12.9477 3.25 13.5 3.25C14.0523 3.25 14.5 3.69772 14.5 4.25C14.5 4.80228 14.0523 5.25 13.5 5.25C12.9477 5.25 12.5 4.80228 12.5 4.25Z" }),
		/* @__PURE__ */ h("path", { d: "M4.5 4.25C4.5 3.69772 4.94772 3.25 5.5 3.25C6.05228 3.25 6.5 3.69772 6.5 4.25C6.5 4.80228 6.05228 5.25 5.5 5.25C4.94772 5.25 4.5 4.80228 4.5 4.25Z" }),
		/* @__PURE__ */ h("path", { d: "M20.5 4.25C20.5 3.69772 20.9477 3.25 21.5 3.25C22.0523 3.25 22.5 3.69772 22.5 4.25C22.5 4.80228 22.0523 5.25 21.5 5.25C20.9477 5.25 20.5 4.80228 20.5 4.25Z" })
	]
}), Jt = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 24,
	viewBox: "-1 -7 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.2803 4.21967C22.5732 4.51256 22.5732 4.98744 22.2803 5.28033L18.5303 9.03033C18.2374 9.32322 17.7626 9.32322 17.4697 9.03033C17.1768 8.73744 17.1768 8.26256 17.4697 7.96967L20.6893 4.75L17.4697 1.53033C17.1768 1.23744 17.1768 0.762563 17.4697 0.46967C17.7626 0.176776 18.2374 0.176777 18.5303 0.46967L22.2803 4.21967ZM12.6893 4.75L9.46967 1.53033C9.17678 1.23744 9.17678 0.762563 9.46967 0.46967C9.76256 0.176776 10.2374 0.176777 10.5303 0.46967L14.2803 4.21967C14.5732 4.51256 14.5732 4.98744 14.2803 5.28033L10.5303 9.03033C10.2374 9.32322 9.76256 9.32322 9.46967 9.03033C9.17678 8.73744 9.17678 8.26256 9.46967 7.96967L12.6893 4.75ZM4.68934 4.75L1.46967 1.53033C1.17678 1.23744 1.17678 0.762563 1.46967 0.46967C1.76256 0.176776 2.23744 0.176777 2.53033 0.46967L6.28033 4.21967C6.57322 4.51256 6.57322 4.98744 6.28033 5.28033L2.53033 9.03033C2.23744 9.32322 1.76256 9.32322 1.46967 9.03033C1.17678 8.73744 1.17678 8.26256 1.46967 7.96967L4.68934 4.75Z"
		}),
		/* @__PURE__ */ h("path", { d: "M10 5C10 5.55228 9.55228 6 9 6C8.44772 6 8 5.55228 8 5C8 4.44772 8.44772 4 9 4C9.55228 4 10 4.44772 10 5Z" }),
		/* @__PURE__ */ h("path", { d: "M18 5C18 5.55228 17.5523 6 17 6C16.4477 6 16 5.55228 16 5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5Z" }),
		/* @__PURE__ */ h("path", { d: "M2 5C2 5.55228 1.55228 6 1 6C0.447715 6 0 5.55228 0 5C0 4.44772 0.447715 4 1 4C1.55228 4 2 4.44772 2 5Z" })
	]
}), Yt = (t) => {
	let { children: n, defaultIsOpen: r = !0, isBgTransparent: i = !1 } = t, [a, o] = f(r);
	return /* @__PURE__ */ g(e, {
		sx: {
			display: "flex",
			alignItems: "center",
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			overflowX: "clip",
			height: "40px"
		},
		children: [/* @__PURE__ */ h(ze, {
			"data-testid": "toggle-banner",
			"aria-label": "open banner",
			title: "open banner",
			icon: a ? qt : Jt,
			onClick: () => o((e) => !e),
			sx: {
				width: "40px",
				height: "40px",
				backgroundColor: "white",
				borderRadius: 0,
				borderBottomRightRadius: a ? 0 : "10px",
				position: "absolute",
				top: 0,
				left: 0,
				zIndex: 10,
				padding: "0.5rem",
				"&:hover": { backgroundColor: "white" }
			}
		}), /* @__PURE__ */ h(e, {
			"data-testid": "banner-content",
			sx: {
				position: "absolute",
				left: 0,
				paddingLeft: "40px",
				top: 0,
				width: "100%",
				height: "40px",
				display: "flex",
				alignItems: "center",
				transition: "transform 0.3s ease-in-out",
				transform: a ? "translateX(0)" : "translateX(-100%)",
				color: (e) => e.palette.grey[600],
				backgroundColor: i ? "transparent" : "rgb(255, 255, 255, 0.8)"
			},
			children: n
		})]
	});
};
//#endregion
//#region ../../node_modules/@heroicons/react/24/solid/esm/ChevronRightIcon.js
function Xt({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
		clipRule: "evenodd"
	}));
}
var Zt = /*#__PURE__*/ t.forwardRef(Xt);
//#endregion
//#region ../../node_modules/@heroicons/react/24/solid/esm/MagnifyingGlassIcon.js
function Qt({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z",
		clipRule: "evenodd"
	}));
}
var R = /*#__PURE__*/ t.forwardRef(Qt);
//#endregion
//#region ../../node_modules/@heroicons/react/24/solid/esm/TrashIcon.js
function $t({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z",
		clipRule: "evenodd"
	}));
}
var en = /*#__PURE__*/ t.forwardRef($t), tn = (t) => {
	let { items: n, onClick: r } = t, i = d(null), a = d(null), [o, s] = f(!1), [l, u] = f([]), [p, m] = f(0), [_, v] = f(""), y = (e, t) => {
		let n = t.target.offsetLeft - 16;
		m(n), v(e.text);
	}, b = () => {
		v("");
	};
	return c(() => {
		u([]);
	}, [n]), c(() => {
		let e = i.current?.clientWidth, t = a.current?.clientWidth;
		e != null && t != null && (t >= e && l.length < n.length - 1 && u((e) => [...e, n[e.length].id]), s(t >= e));
	}, [l]), /* @__PURE__ */ g(e, {
		sx: {
			position: "relative",
			width: "100%"
		},
		children: [_ != "" && /* @__PURE__ */ h(rn, {
			left: p,
			text: _
		}), /* @__PURE__ */ h(O, {
			direction: "row",
			sx: {
				width: "100%",
				overflow: "hidden",
				backgroundColor: "rgba(255, 255, 255, 0.8)",
				justifyContent: o ? "flex-end" : "flex-start"
			},
			ref: i,
			children: /* @__PURE__ */ h(O, {
				direction: "row",
				sx: {
					width: "fit-content",
					justifyContent: o ? "flex-end" : "flex-start",
					px: 4
				},
				ref: a,
				children: n.map((e, t) => /* @__PURE__ */ h(nn, {
					item: e,
					onClick: r,
					onMoveOver: y,
					onMouseLeave: b,
					isHidden: l.includes(e.id),
					isLastItem: t == n.length - 1
				}, e.id))
			})
		})]
	});
}, nn = (e) => {
	let { item: t, onClick: n, onMoveOver: r, isHidden: i, isLastItem: a, onMouseLeave: o } = e;
	return /* @__PURE__ */ g("button", {
		onMouseOver: (e) => i && r?.(t, e),
		onFocus: (e) => i && r?.(t, e),
		onMouseLeave: o,
		onClick: (e) => n?.(t, e),
		style: {
			display: "flex",
			alignItems: "center",
			border: 0,
			height: "40px",
			minWidth: "fit-content"
		},
		children: [/* @__PURE__ */ h(Ve, {
			component: "p",
			sx: {
				color: (e) => e.palette.grey[600],
				"&:hover": {
					color: (e) => i ? "" : e.palette.primary.main,
					weight: i ? "bold" : "normal"
				},
				marginRight: a ? "0.5rem" : 0,
				maxWidth: i ? "30px" : "none",
				overflow: i ? "hidden" : "none",
				textOverflow: i ? "ellipsis" : "none",
				whiteSpace: i ? "nowrap" : "none",
				transition: "all 0.2s ease-in-out"
			},
			children: t.text
		}), !a && /* @__PURE__ */ h(Be, {
			component: Zt,
			fontSize: "small",
			sx: {
				width: 16,
				height: 16,
				marginX: 2
			}
		})]
	});
}, rn = (t) => {
	let { left: n, text: r } = t;
	return /* @__PURE__ */ h(e, {
		sx: {
			position: "absolute",
			top: "40px",
			left: 0,
			fontSize: "0.875rem",
			lineHeight: "1.25rem",
			backgroundColor: "rgba(255, 255, 255, 0.6)",
			px: "6px",
			py: "2px",
			right: 0,
			borderBottomLeftRadius: "0.5rem",
			color: (e) => e.palette.primary.main,
			fontWeight: "bold"
		},
		children: /* @__PURE__ */ h("p", {
			style: { left: `${n}px` },
			children: r
		})
	});
}, an = () => {
	let { viewer: e } = P(), [t, r] = n.useState([]), [i, a] = n.useState(!1), o = () => {
		let t = [], n = e.scene.objectSelection.getFirstObject();
		if (n) {
			t.push({
				id: n.uuid,
				text: n.name
			});
			let e = n.parentsGenerator();
			for (let n of e) t.push({
				id: n.uuid,
				text: n.name
			});
			t.reverse();
		}
		r(t);
	}, s = () => {
		a(!0);
	}, c = () => {
		a(!1);
	}, l = (t) => {
		new he(e, [t.id]).execute(), new y(e, [t.id]).execute();
	};
	n.useEffect(() => (e.signals.onObjectSelectionChanged.connect(o), e.signals.onLoadingStarted.connect(s), e.signals.onLoadingFinished.connect(c), () => {
		e.signals.onObjectSelectionChanged.disconnect(o), e.signals.onLoadingStarted.disconnect(s), e.signals.onLoadingFinished.disconnect(c);
	}), []);
	let u = /* @__PURE__ */ h("p", {
		style: { padding: "1rem" },
		children: "Select an object"
	}), d = !1;
	return i ? u = /* @__PURE__ */ g(O, {
		direction: "row",
		sx: {
			alignItems: "center",
			p: 4
		},
		children: [/* @__PURE__ */ h(Le, { size: 15 }), /* @__PURE__ */ h("p", {
			style: { marginLeft: "0.5rem" },
			children: "Hierarchy is loading"
		})]
	}) : t.length > 0 && (d = !0, u = /* @__PURE__ */ h(tn, {
		items: t,
		onClick: l
	})), /* @__PURE__ */ h(Yt, {
		defaultIsOpen: !0,
		isBgTransparent: d,
		children: u
	});
}, on = (e) => {
	let { onCancel: t, onValidate: n, text: r, textValidate: i, textCancel: a } = e;
	return /* @__PURE__ */ h(O, {
		sx: {
			width: "100%",
			height: "100vh",
			border: (e) => `7px solid ${e.palette.primary.main}`,
			position: "absolute",
			top: 0,
			zIndex: 10,
			pointerEvents: "none"
		},
		direction: "column",
		alignItems: "center",
		justifyContent: "start",
		children: /* @__PURE__ */ g(O, {
			direction: "row",
			alignItems: "center",
			justifyContent: "space-between",
			sx: {
				width: "610px",
				backgroundColor: (e) => e.palette.background.paper,
				border: (e) => `3px solid ${e.palette.primary.main}`,
				padding: "7px 12px",
				borderTop: "none",
				borderRadius: "0px 0px 5px 5px",
				pointerEvents: "auto"
			},
			children: [
				/* @__PURE__ */ h(Ve, {
					sx: { margin: 0 },
					children: r
				}),
				/* @__PURE__ */ h(He, {
					variant: "info",
					sx: { minWidth: "130px" },
					onClick: n,
					"data-testid": "frame-alert-validate-button",
					children: i
				}),
				/* @__PURE__ */ h(He, {
					sx: { minWidth: "130px" },
					variant: "info",
					onClick: t,
					"data-testid": "frame-alert-cancel-button",
					children: a
				})
			]
		})
	});
}, sn = (e) => [p(e.onChange.subscribe, () => e.value), o((t) => {
	e.value = typeof t == "function" ? t(e.value) : t;
}, [e])], cn = /* @__PURE__ */ It((/* @__PURE__ */ Pt(((e, t) => {
	(function() {
		var n, r = "Expected a function", i = "__lodash_hash_undefined__", a = "__lodash_placeholder__", o = 1, s = 2, c = 8, l = 16, u = 32, d = 64, f = 128, p = 256, m = 512, h = 1 / 0, g = 9007199254740991, _ = 17976931348623157e292, v = NaN, y = 4294967295, b = y - 1, x = y >>> 1, S = [
			["ary", f],
			["bind", o],
			["bindKey", s],
			["curry", c],
			["curryRight", l],
			["flip", m],
			["partial", u],
			["partialRight", d],
			["rearg", p]
		], C = "[object Arguments]", w = "[object Array]", ee = "[object AsyncFunction]", te = "[object Boolean]", ne = "[object Date]", re = "[object DOMException]", ie = "[object Error]", ae = "[object Function]", oe = "[object GeneratorFunction]", se = "[object Map]", ce = "[object Number]", le = "[object Null]", ue = "[object Object]", T = "[object Promise]", de = "[object Proxy]", fe = "[object RegExp]", E = "[object Set]", pe = "[object String]", me = "[object Symbol]", he = "[object Undefined]", ge = "[object WeakMap]", _e = "[object WeakSet]", ve = "[object ArrayBuffer]", ye = "[object DataView]", be = "[object Float32Array]", xe = "[object Float64Array]", Se = "[object Int8Array]", Ce = "[object Int16Array]", we = "[object Int32Array]", Te = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", De = "[object Uint16Array]", Oe = "[object Uint32Array]", ke = /\b__p \+= '';/g, Ae = /\b(__p \+=) '' \+/g, je = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Me = /&(?:amp|lt|gt|quot|#39);/g, Ne = /[&<>"']/g, Pe = RegExp(Me.source), Fe = RegExp(Ne.source), Ie = /<%-([\s\S]+?)%>/g, D = /<%([\s\S]+?)%>/g, Le = /<%=([\s\S]+?)%>/g, Re = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, O = /^\w*$/, ze = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Be = /[\\^$.*+?()[\]{}|]/g, Ve = RegExp(Be.source), He = /^\s+/, k = /\s/, Ue = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, A = /\{\n\/\* \[wrapped with (.+)\] \*/, We = /,? & /, Ge = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, j = /[()=,{}\[\]\/\s]/, Ke = /\\(\\)?/g, qe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Je = /\w*$/, Ye = /^[-+]0x[0-9a-f]+$/i, Xe = /^0b[01]+$/i, Ze = /^\[object .+?Constructor\]$/, Qe = /^0o[0-7]+$/i, $e = /^(?:0|[1-9]\d*)$/, et = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, tt = /($^)/, nt = /['\n\r\u2028\u2029\\]/g, rt = "\\ud800-\\udfff", it = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", at = "\\u2700-\\u27bf", M = "a-z\\xdf-\\xf6\\xf8-\\xff", ot = "\\xac\\xb1\\xd7\\xf7", st = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ct = "\\u2000-\\u206f", lt = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ut = "A-Z\\xc0-\\xd6\\xd8-\\xde", dt = "\\ufe0e\\ufe0f", ft = ot + st + ct + lt, pt = "['’]", N = "[" + rt + "]", mt = "[" + ft + "]", ht = "[" + it + "]", gt = "\\d+", _t = "[" + at + "]", vt = "[" + M + "]", yt = "[^" + rt + ft + gt + at + M + ut + "]", bt = "\\ud83c[\\udffb-\\udfff]", xt = "(?:" + ht + "|" + bt + ")", St = "[^" + rt + "]", Ct = "(?:\\ud83c[\\udde6-\\uddff]){2}", wt = "[\\ud800-\\udbff][\\udc00-\\udfff]", Tt = "[" + ut + "]", Et = "\\u200d", Dt = "(?:" + vt + "|" + yt + ")", Ot = "(?:" + Tt + "|" + yt + ")", kt = "(?:" + pt + "(?:d|ll|m|re|s|t|ve))?", At = "(?:" + pt + "(?:D|LL|M|RE|S|T|VE))?", jt = xt + "?", Mt = "[" + dt + "]?", Nt = "(?:" + Et + "(?:" + [
			St,
			Ct,
			wt
		].join("|") + ")" + Mt + jt + ")*", Pt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ft = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", It = Mt + jt + Nt, Lt = "(?:" + [
			_t,
			Ct,
			wt
		].join("|") + ")" + It, Rt = "(?:" + [
			St + ht + "?",
			ht,
			Ct,
			wt,
			N
		].join("|") + ")", P = RegExp(pt, "g"), zt = RegExp(ht, "g"), Bt = RegExp(bt + "(?=" + bt + ")|" + Rt + It, "g"), Vt = RegExp([
			Tt + "?" + vt + "+" + kt + "(?=" + [
				mt,
				Tt,
				"$"
			].join("|") + ")",
			Ot + "+" + At + "(?=" + [
				mt,
				Tt + Dt,
				"$"
			].join("|") + ")",
			Tt + "?" + Dt + "+" + kt,
			Tt + "+" + At,
			Ft,
			Pt,
			gt,
			Lt
		].join("|"), "g"), Ht = RegExp("[" + Et + rt + it + dt + "]"), F = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Ut = /* @__PURE__ */ "Array.Buffer.DataView.Date.Error.Float32Array.Float64Array.Function.Int8Array.Int16Array.Int32Array.Map.Math.Object.Promise.RegExp.Set.String.Symbol.TypeError.Uint8Array.Uint8ClampedArray.Uint16Array.Uint32Array.WeakMap._.clearTimeout.isFinite.parseInt.setTimeout".split("."), Wt = -1, I = {};
		I[be] = I[xe] = I[Se] = I[Ce] = I[we] = I[Te] = I[Ee] = I[De] = I[Oe] = !0, I[C] = I[w] = I[ve] = I[te] = I[ye] = I[ne] = I[ie] = I[ae] = I[se] = I[ce] = I[ue] = I[fe] = I[E] = I[pe] = I[ge] = !1;
		var L = {};
		L[C] = L[w] = L[ve] = L[ye] = L[te] = L[ne] = L[be] = L[xe] = L[Se] = L[Ce] = L[we] = L[se] = L[ce] = L[ue] = L[fe] = L[E] = L[pe] = L[me] = L[Te] = L[Ee] = L[De] = L[Oe] = !0, L[ie] = L[ae] = L[ge] = !1;
		var Gt = {
			À: "A",
			Á: "A",
			Â: "A",
			Ã: "A",
			Ä: "A",
			Å: "A",
			à: "a",
			á: "a",
			â: "a",
			ã: "a",
			ä: "a",
			å: "a",
			Ç: "C",
			ç: "c",
			Ð: "D",
			ð: "d",
			È: "E",
			É: "E",
			Ê: "E",
			Ë: "E",
			è: "e",
			é: "e",
			ê: "e",
			ë: "e",
			Ì: "I",
			Í: "I",
			Î: "I",
			Ï: "I",
			ì: "i",
			í: "i",
			î: "i",
			ï: "i",
			Ñ: "N",
			ñ: "n",
			Ò: "O",
			Ó: "O",
			Ô: "O",
			Õ: "O",
			Ö: "O",
			Ø: "O",
			ò: "o",
			ó: "o",
			ô: "o",
			õ: "o",
			ö: "o",
			ø: "o",
			Ù: "U",
			Ú: "U",
			Û: "U",
			Ü: "U",
			ù: "u",
			ú: "u",
			û: "u",
			ü: "u",
			Ý: "Y",
			ý: "y",
			ÿ: "y",
			Æ: "Ae",
			æ: "ae",
			Þ: "Th",
			þ: "th",
			ß: "ss",
			Ā: "A",
			Ă: "A",
			Ą: "A",
			ā: "a",
			ă: "a",
			ą: "a",
			Ć: "C",
			Ĉ: "C",
			Ċ: "C",
			Č: "C",
			ć: "c",
			ĉ: "c",
			ċ: "c",
			č: "c",
			Ď: "D",
			Đ: "D",
			ď: "d",
			đ: "d",
			Ē: "E",
			Ĕ: "E",
			Ė: "E",
			Ę: "E",
			Ě: "E",
			ē: "e",
			ĕ: "e",
			ė: "e",
			ę: "e",
			ě: "e",
			Ĝ: "G",
			Ğ: "G",
			Ġ: "G",
			Ģ: "G",
			ĝ: "g",
			ğ: "g",
			ġ: "g",
			ģ: "g",
			Ĥ: "H",
			Ħ: "H",
			ĥ: "h",
			ħ: "h",
			Ĩ: "I",
			Ī: "I",
			Ĭ: "I",
			Į: "I",
			İ: "I",
			ĩ: "i",
			ī: "i",
			ĭ: "i",
			į: "i",
			ı: "i",
			Ĵ: "J",
			ĵ: "j",
			Ķ: "K",
			ķ: "k",
			ĸ: "k",
			Ĺ: "L",
			Ļ: "L",
			Ľ: "L",
			Ŀ: "L",
			Ł: "L",
			ĺ: "l",
			ļ: "l",
			ľ: "l",
			ŀ: "l",
			ł: "l",
			Ń: "N",
			Ņ: "N",
			Ň: "N",
			Ŋ: "N",
			ń: "n",
			ņ: "n",
			ň: "n",
			ŋ: "n",
			Ō: "O",
			Ŏ: "O",
			Ő: "O",
			ō: "o",
			ŏ: "o",
			ő: "o",
			Ŕ: "R",
			Ŗ: "R",
			Ř: "R",
			ŕ: "r",
			ŗ: "r",
			ř: "r",
			Ś: "S",
			Ŝ: "S",
			Ş: "S",
			Š: "S",
			ś: "s",
			ŝ: "s",
			ş: "s",
			š: "s",
			Ţ: "T",
			Ť: "T",
			Ŧ: "T",
			ţ: "t",
			ť: "t",
			ŧ: "t",
			Ũ: "U",
			Ū: "U",
			Ŭ: "U",
			Ů: "U",
			Ű: "U",
			Ų: "U",
			ũ: "u",
			ū: "u",
			ŭ: "u",
			ů: "u",
			ű: "u",
			ų: "u",
			Ŵ: "W",
			ŵ: "w",
			Ŷ: "Y",
			ŷ: "y",
			Ÿ: "Y",
			Ź: "Z",
			Ż: "Z",
			Ž: "Z",
			ź: "z",
			ż: "z",
			ž: "z",
			Ĳ: "IJ",
			ĳ: "ij",
			Œ: "Oe",
			œ: "oe",
			ŉ: "'n",
			ſ: "s"
		}, Kt = {
			"&": "&amp;",
			"<": "&lt;",
			">": "&gt;",
			"\"": "&quot;",
			"'": "&#39;"
		}, qt = {
			"&amp;": "&",
			"&lt;": "<",
			"&gt;": ">",
			"&quot;": "\"",
			"&#39;": "'"
		}, Jt = {
			"\\": "\\",
			"'": "'",
			"\n": "n",
			"\r": "r",
			"\u2028": "u2028",
			"\u2029": "u2029"
		}, Yt = parseFloat, Xt = parseInt, Zt = typeof global == "object" && global && global.Object === Object && global, Qt = typeof self == "object" && self && self.Object === Object && self, R = Zt || Qt || Function("return this")(), $t = typeof e == "object" && e && !e.nodeType && e, en = $t && typeof t == "object" && t && !t.nodeType && t, tn = en && en.exports === $t, nn = tn && Zt.process, rn = function() {
			try {
				return en && en.require && en.require("util").types || nn && nn.binding && nn.binding("util");
			} catch {}
		}(), an = rn && rn.isArrayBuffer, on = rn && rn.isDate, sn = rn && rn.isMap, cn = rn && rn.isRegExp, ln = rn && rn.isSet, un = rn && rn.isTypedArray;
		function z(e, t, n) {
			switch (n.length) {
				case 0: return e.call(t);
				case 1: return e.call(t, n[0]);
				case 2: return e.call(t, n[0], n[1]);
				case 3: return e.call(t, n[0], n[1], n[2]);
			}
			return e.apply(t, n);
		}
		function dn(e, t, n, r) {
			for (var i = -1, a = e == null ? 0 : e.length; ++i < a;) {
				var o = e[i];
				t(r, o, n(o), e);
			}
			return r;
		}
		function fn(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
			return e;
		}
		function pn(e, t) {
			for (var n = e == null ? 0 : e.length; n-- && t(e[n], n, e) !== !1;);
			return e;
		}
		function mn(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (!t(e[n], n, e)) return !1;
			return !0;
		}
		function hn(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
				var o = e[n];
				t(o, n, e) && (a[i++] = o);
			}
			return a;
		}
		function gn(e, t) {
			return !!(e != null && e.length) && Dn(e, t, 0) > -1;
		}
		function _n(e, t, n) {
			for (var r = -1, i = e == null ? 0 : e.length; ++r < i;) if (n(t, e[r])) return !0;
			return !1;
		}
		function B(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
			return i;
		}
		function vn(e, t) {
			for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
			return e;
		}
		function yn(e, t, n, r) {
			var i = -1, a = e == null ? 0 : e.length;
			for (r && a && (n = e[++i]); ++i < a;) n = t(n, e[i], i, e);
			return n;
		}
		function bn(e, t, n, r) {
			var i = e == null ? 0 : e.length;
			for (r && i && (n = e[--i]); i--;) n = t(n, e[i], i, e);
			return n;
		}
		function xn(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
			return !1;
		}
		var Sn = jn("length");
		function Cn(e) {
			return e.split("");
		}
		function wn(e) {
			return e.match(Ge) || [];
		}
		function Tn(e, t, n) {
			var r;
			return n(e, function(e, n, i) {
				if (t(e, n, i)) return r = n, !1;
			}), r;
		}
		function En(e, t, n, r) {
			for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) if (t(e[a], a, e)) return a;
			return -1;
		}
		function Dn(e, t, n) {
			return t === t ? rr(e, t, n) : En(e, kn, n);
		}
		function On(e, t, n, r) {
			for (var i = n - 1, a = e.length; ++i < a;) if (r(e[i], t)) return i;
			return -1;
		}
		function kn(e) {
			return e !== e;
		}
		function An(e, t) {
			var n = e == null ? 0 : e.length;
			return n ? Fn(e, t) / n : v;
		}
		function jn(e) {
			return function(t) {
				return t == null ? n : t[e];
			};
		}
		function Mn(e) {
			return function(t) {
				return e == null ? n : e[t];
			};
		}
		function Nn(e, t, n, r, i) {
			return i(e, function(e, i, a) {
				n = r ? (r = !1, e) : t(n, e, i, a);
			}), n;
		}
		function Pn(e, t) {
			var n = e.length;
			for (e.sort(t); n--;) e[n] = e[n].value;
			return e;
		}
		function Fn(e, t) {
			for (var r, i = -1, a = e.length; ++i < a;) {
				var o = t(e[i]);
				o !== n && (r = r === n ? o : r + o);
			}
			return r;
		}
		function In(e, t) {
			for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
			return r;
		}
		function Ln(e, t) {
			return B(t, function(t) {
				return [t, e[t]];
			});
		}
		function Rn(e) {
			return e && e.slice(0, sr(e) + 1).replace(He, "");
		}
		function zn(e) {
			return function(t) {
				return e(t);
			};
		}
		function Bn(e, t) {
			return B(t, function(t) {
				return e[t];
			});
		}
		function Vn(e, t) {
			return e.has(t);
		}
		function Hn(e, t) {
			for (var n = -1, r = e.length; ++n < r && Dn(t, e[n], 0) > -1;);
			return n;
		}
		function Un(e, t) {
			for (var n = e.length; n-- && Dn(t, e[n], 0) > -1;);
			return n;
		}
		function Wn(e, t) {
			for (var n = e.length, r = 0; n--;) e[n] === t && ++r;
			return r;
		}
		var Gn = Mn(Gt), Kn = Mn(Kt);
		function qn(e) {
			return "\\" + Jt[e];
		}
		function Jn(e, t) {
			return e == null ? n : e[t];
		}
		function Yn(e) {
			return Ht.test(e);
		}
		function Xn(e) {
			return F.test(e);
		}
		function Zn(e) {
			for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
			return n;
		}
		function Qn(e) {
			var t = -1, n = Array(e.size);
			return e.forEach(function(e, r) {
				n[++t] = [r, e];
			}), n;
		}
		function $n(e, t) {
			return function(n) {
				return e(t(n));
			};
		}
		function er(e, t) {
			for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
				var s = e[n];
				(s === t || s === a) && (e[n] = a, o[i++] = n);
			}
			return o;
		}
		function tr(e) {
			var t = -1, n = Array(e.size);
			return e.forEach(function(e) {
				n[++t] = e;
			}), n;
		}
		function nr(e) {
			var t = -1, n = Array(e.size);
			return e.forEach(function(e) {
				n[++t] = [e, e];
			}), n;
		}
		function rr(e, t, n) {
			for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
			return -1;
		}
		function ir(e, t, n) {
			for (var r = n + 1; r--;) if (e[r] === t) return r;
			return r;
		}
		function ar(e) {
			return Yn(e) ? lr(e) : Sn(e);
		}
		function or(e) {
			return Yn(e) ? ur(e) : Cn(e);
		}
		function sr(e) {
			for (var t = e.length; t-- && k.test(e.charAt(t)););
			return t;
		}
		var cr = Mn(qt);
		function lr(e) {
			for (var t = Bt.lastIndex = 0; Bt.test(e);) ++t;
			return t;
		}
		function ur(e) {
			return e.match(Bt) || [];
		}
		function dr(e) {
			return e.match(Vt) || [];
		}
		var fr = (function e(t) {
			t = t == null ? R : fr.defaults(R.Object(), t, fr.pick(R, Ut));
			var k = t.Array, Ge = t.Date, rt = t.Error, it = t.Function, at = t.Math, M = t.Object, ot = t.RegExp, st = t.String, ct = t.TypeError, lt = k.prototype, ut = it.prototype, dt = M.prototype, ft = t["__core-js_shared__"], pt = ut.toString, N = dt.hasOwnProperty, mt = 0, ht = function() {
				var e = /[^.]+$/.exec(ft && ft.keys && ft.keys.IE_PROTO || "");
				return e ? "Symbol(src)_1." + e : "";
			}(), gt = dt.toString, _t = pt.call(M), vt = R._, yt = ot("^" + pt.call(N).replace(Be, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), bt = tn ? t.Buffer : n, xt = t.Symbol, St = t.Uint8Array, Ct = bt ? bt.allocUnsafe : n, wt = $n(M.getPrototypeOf, M), Tt = M.create, Et = dt.propertyIsEnumerable, Dt = lt.splice, Ot = xt ? xt.isConcatSpreadable : n, kt = xt ? xt.iterator : n, At = xt ? xt.toStringTag : n, jt = function() {
				try {
					var e = Io(M, "defineProperty");
					return e({}, "", {}), e;
				} catch {}
			}(), Mt = t.clearTimeout !== R.clearTimeout && t.clearTimeout, Nt = Ge && Ge.now !== R.Date.now && Ge.now, Pt = t.setTimeout !== R.setTimeout && t.setTimeout, Ft = at.ceil, It = at.floor, Lt = M.getOwnPropertySymbols, Rt = bt ? bt.isBuffer : n, Bt = t.isFinite, Vt = lt.join, Ht = $n(M.keys, M), F = at.max, Gt = at.min, Kt = Ge.now, qt = t.parseInt, Jt = at.random, Zt = lt.reverse, Qt = Io(t, "DataView"), $t = Io(t, "Map"), en = Io(t, "Promise"), nn = Io(t, "Set"), rn = Io(t, "WeakMap"), Sn = Io(M, "create"), Cn = rn && new rn(), Mn = {}, rr = bs(Qt), lr = bs($t), ur = bs(en), pr = bs(nn), mr = bs(rn), hr = xt ? xt.prototype : n, gr = hr ? hr.valueOf : n, _r = hr ? hr.toString : n;
			function V(e) {
				if (Z(e) && !J(e) && !(e instanceof H)) {
					if (e instanceof br) return e;
					if (N.call(e, "__wrapped__")) return Ss(e);
				}
				return new br(e);
			}
			var vr = function() {
				function e() {}
				return function(t) {
					if (!X(t)) return {};
					if (Tt) return Tt(t);
					e.prototype = t;
					var r = new e();
					return e.prototype = n, r;
				};
			}();
			function yr() {}
			function br(e, t) {
				this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = n;
			}
			V.templateSettings = {
				escape: Ie,
				evaluate: D,
				interpolate: Le,
				variable: "",
				imports: { _: V }
			}, V.prototype = yr.prototype, V.prototype.constructor = V, br.prototype = vr(yr.prototype), br.prototype.constructor = br;
			function H(e) {
				this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = y, this.__views__ = [];
			}
			function xr() {
				var e = new H(this.__wrapped__);
				return e.__actions__ = Ya(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Ya(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Ya(this.__views__), e;
			}
			function Sr() {
				if (this.__filtered__) {
					var e = new H(this);
					e.__dir__ = -1, e.__filtered__ = !0;
				} else e = this.clone(), e.__dir__ *= -1;
				return e;
			}
			function Cr() {
				var e = this.__wrapped__.value(), t = this.__dir__, n = J(e), r = t < 0, i = n ? e.length : 0, a = q(0, i, this.__views__), o = a.start, s = a.end, c = s - o, l = r ? s : o - 1, u = this.__iteratees__, d = u.length, f = 0, p = Gt(c, this.__takeCount__);
				if (!n || !r && i == c && p == c) return Aa(e, this.__actions__);
				var m = [];
				outer: for (; c-- && f < p;) {
					l += t;
					for (var h = -1, g = e[l]; ++h < d;) {
						var _ = u[h], v = _.iteratee, y = _.type, b = v(g);
						if (y == 2) g = b;
						else if (!b) {
							if (y == 1) continue outer;
							break outer;
						}
					}
					m[f++] = g;
				}
				return m;
			}
			H.prototype = vr(yr.prototype), H.prototype.constructor = H;
			function wr(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.clear(); ++t < n;) {
					var r = e[t];
					this.set(r[0], r[1]);
				}
			}
			function Tr() {
				this.__data__ = Sn ? Sn(null) : {}, this.size = 0;
			}
			function Er(e) {
				var t = this.has(e) && delete this.__data__[e];
				return this.size -= +!!t, t;
			}
			function Dr(e) {
				var t = this.__data__;
				if (Sn) {
					var r = t[e];
					return r === i ? n : r;
				}
				return N.call(t, e) ? t[e] : n;
			}
			function Or(e) {
				var t = this.__data__;
				return Sn ? t[e] !== n : N.call(t, e);
			}
			function kr(e, t) {
				var r = this.__data__;
				return this.size += +!this.has(e), r[e] = Sn && t === n ? i : t, this;
			}
			wr.prototype.clear = Tr, wr.prototype.delete = Er, wr.prototype.get = Dr, wr.prototype.has = Or, wr.prototype.set = kr;
			function Ar(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.clear(); ++t < n;) {
					var r = e[t];
					this.set(r[0], r[1]);
				}
			}
			function jr() {
				this.__data__ = [], this.size = 0;
			}
			function Mr(e) {
				var t = this.__data__, n = ri(t, e);
				return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Dt.call(t, n, 1), --this.size, !0);
			}
			function Nr(e) {
				var t = this.__data__, r = ri(t, e);
				return r < 0 ? n : t[r][1];
			}
			function Pr(e) {
				return ri(this.__data__, e) > -1;
			}
			function Fr(e, t) {
				var n = this.__data__, r = ri(n, e);
				return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
			}
			Ar.prototype.clear = jr, Ar.prototype.delete = Mr, Ar.prototype.get = Nr, Ar.prototype.has = Pr, Ar.prototype.set = Fr;
			function Ir(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.clear(); ++t < n;) {
					var r = e[t];
					this.set(r[0], r[1]);
				}
			}
			function Lr() {
				this.size = 0, this.__data__ = {
					hash: new wr(),
					map: new ($t || Ar)(),
					string: new wr()
				};
			}
			function Rr(e) {
				var t = Po(this, e).delete(e);
				return this.size -= +!!t, t;
			}
			function zr(e) {
				return Po(this, e).get(e);
			}
			function Br(e) {
				return Po(this, e).has(e);
			}
			function Vr(e, t) {
				var n = Po(this, e), r = n.size;
				return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
			}
			Ir.prototype.clear = Lr, Ir.prototype.delete = Rr, Ir.prototype.get = zr, Ir.prototype.has = Br, Ir.prototype.set = Vr;
			function Hr(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.__data__ = new Ir(); ++t < n;) this.add(e[t]);
			}
			function Ur(e) {
				return this.__data__.set(e, i), this;
			}
			function Wr(e) {
				return this.__data__.has(e);
			}
			Hr.prototype.add = Hr.prototype.push = Ur, Hr.prototype.has = Wr;
			function Gr(e) {
				var t = this.__data__ = new Ar(e);
				this.size = t.size;
			}
			function Kr() {
				this.__data__ = new Ar(), this.size = 0;
			}
			function qr(e) {
				var t = this.__data__, n = t.delete(e);
				return this.size = t.size, n;
			}
			function Jr(e) {
				return this.__data__.get(e);
			}
			function Yr(e) {
				return this.__data__.has(e);
			}
			function Xr(e, t) {
				var n = this.__data__;
				if (n instanceof Ar) {
					var r = n.__data__;
					if (!$t || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
					n = this.__data__ = new Ir(r);
				}
				return n.set(e, t), this.size = n.size, this;
			}
			Gr.prototype.clear = Kr, Gr.prototype.delete = qr, Gr.prototype.get = Jr, Gr.prototype.has = Yr, Gr.prototype.set = Xr;
			function Zr(e, t) {
				var n = J(e), r = !n && Yl(e), i = !n && !r && $l(e), a = !n && !r && !i && wu(e), o = n || r || i || a, s = o ? In(e.length, st) : [], c = s.length;
				for (var l in e) (t || N.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Jo(l, c))) && s.push(l);
				return s;
			}
			function Qr(e) {
				var t = e.length;
				return t ? e[ua(0, t - 1)] : n;
			}
			function $r(e, t) {
				return _s(Ya(e), li(t, 0, e.length));
			}
			function ei(e) {
				return _s(Ya(e));
			}
			function ti(e, t, r) {
				(r !== n && !Kl(e[t], r) || r === n && !(t in e)) && si(e, t, r);
			}
			function ni(e, t, r) {
				var i = e[t];
				(!(N.call(e, t) && Kl(i, r)) || r === n && !(t in e)) && si(e, t, r);
			}
			function ri(e, t) {
				for (var n = e.length; n--;) if (Kl(e[n][0], t)) return n;
				return -1;
			}
			function ii(e, t, n, r) {
				return hi(e, function(e, i, a) {
					t(r, e, n(e), a);
				}), r;
			}
			function ai(e, t) {
				return e && W(t, id(t), e);
			}
			function oi(e, t) {
				return e && W(t, ad(t), e);
			}
			function si(e, t, n) {
				t == "__proto__" && jt ? jt(e, t, {
					configurable: !0,
					enumerable: !0,
					value: n,
					writable: !0
				}) : e[t] = n;
			}
			function ci(e, t) {
				for (var r = -1, i = t.length, a = k(i), o = e == null; ++r < i;) a[r] = o ? n : Qu(e, t[r]);
				return a;
			}
			function li(e, t, r) {
				return e === e && (r !== n && (e = e <= r ? e : r), t !== n && (e = e >= t ? e : t)), e;
			}
			function ui(e, t, r, i, a, o) {
				var s, c = t & 1, l = t & 2, u = t & 4;
				if (r && (s = a ? r(e, i, a, o) : r(e)), s !== n) return s;
				if (!X(e)) return e;
				var d = J(e);
				if (d) {
					if (s = Uo(e), !c) return Ya(e, s);
				} else {
					var f = Bo(e), p = f == ae || f == oe;
					if ($l(e)) return za(e, c);
					if (f == ue || f == C || p && !a) {
						if (s = l || p ? {} : Wo(e), !c) return l ? Za(e, oi(s, e)) : Xa(e, ai(s, e));
					} else {
						if (!L[f]) return a ? e : {};
						s = Go(e, f, c);
					}
				}
				o ||= new Gr();
				var m = o.get(e);
				if (m) return m;
				o.set(e, s), xu(e) ? e.forEach(function(n) {
					s.add(ui(n, t, r, n, e, o));
				}) : uu(e) && e.forEach(function(n, i) {
					s.set(i, ui(n, t, r, i, e, o));
				});
				var h = d ? n : (u ? l ? Ao : ko : l ? ad : id)(e);
				return fn(h || e, function(n, i) {
					h && (i = n, n = e[i]), ni(s, i, ui(n, t, r, i, e, o));
				}), s;
			}
			function di(e) {
				var t = id(e);
				return function(n) {
					return fi(n, e, t);
				};
			}
			function fi(e, t, r) {
				var i = r.length;
				if (e == null) return !i;
				for (e = M(e); i--;) {
					var a = r[i], o = t[a], s = e[a];
					if (s === n && !(a in e) || !o(s)) return !1;
				}
				return !0;
			}
			function pi(e, t, i) {
				if (typeof e != "function") throw new ct(r);
				return ps(function() {
					e.apply(n, i);
				}, t);
			}
			function mi(e, t, n, r) {
				var i = -1, a = gn, o = !0, s = e.length, c = [], l = t.length;
				if (!s) return c;
				n && (t = B(t, zn(n))), r ? (a = _n, o = !1) : t.length >= 200 && (a = Vn, o = !1, t = new Hr(t));
				outer: for (; ++i < s;) {
					var u = e[i], d = n == null ? u : n(u);
					if (u = r || u !== 0 ? u : 0, o && d === d) {
						for (var f = l; f--;) if (t[f] === d) continue outer;
						c.push(u);
					} else a(t, d, r) || c.push(u);
				}
				return c;
			}
			var hi = eo(wi), gi = eo(Ti, !0);
			function _i(e, t) {
				var n = !0;
				return hi(e, function(e, r, i) {
					return n = !!t(e, r, i), n;
				}), n;
			}
			function vi(e, t, r) {
				for (var i = -1, a = e.length; ++i < a;) {
					var o = e[i], s = t(o);
					if (s != null && (c === n ? s === s && !Cu(s) : r(s, c))) var c = s, l = o;
				}
				return l;
			}
			function yi(e, t, r, i) {
				var a = e.length;
				for (r = Q(r), r < 0 && (r = -r > a ? 0 : a + r), i = i === n || i > a ? a : Q(i), i < 0 && (i += a), i = r > i ? 0 : Mu(i); r < i;) e[r++] = t;
				return e;
			}
			function bi(e, t) {
				var n = [];
				return hi(e, function(e, r, i) {
					t(e, r, i) && n.push(e);
				}), n;
			}
			function xi(e, t, n, r, i) {
				var a = -1, o = e.length;
				for (n ||= qo, i ||= []; ++a < o;) {
					var s = e[a];
					t > 0 && n(s) ? t > 1 ? xi(s, t - 1, n, r, i) : vn(i, s) : r || (i[i.length] = s);
				}
				return i;
			}
			var Si = to(), Ci = to(!0);
			function wi(e, t) {
				return e && Si(e, t, id);
			}
			function Ti(e, t) {
				return e && Ci(e, t, id);
			}
			function Ei(e, t) {
				return hn(t, function(t) {
					return su(e[t]);
				});
			}
			function Di(e, t) {
				t = Fa(t, e);
				for (var r = 0, i = t.length; e != null && r < i;) e = e[ys(t[r++])];
				return r && r == i ? e : n;
			}
			function Oi(e, t, n) {
				var r = t(e);
				return J(e) ? r : vn(r, n(e));
			}
			function ki(e) {
				return e == null ? e === n ? he : le : At && At in M(e) ? Lo(e) : ss(e);
			}
			function Ai(e, t) {
				return e > t;
			}
			function ji(e, t) {
				return e != null && N.call(e, t);
			}
			function Mi(e, t) {
				return e != null && t in M(e);
			}
			function Ni(e, t, n) {
				return e >= Gt(t, n) && e < F(t, n);
			}
			function Pi(e, t, r) {
				for (var i = r ? _n : gn, a = e[0].length, o = e.length, s = o, c = k(o), l = Infinity, u = []; s--;) {
					var d = e[s];
					s && t && (d = B(d, zn(t))), l = Gt(d.length, l), c[s] = !r && (t || a >= 120 && d.length >= 120) ? new Hr(s && d) : n;
				}
				d = e[0];
				var f = -1, p = c[0];
				outer: for (; ++f < a && u.length < l;) {
					var m = d[f], h = t ? t(m) : m;
					if (m = r || m !== 0 ? m : 0, !(p ? Vn(p, h) : i(u, h, r))) {
						for (s = o; --s;) {
							var g = c[s];
							if (!(g ? Vn(g, h) : i(e[s], h, r))) continue outer;
						}
						p && p.push(h), u.push(m);
					}
				}
				return u;
			}
			function Fi(e, t, n, r) {
				return wi(e, function(e, i, a) {
					t(r, n(e), i, a);
				}), r;
			}
			function Ii(e, t, r) {
				t = Fa(t, e), e = ls(e, t);
				var i = e == null ? e : e[ys(qs(t))];
				return i == null ? n : z(i, e, r);
			}
			function Li(e) {
				return Z(e) && ki(e) == C;
			}
			function Ri(e) {
				return Z(e) && ki(e) == ve;
			}
			function zi(e) {
				return Z(e) && ki(e) == ne;
			}
			function Bi(e, t, n, r, i) {
				return e === t ? !0 : e == null || t == null || !Z(e) && !Z(t) ? e !== e && t !== t : Vi(e, t, n, r, Bi, i);
			}
			function Vi(e, t, n, r, i, a) {
				var o = J(e), s = J(t), c = o ? w : Bo(e), l = s ? w : Bo(t);
				c = c == C ? ue : c, l = l == C ? ue : l;
				var u = c == ue, d = l == ue, f = c == l;
				if (f && $l(e)) {
					if (!$l(t)) return !1;
					o = !0, u = !1;
				}
				if (f && !u) return a ||= new Gr(), o || wu(e) ? To(e, t, n, r, i, a) : Eo(e, t, c, n, r, i, a);
				if (!(n & 1)) {
					var p = u && N.call(e, "__wrapped__"), m = d && N.call(t, "__wrapped__");
					if (p || m) {
						var h = p ? e.value() : e, g = m ? t.value() : t;
						return a ||= new Gr(), i(h, g, n, r, a);
					}
				}
				return f ? (a ||= new Gr(), Do(e, t, n, r, i, a)) : !1;
			}
			function Hi(e) {
				return Z(e) && Bo(e) == se;
			}
			function Ui(e, t, r, i) {
				var a = r.length, o = a, s = !i;
				if (e == null) return !o;
				for (e = M(e); a--;) {
					var c = r[a];
					if (s && c[2] ? c[1] !== e[c[0]] : !(c[0] in e)) return !1;
				}
				for (; ++a < o;) {
					c = r[a];
					var l = c[0], u = e[l], d = c[1];
					if (s && c[2]) {
						if (u === n && !(l in e)) return !1;
					} else {
						var f = new Gr();
						if (i) var p = i(u, d, l, e, t, f);
						if (!(p === n ? Bi(d, u, 3, i, f) : p)) return !1;
					}
				}
				return !0;
			}
			function Wi(e) {
				return !X(e) || $o(e) ? !1 : (su(e) ? yt : Ze).test(bs(e));
			}
			function Gi(e) {
				return Z(e) && ki(e) == fe;
			}
			function Ki(e) {
				return Z(e) && Bo(e) == E;
			}
			function qi(e) {
				return Z(e) && lu(e.length) && !!I[ki(e)];
			}
			function Ji(e) {
				return typeof e == "function" ? e : e == null ? pf : typeof e == "object" ? J(e) ? ea(e[0], e[1]) : $i(e) : Ef(e);
			}
			function Yi(e) {
				if (!ts(e)) return Ht(e);
				var t = [];
				for (var n in M(e)) N.call(e, n) && n != "constructor" && t.push(n);
				return t;
			}
			function Xi(e) {
				if (!X(e)) return os(e);
				var t = ts(e), n = [];
				for (var r in e) (r != "constructor" || !t && N.call(e, r)) && n.push(r);
				return n;
			}
			function Zi(e, t) {
				return e < t;
			}
			function Qi(e, t) {
				var n = -1, r = Zl(e) ? k(e.length) : [];
				return hi(e, function(e, i, a) {
					r[++n] = t(e, i, a);
				}), r;
			}
			function $i(e) {
				var t = Fo(e);
				return t.length == 1 && t[0][2] ? rs(t[0][0], t[0][1]) : function(n) {
					return n === e || Ui(n, e, t);
				};
			}
			function ea(e, t) {
				return Xo(e) && ns(t) ? rs(ys(e), t) : function(r) {
					var i = Qu(r, e);
					return i === n && i === t ? ed(r, e) : Bi(t, i, 3);
				};
			}
			function ta(e, t, r, i, a) {
				e !== t && Si(t, function(o, s) {
					if (a ||= new Gr(), X(o)) na(e, t, s, r, ta, i, a);
					else {
						var c = i ? i(ds(e, s), o, s + "", e, t, a) : n;
						c === n && (c = o), ti(e, s, c);
					}
				}, ad);
			}
			function na(e, t, r, i, a, o, s) {
				var c = ds(e, r), l = ds(t, r), u = s.get(l);
				if (u) {
					ti(e, r, u);
					return;
				}
				var d = o ? o(c, l, r + "", e, t, s) : n, f = d === n;
				if (f) {
					var p = J(l), m = !p && $l(l), h = !p && !m && wu(l);
					d = l, p || m || h ? J(c) ? d = c : Y(c) ? d = Ya(c) : m ? (f = !1, d = za(l, !0)) : h ? (f = !1, d = Wa(l, !0)) : d = [] : vu(l) || Yl(l) ? (d = c, Yl(c) ? d = Pu(c) : (!X(c) || su(c)) && (d = Wo(l))) : f = !1;
				}
				f && (s.set(l, d), a(d, l, i, o, s), s.delete(l)), ti(e, r, d);
			}
			function ra(e, t) {
				var r = e.length;
				if (r) return t += t < 0 ? r : 0, Jo(t, r) ? e[t] : n;
			}
			function ia(e, t, n) {
				t = t.length ? B(t, function(e) {
					return J(e) ? function(t) {
						return Di(t, e.length === 1 ? e[0] : e);
					} : e;
				}) : [pf];
				var r = -1;
				return t = B(t, zn(K())), Pn(Qi(e, function(e, n, i) {
					return {
						criteria: B(t, function(t) {
							return t(e);
						}),
						index: ++r,
						value: e
					};
				}), function(e, t) {
					return Ka(e, t, n);
				});
			}
			function aa(e, t) {
				return oa(e, t, function(t, n) {
					return ed(e, n);
				});
			}
			function oa(e, t, n) {
				for (var r = -1, i = t.length, a = {}; ++r < i;) {
					var o = t[r], s = Di(e, o);
					n(s, o) && ha(a, Fa(o, e), s);
				}
				return a;
			}
			function sa(e) {
				return function(t) {
					return Di(t, e);
				};
			}
			function ca(e, t, n, r) {
				var i = r ? On : Dn, a = -1, o = t.length, s = e;
				for (e === t && (t = Ya(t)), n && (s = B(e, zn(n))); ++a < o;) for (var c = 0, l = t[a], u = n ? n(l) : l; (c = i(s, u, c, r)) > -1;) s !== e && Dt.call(s, c, 1), Dt.call(e, c, 1);
				return e;
			}
			function la(e, t) {
				for (var n = e ? t.length : 0, r = n - 1; n--;) {
					var i = t[n];
					if (n == r || i !== a) {
						var a = i;
						Jo(i) ? Dt.call(e, i, 1) : Da(e, i);
					}
				}
				return e;
			}
			function ua(e, t) {
				return e + It(Jt() * (t - e + 1));
			}
			function da(e, t, n, r) {
				for (var i = -1, a = F(Ft((t - e) / (n || 1)), 0), o = k(a); a--;) o[r ? a : ++i] = e, e += n;
				return o;
			}
			function fa(e, t) {
				var n = "";
				if (!e || t < 1 || t > g) return n;
				do
					t % 2 && (n += e), t = It(t / 2), t && (e += e);
				while (t);
				return n;
			}
			function U(e, t) {
				return ms(cs(e, t, pf), e + "");
			}
			function pa(e) {
				return Qr(Cd(e));
			}
			function ma(e, t) {
				var n = Cd(e);
				return _s(n, li(t, 0, n.length));
			}
			function ha(e, t, r, i) {
				if (!X(e)) return e;
				t = Fa(t, e);
				for (var a = -1, o = t.length, s = o - 1, c = e; c != null && ++a < o;) {
					var l = ys(t[a]), u = r;
					if (l === "__proto__" || l === "constructor" || l === "prototype") return e;
					if (a != s) {
						var d = c[l];
						u = i ? i(d, l, c) : n, u === n && (u = X(d) ? d : Jo(t[a + 1]) ? [] : {});
					}
					ni(c, l, u), c = c[l];
				}
				return e;
			}
			var ga = Cn ? function(e, t) {
				return Cn.set(e, t), e;
			} : pf, _a = jt ? function(e, t) {
				return jt(e, "toString", {
					configurable: !0,
					enumerable: !1,
					value: lf(t),
					writable: !0
				});
			} : pf;
			function va(e) {
				return _s(Cd(e));
			}
			function ya(e, t, n) {
				var r = -1, i = e.length;
				t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
				for (var a = k(i); ++r < i;) a[r] = e[r + t];
				return a;
			}
			function ba(e, t) {
				var n;
				return hi(e, function(e, r, i) {
					return n = t(e, r, i), !n;
				}), !!n;
			}
			function xa(e, t, n) {
				var r = 0, i = e == null ? r : e.length;
				if (typeof t == "number" && t === t && i <= x) {
					for (; r < i;) {
						var a = r + i >>> 1, o = e[a];
						o !== null && !Cu(o) && (n ? o <= t : o < t) ? r = a + 1 : i = a;
					}
					return i;
				}
				return Sa(e, t, pf, n);
			}
			function Sa(e, t, r, i) {
				var a = 0, o = e == null ? 0 : e.length;
				if (o === 0) return 0;
				t = r(t);
				for (var s = t !== t, c = t === null, l = Cu(t), u = t === n; a < o;) {
					var d = It((a + o) / 2), f = r(e[d]), p = f !== n, m = f === null, h = f === f, g = Cu(f);
					if (s) var _ = i || h;
					else _ = u ? h && (i || p) : c ? h && p && (i || !m) : l ? h && p && !m && (i || !g) : m || g ? !1 : i ? f <= t : f < t;
					_ ? a = d + 1 : o = d;
				}
				return Gt(o, b);
			}
			function Ca(e, t) {
				for (var n = -1, r = e.length, i = 0, a = []; ++n < r;) {
					var o = e[n], s = t ? t(o) : o;
					if (!n || !Kl(s, c)) {
						var c = s;
						a[i++] = o === 0 ? 0 : o;
					}
				}
				return a;
			}
			function wa(e) {
				return typeof e == "number" ? e : Cu(e) ? v : +e;
			}
			function Ta(e) {
				if (typeof e == "string") return e;
				if (J(e)) return B(e, Ta) + "";
				if (Cu(e)) return _r ? _r.call(e) : "";
				var t = e + "";
				return t == "0" && 1 / e == -Infinity ? "-0" : t;
			}
			function Ea(e, t, n) {
				var r = -1, i = gn, a = e.length, o = !0, s = [], c = s;
				if (n) o = !1, i = _n;
				else if (a >= 200) {
					var l = t ? null : bo(e);
					if (l) return tr(l);
					o = !1, i = Vn, c = new Hr();
				} else c = t ? [] : s;
				outer: for (; ++r < a;) {
					var u = e[r], d = t ? t(u) : u;
					if (u = n || u !== 0 ? u : 0, o && d === d) {
						for (var f = c.length; f--;) if (c[f] === d) continue outer;
						t && c.push(d), s.push(u);
					} else i(c, d, n) || (c !== s && c.push(d), s.push(u));
				}
				return s;
			}
			function Da(e, t) {
				t = Fa(t, e);
				var n = -1, r = t.length;
				if (!r) return !0;
				for (; ++n < r;) {
					var i = ys(t[n]);
					if (i === "__proto__" && !N.call(e, "__proto__") || (i === "constructor" || i === "prototype") && n < r - 1) return !1;
				}
				var a = ls(e, t);
				return a == null || delete a[ys(qs(t))];
			}
			function Oa(e, t, n, r) {
				return ha(e, t, n(Di(e, t)), r);
			}
			function ka(e, t, n, r) {
				for (var i = e.length, a = r ? i : -1; (r ? a-- : ++a < i) && t(e[a], a, e););
				return n ? ya(e, r ? 0 : a, r ? a + 1 : i) : ya(e, r ? a + 1 : 0, r ? i : a);
			}
			function Aa(e, t) {
				var n = e;
				return n instanceof H && (n = n.value()), yn(t, function(e, t) {
					return t.func.apply(t.thisArg, vn([e], t.args));
				}, n);
			}
			function ja(e, t, n) {
				var r = e.length;
				if (r < 2) return r ? Ea(e[0]) : [];
				for (var i = -1, a = k(r); ++i < r;) for (var o = e[i], s = -1; ++s < r;) s != i && (a[i] = mi(a[i] || o, e[s], t, n));
				return Ea(xi(a, 1), t, n);
			}
			function Ma(e, t, r) {
				for (var i = -1, a = e.length, o = t.length, s = {}; ++i < a;) {
					var c = i < o ? t[i] : n;
					r(s, e[i], c);
				}
				return s;
			}
			function Na(e) {
				return Y(e) ? e : [];
			}
			function Pa(e) {
				return typeof e == "function" ? e : pf;
			}
			function Fa(e, t) {
				return J(e) ? e : Xo(e, t) ? [e] : vs($(e));
			}
			var Ia = U;
			function La(e, t, r) {
				var i = e.length;
				return r = r === n ? i : r, !t && r >= i ? e : ya(e, t, r);
			}
			var Ra = Mt || function(e) {
				return R.clearTimeout(e);
			};
			function za(e, t) {
				if (t) return e.slice();
				var n = e.length, r = Ct ? Ct(n) : new e.constructor(n);
				return e.copy(r), r;
			}
			function Ba(e) {
				var t = new e.constructor(e.byteLength);
				return new St(t).set(new St(e)), t;
			}
			function Va(e, t) {
				var n = t ? Ba(e.buffer) : e.buffer;
				return new e.constructor(n, e.byteOffset, e.byteLength);
			}
			function Ha(e) {
				var t = new e.constructor(e.source, Je.exec(e));
				return t.lastIndex = e.lastIndex, t;
			}
			function Ua(e) {
				return gr ? M(gr.call(e)) : {};
			}
			function Wa(e, t) {
				var n = t ? Ba(e.buffer) : e.buffer;
				return new e.constructor(n, e.byteOffset, e.length);
			}
			function Ga(e, t) {
				if (e !== t) {
					var r = e !== n, i = e === null, a = e === e, o = Cu(e), s = t !== n, c = t === null, l = t === t, u = Cu(t);
					if (!c && !u && !o && e > t || o && s && l && !c && !u || i && s && l || !r && l || !a) return 1;
					if (!i && !o && !u && e < t || u && r && a && !i && !o || c && r && a || !s && a || !l) return -1;
				}
				return 0;
			}
			function Ka(e, t, n) {
				for (var r = -1, i = e.criteria, a = t.criteria, o = i.length, s = n.length; ++r < o;) {
					var c = Ga(i[r], a[r]);
					if (c) return r >= s ? c : c * (n[r] == "desc" ? -1 : 1);
				}
				return e.index - t.index;
			}
			function qa(e, t, n, r) {
				for (var i = -1, a = e.length, o = n.length, s = -1, c = t.length, l = F(a - o, 0), u = k(c + l), d = !r; ++s < c;) u[s] = t[s];
				for (; ++i < o;) (d || i < a) && (u[n[i]] = e[i]);
				for (; l--;) u[s++] = e[i++];
				return u;
			}
			function Ja(e, t, n, r) {
				for (var i = -1, a = e.length, o = -1, s = n.length, c = -1, l = t.length, u = F(a - s, 0), d = k(u + l), f = !r; ++i < u;) d[i] = e[i];
				for (var p = i; ++c < l;) d[p + c] = t[c];
				for (; ++o < s;) (f || i < a) && (d[p + n[o]] = e[i++]);
				return d;
			}
			function Ya(e, t) {
				var n = -1, r = e.length;
				for (t ||= k(r); ++n < r;) t[n] = e[n];
				return t;
			}
			function W(e, t, r, i) {
				var a = !r;
				r ||= {};
				for (var o = -1, s = t.length; ++o < s;) {
					var c = t[o], l = i ? i(r[c], e[c], c, r, e) : n;
					l === n && (l = e[c]), a ? si(r, c, l) : ni(r, c, l);
				}
				return r;
			}
			function Xa(e, t) {
				return W(e, Ro(e), t);
			}
			function Za(e, t) {
				return W(e, zo(e), t);
			}
			function Qa(e, t) {
				return function(n, r) {
					var i = J(n) ? dn : ii, a = t ? t() : {};
					return i(n, e, K(r, 2), a);
				};
			}
			function $a(e) {
				return U(function(t, r) {
					var i = -1, a = r.length, o = a > 1 ? r[a - 1] : n, s = a > 2 ? r[2] : n;
					for (o = e.length > 3 && typeof o == "function" ? (a--, o) : n, s && Yo(r[0], r[1], s) && (o = a < 3 ? n : o, a = 1), t = M(t); ++i < a;) {
						var c = r[i];
						c && e(t, c, i, o);
					}
					return t;
				});
			}
			function eo(e, t) {
				return function(n, r) {
					if (n == null) return n;
					if (!Zl(n)) return e(n, r);
					for (var i = n.length, a = t ? i : -1, o = M(n); (t ? a-- : ++a < i) && r(o[a], a, o) !== !1;);
					return n;
				};
			}
			function to(e) {
				return function(t, n, r) {
					for (var i = -1, a = M(t), o = r(t), s = o.length; s--;) {
						var c = o[e ? s : ++i];
						if (n(a[c], c, a) === !1) break;
					}
					return t;
				};
			}
			function no(e, t, n) {
				var r = t & o, i = ao(e);
				function a() {
					return (this && this !== R && this instanceof a ? i : e).apply(r ? n : this, arguments);
				}
				return a;
			}
			function ro(e) {
				return function(t) {
					t = $(t);
					var r = Yn(t) ? or(t) : n, i = r ? r[0] : t.charAt(0), a = r ? La(r, 1).join("") : t.slice(1);
					return i[e]() + a;
				};
			}
			function io(e) {
				return function(t) {
					return yn(rf(Ad(t).replace(P, "")), e, "");
				};
			}
			function ao(e) {
				return function() {
					var t = arguments;
					switch (t.length) {
						case 0: return new e();
						case 1: return new e(t[0]);
						case 2: return new e(t[0], t[1]);
						case 3: return new e(t[0], t[1], t[2]);
						case 4: return new e(t[0], t[1], t[2], t[3]);
						case 5: return new e(t[0], t[1], t[2], t[3], t[4]);
						case 6: return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
						case 7: return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
					}
					var n = vr(e.prototype), r = e.apply(n, t);
					return X(r) ? r : n;
				};
			}
			function oo(e, t, r) {
				var i = ao(e);
				function a() {
					for (var o = arguments.length, s = k(o), c = o, l = No(a); c--;) s[c] = arguments[c];
					var u = o < 3 && s[0] !== l && s[o - 1] !== l ? [] : er(s, l);
					return o -= u.length, o < r ? vo(e, t, lo, a.placeholder, n, s, u, n, n, r - o) : z(this && this !== R && this instanceof a ? i : e, this, s);
				}
				return a;
			}
			function so(e) {
				return function(t, r, i) {
					var a = M(t);
					if (!Zl(t)) {
						var o = K(r, 3);
						t = id(t), r = function(e) {
							return o(a[e], e, a);
						};
					}
					var s = e(t, r, i);
					return s > -1 ? a[o ? t[s] : s] : n;
				};
			}
			function co(e) {
				return Oo(function(t) {
					var i = t.length, a = i, o = br.prototype.thru;
					for (e && t.reverse(); a--;) {
						var s = t[a];
						if (typeof s != "function") throw new ct(r);
						if (o && !l && Mo(s) == "wrapper") var l = new br([], !0);
					}
					for (a = l ? a : i; ++a < i;) {
						s = t[a];
						var d = Mo(s), m = d == "wrapper" ? jo(s) : n;
						l = m && Qo(m[0]) && m[1] == (f | c | u | p) && !m[4].length && m[9] == 1 ? l[Mo(m[0])].apply(l, m[3]) : s.length == 1 && Qo(s) ? l[d]() : l.thru(s);
					}
					return function() {
						var e = arguments, n = e[0];
						if (l && e.length == 1 && J(n)) return l.plant(n).value();
						for (var r = 0, a = i ? t[r].apply(this, e) : n; ++r < i;) a = t[r].call(this, a);
						return a;
					};
				});
			}
			function lo(e, t, r, i, a, u, d, p, h, g) {
				var _ = t & f, v = t & o, y = t & s, b = t & (c | l), x = t & m, S = y ? n : ao(e);
				function C() {
					for (var n = arguments.length, o = k(n), s = n; s--;) o[s] = arguments[s];
					if (b) var c = No(C), l = Wn(o, c);
					if (i && (o = qa(o, i, a, b)), u && (o = Ja(o, u, d, b)), n -= l, b && n < g) {
						var f = er(o, c);
						return vo(e, t, lo, C.placeholder, r, o, f, p, h, g - n);
					}
					var m = v ? r : this, w = y ? m[e] : e;
					return n = o.length, p ? o = us(o, p) : x && n > 1 && o.reverse(), _ && h < n && (o.length = h), this && this !== R && this instanceof C && (w = S || ao(w)), w.apply(m, o);
				}
				return C;
			}
			function uo(e, t) {
				return function(n, r) {
					return Fi(n, e, t(r), {});
				};
			}
			function fo(e, t) {
				return function(r, i) {
					var a;
					if (r === n && i === n) return t;
					if (r !== n && (a = r), i !== n) {
						if (a === n) return i;
						typeof r == "string" || typeof i == "string" ? (r = Ta(r), i = Ta(i)) : (r = wa(r), i = wa(i)), a = e(r, i);
					}
					return a;
				};
			}
			function po(e) {
				return Oo(function(t) {
					return t = B(t, zn(K())), U(function(n) {
						var r = this;
						return e(t, function(e) {
							return z(e, r, n);
						});
					});
				});
			}
			function mo(e, t) {
				t = t === n ? " " : Ta(t);
				var r = t.length;
				if (r < 2) return r ? fa(t, e) : t;
				var i = fa(t, Ft(e / ar(t)));
				return Yn(t) ? La(or(i), 0, e).join("") : i.slice(0, e);
			}
			function ho(e, t, n, r) {
				var i = t & o, a = ao(e);
				function s() {
					for (var t = -1, o = arguments.length, c = -1, l = r.length, u = k(l + o), d = this && this !== R && this instanceof s ? a : e; ++c < l;) u[c] = r[c];
					for (; o--;) u[c++] = arguments[++t];
					return z(d, i ? n : this, u);
				}
				return s;
			}
			function go(e) {
				return function(t, r, i) {
					return i && typeof i != "number" && Yo(t, r, i) && (r = i = n), t = ju(t), r === n ? (r = t, t = 0) : r = ju(r), i = i === n ? t < r ? 1 : -1 : ju(i), da(t, r, i, e);
				};
			}
			function _o(e) {
				return function(t, n) {
					return (typeof t != "string" || typeof n != "string") && (t = Nu(t), n = Nu(n)), e(t, n);
				};
			}
			function vo(e, t, r, i, a, l, f, p, m, h) {
				var g = t & c, _ = g ? f : n, v = g ? n : f, y = g ? l : n, b = g ? n : l;
				t |= g ? u : d, t &= ~(g ? d : u), t & 4 || (t &= ~(o | s));
				var x = [
					e,
					t,
					a,
					y,
					_,
					b,
					v,
					p,
					m,
					h
				], S = r.apply(n, x);
				return Qo(e) && fs(S, x), S.placeholder = i, hs(S, e, t);
			}
			function yo(e) {
				var t = at[e];
				return function(e, n) {
					if (e = Nu(e), n = n == null ? 0 : Gt(Q(n), 292), n && Bt(e)) {
						var r = ($(e) + "e").split("e");
						return r = ($(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"), +(r[0] + "e" + (+r[1] - n));
					}
					return t(e);
				};
			}
			var bo = nn && 1 / tr(new nn([, -0]))[1] == h ? function(e) {
				return new nn(e);
			} : xf;
			function xo(e) {
				return function(t) {
					var n = Bo(t);
					return n == se ? Qn(t) : n == E ? nr(t) : Ln(t, e(t));
				};
			}
			function G(e, t, i, a, f, p, m, h) {
				var g = t & s;
				if (!g && typeof e != "function") throw new ct(r);
				var _ = a ? a.length : 0;
				if (_ || (t &= ~(u | d), a = f = n), m = m === n ? m : F(Q(m), 0), h = h === n ? h : Q(h), _ -= f ? f.length : 0, t & d) {
					var v = a, y = f;
					a = f = n;
				}
				var b = g ? n : jo(e), x = [
					e,
					t,
					i,
					a,
					f,
					v,
					y,
					p,
					m,
					h
				];
				if (b && as(x, b), e = x[0], t = x[1], i = x[2], a = x[3], f = x[4], h = x[9] = x[9] === n ? g ? 0 : e.length : F(x[9] - _, 0), !h && t & (c | l) && (t &= ~(c | l)), !t || t == o) var S = no(e, t, i);
				else S = t == c || t == l ? oo(e, t, h) : (t == u || t == (o | u)) && !f.length ? ho(e, t, i, a) : lo.apply(n, x);
				return hs((b ? ga : fs)(S, x), e, t);
			}
			function So(e, t, r, i) {
				return e === n || Kl(e, dt[r]) && !N.call(i, r) ? t : e;
			}
			function Co(e, t, r, i, a, o) {
				return X(e) && X(t) && (o.set(t, e), ta(e, t, n, Co, o), o.delete(t)), e;
			}
			function wo(e) {
				return vu(e) ? n : e;
			}
			function To(e, t, r, i, a, o) {
				var s = r & 1, c = e.length, l = t.length;
				if (c != l && !(s && l > c)) return !1;
				var u = o.get(e), d = o.get(t);
				if (u && d) return u == t && d == e;
				var f = -1, p = !0, m = r & 2 ? new Hr() : n;
				for (o.set(e, t), o.set(t, e); ++f < c;) {
					var h = e[f], g = t[f];
					if (i) var _ = s ? i(g, h, f, t, e, o) : i(h, g, f, e, t, o);
					if (_ !== n) {
						if (_) continue;
						p = !1;
						break;
					}
					if (m) {
						if (!xn(t, function(e, t) {
							if (!Vn(m, t) && (h === e || a(h, e, r, i, o))) return m.push(t);
						})) {
							p = !1;
							break;
						}
					} else if (!(h === g || a(h, g, r, i, o))) {
						p = !1;
						break;
					}
				}
				return o.delete(e), o.delete(t), p;
			}
			function Eo(e, t, n, r, i, a, o) {
				switch (n) {
					case ye:
						if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
						e = e.buffer, t = t.buffer;
					case ve: return !(e.byteLength != t.byteLength || !a(new St(e), new St(t)));
					case te:
					case ne:
					case ce: return Kl(+e, +t);
					case ie: return e.name == t.name && e.message == t.message;
					case fe:
					case pe: return e == t + "";
					case se: var s = Qn;
					case E:
						var c = r & 1;
						if (s ||= tr, e.size != t.size && !c) return !1;
						var l = o.get(e);
						if (l) return l == t;
						r |= 2, o.set(e, t);
						var u = To(s(e), s(t), r, i, a, o);
						return o.delete(e), u;
					case me: if (gr) return gr.call(e) == gr.call(t);
				}
				return !1;
			}
			function Do(e, t, r, i, a, o) {
				var s = r & 1, c = ko(e), l = c.length;
				if (l != ko(t).length && !s) return !1;
				for (var u = l; u--;) {
					var d = c[u];
					if (!(s ? d in t : N.call(t, d))) return !1;
				}
				var f = o.get(e), p = o.get(t);
				if (f && p) return f == t && p == e;
				var m = !0;
				o.set(e, t), o.set(t, e);
				for (var h = s; ++u < l;) {
					d = c[u];
					var g = e[d], _ = t[d];
					if (i) var v = s ? i(_, g, d, t, e, o) : i(g, _, d, e, t, o);
					if (!(v === n ? g === _ || a(g, _, r, i, o) : v)) {
						m = !1;
						break;
					}
					h ||= d == "constructor";
				}
				if (m && !h) {
					var y = e.constructor, b = t.constructor;
					y != b && "constructor" in e && "constructor" in t && !(typeof y == "function" && y instanceof y && typeof b == "function" && b instanceof b) && (m = !1);
				}
				return o.delete(e), o.delete(t), m;
			}
			function Oo(e) {
				return ms(cs(e, n, Is), e + "");
			}
			function ko(e) {
				return Oi(e, id, Ro);
			}
			function Ao(e) {
				return Oi(e, ad, zo);
			}
			var jo = Cn ? function(e) {
				return Cn.get(e);
			} : xf;
			function Mo(e) {
				for (var t = e.name + "", n = Mn[t], r = N.call(Mn, t) ? n.length : 0; r--;) {
					var i = n[r], a = i.func;
					if (a == null || a == e) return i.name;
				}
				return t;
			}
			function No(e) {
				return (N.call(V, "placeholder") ? V : e).placeholder;
			}
			function K() {
				var e = V.iteratee || mf;
				return e = e === mf ? Ji : e, arguments.length ? e(arguments[0], arguments[1]) : e;
			}
			function Po(e, t) {
				var n = e.__data__;
				return Zo(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
			}
			function Fo(e) {
				for (var t = id(e), n = t.length; n--;) {
					var r = t[n], i = e[r];
					t[n] = [
						r,
						i,
						ns(i)
					];
				}
				return t;
			}
			function Io(e, t) {
				var r = Jn(e, t);
				return Wi(r) ? r : n;
			}
			function Lo(e) {
				var t = N.call(e, At), r = e[At];
				try {
					e[At] = n;
					var i = !0;
				} catch {}
				var a = gt.call(e);
				return i && (t ? e[At] = r : delete e[At]), a;
			}
			var Ro = Lt ? function(e) {
				return e == null ? [] : (e = M(e), hn(Lt(e), function(t) {
					return Et.call(e, t);
				}));
			} : Af, zo = Lt ? function(e) {
				for (var t = []; e;) vn(t, Ro(e)), e = wt(e);
				return t;
			} : Af, Bo = ki;
			(Qt && Bo(new Qt(/* @__PURE__ */ new ArrayBuffer(1))) != ye || $t && Bo(new $t()) != se || en && Bo(en.resolve()) != T || nn && Bo(new nn()) != E || rn && Bo(new rn()) != ge) && (Bo = function(e) {
				var t = ki(e), r = t == ue ? e.constructor : n, i = r ? bs(r) : "";
				if (i) switch (i) {
					case rr: return ye;
					case lr: return se;
					case ur: return T;
					case pr: return E;
					case mr: return ge;
				}
				return t;
			});
			function q(e, t, n) {
				for (var r = -1, i = n.length; ++r < i;) {
					var a = n[r], o = a.size;
					switch (a.type) {
						case "drop":
							e += o;
							break;
						case "dropRight":
							t -= o;
							break;
						case "take":
							t = Gt(t, e + o);
							break;
						case "takeRight": e = F(e, t - o);
					}
				}
				return {
					start: e,
					end: t
				};
			}
			function Vo(e) {
				var t = e.match(A);
				return t ? t[1].split(We) : [];
			}
			function Ho(e, t, n) {
				t = Fa(t, e);
				for (var r = -1, i = t.length, a = !1; ++r < i;) {
					var o = ys(t[r]);
					if (!(a = e != null && n(e, o))) break;
					e = e[o];
				}
				return a || ++r != i ? a : (i = e == null ? 0 : e.length, !!i && lu(i) && Jo(o, i) && (J(e) || Yl(e)));
			}
			function Uo(e) {
				var t = e.length, n = new e.constructor(t);
				return t && typeof e[0] == "string" && N.call(e, "index") && (n.index = e.index, n.input = e.input), n;
			}
			function Wo(e) {
				return typeof e.constructor == "function" && !ts(e) ? vr(wt(e)) : {};
			}
			function Go(e, t, n) {
				var r = e.constructor;
				switch (t) {
					case ve: return Ba(e);
					case te:
					case ne: return new r(+e);
					case ye: return Va(e, n);
					case be:
					case xe:
					case Se:
					case Ce:
					case we:
					case Te:
					case Ee:
					case De:
					case Oe: return Wa(e, n);
					case se: return new r();
					case ce:
					case pe: return new r(e);
					case fe: return Ha(e);
					case E: return new r();
					case me: return Ua(e);
				}
			}
			function Ko(e, t) {
				var n = t.length;
				if (!n) return e;
				var r = n - 1;
				return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(Ue, "{\n/* [wrapped with " + t + "] */\n");
			}
			function qo(e) {
				return J(e) || Yl(e) || !!(Ot && e && e[Ot]);
			}
			function Jo(e, t) {
				var n = typeof e;
				return t ??= g, !!t && (n == "number" || n != "symbol" && $e.test(e)) && e > -1 && e % 1 == 0 && e < t;
			}
			function Yo(e, t, n) {
				if (!X(n)) return !1;
				var r = typeof t;
				return (r == "number" ? Zl(n) && Jo(t, n.length) : r == "string" && t in n) ? Kl(n[t], e) : !1;
			}
			function Xo(e, t) {
				if (J(e)) return !1;
				var n = typeof e;
				return n == "number" || n == "symbol" || n == "boolean" || e == null || Cu(e) ? !0 : O.test(e) || !Re.test(e) || t != null && e in M(t);
			}
			function Zo(e) {
				var t = typeof e;
				return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
			}
			function Qo(e) {
				var t = Mo(e), n = V[t];
				if (typeof n != "function" || !(t in H.prototype)) return !1;
				if (e === n) return !0;
				var r = jo(n);
				return !!r && e === r[0];
			}
			function $o(e) {
				return !!ht && ht in e;
			}
			var es = ft ? su : jf;
			function ts(e) {
				var t = e && e.constructor;
				return e === (typeof t == "function" && t.prototype || dt);
			}
			function ns(e) {
				return e === e && !X(e);
			}
			function rs(e, t) {
				return function(r) {
					return r != null && r[e] === t && (t !== n || e in M(r));
				};
			}
			function is(e) {
				var t = Ol(e, function(e) {
					return n.size === 500 && n.clear(), e;
				}), n = t.cache;
				return t;
			}
			function as(e, t) {
				var n = e[1], r = t[1], i = n | r, l = i < (o | s | f), u = r == f && n == c || r == f && n == p && e[7].length <= t[8] || r == (f | p) && t[7].length <= t[8] && n == c;
				if (!(l || u)) return e;
				r & o && (e[2] = t[2], i |= n & o ? 0 : 4);
				var d = t[3];
				if (d) {
					var m = e[3];
					e[3] = m ? qa(m, d, t[4]) : d, e[4] = m ? er(e[3], a) : t[4];
				}
				return d = t[5], d && (m = e[5], e[5] = m ? Ja(m, d, t[6]) : d, e[6] = m ? er(e[5], a) : t[6]), d = t[7], d && (e[7] = d), r & f && (e[8] = e[8] == null ? t[8] : Gt(e[8], t[8])), e[9] ??= t[9], e[0] = t[0], e[1] = i, e;
			}
			function os(e) {
				var t = [];
				if (e != null) for (var n in M(e)) t.push(n);
				return t;
			}
			function ss(e) {
				return gt.call(e);
			}
			function cs(e, t, r) {
				return t = F(t === n ? e.length - 1 : t, 0), function() {
					for (var n = arguments, i = -1, a = F(n.length - t, 0), o = k(a); ++i < a;) o[i] = n[t + i];
					i = -1;
					for (var s = k(t + 1); ++i < t;) s[i] = n[i];
					return s[t] = r(o), z(e, this, s);
				};
			}
			function ls(e, t) {
				return t.length < 2 ? e : Di(e, ya(t, 0, -1));
			}
			function us(e, t) {
				for (var r = e.length, i = Gt(t.length, r), a = Ya(e); i--;) {
					var o = t[i];
					e[i] = Jo(o, r) ? a[o] : n;
				}
				return e;
			}
			function ds(e, t) {
				if ((t !== "constructor" || typeof e[t] != "function") && t != "__proto__") return e[t];
			}
			var fs = gs(ga), ps = Pt || function(e, t) {
				return R.setTimeout(e, t);
			}, ms = gs(_a);
			function hs(e, t, n) {
				var r = t + "";
				return ms(e, Ko(r, xs(Vo(r), n)));
			}
			function gs(e) {
				var t = 0, r = 0;
				return function() {
					var i = Kt(), a = 16 - (i - r);
					if (r = i, a > 0) {
						if (++t >= 800) return arguments[0];
					} else t = 0;
					return e.apply(n, arguments);
				};
			}
			function _s(e, t) {
				var r = -1, i = e.length, a = i - 1;
				for (t = t === n ? i : t; ++r < t;) {
					var o = ua(r, a), s = e[o];
					e[o] = e[r], e[r] = s;
				}
				return e.length = t, e;
			}
			var vs = is(function(e) {
				var t = [];
				return e.charCodeAt(0) === 46 && t.push(""), e.replace(ze, function(e, n, r, i) {
					t.push(r ? i.replace(Ke, "$1") : n || e);
				}), t;
			});
			function ys(e) {
				if (typeof e == "string" || Cu(e)) return e;
				var t = e + "";
				return t == "0" && 1 / e == -Infinity ? "-0" : t;
			}
			function bs(e) {
				if (e != null) {
					try {
						return pt.call(e);
					} catch {}
					try {
						return e + "";
					} catch {}
				}
				return "";
			}
			function xs(e, t) {
				return fn(S, function(n) {
					var r = "_." + n[0];
					t & n[1] && !gn(e, r) && e.push(r);
				}), e.sort();
			}
			function Ss(e) {
				if (e instanceof H) return e.clone();
				var t = new br(e.__wrapped__, e.__chain__);
				return t.__actions__ = Ya(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
			}
			function Cs(e, t, r) {
				t = (r ? Yo(e, t, r) : t === n) ? 1 : F(Q(t), 0);
				var i = e == null ? 0 : e.length;
				if (!i || t < 1) return [];
				for (var a = 0, o = 0, s = k(Ft(i / t)); a < i;) s[o++] = ya(e, a, a += t);
				return s;
			}
			function ws(e) {
				for (var t = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++t < n;) {
					var a = e[t];
					a && (i[r++] = a);
				}
				return i;
			}
			function Ts() {
				var e = arguments.length;
				if (!e) return [];
				for (var t = k(e - 1), n = arguments[0], r = e; r--;) t[r - 1] = arguments[r];
				return vn(J(n) ? Ya(n) : [n], xi(t, 1));
			}
			var Es = U(function(e, t) {
				return Y(e) ? mi(e, xi(t, 1, Y, !0)) : [];
			}), Ds = U(function(e, t) {
				var r = qs(t);
				return Y(r) && (r = n), Y(e) ? mi(e, xi(t, 1, Y, !0), K(r, 2)) : [];
			}), Os = U(function(e, t) {
				var r = qs(t);
				return Y(r) && (r = n), Y(e) ? mi(e, xi(t, 1, Y, !0), n, r) : [];
			});
			function ks(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (t = r || t === n ? 1 : Q(t), ya(e, t < 0 ? 0 : t, i)) : [];
			}
			function As(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (t = r || t === n ? 1 : Q(t), t = i - t, ya(e, 0, t < 0 ? 0 : t)) : [];
			}
			function js(e, t) {
				return e && e.length ? ka(e, K(t, 3), !0, !0) : [];
			}
			function Ms(e, t) {
				return e && e.length ? ka(e, K(t, 3), !0) : [];
			}
			function Ns(e, t, n, r) {
				var i = e == null ? 0 : e.length;
				return i ? (n && typeof n != "number" && Yo(e, t, n) && (n = 0, r = i), yi(e, t, n, r)) : [];
			}
			function Ps(e, t, n) {
				var r = e == null ? 0 : e.length;
				if (!r) return -1;
				var i = n == null ? 0 : Q(n);
				return i < 0 && (i = F(r + i, 0)), En(e, K(t, 3), i);
			}
			function Fs(e, t, r) {
				var i = e == null ? 0 : e.length;
				if (!i) return -1;
				var a = i - 1;
				return r !== n && (a = Q(r), a = r < 0 ? F(i + a, 0) : Gt(a, i - 1)), En(e, K(t, 3), a, !0);
			}
			function Is(e) {
				return e != null && e.length ? xi(e, 1) : [];
			}
			function Ls(e) {
				return e != null && e.length ? xi(e, h) : [];
			}
			function Rs(e, t) {
				return e != null && e.length ? (t = t === n ? 1 : Q(t), xi(e, t)) : [];
			}
			function zs(e) {
				for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n;) {
					var i = e[t];
					si(r, i[0], i[1]);
				}
				return r;
			}
			function Bs(e) {
				return e && e.length ? e[0] : n;
			}
			function Vs(e, t, n) {
				var r = e == null ? 0 : e.length;
				if (!r) return -1;
				var i = n == null ? 0 : Q(n);
				return i < 0 && (i = F(r + i, 0)), Dn(e, t, i);
			}
			function Hs(e) {
				return e != null && e.length ? ya(e, 0, -1) : [];
			}
			var Us = U(function(e) {
				var t = B(e, Na);
				return t.length && t[0] === e[0] ? Pi(t) : [];
			}), Ws = U(function(e) {
				var t = qs(e), r = B(e, Na);
				return t === qs(r) ? t = n : r.pop(), r.length && r[0] === e[0] ? Pi(r, K(t, 2)) : [];
			}), Gs = U(function(e) {
				var t = qs(e), r = B(e, Na);
				return t = typeof t == "function" ? t : n, t && r.pop(), r.length && r[0] === e[0] ? Pi(r, n, t) : [];
			});
			function Ks(e, t) {
				return e == null ? "" : Vt.call(e, t);
			}
			function qs(e) {
				var t = e == null ? 0 : e.length;
				return t ? e[t - 1] : n;
			}
			function Js(e, t, r) {
				var i = e == null ? 0 : e.length;
				if (!i) return -1;
				var a = i;
				return r !== n && (a = Q(r), a = a < 0 ? F(i + a, 0) : Gt(a, i - 1)), t === t ? ir(e, t, a) : En(e, kn, a, !0);
			}
			function Ys(e, t) {
				return e && e.length ? ra(e, Q(t)) : n;
			}
			var Xs = U(Zs);
			function Zs(e, t) {
				return e && e.length && t && t.length ? ca(e, t) : e;
			}
			function Qs(e, t, n) {
				return e && e.length && t && t.length ? ca(e, t, K(n, 2)) : e;
			}
			function $s(e, t, r) {
				return e && e.length && t && t.length ? ca(e, t, n, r) : e;
			}
			var ec = Oo(function(e, t) {
				var n = e == null ? 0 : e.length, r = ci(e, t);
				return la(e, B(t, function(e) {
					return Jo(e, n) ? +e : e;
				}).sort(Ga)), r;
			});
			function tc(e, t) {
				var n = [];
				if (!(e && e.length)) return n;
				var r = -1, i = [], a = e.length;
				for (t = K(t, 3); ++r < a;) {
					var o = e[r];
					t(o, r, e) && (n.push(o), i.push(r));
				}
				return la(e, i), n;
			}
			function nc(e) {
				return e == null ? e : Zt.call(e);
			}
			function rc(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (r && typeof r != "number" && Yo(e, t, r) ? (t = 0, r = i) : (t = t == null ? 0 : Q(t), r = r === n ? i : Q(r)), ya(e, t, r)) : [];
			}
			function ic(e, t) {
				return xa(e, t);
			}
			function ac(e, t, n) {
				return Sa(e, t, K(n, 2));
			}
			function oc(e, t) {
				var n = e == null ? 0 : e.length;
				if (n) {
					var r = xa(e, t);
					if (r < n && Kl(e[r], t)) return r;
				}
				return -1;
			}
			function sc(e, t) {
				return xa(e, t, !0);
			}
			function cc(e, t, n) {
				return Sa(e, t, K(n, 2), !0);
			}
			function lc(e, t) {
				if (e != null && e.length) {
					var n = xa(e, t, !0) - 1;
					if (Kl(e[n], t)) return n;
				}
				return -1;
			}
			function uc(e) {
				return e && e.length ? Ca(e) : [];
			}
			function dc(e, t) {
				return e && e.length ? Ca(e, K(t, 2)) : [];
			}
			function fc(e) {
				var t = e == null ? 0 : e.length;
				return t ? ya(e, 1, t) : [];
			}
			function pc(e, t, r) {
				return e && e.length ? (t = r || t === n ? 1 : Q(t), ya(e, 0, t < 0 ? 0 : t)) : [];
			}
			function mc(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (t = r || t === n ? 1 : Q(t), t = i - t, ya(e, t < 0 ? 0 : t, i)) : [];
			}
			function hc(e, t) {
				return e && e.length ? ka(e, K(t, 3), !1, !0) : [];
			}
			function gc(e, t) {
				return e && e.length ? ka(e, K(t, 3)) : [];
			}
			var _c = U(function(e) {
				return Ea(xi(e, 1, Y, !0));
			}), vc = U(function(e) {
				var t = qs(e);
				return Y(t) && (t = n), Ea(xi(e, 1, Y, !0), K(t, 2));
			}), yc = U(function(e) {
				var t = qs(e);
				return t = typeof t == "function" ? t : n, Ea(xi(e, 1, Y, !0), n, t);
			});
			function bc(e) {
				return e && e.length ? Ea(e) : [];
			}
			function xc(e, t) {
				return e && e.length ? Ea(e, K(t, 2)) : [];
			}
			function Sc(e, t) {
				return t = typeof t == "function" ? t : n, e && e.length ? Ea(e, n, t) : [];
			}
			function Cc(e) {
				if (!(e && e.length)) return [];
				var t = 0;
				return e = hn(e, function(e) {
					if (Y(e)) return t = F(e.length, t), !0;
				}), In(t, function(t) {
					return B(e, jn(t));
				});
			}
			function wc(e, t) {
				if (!(e && e.length)) return [];
				var r = Cc(e);
				return t == null ? r : B(r, function(e) {
					return z(t, n, e);
				});
			}
			var Tc = U(function(e, t) {
				return Y(e) ? mi(e, t) : [];
			}), Ec = U(function(e) {
				return ja(hn(e, Y));
			}), Dc = U(function(e) {
				var t = qs(e);
				return Y(t) && (t = n), ja(hn(e, Y), K(t, 2));
			}), Oc = U(function(e) {
				var t = qs(e);
				return t = typeof t == "function" ? t : n, ja(hn(e, Y), n, t);
			}), kc = U(Cc);
			function Ac(e, t) {
				return Ma(e || [], t || [], ni);
			}
			function jc(e, t) {
				return Ma(e || [], t || [], ha);
			}
			var Mc = U(function(e) {
				var t = e.length, r = t > 1 ? e[t - 1] : n;
				return r = typeof r == "function" ? (e.pop(), r) : n, wc(e, r);
			});
			function Nc(e) {
				var t = V(e);
				return t.__chain__ = !0, t;
			}
			function Pc(e, t) {
				return t(e), e;
			}
			function Fc(e, t) {
				return t(e);
			}
			var Ic = Oo(function(e) {
				var t = e.length, r = t ? e[0] : 0, i = this.__wrapped__, a = function(t) {
					return ci(t, e);
				};
				return t > 1 || this.__actions__.length || !(i instanceof H) || !Jo(r) ? this.thru(a) : (i = i.slice(r, +r + +!!t), i.__actions__.push({
					func: Fc,
					args: [a],
					thisArg: n
				}), new br(i, this.__chain__).thru(function(e) {
					return t && !e.length && e.push(n), e;
				}));
			});
			function Lc() {
				return Nc(this);
			}
			function Rc() {
				return new br(this.value(), this.__chain__);
			}
			function zc() {
				this.__values__ === n && (this.__values__ = Au(this.value()));
				var e = this.__index__ >= this.__values__.length;
				return {
					done: e,
					value: e ? n : this.__values__[this.__index__++]
				};
			}
			function Bc() {
				return this;
			}
			function Vc(e) {
				for (var t, r = this; r instanceof yr;) {
					var i = Ss(r);
					i.__index__ = 0, i.__values__ = n, t ? a.__wrapped__ = i : t = i;
					var a = i;
					r = r.__wrapped__;
				}
				return a.__wrapped__ = e, t;
			}
			function Hc() {
				var e = this.__wrapped__;
				if (e instanceof H) {
					var t = e;
					return this.__actions__.length && (t = new H(this)), t = t.reverse(), t.__actions__.push({
						func: Fc,
						args: [nc],
						thisArg: n
					}), new br(t, this.__chain__);
				}
				return this.thru(nc);
			}
			function Uc() {
				return Aa(this.__wrapped__, this.__actions__);
			}
			var Wc = Qa(function(e, t, n) {
				N.call(e, n) ? ++e[n] : si(e, n, 1);
			});
			function Gc(e, t, r) {
				var i = J(e) ? mn : _i;
				return r && Yo(e, t, r) && (t = n), i(e, K(t, 3));
			}
			function Kc(e, t) {
				return (J(e) ? hn : bi)(e, K(t, 3));
			}
			var qc = so(Ps), Jc = so(Fs);
			function Yc(e, t) {
				return xi(il(e, t), 1);
			}
			function Xc(e, t) {
				return xi(il(e, t), h);
			}
			function Zc(e, t, r) {
				return r = r === n ? 1 : Q(r), xi(il(e, t), r);
			}
			function Qc(e, t) {
				return (J(e) ? fn : hi)(e, K(t, 3));
			}
			function $c(e, t) {
				return (J(e) ? pn : gi)(e, K(t, 3));
			}
			var el = Qa(function(e, t, n) {
				N.call(e, n) ? e[n].push(t) : si(e, n, [t]);
			});
			function tl(e, t, n, r) {
				e = Zl(e) ? e : Cd(e), n = n && !r ? Q(n) : 0;
				var i = e.length;
				return n < 0 && (n = F(i + n, 0)), Su(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && Dn(e, t, n) > -1;
			}
			var nl = U(function(e, t, n) {
				var r = -1, i = typeof t == "function", a = Zl(e) ? k(e.length) : [];
				return hi(e, function(e) {
					a[++r] = i ? z(t, e, n) : Ii(e, t, n);
				}), a;
			}), rl = Qa(function(e, t, n) {
				si(e, n, t);
			});
			function il(e, t) {
				return (J(e) ? B : Qi)(e, K(t, 3));
			}
			function al(e, t, r, i) {
				return e == null ? [] : (J(t) || (t = t == null ? [] : [t]), r = i ? n : r, J(r) || (r = r == null ? [] : [r]), ia(e, t, r));
			}
			var ol = Qa(function(e, t, n) {
				e[+!n].push(t);
			}, function() {
				return [[], []];
			});
			function sl(e, t, n) {
				var r = J(e) ? yn : Nn, i = arguments.length < 3;
				return r(e, K(t, 4), n, i, hi);
			}
			function cl(e, t, n) {
				var r = J(e) ? bn : Nn, i = arguments.length < 3;
				return r(e, K(t, 4), n, i, gi);
			}
			function ll(e, t) {
				return (J(e) ? hn : bi)(e, kl(K(t, 3)));
			}
			function ul(e) {
				return (J(e) ? Qr : pa)(e);
			}
			function dl(e, t, r) {
				return t = (r ? Yo(e, t, r) : t === n) ? 1 : Q(t), (J(e) ? $r : ma)(e, t);
			}
			function fl(e) {
				return (J(e) ? ei : va)(e);
			}
			function pl(e) {
				if (e == null) return 0;
				if (Zl(e)) return Su(e) ? ar(e) : e.length;
				var t = Bo(e);
				return t == se || t == E ? e.size : Yi(e).length;
			}
			function ml(e, t, r) {
				var i = J(e) ? xn : ba;
				return r && Yo(e, t, r) && (t = n), i(e, K(t, 3));
			}
			var hl = U(function(e, t) {
				if (e == null) return [];
				var n = t.length;
				return n > 1 && Yo(e, t[0], t[1]) ? t = [] : n > 2 && Yo(t[0], t[1], t[2]) && (t = [t[0]]), ia(e, xi(t, 1), []);
			}), gl = Nt || function() {
				return R.Date.now();
			};
			function _l(e, t) {
				if (typeof t != "function") throw new ct(r);
				return e = Q(e), function() {
					if (--e < 1) return t.apply(this, arguments);
				};
			}
			function vl(e, t, r) {
				return t = r ? n : t, t = e && t == null ? e.length : t, G(e, f, n, n, n, n, t);
			}
			function yl(e, t) {
				var i;
				if (typeof t != "function") throw new ct(r);
				return e = Q(e), function() {
					return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = n), i;
				};
			}
			var bl = U(function(e, t, n) {
				var r = o;
				if (n.length) {
					var i = er(n, No(bl));
					r |= u;
				}
				return G(e, r, t, n, i);
			}), xl = U(function(e, t, n) {
				var r = o | s;
				if (n.length) {
					var i = er(n, No(xl));
					r |= u;
				}
				return G(t, r, e, n, i);
			});
			function Sl(e, t, r) {
				t = r ? n : t;
				var i = G(e, c, n, n, n, n, n, t);
				return i.placeholder = Sl.placeholder, i;
			}
			function Cl(e, t, r) {
				t = r ? n : t;
				var i = G(e, l, n, n, n, n, n, t);
				return i.placeholder = Cl.placeholder, i;
			}
			function wl(e, t, i) {
				var a, o, s, c, l, u, d = 0, f = !1, p = !1, m = !0;
				if (typeof e != "function") throw new ct(r);
				t = Nu(t) || 0, X(i) && (f = !!i.leading, p = "maxWait" in i, s = p ? F(Nu(i.maxWait) || 0, t) : s, m = "trailing" in i ? !!i.trailing : m);
				function h(t) {
					var r = a, i = o;
					return a = o = n, d = t, c = e.apply(i, r), c;
				}
				function g(e) {
					return d = e, l = ps(y, t), f ? h(e) : c;
				}
				function _(e) {
					var n = e - u, r = e - d, i = t - n;
					return p ? Gt(i, s - r) : i;
				}
				function v(e) {
					var r = e - u, i = e - d;
					return u === n || r >= t || r < 0 || p && i >= s;
				}
				function y() {
					var e = gl();
					if (v(e)) return b(e);
					l = ps(y, _(e));
				}
				function b(e) {
					return l = n, m && a ? h(e) : (a = o = n, c);
				}
				function x() {
					l !== n && Ra(l), d = 0, a = u = o = l = n;
				}
				function S() {
					return l === n ? c : b(gl());
				}
				function C() {
					var e = gl(), r = v(e);
					if (a = arguments, o = this, u = e, r) {
						if (l === n) return g(u);
						if (p) return Ra(l), l = ps(y, t), h(u);
					}
					return l === n && (l = ps(y, t)), c;
				}
				return C.cancel = x, C.flush = S, C;
			}
			var Tl = U(function(e, t) {
				return pi(e, 1, t);
			}), El = U(function(e, t, n) {
				return pi(e, Nu(t) || 0, n);
			});
			function Dl(e) {
				return G(e, m);
			}
			function Ol(e, t) {
				if (typeof e != "function" || t != null && typeof t != "function") throw new ct(r);
				var n = function() {
					var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
					if (a.has(i)) return a.get(i);
					var o = e.apply(this, r);
					return n.cache = a.set(i, o) || a, o;
				};
				return n.cache = new (Ol.Cache || Ir)(), n;
			}
			Ol.Cache = Ir;
			function kl(e) {
				if (typeof e != "function") throw new ct(r);
				return function() {
					var t = arguments;
					switch (t.length) {
						case 0: return !e.call(this);
						case 1: return !e.call(this, t[0]);
						case 2: return !e.call(this, t[0], t[1]);
						case 3: return !e.call(this, t[0], t[1], t[2]);
					}
					return !e.apply(this, t);
				};
			}
			function Al(e) {
				return yl(2, e);
			}
			var jl = Ia(function(e, t) {
				t = t.length == 1 && J(t[0]) ? B(t[0], zn(K())) : B(xi(t, 1), zn(K()));
				var n = t.length;
				return U(function(r) {
					for (var i = -1, a = Gt(r.length, n); ++i < a;) r[i] = t[i].call(this, r[i]);
					return z(e, this, r);
				});
			}), Ml = U(function(e, t) {
				return G(e, u, n, t, er(t, No(Ml)));
			}), Nl = U(function(e, t) {
				return G(e, d, n, t, er(t, No(Nl)));
			}), Pl = Oo(function(e, t) {
				return G(e, p, n, n, n, t);
			});
			function Fl(e, t) {
				if (typeof e != "function") throw new ct(r);
				return t = t === n ? t : Q(t), U(e, t);
			}
			function Il(e, t) {
				if (typeof e != "function") throw new ct(r);
				return t = t == null ? 0 : F(Q(t), 0), U(function(n) {
					var r = n[t], i = La(n, 0, t);
					return r && vn(i, r), z(e, this, i);
				});
			}
			function Ll(e, t, n) {
				var i = !0, a = !0;
				if (typeof e != "function") throw new ct(r);
				return X(n) && (i = "leading" in n ? !!n.leading : i, a = "trailing" in n ? !!n.trailing : a), wl(e, t, {
					leading: i,
					maxWait: t,
					trailing: a
				});
			}
			function Rl(e) {
				return vl(e, 1);
			}
			function zl(e, t) {
				return Ml(Pa(t), e);
			}
			function Bl() {
				if (!arguments.length) return [];
				var e = arguments[0];
				return J(e) ? e : [e];
			}
			function Vl(e) {
				return ui(e, 4);
			}
			function Hl(e, t) {
				return t = typeof t == "function" ? t : n, ui(e, 4, t);
			}
			function Ul(e) {
				return ui(e, 5);
			}
			function Wl(e, t) {
				return t = typeof t == "function" ? t : n, ui(e, 5, t);
			}
			function Gl(e, t) {
				return t == null || fi(e, t, id(t));
			}
			function Kl(e, t) {
				return e === t || e !== e && t !== t;
			}
			var ql = _o(Ai), Jl = _o(function(e, t) {
				return e >= t;
			}), Yl = Li(function() {
				return arguments;
			}()) ? Li : function(e) {
				return Z(e) && N.call(e, "callee") && !Et.call(e, "callee");
			}, J = k.isArray, Xl = an ? zn(an) : Ri;
			function Zl(e) {
				return e != null && lu(e.length) && !su(e);
			}
			function Y(e) {
				return Z(e) && Zl(e);
			}
			function Ql(e) {
				return e === !0 || e === !1 || Z(e) && ki(e) == te;
			}
			var $l = Rt || jf, eu = on ? zn(on) : zi;
			function tu(e) {
				return Z(e) && e.nodeType === 1 && !vu(e);
			}
			function nu(e) {
				if (e == null) return !0;
				if (Zl(e) && (J(e) || typeof e == "string" || typeof e.splice == "function" || $l(e) || wu(e) || Yl(e))) return !e.length;
				var t = Bo(e);
				if (t == se || t == E) return !e.size;
				if (ts(e)) return !Yi(e).length;
				for (var n in e) if (N.call(e, n)) return !1;
				return !0;
			}
			function ru(e, t) {
				return Bi(e, t);
			}
			function iu(e, t, r) {
				r = typeof r == "function" ? r : n;
				var i = r ? r(e, t) : n;
				return i === n ? Bi(e, t, n, r) : !!i;
			}
			function au(e) {
				if (!Z(e)) return !1;
				var t = ki(e);
				return t == ie || t == re || typeof e.message == "string" && typeof e.name == "string" && !vu(e);
			}
			function ou(e) {
				return typeof e == "number" && Bt(e);
			}
			function su(e) {
				if (!X(e)) return !1;
				var t = ki(e);
				return t == ae || t == oe || t == ee || t == de;
			}
			function cu(e) {
				return typeof e == "number" && e == Q(e);
			}
			function lu(e) {
				return typeof e == "number" && e > -1 && e % 1 == 0 && e <= g;
			}
			function X(e) {
				var t = typeof e;
				return e != null && (t == "object" || t == "function");
			}
			function Z(e) {
				return typeof e == "object" && !!e;
			}
			var uu = sn ? zn(sn) : Hi;
			function du(e, t) {
				return e === t || Ui(e, t, Fo(t));
			}
			function fu(e, t, r) {
				return r = typeof r == "function" ? r : n, Ui(e, t, Fo(t), r);
			}
			function pu(e) {
				return _u(e) && e != +e;
			}
			function mu(e) {
				if (es(e)) throw new rt("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
				return Wi(e);
			}
			function hu(e) {
				return e === null;
			}
			function gu(e) {
				return e == null;
			}
			function _u(e) {
				return typeof e == "number" || Z(e) && ki(e) == ce;
			}
			function vu(e) {
				if (!Z(e) || ki(e) != ue) return !1;
				var t = wt(e);
				if (t === null) return !0;
				var n = N.call(t, "constructor") && t.constructor;
				return typeof n == "function" && n instanceof n && pt.call(n) == _t;
			}
			var yu = cn ? zn(cn) : Gi;
			function bu(e) {
				return cu(e) && e >= -g && e <= g;
			}
			var xu = ln ? zn(ln) : Ki;
			function Su(e) {
				return typeof e == "string" || !J(e) && Z(e) && ki(e) == pe;
			}
			function Cu(e) {
				return typeof e == "symbol" || Z(e) && ki(e) == me;
			}
			var wu = un ? zn(un) : qi;
			function Tu(e) {
				return e === n;
			}
			function Eu(e) {
				return Z(e) && Bo(e) == ge;
			}
			function Du(e) {
				return Z(e) && ki(e) == _e;
			}
			var Ou = _o(Zi), ku = _o(function(e, t) {
				return e <= t;
			});
			function Au(e) {
				if (!e) return [];
				if (Zl(e)) return Su(e) ? or(e) : Ya(e);
				if (kt && e[kt]) return Zn(e[kt]());
				var t = Bo(e);
				return (t == se ? Qn : t == E ? tr : Cd)(e);
			}
			function ju(e) {
				return e ? (e = Nu(e), e === h || e === -Infinity ? (e < 0 ? -1 : 1) * _ : e === e ? e : 0) : e === 0 ? e : 0;
			}
			function Q(e) {
				var t = ju(e), n = t % 1;
				return t === t ? n ? t - n : t : 0;
			}
			function Mu(e) {
				return e ? li(Q(e), 0, y) : 0;
			}
			function Nu(e) {
				if (typeof e == "number") return e;
				if (Cu(e)) return v;
				if (X(e)) {
					var t = typeof e.valueOf == "function" ? e.valueOf() : e;
					e = X(t) ? t + "" : t;
				}
				if (typeof e != "string") return e === 0 ? e : +e;
				e = Rn(e);
				var n = Xe.test(e);
				return n || Qe.test(e) ? Xt(e.slice(2), n ? 2 : 8) : Ye.test(e) ? v : +e;
			}
			function Pu(e) {
				return W(e, ad(e));
			}
			function Fu(e) {
				return e ? li(Q(e), -g, g) : e === 0 ? e : 0;
			}
			function $(e) {
				return e == null ? "" : Ta(e);
			}
			var Iu = $a(function(e, t) {
				if (ts(t) || Zl(t)) {
					W(t, id(t), e);
					return;
				}
				for (var n in t) N.call(t, n) && ni(e, n, t[n]);
			}), Lu = $a(function(e, t) {
				W(t, ad(t), e);
			}), Ru = $a(function(e, t, n, r) {
				W(t, ad(t), e, r);
			}), zu = $a(function(e, t, n, r) {
				W(t, id(t), e, r);
			}), Bu = Oo(ci);
			function Vu(e, t) {
				var n = vr(e);
				return t == null ? n : ai(n, t);
			}
			var Hu = U(function(e, t) {
				e = M(e);
				var r = -1, i = t.length, a = i > 2 ? t[2] : n;
				for (a && Yo(t[0], t[1], a) && (i = 1); ++r < i;) for (var o = t[r], s = ad(o), c = -1, l = s.length; ++c < l;) {
					var u = s[c], d = e[u];
					(d === n || Kl(d, dt[u]) && !N.call(e, u)) && (e[u] = o[u]);
				}
				return e;
			}), Uu = U(function(e) {
				return e.push(n, Co), z(ld, n, e);
			});
			function Wu(e, t) {
				return Tn(e, K(t, 3), wi);
			}
			function Gu(e, t) {
				return Tn(e, K(t, 3), Ti);
			}
			function Ku(e, t) {
				return e == null ? e : Si(e, K(t, 3), ad);
			}
			function qu(e, t) {
				return e == null ? e : Ci(e, K(t, 3), ad);
			}
			function Ju(e, t) {
				return e && wi(e, K(t, 3));
			}
			function Yu(e, t) {
				return e && Ti(e, K(t, 3));
			}
			function Xu(e) {
				return e == null ? [] : Ei(e, id(e));
			}
			function Zu(e) {
				return e == null ? [] : Ei(e, ad(e));
			}
			function Qu(e, t, r) {
				var i = e == null ? n : Di(e, t);
				return i === n ? r : i;
			}
			function $u(e, t) {
				return e != null && Ho(e, t, ji);
			}
			function ed(e, t) {
				return e != null && Ho(e, t, Mi);
			}
			var td = uo(function(e, t, n) {
				t != null && typeof t.toString != "function" && (t = gt.call(t)), e[t] = n;
			}, lf(pf)), nd = uo(function(e, t, n) {
				t != null && typeof t.toString != "function" && (t = gt.call(t)), N.call(e, t) ? e[t].push(n) : e[t] = [n];
			}, K), rd = U(Ii);
			function id(e) {
				return Zl(e) ? Zr(e) : Yi(e);
			}
			function ad(e) {
				return Zl(e) ? Zr(e, !0) : Xi(e);
			}
			function od(e, t) {
				var n = {};
				return t = K(t, 3), wi(e, function(e, r, i) {
					si(n, t(e, r, i), e);
				}), n;
			}
			function sd(e, t) {
				var n = {};
				return t = K(t, 3), wi(e, function(e, r, i) {
					si(n, r, t(e, r, i));
				}), n;
			}
			var cd = $a(function(e, t, n) {
				ta(e, t, n);
			}), ld = $a(function(e, t, n, r) {
				ta(e, t, n, r);
			}), ud = Oo(function(e, t) {
				var n = {};
				if (e == null) return n;
				var r = !1;
				t = B(t, function(t) {
					return t = Fa(t, e), r ||= t.length > 1, t;
				}), W(e, Ao(e), n), r && (n = ui(n, 7, wo));
				for (var i = t.length; i--;) Da(n, t[i]);
				return n;
			});
			function dd(e, t) {
				return pd(e, kl(K(t)));
			}
			var fd = Oo(function(e, t) {
				return e == null ? {} : aa(e, t);
			});
			function pd(e, t) {
				if (e == null) return {};
				var n = B(Ao(e), function(e) {
					return [e];
				});
				return t = K(t), oa(e, n, function(e, n) {
					return t(e, n[0]);
				});
			}
			function md(e, t, r) {
				t = Fa(t, e);
				var i = -1, a = t.length;
				for (a || (a = 1, e = n); ++i < a;) {
					var o = e == null ? n : e[ys(t[i])];
					o === n && (i = a, o = r), e = su(o) ? o.call(e) : o;
				}
				return e;
			}
			function hd(e, t, n) {
				return e == null ? e : ha(e, t, n);
			}
			function gd(e, t, r, i) {
				return i = typeof i == "function" ? i : n, e == null ? e : ha(e, t, r, i);
			}
			var _d = xo(id), vd = xo(ad);
			function yd(e, t, n) {
				var r = J(e), i = r || $l(e) || wu(e);
				if (t = K(t, 4), n == null) {
					var a = e && e.constructor;
					n = i ? r ? new a() : [] : X(e) && su(a) ? vr(wt(e)) : {};
				}
				return (i ? fn : wi)(e, function(e, r, i) {
					return t(n, e, r, i);
				}), n;
			}
			function bd(e, t) {
				return e == null || Da(e, t);
			}
			function xd(e, t, n) {
				return e == null ? e : Oa(e, t, Pa(n));
			}
			function Sd(e, t, r, i) {
				return i = typeof i == "function" ? i : n, e == null ? e : Oa(e, t, Pa(r), i);
			}
			function Cd(e) {
				return e == null ? [] : Bn(e, id(e));
			}
			function wd(e) {
				return e == null ? [] : Bn(e, ad(e));
			}
			function Td(e, t, r) {
				return r === n && (r = t, t = n), r !== n && (r = Nu(r), r = r === r ? r : 0), t !== n && (t = Nu(t), t = t === t ? t : 0), li(Nu(e), t, r);
			}
			function Ed(e, t, r) {
				return t = ju(t), r === n ? (r = t, t = 0) : r = ju(r), e = Nu(e), Ni(e, t, r);
			}
			function Dd(e, t, r) {
				if (r && typeof r != "boolean" && Yo(e, t, r) && (t = r = n), r === n && (typeof t == "boolean" ? (r = t, t = n) : typeof e == "boolean" && (r = e, e = n)), e === n && t === n ? (e = 0, t = 1) : (e = ju(e), t === n ? (t = e, e = 0) : t = ju(t)), e > t) {
					var i = e;
					e = t, t = i;
				}
				if (r || e % 1 || t % 1) {
					var a = Jt();
					return Gt(e + a * (t - e + Yt("1e-" + ((a + "").length - 1))), t);
				}
				return ua(e, t);
			}
			var Od = io(function(e, t, n) {
				return t = t.toLowerCase(), e + (n ? kd(t) : t);
			});
			function kd(e) {
				return nf($(e).toLowerCase());
			}
			function Ad(e) {
				return e = $(e), e && e.replace(et, Gn).replace(zt, "");
			}
			function jd(e, t, r) {
				e = $(e), t = Ta(t);
				var i = e.length;
				r = r === n ? i : li(Q(r), 0, i);
				var a = r;
				return r -= t.length, r >= 0 && e.slice(r, a) == t;
			}
			function Md(e) {
				return e = $(e), e && Fe.test(e) ? e.replace(Ne, Kn) : e;
			}
			function Nd(e) {
				return e = $(e), e && Ve.test(e) ? e.replace(Be, "\\$&") : e;
			}
			var Pd = io(function(e, t, n) {
				return e + (n ? "-" : "") + t.toLowerCase();
			}), Fd = io(function(e, t, n) {
				return e + (n ? " " : "") + t.toLowerCase();
			}), Id = ro("toLowerCase");
			function Ld(e, t, n) {
				e = $(e), t = Q(t);
				var r = t ? ar(e) : 0;
				if (!t || r >= t) return e;
				var i = (t - r) / 2;
				return mo(It(i), n) + e + mo(Ft(i), n);
			}
			function Rd(e, t, n) {
				e = $(e), t = Q(t);
				var r = t ? ar(e) : 0;
				return t && r < t ? e + mo(t - r, n) : e;
			}
			function zd(e, t, n) {
				e = $(e), t = Q(t);
				var r = t ? ar(e) : 0;
				return t && r < t ? mo(t - r, n) + e : e;
			}
			function Bd(e, t, n) {
				return n || t == null ? t = 0 : t &&= +t, qt($(e).replace(He, ""), t || 0);
			}
			function Vd(e, t, r) {
				return t = (r ? Yo(e, t, r) : t === n) ? 1 : Q(t), fa($(e), t);
			}
			function Hd() {
				var e = arguments, t = $(e[0]);
				return e.length < 3 ? t : t.replace(e[1], e[2]);
			}
			var Ud = io(function(e, t, n) {
				return e + (n ? "_" : "") + t.toLowerCase();
			});
			function Wd(e, t, r) {
				return r && typeof r != "number" && Yo(e, t, r) && (t = r = n), r = r === n ? y : r >>> 0, r ? (e = $(e), e && (typeof t == "string" || t != null && !yu(t)) && (t = Ta(t), !t && Yn(e)) ? La(or(e), 0, r) : e.split(t, r)) : [];
			}
			var Gd = io(function(e, t, n) {
				return e + (n ? " " : "") + nf(t);
			});
			function Kd(e, t, n) {
				return e = $(e), n = n == null ? 0 : li(Q(n), 0, e.length), t = Ta(t), e.slice(n, n + t.length) == t;
			}
			function qd(e, t, r) {
				var i = V.templateSettings;
				r && Yo(e, t, r) && (t = n), e = $(e), t = zu({}, t, i, So);
				var a = zu({}, t.imports, i.imports, So), o = id(a), s = Bn(a, o);
				fn(o, function(e) {
					if (j.test(e)) throw new rt("Invalid `imports` option passed into `_.template`");
				});
				var c, l, u = 0, d = t.interpolate || tt, f = "__p += '", p = ot((t.escape || tt).source + "|" + d.source + "|" + (d === Le ? qe : tt).source + "|" + (t.evaluate || tt).source + "|$", "g"), m = "//# sourceURL=" + (N.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Wt + "]") + "\n";
				e.replace(p, function(t, n, r, i, a, o) {
					return r ||= i, f += e.slice(u, o).replace(nt, qn), n && (c = !0, f += "' +\n__e(" + n + ") +\n'"), a && (l = !0, f += "';\n" + a + ";\n__p += '"), r && (f += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), u = o + t.length, t;
				}), f += "';\n";
				var h = N.call(t, "variable") && t.variable;
				if (!h) f = "with (obj) {\n" + f + "\n}\n";
				else if (j.test(h)) throw new rt("Invalid `variable` option passed into `_.template`");
				f = (l ? f.replace(ke, "") : f).replace(Ae, "$1").replace(je, "$1;"), f = "function(" + (h || "obj") + ") {\n" + (h ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (l ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + f + "return __p\n}";
				var g = af(function() {
					return it(o, m + "return " + f).apply(n, s);
				});
				if (g.source = f, au(g)) throw g;
				return g;
			}
			function Jd(e) {
				return $(e).toLowerCase();
			}
			function Yd(e) {
				return $(e).toUpperCase();
			}
			function Xd(e, t, r) {
				if (e = $(e), e && (r || t === n)) return Rn(e);
				if (!e || !(t = Ta(t))) return e;
				var i = or(e), a = or(t);
				return La(i, Hn(i, a), Un(i, a) + 1).join("");
			}
			function Zd(e, t, r) {
				if (e = $(e), e && (r || t === n)) return e.slice(0, sr(e) + 1);
				if (!e || !(t = Ta(t))) return e;
				var i = or(e);
				return La(i, 0, Un(i, or(t)) + 1).join("");
			}
			function Qd(e, t, r) {
				if (e = $(e), e && (r || t === n)) return e.replace(He, "");
				if (!e || !(t = Ta(t))) return e;
				var i = or(e);
				return La(i, Hn(i, or(t))).join("");
			}
			function $d(e, t) {
				var r = 30, i = "...";
				if (X(t)) {
					var a = "separator" in t ? t.separator : a;
					r = "length" in t ? Q(t.length) : r, i = "omission" in t ? Ta(t.omission) : i;
				}
				e = $(e);
				var o = e.length;
				if (Yn(e)) {
					var s = or(e);
					o = s.length;
				}
				if (r >= o) return e;
				var c = r - ar(i);
				if (c < 1) return i;
				var l = s ? La(s, 0, c).join("") : e.slice(0, c);
				if (a === n) return l + i;
				if (s && (c += l.length - c), yu(a)) {
					if (e.slice(c).search(a)) {
						var u, d = l;
						for (a.global || (a = ot(a.source, $(Je.exec(a)) + "g")), a.lastIndex = 0; u = a.exec(d);) var f = u.index;
						l = l.slice(0, f === n ? c : f);
					}
				} else if (e.indexOf(Ta(a), c) != c) {
					var p = l.lastIndexOf(a);
					p > -1 && (l = l.slice(0, p));
				}
				return l + i;
			}
			function ef(e) {
				return e = $(e), e && Pe.test(e) ? e.replace(Me, cr) : e;
			}
			var tf = io(function(e, t, n) {
				return e + (n ? " " : "") + t.toUpperCase();
			}), nf = ro("toUpperCase");
			function rf(e, t, r) {
				return e = $(e), t = r ? n : t, t === n ? Xn(e) ? dr(e) : wn(e) : e.match(t) || [];
			}
			var af = U(function(e, t) {
				try {
					return z(e, n, t);
				} catch (e) {
					return au(e) ? e : new rt(e);
				}
			}), of = Oo(function(e, t) {
				return fn(t, function(t) {
					t = ys(t), si(e, t, bl(e[t], e));
				}), e;
			});
			function sf(e) {
				var t = e == null ? 0 : e.length, n = K();
				return e = t ? B(e, function(e) {
					if (typeof e[1] != "function") throw new ct(r);
					return [n(e[0]), e[1]];
				}) : [], U(function(n) {
					for (var r = -1; ++r < t;) {
						var i = e[r];
						if (z(i[0], this, n)) return z(i[1], this, n);
					}
				});
			}
			function cf(e) {
				return di(ui(e, 1));
			}
			function lf(e) {
				return function() {
					return e;
				};
			}
			function uf(e, t) {
				return e == null || e !== e ? t : e;
			}
			var df = co(), ff = co(!0);
			function pf(e) {
				return e;
			}
			function mf(e) {
				return Ji(typeof e == "function" ? e : ui(e, 1));
			}
			function hf(e) {
				return $i(ui(e, 1));
			}
			function gf(e, t) {
				return ea(e, ui(t, 1));
			}
			var _f = U(function(e, t) {
				return function(n) {
					return Ii(n, e, t);
				};
			}), vf = U(function(e, t) {
				return function(n) {
					return Ii(e, n, t);
				};
			});
			function yf(e, t, n) {
				var r = id(t), i = Ei(t, r);
				n == null && (!X(t) || !i.length && r.length) && (n = t, t = e, e = this, i = Ei(t, id(t)));
				var a = !(X(n) && "chain" in n) || !!n.chain, o = su(e);
				return fn(i, function(n) {
					var r = t[n];
					e[n] = r, o && (e.prototype[n] = function() {
						var t = this.__chain__;
						if (a || t) {
							var n = e(this.__wrapped__);
							return (n.__actions__ = Ya(this.__actions__)).push({
								func: r,
								args: arguments,
								thisArg: e
							}), n.__chain__ = t, n;
						}
						return r.apply(e, vn([this.value()], arguments));
					});
				}), e;
			}
			function bf() {
				return R._ === this && (R._ = vt), this;
			}
			function xf() {}
			function Sf(e) {
				return e = Q(e), U(function(t) {
					return ra(t, e);
				});
			}
			var Cf = po(B), wf = po(mn), Tf = po(xn);
			function Ef(e) {
				return Xo(e) ? jn(ys(e)) : sa(e);
			}
			function Df(e) {
				return function(t) {
					return e == null ? n : Di(e, t);
				};
			}
			var Of = go(), kf = go(!0);
			function Af() {
				return [];
			}
			function jf() {
				return !1;
			}
			function Mf() {
				return {};
			}
			function Nf() {
				return "";
			}
			function Pf() {
				return !0;
			}
			function Ff(e, t) {
				if (e = Q(e), e < 1 || e > g) return [];
				var n = y, r = Gt(e, y);
				t = K(t), e -= y;
				for (var i = In(r, t); ++n < e;) t(n);
				return i;
			}
			function If(e) {
				return J(e) ? B(e, ys) : Cu(e) ? [e] : Ya(vs($(e)));
			}
			function Lf(e) {
				var t = ++mt;
				return $(e) + t;
			}
			var Rf = fo(function(e, t) {
				return e + t;
			}, 0), zf = yo("ceil"), Bf = fo(function(e, t) {
				return e / t;
			}, 1), Vf = yo("floor");
			function Hf(e) {
				return e && e.length ? vi(e, pf, Ai) : n;
			}
			function Uf(e, t) {
				return e && e.length ? vi(e, K(t, 2), Ai) : n;
			}
			function Wf(e) {
				return An(e, pf);
			}
			function Gf(e, t) {
				return An(e, K(t, 2));
			}
			function Kf(e) {
				return e && e.length ? vi(e, pf, Zi) : n;
			}
			function qf(e, t) {
				return e && e.length ? vi(e, K(t, 2), Zi) : n;
			}
			var Jf = fo(function(e, t) {
				return e * t;
			}, 1), Yf = yo("round"), Xf = fo(function(e, t) {
				return e - t;
			}, 0);
			function Zf(e) {
				return e && e.length ? Fn(e, pf) : 0;
			}
			function Qf(e, t) {
				return e && e.length ? Fn(e, K(t, 2)) : 0;
			}
			return V.after = _l, V.ary = vl, V.assign = Iu, V.assignIn = Lu, V.assignInWith = Ru, V.assignWith = zu, V.at = Bu, V.before = yl, V.bind = bl, V.bindAll = of, V.bindKey = xl, V.castArray = Bl, V.chain = Nc, V.chunk = Cs, V.compact = ws, V.concat = Ts, V.cond = sf, V.conforms = cf, V.constant = lf, V.countBy = Wc, V.create = Vu, V.curry = Sl, V.curryRight = Cl, V.debounce = wl, V.defaults = Hu, V.defaultsDeep = Uu, V.defer = Tl, V.delay = El, V.difference = Es, V.differenceBy = Ds, V.differenceWith = Os, V.drop = ks, V.dropRight = As, V.dropRightWhile = js, V.dropWhile = Ms, V.fill = Ns, V.filter = Kc, V.flatMap = Yc, V.flatMapDeep = Xc, V.flatMapDepth = Zc, V.flatten = Is, V.flattenDeep = Ls, V.flattenDepth = Rs, V.flip = Dl, V.flow = df, V.flowRight = ff, V.fromPairs = zs, V.functions = Xu, V.functionsIn = Zu, V.groupBy = el, V.initial = Hs, V.intersection = Us, V.intersectionBy = Ws, V.intersectionWith = Gs, V.invert = td, V.invertBy = nd, V.invokeMap = nl, V.iteratee = mf, V.keyBy = rl, V.keys = id, V.keysIn = ad, V.map = il, V.mapKeys = od, V.mapValues = sd, V.matches = hf, V.matchesProperty = gf, V.memoize = Ol, V.merge = cd, V.mergeWith = ld, V.method = _f, V.methodOf = vf, V.mixin = yf, V.negate = kl, V.nthArg = Sf, V.omit = ud, V.omitBy = dd, V.once = Al, V.orderBy = al, V.over = Cf, V.overArgs = jl, V.overEvery = wf, V.overSome = Tf, V.partial = Ml, V.partialRight = Nl, V.partition = ol, V.pick = fd, V.pickBy = pd, V.property = Ef, V.propertyOf = Df, V.pull = Xs, V.pullAll = Zs, V.pullAllBy = Qs, V.pullAllWith = $s, V.pullAt = ec, V.range = Of, V.rangeRight = kf, V.rearg = Pl, V.reject = ll, V.remove = tc, V.rest = Fl, V.reverse = nc, V.sampleSize = dl, V.set = hd, V.setWith = gd, V.shuffle = fl, V.slice = rc, V.sortBy = hl, V.sortedUniq = uc, V.sortedUniqBy = dc, V.split = Wd, V.spread = Il, V.tail = fc, V.take = pc, V.takeRight = mc, V.takeRightWhile = hc, V.takeWhile = gc, V.tap = Pc, V.throttle = Ll, V.thru = Fc, V.toArray = Au, V.toPairs = _d, V.toPairsIn = vd, V.toPath = If, V.toPlainObject = Pu, V.transform = yd, V.unary = Rl, V.union = _c, V.unionBy = vc, V.unionWith = yc, V.uniq = bc, V.uniqBy = xc, V.uniqWith = Sc, V.unset = bd, V.unzip = Cc, V.unzipWith = wc, V.update = xd, V.updateWith = Sd, V.values = Cd, V.valuesIn = wd, V.without = Tc, V.words = rf, V.wrap = zl, V.xor = Ec, V.xorBy = Dc, V.xorWith = Oc, V.zip = kc, V.zipObject = Ac, V.zipObjectDeep = jc, V.zipWith = Mc, V.entries = _d, V.entriesIn = vd, V.extend = Lu, V.extendWith = Ru, yf(V, V), V.add = Rf, V.attempt = af, V.camelCase = Od, V.capitalize = kd, V.ceil = zf, V.clamp = Td, V.clone = Vl, V.cloneDeep = Ul, V.cloneDeepWith = Wl, V.cloneWith = Hl, V.conformsTo = Gl, V.deburr = Ad, V.defaultTo = uf, V.divide = Bf, V.endsWith = jd, V.eq = Kl, V.escape = Md, V.escapeRegExp = Nd, V.every = Gc, V.find = qc, V.findIndex = Ps, V.findKey = Wu, V.findLast = Jc, V.findLastIndex = Fs, V.findLastKey = Gu, V.floor = Vf, V.forEach = Qc, V.forEachRight = $c, V.forIn = Ku, V.forInRight = qu, V.forOwn = Ju, V.forOwnRight = Yu, V.get = Qu, V.gt = ql, V.gte = Jl, V.has = $u, V.hasIn = ed, V.head = Bs, V.identity = pf, V.includes = tl, V.indexOf = Vs, V.inRange = Ed, V.invoke = rd, V.isArguments = Yl, V.isArray = J, V.isArrayBuffer = Xl, V.isArrayLike = Zl, V.isArrayLikeObject = Y, V.isBoolean = Ql, V.isBuffer = $l, V.isDate = eu, V.isElement = tu, V.isEmpty = nu, V.isEqual = ru, V.isEqualWith = iu, V.isError = au, V.isFinite = ou, V.isFunction = su, V.isInteger = cu, V.isLength = lu, V.isMap = uu, V.isMatch = du, V.isMatchWith = fu, V.isNaN = pu, V.isNative = mu, V.isNil = gu, V.isNull = hu, V.isNumber = _u, V.isObject = X, V.isObjectLike = Z, V.isPlainObject = vu, V.isRegExp = yu, V.isSafeInteger = bu, V.isSet = xu, V.isString = Su, V.isSymbol = Cu, V.isTypedArray = wu, V.isUndefined = Tu, V.isWeakMap = Eu, V.isWeakSet = Du, V.join = Ks, V.kebabCase = Pd, V.last = qs, V.lastIndexOf = Js, V.lowerCase = Fd, V.lowerFirst = Id, V.lt = Ou, V.lte = ku, V.max = Hf, V.maxBy = Uf, V.mean = Wf, V.meanBy = Gf, V.min = Kf, V.minBy = qf, V.stubArray = Af, V.stubFalse = jf, V.stubObject = Mf, V.stubString = Nf, V.stubTrue = Pf, V.multiply = Jf, V.nth = Ys, V.noConflict = bf, V.noop = xf, V.now = gl, V.pad = Ld, V.padEnd = Rd, V.padStart = zd, V.parseInt = Bd, V.random = Dd, V.reduce = sl, V.reduceRight = cl, V.repeat = Vd, V.replace = Hd, V.result = md, V.round = Yf, V.runInContext = e, V.sample = ul, V.size = pl, V.snakeCase = Ud, V.some = ml, V.sortedIndex = ic, V.sortedIndexBy = ac, V.sortedIndexOf = oc, V.sortedLastIndex = sc, V.sortedLastIndexBy = cc, V.sortedLastIndexOf = lc, V.startCase = Gd, V.startsWith = Kd, V.subtract = Xf, V.sum = Zf, V.sumBy = Qf, V.template = qd, V.times = Ff, V.toFinite = ju, V.toInteger = Q, V.toLength = Mu, V.toLower = Jd, V.toNumber = Nu, V.toSafeInteger = Fu, V.toString = $, V.toUpper = Yd, V.trim = Xd, V.trimEnd = Zd, V.trimStart = Qd, V.truncate = $d, V.unescape = ef, V.uniqueId = Lf, V.upperCase = tf, V.upperFirst = nf, V.each = Qc, V.eachRight = $c, V.first = Bs, yf(V, function() {
				var e = {};
				return wi(V, function(t, n) {
					N.call(V.prototype, n) || (e[n] = t);
				}), e;
			}(), { chain: !1 }), V.VERSION = "4.18.1", fn([
				"bind",
				"bindKey",
				"curry",
				"curryRight",
				"partial",
				"partialRight"
			], function(e) {
				V[e].placeholder = V;
			}), fn(["drop", "take"], function(e, t) {
				H.prototype[e] = function(r) {
					r = r === n ? 1 : F(Q(r), 0);
					var i = this.__filtered__ && !t ? new H(this) : this.clone();
					return i.__filtered__ ? i.__takeCount__ = Gt(r, i.__takeCount__) : i.__views__.push({
						size: Gt(r, y),
						type: e + (i.__dir__ < 0 ? "Right" : "")
					}), i;
				}, H.prototype[e + "Right"] = function(t) {
					return this.reverse()[e](t).reverse();
				};
			}), fn([
				"filter",
				"map",
				"takeWhile"
			], function(e, t) {
				var n = t + 1, r = n == 1 || n == 3;
				H.prototype[e] = function(e) {
					var t = this.clone();
					return t.__iteratees__.push({
						iteratee: K(e, 3),
						type: n
					}), t.__filtered__ = t.__filtered__ || r, t;
				};
			}), fn(["head", "last"], function(e, t) {
				var n = "take" + (t ? "Right" : "");
				H.prototype[e] = function() {
					return this[n](1).value()[0];
				};
			}), fn(["initial", "tail"], function(e, t) {
				var n = "drop" + (t ? "" : "Right");
				H.prototype[e] = function() {
					return this.__filtered__ ? new H(this) : this[n](1);
				};
			}), H.prototype.compact = function() {
				return this.filter(pf);
			}, H.prototype.find = function(e) {
				return this.filter(e).head();
			}, H.prototype.findLast = function(e) {
				return this.reverse().find(e);
			}, H.prototype.invokeMap = U(function(e, t) {
				return typeof e == "function" ? new H(this) : this.map(function(n) {
					return Ii(n, e, t);
				});
			}), H.prototype.reject = function(e) {
				return this.filter(kl(K(e)));
			}, H.prototype.slice = function(e, t) {
				e = Q(e);
				var r = this;
				return r.__filtered__ && (e > 0 || t < 0) ? new H(r) : (e < 0 ? r = r.takeRight(-e) : e && (r = r.drop(e)), t !== n && (t = Q(t), r = t < 0 ? r.dropRight(-t) : r.take(t - e)), r);
			}, H.prototype.takeRightWhile = function(e) {
				return this.reverse().takeWhile(e).reverse();
			}, H.prototype.toArray = function() {
				return this.take(y);
			}, wi(H.prototype, function(e, t) {
				var r = /^(?:filter|find|map|reject)|While$/.test(t), i = /^(?:head|last)$/.test(t), a = V[i ? "take" + (t == "last" ? "Right" : "") : t], o = i || /^find/.test(t);
				a && (V.prototype[t] = function() {
					var t = this.__wrapped__, s = i ? [1] : arguments, c = t instanceof H, l = s[0], u = c || J(t), d = function(e) {
						var t = a.apply(V, vn([e], s));
						return i && f ? t[0] : t;
					};
					u && r && typeof l == "function" && l.length != 1 && (c = u = !1);
					var f = this.__chain__, p = !!this.__actions__.length, m = o && !f, h = c && !p;
					if (!o && u) {
						t = h ? t : new H(this);
						var g = e.apply(t, s);
						return g.__actions__.push({
							func: Fc,
							args: [d],
							thisArg: n
						}), new br(g, f);
					}
					return m && h ? e.apply(this, s) : (g = this.thru(d), m ? i ? g.value()[0] : g.value() : g);
				});
			}), fn([
				"pop",
				"push",
				"shift",
				"sort",
				"splice",
				"unshift"
			], function(e) {
				var t = lt[e], n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(e);
				V.prototype[e] = function() {
					var e = arguments;
					if (r && !this.__chain__) {
						var i = this.value();
						return t.apply(J(i) ? i : [], e);
					}
					return this[n](function(n) {
						return t.apply(J(n) ? n : [], e);
					});
				};
			}), wi(H.prototype, function(e, t) {
				var n = V[t];
				if (n) {
					var r = n.name + "";
					N.call(Mn, r) || (Mn[r] = []), Mn[r].push({
						name: t,
						func: n
					});
				}
			}), Mn[lo(n, s).name] = [{
				name: "wrapper",
				func: n
			}], H.prototype.clone = xr, H.prototype.reverse = Sr, H.prototype.value = Cr, V.prototype.at = Ic, V.prototype.chain = Lc, V.prototype.commit = Rc, V.prototype.next = zc, V.prototype.plant = Vc, V.prototype.reverse = Hc, V.prototype.toJSON = V.prototype.valueOf = V.prototype.value = Uc, V.prototype.first = V.prototype.head, kt && (V.prototype[kt] = Bc), V;
		})();
		typeof define == "function" && typeof define.amd == "object" && define.amd ? (R._ = fr, define(function() {
			return fr;
		})) : en ? ((en.exports = fr)._ = fr, $t._ = fr) : R._ = fr;
	}).call(e);
})))(), 1);
function ln(e) {
	let { viewer: t } = P();
	return { plugin: t.getPlugin(e) };
}
var un = (e, t) => {
	let { plugin: n } = ln(e);
	return sn(cn.default.get(n.settings, t));
}, z = class {}, dn = class extends z {
	constructor(...e) {
		super(...e), this.label = () => A("teiaviewer:spotlight.select_all.text");
	}
	value(e) {
		new me(e).execute();
	}
}, fn = class extends z {
	constructor(...e) {
		super(...e), this.label = (e) => `${A("teiaviewer:spotlight.isolate_selection.text", { count: e })}`;
	}
	value(e) {
		e.scene.objectSelection.isEmpty || new ae(e, e.scene.objectSelection.getBimMeshUuids()).execute();
	}
}, pn = class extends z {
	constructor(...e) {
		super(...e), this.label = (e) => `${A("teiaviewer:spotlight.hide_selection.text", { count: e })}`;
	}
	value(e) {
		e.scene.objectSelection.isEmpty || new ye(e, e.scene.objectSelection.getBimMeshUuids(), !1).execute();
	}
}, mn = class extends z {
	constructor(...e) {
		super(...e), this.label = () => A("teiaviewer:spotlight.copy_selection.text");
	}
	value(e) {
		navigator.clipboard.writeText(e.scene.objectSelection.toString());
	}
}, hn = class extends z {
	constructor(...e) {
		super(...e), this.label = () => A("teiaviewer:spotlight.undo.text");
	}
	value(e) {
		e.commandHistory.canUndo && e.commandHistory.undoLastCommand();
	}
}, gn = class extends z {
	constructor(...e) {
		super(...e), this.label = () => A("teiaviewer:spotlight.redo.text");
	}
	value(e) {
		e.commandHistory.canRedo && e.commandHistory.redoLastCommand();
	}
}, _n = class extends z {
	constructor(...e) {
		super(...e), this.label = () => A("teiaviewer:spotlight.xray_selection.text");
	}
	value(e) {
		new be(e, e.scene.objectSelection.getBimMeshUuids(), !0).execute();
	}
}, B = [
	new dn(),
	new fn(),
	new pn(),
	new mn(),
	new _n(),
	new hn(),
	new gn()
], vn = () => {
	let { viewer: t } = P(), { plugin: r } = ln("Viewport"), [i, a] = n.useState(!1), o = d(null), s = (e) => {
		(ke(e) && e.key === "k" || e.key === "Escape") && (e.preventDefault(), r.spotlight.isOpen && r.spotlight.hide());
	}, c = (e) => {
		e.button === 0 && r.spotlight.isOpen && (e.preventDefault(), r.spotlight.hide());
	};
	return n.useEffect(() => (addEventListener("pointerdown", c), addEventListener("keydown", s, !0), () => {
		removeEventListener("pointerdown", c), removeEventListener("keydown", s, !0);
	}), []), n.useEffect(() => {
		let e = () => {
			a(r.spotlight.isOpen);
		};
		return r.spotlight.signals.onStatusChanged.connect(e), () => {
			r.spotlight.signals.onStatusChanged.disconnect(e);
		};
	}, []), n.useEffect(() => {
		i && o.current?.querySelector("input")?.focus();
	}, [i]), /* @__PURE__ */ h(e, {
		sx: {
			top: 0,
			left: 0,
			position: "absolute",
			zIndex: 50,
			height: "100%",
			width: "100%",
			backgroundColor: "rgba(0, 0, 0, 0.25)",
			display: i ? "flex" : "none",
			alignItems: "flex-start",
			justifyContent: "center"
		},
		"data-testid": "spotlight-container",
		children: /* @__PURE__ */ h(e, {
			ref: o,
			onPointerDown: (e) => {
				e.stopPropagation();
			},
			"data-testid": "spotlight-panel",
			sx: {
				backgroundColor: "common.white",
				minWidth: "400px",
				borderRadius: 1,
				position: "relative",
				top: "300px"
			},
			children: /* @__PURE__ */ h(k, {
				id: "select-spotlight",
				sx: { margin: "0.5rem" },
				options: B,
				onChange: (e) => {
					r.spotlight.hide(), e?.value(t);
				},
				getOptionLabel: (e) => e.label(t.scene.objectSelection.length),
				placeholder: "Spotlight",
				"data-testid": "spotlight-select"
			})
		})
	});
}, yn = () => {
	let [, e] = n.useReducer((e) => e + 1, 0);
	return { forceUpdate: e };
}, bn = (e) => {
	let { ref: t, onResize: n } = e, r = d(n);
	r.current = n, c(() => {
		let e = t.current;
		if (!e) return;
		let n = new ResizeObserver(() => {
			let { width: t, height: n } = e.getBoundingClientRect();
			r.current({
				width: t,
				height: n
			});
		});
		return n.observe(e), () => n.disconnect();
	}, [t]);
}, xn = 40, Sn = 40, Cn = /* @__PURE__ */ function(e) {
	return e[e.Foreground = 0] = "Foreground", e[e.Background = 1] = "Background", e;
}({}), wn = class {
	static {
		this.DragHandleClassName = "ViewportWidgetDragHandle-" + We();
	}
	constructor(e, t = {}) {
		this.viewer = e, this._xMinimize = 0, this._yMinimize = 0, this._xMaximize = 0, this._yMaximize = 0, this._width = xn, this._height = Sn, this._minWidth = xn, this._minHeight = Sn, this._zIndex = 1, this._isMinimized = !1, this._isMaximized = !1, this._minimizedHeight = 0, this._maximizedWidth = 0, this._maximizedHeight = 0, this._isLocked = !1, this._isClosable = !0, this.ignoreLastPosition = !1, this.id = We(), this.signals = {
			onUpdateRect: new we(),
			onUpdateRectContent: new we()
		}, this.ExtraContent = () => null, this.ContextProvider = (e) => {
			let { children: t } = e;
			return /* @__PURE__ */ h(m, { children: t });
		};
		let { x: n = 0, y: r = 0, width: i = xn, height: a = Sn, minWidth: o = xn, minHeight: s = Sn, maxWidth: c = 9999, maxHeight: l = 9999, locked: u = !1, ignoreLastPosition: d = !1, isClosable: f = !0 } = t;
		this._isDraggable = t.isDraggable ?? !0, this._isResizable = t.isResizable ?? !0, this._isMinimizable = t.isMinimizable ?? !0, this._isMaximizable = t.isMaximizable ?? !0, this._fitContent = t.fitContent ?? !1, this._fitDirection = t.fitDirection ?? "both", this._isScrollable = t.isScrollable ?? !1, this._minWidth = Math.max(xn, o), this._minHeight = Math.max(Sn, s), this._maxWidth = c, this._maxHeight = l, this._isClosable = f, this.isLocked = u, this.ignoreLastPosition = d, this._setInitialPosition(n, r, i, a);
	}
	close() {
		this.viewer.getPlugin("Viewport").widgetController.removeWidget(this);
	}
	dispose() {}
	_saveConfig(e, t, n, r) {
		let i = this.constructor.name, a = /* @__PURE__ */ new Map();
		a.set(i, {
			x: e,
			y: t,
			width: n,
			height: r
		}), le.instance.setLocalStorageMap(["WidgetsCfg"], Object.fromEntries(a));
	}
	setPosition(e, t) {
		this.isMaximized || this.setRect(e, t, this.width, this.height);
	}
	minimize(e = 0) {
		(!this._isMinimized || this._minimizedHeight !== e) && (this.isMinimized = !0, this.isMaximized = !1, this.setRect(this.x, this.y, this.width, e, !1), this.signals.onUpdateRect.emit(), this.signals.onUpdateRectContent.emit());
	}
	unminimize() {
		this.isMinimized && (this.isMinimized = !1, this.updateRect(!1), this.signals.onUpdateRect.emit(), this.signals.onUpdateRectContent.emit());
	}
	maximize(e, t) {
		this.isMaximized = !0, this.isMinimized = !1, this.setRect(0, 0, e, t, !1), this.signals.onUpdateRect.emit(), this.signals.onUpdateRectContent.emit();
	}
	unmaximize() {
		this.isMaximized && (this.isMaximized = !1, this.updateRect(!1), this.signals.onUpdateRect.emit(), this.signals.onUpdateRectContent.emit());
	}
	setSize(e, t) {
		this.setRect(this.x, this.y, e, t);
	}
	setRect(e, t, n, r, i = !0) {
		n = Math.max(this.minWidth, Math.min(this.maxWidth, n)), r = Math.max(this.minHeight, Math.min(this.maxHeight, r));
		let a = document.getElementById(Nn);
		if (a) {
			let i = a.clientHeight;
			n = Math.min(n, a.clientWidth), r = Math.min(r, i), e += Math.max(0, a.clientLeft - e) + Math.min(0, a.clientWidth - e - n), t += Math.max(0, a.clientTop - t) + Math.min(0, i - t - r);
		}
		(Math.abs(this.x - e) > 1 || Math.abs(this.y - t) > 1 || Math.abs(this.width - n) > 1 || Math.abs(this.height - r) > 1) && (this.width = n, this.height = r, this.x = e, this.y = t, i && this._saveConfig(e, t, n, r), this.signals.onUpdateRect.emit());
	}
	updateRect(e = !0) {
		this.setRect(this.x, this.y, this.width, this.height, e);
	}
	setMinSize(e, t) {
		(e < xn || t < xn) && ne.warn(`Widget is a strict minimum size of [${xn}x${Sn}]`), this._minWidth = Math.max(e, xn), this._minHeight = Math.max(t, Sn), this.updateRect();
	}
	setMaxSize(e, t) {
		this._maxWidth = e, this._maxHeight = t, this.updateRect();
	}
	_setInitialPosition(e, t, n, r) {
		return this.ignoreLastPosition ? this.setRect(e, t, n, r) : this.setRect(this._widgetConfig?.x ?? e, this._widgetConfig?.y ?? t, this._widgetConfig?.width ?? n, this._widgetConfig?.height ?? r);
	}
	get _widgetConfig() {
		let e = this.constructor.name;
		return le.instance.getFromLocalStorageMap(["WidgetsCfg"])?.[e];
	}
	get isScrollable() {
		return this._isScrollable;
	}
	set isMinimized(e) {
		this._isMinimized = e;
	}
	get isMinimized() {
		return this._isMinimized;
	}
	set isMaximized(e) {
		this._isMaximized = e;
	}
	get isMaximized() {
		return this._isMaximized;
	}
	set zIndex(e) {
		e !== this._zIndex && (this._zIndex = e, this.signals.onUpdateRect.emit());
	}
	get zIndex() {
		return this._zIndex;
	}
	set x(e) {
		this._isMaximized ? this._xMaximize = e : this._xMinimize = e;
	}
	get x() {
		return this._isMaximized ? this._xMaximize : this._xMinimize;
	}
	set y(e) {
		this._isMaximized ? this._yMaximize = e : this._yMinimize = e;
	}
	get y() {
		return this._isMaximized ? this._yMaximize : this._yMinimize;
	}
	set width(e) {
		this.isMaximized ? this._maximizedWidth = e : this._width = e;
	}
	get width() {
		return this._isMaximized ? this._maximizedWidth : this._width;
	}
	set height(e) {
		this.isMinimized ? this._minimizedHeight = e : this.isMaximized ? this._maximizedHeight = e : this._height = e;
	}
	get height() {
		return this.isMinimized ? this._minimizedHeight : this.isMaximized ? this._maximizedHeight : this._height;
	}
	get minWidth() {
		return this._minWidth;
	}
	get minHeight() {
		return this.isMinimized ? 0 : this._minHeight;
	}
	get maxWidth() {
		return this._maxWidth;
	}
	get maxHeight() {
		return this._maxHeight;
	}
	set isResizable(e) {
		this._isResizable = e, this.signals.onUpdateRect.emit();
	}
	get isResizable() {
		return this._isResizable;
	}
	set isMinimizable(e) {
		this._isMinimizable = e, this.signals.onUpdateRect.emit();
	}
	get isMinimizable() {
		return this._isMinimizable;
	}
	set isMaximizable(e) {
		this._isMaximizable = e, this.signals.onUpdateRect.emit();
	}
	get isMaximizable() {
		return this._isMaximizable;
	}
	set isDraggable(e) {
		this._isDraggable = e, this.signals.onUpdateRect.emit();
	}
	get isDraggable() {
		return this._isDraggable;
	}
	get fitContent() {
		return this._fitContent;
	}
	get fitDirection() {
		return this._fitDirection;
	}
	get isLocked() {
		return this._isLocked;
	}
	set isLocked(e) {
		e !== this._isLocked && (this._isLocked = e, this.signals.onUpdateRectContent.emit());
	}
	get isClosable() {
		return this._isClosable;
	}
	set isClosable(e) {
		e !== this._isClosable && (this._isClosable = e, this.signals.onUpdateRectContent.emit());
	}
}, Tn = r(null), En = n.memo((t) => {
	let { widget: r } = t, { plugin: i } = ln("Viewport"), a = n.useRef({
		x: 0,
		y: 0
	}), o = n.useRef(null), [s, c] = f(r.isMaximized), [l, d] = f(r.isMinimized), p = (e) => {
		e.target === e.currentTarget && i.widgetController.putWidgetInForeground(r);
	}, m = (e) => {
		let t = e.clientX - a.current.x, n = e.clientY - a.current.y;
		r.setPosition(t, n);
	}, _ = (e) => {
		if (!r.isDraggable) return;
		i.widgetController.putWidgetInForeground(r);
		let t = document.elementFromPoint(e.clientX, e.clientY), n = !1;
		for (; t && !n;) t.classList.contains(wn.DragHandleClassName) && (n = !0), t = t.parentElement;
		n && (a.current = {
			x: e.clientX - r.x,
			y: e.clientY - r.y
		}, document.addEventListener("pointermove", m), document.addEventListener("pointerup", v));
	}, v = () => {
		document.removeEventListener("pointermove", m), document.removeEventListener("pointerup", v);
	}, y = jn(r), b = Mn(r), x = r.isResizable && !l && !b && !s, S = r.isResizable && !y && !s, C = x && S;
	n.useEffect(() => {
		let e = () => {
			o.current && (o.current.style.width = r.width + "px", o.current.style.height = r.height + "px", o.current.style.left = r.x + "px", o.current.style.top = r.y + "px", o.current.style.zIndex = r.zIndex === Cn.Foreground ? "20" : "10", d(r.isMinimized), c(r.isMaximized));
		};
		return e(), r.signals.onUpdateRect.connect(e), () => {
			r.signals.onUpdateRect.disconnect(e);
		};
	}, [r, o]);
	let w = u(() => ({ widget: r }), [r]);
	return /* @__PURE__ */ g(Tn.Provider, {
		value: w,
		children: [/* @__PURE__ */ g(e, {
			draggable: !1,
			sx: {
				position: "absolute",
				pointerEvents: "auto"
			},
			ref: o,
			"data-testid": "widget-renderer",
			onClick: p,
			onPointerDown: _,
			children: [/* @__PURE__ */ h(An, { widget: r }), /* @__PURE__ */ h(Dn, {
				widget: r,
				canResizeVertically: x,
				canResizeHorizontally: S,
				canResizeBothDirection: C
			})]
		}), /* @__PURE__ */ h(r.ExtraContent, {})]
	});
}), Dn = (e) => {
	let { widget: t, canResizeVertically: n, canResizeHorizontally: r, canResizeBothDirection: i } = e;
	return /* @__PURE__ */ g(m, { children: [
		!!n && /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ h(On, {
			direction: "n",
			widget: t
		}), /* @__PURE__ */ h(On, {
			direction: "s",
			widget: t
		})] }),
		!!r && /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ h(On, {
			direction: "e",
			widget: t
		}), /* @__PURE__ */ h(On, {
			direction: "w",
			widget: t
		})] }),
		!!i && /* @__PURE__ */ g(m, { children: [
			/* @__PURE__ */ h(On, {
				direction: "nw",
				widget: t
			}),
			/* @__PURE__ */ h(On, {
				direction: "ne",
				widget: t
			}),
			/* @__PURE__ */ h(On, {
				direction: "sw",
				widget: t
			}),
			/* @__PURE__ */ h(On, {
				direction: "se",
				widget: t
			})
		] })
	] });
}, On = (e) => {
	let { direction: t, widget: n } = e, r = d(null), i = d({
		x: 0,
		y: 0
	}), a = d({
		width: 0,
		height: 0
	}), o = d({
		x: 0,
		y: 0
	}), s = d({
		x: 0,
		y: 0
	}), c = d({
		x: 0,
		y: 0
	}), l = (e) => {
		let r = Math.max(0, Math.min(window.innerWidth, e.clientX)), l = Math.max(0, Math.min(window.innerHeight, e.clientY)), u = r - i.current.x, d = l - i.current.y, f = a.current.width, p = a.current.height, m = o.current.x, h = o.current.y;
		t.includes("e") && (f = a.current?.width + u), t.includes("w") && (f = a.current?.width - u, m = i.current.x + u), t.includes("n") && (p = a.current?.height - d, h = i.current.y + d), t.includes("s") && (p = a.current?.height + d), t.includes("n") && (p < n.minHeight ? h = s.current.y : p > n.maxHeight && (h = c.current.y)), t.includes("w") && (f < n.minWidth ? m = s.current.x : f > n.maxWidth && (m = c.current.x)), n.setRect(m, h, f, p);
	}, u = (e) => {
		i.current = {
			x: e.clientX,
			y: e.clientY
		}, a.current = {
			width: n.width,
			height: n.height
		}, o.current = {
			x: n.x,
			y: n.y
		}, s.current.y = e.clientY + (n.height - n.minHeight), c.current.y = e.clientY - (n.maxHeight - n.height), s.current.x = e.clientX + (n.width - n.minWidth), c.current.x = e.clientX - (n.maxWidth - n.width), document.addEventListener("pointermove", l), document.addEventListener("pointerup", f);
	}, f = () => {
		document.removeEventListener("pointermove", l), document.removeEventListener("pointerup", f);
	};
	return /* @__PURE__ */ h("div", {
		ref: r,
		"data-testid": `widget-resize-handle-${t}`,
		onPointerDown: u,
		style: {
			...kn(t),
			position: "absolute"
		}
	});
}, kn = (e) => {
	switch (e) {
		case "n": return {
			width: "100%",
			height: "10px",
			top: "-5px",
			left: "0",
			cursor: "n-resize"
		};
		case "e": return {
			width: "10px",
			height: "100%",
			top: "0",
			right: "-5px",
			cursor: "e-resize"
		};
		case "s": return {
			width: "100%",
			height: "10px",
			bottom: "-5px",
			left: "0",
			cursor: "s-resize"
		};
		case "w": return {
			width: "10px",
			height: "100%",
			top: "0",
			left: "-5px",
			cursor: "w-resize"
		};
		case "nw": return {
			width: "10px",
			height: "10px",
			top: "-5px",
			left: "-5px",
			cursor: "nw-resize"
		};
		case "ne": return {
			width: "10px",
			height: "10px",
			top: "-5px",
			right: "-5px",
			cursor: "ne-resize"
		};
		case "sw": return {
			width: "10px",
			height: "10px",
			bottom: "-5px",
			left: "-5px",
			cursor: "sw-resize"
		};
		case "se": return {
			width: "10px",
			height: "10px",
			bottom: "-5px",
			right: "-5px",
			cursor: "se-resize"
		};
	}
}, An = n.memo((e) => {
	let { widget: t } = e, r = d(null), { forceUpdate: i } = yn();
	c(() => (t.signals.onUpdateRectContent.connect(i), () => {
		t.signals.onUpdateRectContent.disconnect(i);
	}), []), n.useEffect(() => {
		let e = () => {
			t.isMaximized && l();
		};
		return addEventListener("resize", e), () => {
			removeEventListener("resize", e);
		};
	}, []), bn({
		ref: r,
		onResize: ({ width: e, height: n }) => {
			e !== void 0 && n !== void 0 && t.setSize(e, n);
		}
	});
	let a = () => {
		t.close();
	}, o = (e) => {
		t.isMinimized ? t.unminimize() : t.minimize(e);
	}, s = () => {
		t.isMaximized ? t.unmaximize() : l();
	}, l = () => {
		t.maximize(window.innerWidth, window.innerHeight);
	}, u = "100%";
	jn(t) && (u = "fit-content");
	let f = "100%";
	return Mn(t) && (f = "fit-content"), /* @__PURE__ */ h("div", {
		ref: r,
		"data-testid": "widget-content",
		style: {
			width: u,
			height: f
		},
		children: /* @__PURE__ */ h(t.Render, {
			onClose: a,
			onMinimize: o,
			minimized: t.isMinimized,
			minimizable: t.isMinimizable,
			fullscreenable: t.isMaximizable,
			isInFullscreen: t.isMaximized,
			onFullscreen: s,
			isScrollable: t.isScrollable,
			isClosable: t.isClosable
		})
	});
});
function jn(e) {
	return e.fitContent && (e.fitDirection === "both" || e.fitDirection == "horizontal");
}
function Mn(e) {
	return e.fitContent && (e.fitDirection === "both" || e.fitDirection == "vertical");
}
//#endregion
//#region src/widgets/base/WidgetContainer.tsx
var Nn = "WidgetContainer-" + We(), Pn = () => {
	let { plugin: t } = ln("Viewport"), [n, r] = f([...t.widgetController.widgets]);
	return c(() => {
		let e = () => {
			r([...t.widgetController.widgets]);
		};
		return t.widgetController.signals.onWidgetListUpdated.connect(e), () => {
			t.widgetController.signals.onWidgetListUpdated.disconnect(e);
		};
	}, [t]), /* @__PURE__ */ h(e, {
		id: Nn,
		className: ".WidgetContainer",
		sx: {
			top: 0,
			left: 0,
			width: "100%",
			height: "calc(100% - 60px)",
			position: "absolute",
			pointerEvents: "none",
			userSelect: "none",
			touchAction: "none"
		},
		children: n.map((e) => /* @__PURE__ */ h(En, { widget: e }, `draggable-widget-${e.id}`))
	});
}, Fn = (t) => {
	let { viewer: n, sx: r, children: i } = t, a = p((e) => {
		let t = n.signals.onViewportAdded.connect(e);
		return () => {
			t.disconnect();
		};
	}, () => n.viewport), o = n.getPlugin("Viewport"), s = d(null), [l] = sn(o.settings.showObjectHierarchyBanner), [u, m] = f(null);
	return c(() => {
		if (s.current) return n.attachViewport(s.current), () => {
			n.detachViewport();
		};
	}, [n]), c(() => {
		let e = (e) => {
			m(e);
		};
		return o.frameAlertController.signals.onToggle.connect(e), () => {
			o.frameAlertController.signals.onToggle.disconnect(e);
		};
	}, [o]), /* @__PURE__ */ h(e, {
		id: "Viewport",
		sx: {
			position: "relative",
			width: "100%",
			height: "100%",
			overflow: "clip",
			...r
		},
		children: /* @__PURE__ */ g(Rt, {
			viewer: n,
			children: [/* @__PURE__ */ h("canvas", {
				tabIndex: -1,
				ref: s,
				"data-testid": "viewport-canvas",
				style: {
					width: "100%",
					height: "100%"
				}
			}), !!a && /* @__PURE__ */ h(Bt, {
				viewport: a,
				children: /* @__PURE__ */ g(In, {
					wrappers: o.wrappers,
					children: [
						!!l && /* @__PURE__ */ h(an, {}),
						/* @__PURE__ */ h(vn, {}),
						/* @__PURE__ */ h(Pn, {}),
						!!u && /* @__PURE__ */ h(on, { ...u }),
						i
					]
				})
			})]
		})
	});
}, In = (e) => {
	let { children: t, wrappers: n } = e, r = t;
	for (let e of n) r = /* @__PURE__ */ h(e, { children: r });
	return r;
}, Ln = class {
	constructor() {
		this.signals = { onToggle: new we() };
	}
	show(e) {
		this.signals.onToggle.emit(e);
	}
	hide() {
		this.signals.onToggle.emit(null);
	}
}, Rn = class extends Se {
	constructor(...e) {
		super(...e), this.name = "JsHeapSizeObserverBehavior", this.onLoadingProgress = () => {
			if (oe.instance.update(), !oe.instance.isAvailable) return;
			let e = oe.instance.percentageOfUsedMemory, t = Math.trunc(e * 100);
			e > this._viewer.settings.memory.memoryUsageCriticalLevel.value ? this._memoryWarningNotificationId = T.instance.pushNotification({
				type: "technical_limitation",
				status: "error",
				message: `${A("teiaviewer:info_banner.memory_warning.text")} ${t}%`,
				title: A("teiaviewer:info_banner.memory_warning.title")
			}, this._memoryWarningNotificationId) : e > this._viewer.settings.memory.memoryUsageWarningLevel.value && (this._memoryErrorNotificationId = T.instance.pushNotification({
				type: "technical_limitation",
				status: "warning",
				message: `${A("teiaviewer:info_banner.memory_not_optimal_warning.text")} ${t}%`,
				title: A("teiaviewer:info_banner.memory_not_optimal_warning.title")
			}, this._memoryErrorNotificationId));
		};
	}
	setup(e) {
		this._viewer = e, this._viewer.signals.onLoadingStarted.connect(this.onLoadingProgress), this._viewer.signals.onLoadingProgress.connect(this.onLoadingProgress), this._viewer.signals.onLoadingFinished.connect(this.onLoadingProgress);
	}
	dispose() {
		this._viewer.signals.onLoadingStarted.disconnect(this.onLoadingProgress), this._viewer.signals.onLoadingProgress.disconnect(this.onLoadingProgress), this._viewer.signals.onLoadingFinished.disconnect(this.onLoadingProgress);
	}
}, zn = class extends Se {
	constructor(...e) {
		super(...e), this.name = "OperatorValidationBehavior", this._onOperatorChanged = () => {
			Te(this._viewer?.viewport);
			let e = this._viewer.getPlugin("Viewport"), t = this._viewer.viewport.operator;
			t.needsValidation ? e.frameAlertController.show({
				text: A("teiaviewer:frame_alert.text"),
				textValidate: A("teiaviewer:frame_alert.buttons.validate.text"),
				textCancel: A("teiaviewer:frame_alert.buttons.cancel.text"),
				onValidate: () => {
					t.validate(), e.frameAlertController.hide(), e.settings.disableToolbar.value = !1;
				},
				onCancel: () => {
					t.cancel(), e.frameAlertController.hide(), e.settings.disableToolbar.value = !1;
				}
			}) : e.frameAlertController.hide(), e.settings.disableToolbar.value = t.needsValidation;
		};
	}
	setup(e) {
		this._viewer = e, this._viewer.signals.onOperatorChanged.connect(this._onOperatorChanged);
	}
	dispose() {
		Te(this._viewer), this._viewer.signals.onOperatorChanged.disconnect(this._onOperatorChanged);
	}
}, Bn, Vn = class extends Se {
	constructor(...e) {
		super(...e), this.name = "ShowLoadingActivityBehavior", this._info = {
			progress: 0,
			status: "started",
			elapsedTime: 0
		}, this._startTime = 0, this._onStart = (e) => {
			this._info = e, this._startTime = Date.now(), this._updateToast(), Bn = setInterval(() => {
				this._updateToast();
			}, 1e3);
		}, this._onProgress = (e) => {
			this._info = e, this._updateToast();
		}, this._updateToast = () => {
			this._startTime === 0 && (this._startTime = Date.now());
			let e = (Date.now() - this._startTime) / 1e3, t = "";
			t = this._info.status === "preparing" ? A("teiaviewer:toasts.preparing_scene.text") : A("teiaviewer:toasts.loading_scene.text");
			let n = "info";
			this._info.status !== "finished" && this._info.status !== "stopped" ? n = "pending" : this._info.status === "finished" ? n = "success" : this._info.status === "stopped" && (n = "error");
			let r = this._info.progress;
			this._loadingNotificationId = T.instance.pushNotification({
				type: "viewer",
				status: n,
				title: t,
				message: `${t}: ${(r * 100).toFixed(0)}% (${e.toFixed(0)} s)`,
				displayed: !0
			}, this._loadingNotificationId);
		}, this._onFinished = (e) => {
			this._info = e, clearInterval(Bn), this._updateToast();
		};
	}
	setup(e) {
		this._viewer = e, this._viewer.signals.onLoadingStarted.connect(this._onStart), this._viewer.signals.onLoadingProgress.connect(this._onProgress), this._viewer.signals.onLoadingFinished.connect(this._onFinished);
	}
	dispose() {
		clearInterval(Bn), this._viewer.signals.onLoadingStarted.disconnect(this._onStart), this._viewer.signals.onLoadingProgress.disconnect(this._onProgress), this._viewer.signals.onLoadingFinished.disconnect(this._onFinished);
	}
}, Hn = class extends te {
	constructor(e, t, n = {}) {
		super(e), this.name = "CloseWidgetCommand", this.isUndoable = !1, this._type = t, this._options = {
			closeAllWidgets: !1,
			closeLockedWidgets: !1,
			...n
		};
	}
	async _do() {
		let { closeAllWidgets: e } = this._options, t = this.viewer.getPlugin("Viewport"), n = Array.from(t.widgetController.getWidgetsOfType(this._type));
		if (e) for (let e of n) this._closeWidget(e);
		else {
			let e = !1, t = 0;
			for (; t < n.length && !e;) e = this._closeWidget(n[t]), t++;
		}
	}
	_closeWidget(e) {
		let t = this.viewer.getPlugin("Viewport"), { closeLockedWidgets: n } = this._options;
		return n || !e.isLocked ? (t.widgetController.removeWidget(e), !0) : !1;
	}
	async _undo() {
		throw new ue(this);
	}
}, Un = class extends te {
	constructor(e, t, ...n) {
		super(e), this.name = "OpenWidgetCommand", this.isUndoable = !1;
		let [r = {}] = n, { useExistingWidget: i = !0, putInForgroundIfOpened: a = !0, ...o } = r;
		this.type = t, this._useExistingWidget = i, this._putInForgroundIfOpened = a, this._params = { ...o };
	}
	async _do() {
		let e = this.viewer.getPlugin("Viewport"), t = Array.from(e.widgetController.getWidgetsOfType(this.type)), n = t.some((e) => !e.isLocked);
		if (t.length === 0 || !this._useExistingWidget || !n) {
			let t = e.widgetController.factory.createWidget(this.type, this._params);
			e.widgetController.addWidget(t);
		} else t.length > 0 && this._putInForgroundIfOpened && (e.widgetController.putWidgetInForeground(t[0]), t[0].unminimize());
	}
	async _undo() {
		throw new ue(this);
	}
}, Wn = class extends ce {
	constructor() {
		super({
			ctrl: !0,
			key: "k"
		}), this.action = "widgets.open.spotlight";
	}
	get label() {
		return A("teiaviewer:widgets.shortcuts_widget.shortcuts.show_spotlight.text");
	}
	async execute(e) {
		e.getPlugin("Viewport").spotlight.show();
	}
}, Gn = class extends ce {
	constructor() {
		super({ key: "i" }), this.action = "widgets.open.infobox";
	}
	get label() {
		return A("teiaviewer:widgets.shortcuts_widget.shortcuts.open_infobox.text");
	}
	async execute(e) {
		new Un(e, "Infobox").execute();
	}
}, Kn = class {
	constructor() {
		this._isOpen = !1, this.signals = { onStatusChanged: new we() };
	}
	hide() {
		this._isOpen && (this._isOpen = !1, this.signals.onStatusChanged.emit());
	}
	show() {
		this._isOpen || (this._isOpen = !0, this.signals.onStatusChanged.emit());
	}
	get isOpen() {
		return this._isOpen;
	}
};
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ArrowUturnLeftIcon.js
function qn({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
	}));
}
var Jn = /*#__PURE__*/ t.forwardRef(qn);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ArrowUturnRightIcon.js
function Yn({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m15 15 6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3"
	}));
}
var Xn = /*#__PURE__*/ t.forwardRef(Yn);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ArrowsPointingInIcon.js
function Zn({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25"
	}));
}
var Qn = /*#__PURE__*/ t.forwardRef(Zn);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/BackspaceIcon.js
function $n({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z"
	}));
}
var er = /*#__PURE__*/ t.forwardRef($n);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/BarsArrowDownIcon.js
function tr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25"
	}));
}
var nr = /*#__PURE__*/ t.forwardRef(tr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/BellIcon.js
function rr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
	}));
}
var ir = /*#__PURE__*/ t.forwardRef(rr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/BugAntIcon.js
function ar({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
	}));
}
var or = /*#__PURE__*/ t.forwardRef(ar);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/BuildingOffice2Icon.js
function sr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
	}));
}
var cr = /*#__PURE__*/ t.forwardRef(sr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/CameraIcon.js
function lr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
	}), /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
	}));
}
var ur = /*#__PURE__*/ t.forwardRef(lr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/CheckCircleIcon.js
function dr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
	}));
}
var fr = /*#__PURE__*/ t.forwardRef(dr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ChevronDownIcon.js
function pr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m19.5 8.25-7.5 7.5-7.5-7.5"
	}));
}
var mr = /*#__PURE__*/ t.forwardRef(pr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ChevronLeftIcon.js
function hr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M15.75 19.5 8.25 12l7.5-7.5"
	}));
}
var gr = /*#__PURE__*/ t.forwardRef(hr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ChevronRightIcon.js
function _r({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m8.25 4.5 7.5 7.5-7.5 7.5"
	}));
}
var V = /*#__PURE__*/ t.forwardRef(_r);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ChevronUpIcon.js
function vr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m4.5 15.75 7.5-7.5 7.5 7.5"
	}));
}
var yr = /*#__PURE__*/ t.forwardRef(vr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/CubeIcon.js
function br({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
	}));
}
var H = /*#__PURE__*/ t.forwardRef(br);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ExclamationTriangleIcon.js
function xr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
	}));
}
var Sr = /*#__PURE__*/ t.forwardRef(xr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/EyeSlashIcon.js
function Cr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
	}));
}
var wr = /*#__PURE__*/ t.forwardRef(Cr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/EyeIcon.js
function Tr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
	}), /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
	}));
}
var Er = /*#__PURE__*/ t.forwardRef(Tr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/HomeIcon.js
function Dr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
	}));
}
var Or = /*#__PURE__*/ t.forwardRef(Dr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/InformationCircleIcon.js
function kr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
	}));
}
var Ar = /*#__PURE__*/ t.forwardRef(kr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/MagnifyingGlassMinusIcon.js
function jr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM13.5 10.5h-6"
	}));
}
var Mr = /*#__PURE__*/ t.forwardRef(jr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/MagnifyingGlassPlusIcon.js
function Nr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6"
	}));
}
var Pr = /*#__PURE__*/ t.forwardRef(Nr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/MagnifyingGlassIcon.js
function Fr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
	}));
}
var Ir = /*#__PURE__*/ t.forwardRef(Fr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/TrashIcon.js
function Lr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
	}));
}
var Rr = /*#__PURE__*/ t.forwardRef(Lr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/VideoCameraIcon.js
function zr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
	}));
}
var Br = /*#__PURE__*/ t.forwardRef(zr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/WrenchScrewdriverIcon.js
function Vr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z"
	}));
}
var Hr = /*#__PURE__*/ t.forwardRef(Vr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/XCircleIcon.js
function Ur({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
	}));
}
var Wr = /*#__PURE__*/ t.forwardRef(Ur);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/XMarkIcon.js
function Gr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M6 18 18 6M6 6l12 12"
	}));
}
var Kr = /*#__PURE__*/ t.forwardRef(Gr), qr = (e) => {
	let { icon: t, sx: n, ...r } = e, i = /* @__PURE__ */ h(Ve, {
		sx: {
			textTransform: "capitalize",
			...n
		},
		...r
	});
	return t ? /* @__PURE__ */ g(O, {
		direction: "row",
		sx: {
			alignItems: "center",
			gap: 1,
			minWidth: 0
		},
		children: [/* @__PURE__ */ h(Be, {
			component: t,
			sx: {
				flexShrink: 0,
				width: "16px",
				height: "16px"
			}
		}), i]
	}) : i;
}, Jr = (e) => {
	let { searchValue: t, onSearchChange: n } = e, { t: r } = j("teiaviewer");
	return /* @__PURE__ */ h(qe, {
		id: "search-input",
		headIcon: /* @__PURE__ */ h(R, {}),
		sx: { paddingY: 2 },
		placeholder: r("widgets.infobox_widget.search.text"),
		value: t,
		onChange: (e) => {
			n(e.target.value);
		},
		"data-testid": "infobox-search-input"
	});
}, Yr = r(null), Xr = () => {
	let e = s(Yr);
	if (!e) throw Error("InfoboxWidgetContext must be used in InfoboxWidget");
	return e;
}, Zr = Yr.Provider, Qr = {
	id: "object.3d_info",
	icon: H,
	order: 999,
	tooltip: A("teiaviewer:widgets.infobox_widget.tabs.3Ddata_tab.tooltip"),
	Title: $r,
	Content: ei
};
function $r() {
	let { t: e } = j("teiaviewer");
	return /* @__PURE__ */ h(qr, { children: e("widgets.infobox_widget.tabs.3Ddata_tab.title") });
}
function ei() {
	let { viewer: t } = P(), { t: n } = j("teiaviewer"), { uuid: r } = Xr(), [i, a] = f(2), [o, s] = f(""), l = t.scene.getObjectByUUID(r), u = l ? Ae(l.toJson()) : {}, d = (e) => {
		if (e == "") {
			a(2);
			return;
		}
		let t = Ee(u, e.toLowerCase());
		t && a(De(t));
	};
	if (c(() => {
		d(o);
	}, [r, o]), Object.keys(u).length == 0) return /* @__PURE__ */ h(Ge, {
		severity: "info",
		"data-testid": "infobox-3d-data-no-data-alert",
		children: n("widgets.infobox_widget.tabs.3Ddata_tab.alerts.nodata.text")
	});
	let p = Ee(u, o.toLowerCase()) ?? {};
	return /* @__PURE__ */ g(e, {
		sx: {
			display: "flex",
			flexDirection: "column",
			gap: 1
		},
		"data-testid": "infobox-3d-data-tab",
		children: [/* @__PURE__ */ h(Jr, {
			onSearchChange: (e) => {
				s(e), d(e);
			},
			searchValue: o
		}), /* @__PURE__ */ h(O, {
			spacing: 1,
			children: Object.entries(p).length > 0 ? /* @__PURE__ */ h(Ke, {
				style: { fontSize: 13 },
				src: p,
				displaySize: "collapsed",
				collapsed: i,
				enableClipboard: !1,
				editable: !1,
				collapseObjectsAfterLength: 50,
				collapseStringsAfterLength: 50
			}) : /* @__PURE__ */ h(Ge, {
				severity: "info",
				"data-testid": "infobox-3d-data-no-search-result-alert",
				children: n("widgets.infobox_widget.tabs.3Ddata_tab.alerts.nodata_search.text")
			})
		})]
	});
}
//#endregion
//#region ../../resources/icons/ShortcutsIcon.svg?react
var ti = (e) => /* @__PURE__ */ h("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ h("path", { d: "M18.2908 14.29H15.9808V9.87004H18.2908C19.3108 9.87004 20.2608 9.47004 20.9808 8.75004C21.7008 8.03004 22.1008 7.07004 22.1008 6.06004C22.1008 5.05004 21.7008 4.09004 20.9808 3.37004C19.5408 1.93004 17.0408 1.93004 15.6008 3.37004C14.8808 4.09004 14.4808 5.05004 14.4808 6.06004V8.29004H9.92078V6.06004C9.92078 5.04004 9.52078 4.09004 8.80078 3.37004C7.36078 1.94004 4.86078 1.94004 3.42078 3.38004C2.70078 4.10004 2.30078 5.05004 2.30078 6.07004C2.30078 7.09004 2.70078 8.04004 3.42078 8.76004C4.14078 9.48004 5.10078 9.87004 6.11078 9.87004H8.42078V14.29H6.11078C5.09078 14.29 4.14078 14.69 3.42078 15.41C2.70078 16.13 2.30078 17.08 2.30078 18.1C2.30078 19.12 2.70078 20.07 3.42078 20.79C4.14078 21.51 5.09078 21.91 6.11078 21.91C7.13078 21.91 8.08078 21.51 8.80078 20.79C9.52078 20.07 9.92078 19.12 9.92078 18.1V15.86H14.4808V18.1C14.4808 19.12 14.8808 20.07 15.6008 20.79C16.3208 21.51 17.2708 21.91 18.2908 21.91C19.3108 21.91 20.2608 21.51 20.9808 20.79C21.7008 20.07 22.1008 19.12 22.1008 18.1C22.1008 17.08 21.7008 16.13 20.9808 15.41C20.2608 14.69 19.3108 14.29 18.2908 14.29ZM15.9808 6.07004C15.9808 5.45004 16.2208 4.88004 16.6608 4.44004C17.5308 3.57004 19.0508 3.57004 19.9208 4.44004C20.3608 4.88004 20.6008 5.46004 20.6008 6.07004C20.6008 6.68004 20.3608 7.27004 19.9208 7.70004C19.4808 8.13004 18.9108 8.38004 18.2908 8.38004H15.9808V6.07004ZM6.11078 8.38004C5.49078 8.38004 4.91078 8.14004 4.48078 7.70004C4.04078 7.26004 3.80078 6.68004 3.80078 6.07004C3.80078 5.46004 4.04078 4.87004 4.48078 4.44004C4.92078 4.00004 5.50078 3.76004 6.11078 3.76004C6.72078 3.76004 7.31078 4.00004 7.74078 4.44004C8.17078 4.88004 8.42078 5.46004 8.42078 6.07004V8.38004H6.11078ZM8.42078 18.1C8.42078 18.72 8.18078 19.3 7.74078 19.73C6.87078 20.6 5.35078 20.6 4.48078 19.73C4.04078 19.29 3.80078 18.72 3.80078 18.1C3.80078 17.48 4.04078 16.9 4.48078 16.47C4.92078 16.04 5.50078 15.79 6.11078 15.79H8.42078V18.1ZM9.92078 14.37V9.81004H14.4808V14.37H9.92078ZM19.9208 19.73C19.0508 20.6 17.5308 20.6 16.6608 19.73C16.2208 19.29 15.9808 18.72 15.9808 18.1V15.79H18.2908C18.9108 15.79 19.4908 16.03 19.9208 16.47C20.3508 16.91 20.6008 17.49 20.6008 18.1C20.6008 18.71 20.3608 19.3 19.9208 19.73Z" })
}), ni = (t) => {
	let { shortcut: n, sx: r } = t, i = n.split("+"), a = (e) => e === "shift" ? "⇧" : e === "ctrl" && Oe ? "⌘" : e === "space" && Oe ? "⎵" : e === "arrowup" ? "↑" : e === "arrowdown" ? "↓" : e === "arrowleft" ? "←" : e === "arrowright" ? "→" : e;
	return /* @__PURE__ */ h(e, {
		sx: {
			display: "flex",
			fontSize: "0.75rem",
			gap: "0.125rem",
			backgroundColor: (e) => e.palette.grey[50],
			paddingLeft: "0.25rem",
			paddingRight: "0.25rem",
			borderRadius: "0.375rem",
			borderWidth: "1px",
			borderColor: (e) => e.palette.grey[500],
			color: (e) => e.palette.grey[700],
			alignItems: "center",
			height: "18px",
			...r
		},
		children: i.map((e) => /* @__PURE__ */ h("p", { children: a(e) }, e))
	});
}, ri = (t) => {
	let { shortcuts: n } = t, { t: r } = j("teiaviewer"), i = d(null), [a, o] = f(0), s = se.layout === "unknown";
	return bn({
		ref: i,
		onResize: ({ height: e }) => {
			o(e ?? 0);
		}
	}), /* @__PURE__ */ g(m, { children: [!!s && /* @__PURE__ */ h(e, {
		ref: i,
		"data-testid": "settings-shortcuts-layout-warning",
		children: /* @__PURE__ */ h(Ge, {
			severity: "warning",
			children: r("widgets.shortcuts_widget.warning.text")
		})
	}), /* @__PURE__ */ h(e, {
		"data-testid": "settings-shortcuts-list",
		sx: {
			height: s ? `calc(100% - ${a}px)` : "100%",
			overflow: "auto"
		},
		children: /* @__PURE__ */ h(O, {
			divider: /* @__PURE__ */ h(Je, {}),
			children: n.map((e) => e.enabled && /* @__PURE__ */ h(ii, { shortcut: e }, e.id))
		})
	})] });
}, ii = (e) => {
	let { shortcut: t } = e, n = t.shortcut.split("/");
	return /* @__PURE__ */ g(O, {
		direction: "row",
		"data-testid": "settings-shortcut-item",
		sx: {
			justifyContent: "space-between",
			alignItems: "center",
			py: 1
		},
		children: [/* @__PURE__ */ h("p", { children: t.text }), /* @__PURE__ */ h(O, {
			direction: "row",
			children: n.map((e) => /* @__PURE__ */ h(ni, {
				shortcut: e,
				sx: { margin: "0 0.25rem" }
			}, e))
		})]
	});
}, ai = {
	id: "shortcuts",
	icon: ti,
	Title: oi,
	Content: si
};
function oi() {
	let { t: e } = j("teiaviewer");
	return /* @__PURE__ */ h(qr, { children: e("widgets.settings_widget.tabs.shortcuts.title") });
}
function si() {
	let { t: e } = j("teiaviewer"), { viewer: t } = P(), { viewport: n } = Vt(), [r, i] = f([]);
	return c(() => {
		let r = () => {
			let n = [], r = Array.from(t.viewport?.shortcutController.shortcuts ?? []);
			for (let e of r) n.push({
				id: e.action,
				text: e.label,
				shortcut: e.getKeyboardShortcutString(),
				enabled: e.enabled
			});
			n.push({
				id: "select.multiple",
				text: e("widgets.shortcuts_widget.shortcuts.select_several_objects.text"),
				shortcut: `ctrl+${e("widgets.shortcuts_widget.click.text")}`,
				enabled: !0
			}, {
				id: "select.transparent",
				text: e("widgets.shortcuts_widget.shortcuts.select_transparent_object.text"),
				shortcut: `shift+${e("widgets.shortcuts_widget.click.text")}`,
				enabled: !0
			}, {
				id: "select.multiple.transparent",
				text: e("widgets.shortcuts_widget.shortcuts.select_several_transparent_objects.text"),
				shortcut: `ctrl+shift+${e("widgets.shortcuts_widget.click.text")}`,
				enabled: !0
			}, {
				id: "select.multiple.path",
				text: e("widgets.shortcuts_widget.shortcuts.selection_path.text"),
				shortcut: `ctrl+${e("widgets.shortcuts_widget.click_maintained.text")}`,
				enabled: !0
			}), i(n);
		};
		return r(), se.signals.onLayoutUpdated.connect(r), n.shortcutController.signals.onShortcutsChanged.connect(r), () => {
			se.signals.onLayoutUpdated.disconnect(r), n.shortcutController.signals.onShortcutsChanged.disconnect(r);
		};
	}, [Ue.language]), /* @__PURE__ */ h(ri, { shortcuts: r });
}
//#endregion
//#region src/widgets/base/WidgetContentFactory.ts
var ci = class {
	constructor() {
		this.infoboxTabs = new fe(), this.settingsTabs = new fe(), this.addDefaultInfoboxTabs(), this.addDefaultSettingsTabs();
	}
	addDefaultInfoboxTabs() {
		this.infoboxTabs.add(Qr);
	}
	addDefaultSettingsTabs() {
		this.settingsTabs.add(ai);
	}
}, li = class {
	constructor() {
		this._factories = {};
	}
	registerWidget(e, t) {
		this._factories[e] = t;
	}
	unregisterWidget(e) {
		delete this._factories[e];
	}
	createWidget(e, t) {
		let n = this._factories[e];
		if (!n) throw Error(`WidgetFactory has no registered widget type ${e}`);
		return n({
			...t,
			viewportRect: di()
		});
	}
}, ui = class {
	constructor() {
		this.factory = new li(), this.content = new ci(), this.signals = { onWidgetListUpdated: new we() }, this._widgets = /* @__PURE__ */ new Set();
	}
	putWidgetInForeground(e) {
		for (let t of this._widgets) t !== e && (t.zIndex = Cn.Background);
		e.zIndex = Cn.Foreground;
	}
	ensureWidgetsInRect() {
		for (let e of this._widgets) e.updateRect();
	}
	getWidgetsAtPos(e, t, n = 5) {
		let r = [];
		for (let i of this._widgets) Math.abs(i.x - e) < n && Math.abs(i.y - t) < n && r.push(i);
		return r;
	}
	clearAllWidgets() {
		for (let e of this._widgets) e.dispose();
		this._widgets.clear(), this.signals.onWidgetListUpdated.emit();
	}
	addWidget(e, t = 20) {
		this._widgets.add(e), this.shiftOverlappingWidget(e, t), this.putWidgetInForeground(e), this.signals.onWidgetListUpdated.emit();
	}
	shiftOverlappingWidget(e, t) {
		let n = di(), r = e.x, i = e.y, a = this.getWidgetsAtPos(r, i), o = !1;
		for (a.remove(e); a.length > 0 && !o;) o = !0, r + e.width + t < n.width && (r += t, o = !1), i + e.height + t < n.height && (i += t, o = !1), a = this.getWidgetsAtPos(r, i), a.remove(e);
		e.setPosition(r, i);
	}
	removeWidget(e) {
		this._widgets.delete(e), e.dispose(), this.signals.onWidgetListUpdated.emit();
	}
	hasWidget(e) {
		return this._widgets.has(e);
	}
	*getWidgetsOfType(e) {
		for (let t of this._widgets) t.type === e && (yield t);
	}
	hasWidgetOfType(e) {
		return !this.getWidgetsOfType(e).next().done;
	}
	get widgets() {
		return Array.from(this._widgets);
	}
}, di = () => {
	let e = document.getElementById(Nn), t = new DOMRect();
	return e && (t = e.getBoundingClientRect()), t;
}, fi = (e) => /* @__PURE__ */ h("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ h("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 6.75195C6 6.33774 6.33579 6.00195 6.75 6.00195H11.25C11.6642 6.00195 12 6.33774 12 6.75195C12 7.16617 11.6642 7.50195 11.25 7.50195H8.56066L11.5303 10.4716C11.8232 10.7645 11.8232 11.2394 11.5303 11.5323C11.2374 11.8252 10.7626 11.8252 10.4697 11.5323L7.5 8.56261V11.252C7.5 11.6662 7.16421 12.002 6.75 12.002C6.33579 12.002 6 11.6662 6 11.252V6.75195ZM12.4697 12.4716C12.7626 12.1787 13.2374 12.1787 13.5303 12.4716L16.5 15.4413V12.752C16.5 12.3377 16.8358 12.002 17.25 12.002C17.6642 12.002 18 12.3377 18 12.752V17.252C18 17.6662 17.6642 18.002 17.25 18.002H12.75C12.3358 18.002 12 17.6662 12 17.252C12 16.8377 12.3358 16.502 12.75 16.502H15.4393L12.4697 13.5323C12.1768 13.2394 12.1768 12.7645 12.4697 12.4716Z"
	})
}), pi = (e) => /* @__PURE__ */ h("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ h("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.21967 6.22162C6.51256 5.92873 6.98744 5.92873 7.28033 6.22162L10.25 9.19129L10.25 6.50195C10.25 6.08774 10.5858 5.75195 11 5.75195C11.4142 5.75195 11.75 6.08774 11.75 6.50195V11.002C11.75 11.4162 11.4142 11.752 11 11.752L6.5 11.752C6.08579 11.752 5.75 11.4162 5.75 11.002C5.75 10.5877 6.08579 10.252 6.5 10.252L9.18934 10.252L6.21967 7.28228C5.92678 6.98939 5.92678 6.51452 6.21967 6.22162ZM12.25 13.002C12.25 12.5877 12.5858 12.252 13 12.252H17.5C17.9142 12.252 18.25 12.5877 18.25 13.002C18.25 13.4162 17.9142 13.752 17.5 13.752H14.8107L17.7803 16.7216C18.0732 17.0145 18.0732 17.4894 17.7803 17.7823C17.4874 18.0752 17.0126 18.0752 16.7197 17.7823L13.75 14.8126L13.75 17.502C13.75 17.9162 13.4142 18.252 13 18.252C12.5858 18.252 12.25 17.9162 12.25 17.502L12.25 13.002Z"
	})
}), mi = {
	header: 30,
	footer: 30
}, hi = {
	info: "info.light",
	white: "white",
	secondary: "secondary.dark",
	primary: "primary.main"
}, gi = {
	info: "black",
	white: "black",
	secondary: "white",
	primary: "white"
}, _i = r(null), vi = () => {
	let e = s(_i);
	if (!e) throw Error("WidgetContext is undefined");
	return e;
}, yi = (e) => {
	let { minimized: t = !1, Header: n, Content: r, Footer: i, sx: a = {}, color: o = "info", variant: s = "bordered", closable: c = !0, minimizable: l = !0, fullscreenable: d = !1, isInFullscreen: f = !1, isScrollable: p = !1, onFullscreen: m, onClose: _, onMinimize: v } = e, y = !!i, b = u(() => ({
		color: o,
		minimized: t,
		closable: c,
		minimizable: l,
		variant: s,
		hasFooter: y,
		isInFullscreen: f,
		fullscreenable: d,
		isScrollable: p,
		onFullscreen: m,
		onClose: _,
		onMinimize: v
	}), [
		o,
		t,
		c,
		l,
		s,
		y,
		f,
		d,
		m,
		p,
		_,
		v
	]);
	return /* @__PURE__ */ h(_i.Provider, {
		value: b,
		children: /* @__PURE__ */ h(Ye, {
			sx: {
				border: 1,
				borderColor: "info.light",
				backgroundColor: hi[o],
				...a,
				...t && { height: "fit-content" }
			},
			className: "Widget",
			children: /* @__PURE__ */ g(O, {
				direction: "column",
				sx: { height: "100%" },
				children: [
					/* @__PURE__ */ h(bi, { children: n }),
					/* @__PURE__ */ h(xi, { children: r }),
					!!i && /* @__PURE__ */ h(Si, { children: i })
				]
			})
		})
	});
}, bi = (t) => {
	let { children: n } = t, { color: r, closable: i, minimized: a, minimizable: o, variant: s, onClose: c, onMinimize: l, fullscreenable: u, isInFullscreen: d, onFullscreen: f } = vi(), p = a ? Xe : et, m = a ? "Maximize" : "Minimize", _ = d ? pi : fi, v = d ? "Minimize fullscreen" : "Fullscreen", y = (e) => {
		c?.(), e.preventDefault();
	}, b = (e) => {
		l?.(mi.header), e.preventDefault();
	}, x = (e) => {
		f?.(), e.preventDefault();
	};
	return /* @__PURE__ */ g(e, {
		className: wn.DragHandleClassName,
		role: "button",
		tabIndex: 0,
		"aria-label": "WidgetHeader",
		"data-testid": "standard-widget-header",
		onDoubleClick: b,
		sx: {
			cursor: "grab",
			"&:active": { cursor: "grabbing" },
			display: "flex",
			flexDirection: "row",
			height: mi.header,
			minHeight: mi.header,
			maxHeight: mi.header,
			borderBottom: +(s === "bordered"),
			borderColor: "info.light",
			color: gi[r],
			alignItems: "center",
			padding: 1
		},
		children: [
			/* @__PURE__ */ h(e, {
				sx: {
					overflow: "hidden",
					flexGrow: 1,
					textTransform: "uppercase"
				},
				children: n
			}),
			/* @__PURE__ */ h(ze, {
				icon: p,
				onClick: b,
				"aria-label": m,
				"data-testid": "standard-widget-minimize-button",
				sx: {
					...!o && { display: "none" },
					color: gi[r]
				}
			}),
			/* @__PURE__ */ h(ze, {
				icon: _,
				onClick: x,
				"aria-label": v,
				"data-testid": "standard-widget-fullscreen-button",
				sx: {
					...!u && { display: "none" },
					color: gi[r]
				}
			}),
			/* @__PURE__ */ h(ze, {
				icon: tt,
				onClick: y,
				"aria-label": "Close",
				"data-testid": "standard-widget-close-button",
				sx: {
					...!i && { display: "none" },
					color: gi[r]
				}
			})
		]
	});
}, xi = (t) => {
	let { children: n } = t, { minimized: r, hasFooter: i, isScrollable: a } = vi();
	return /* @__PURE__ */ h(e, {
		hidden: r,
		sx: (e) => ({
			...!i && {
				borderBottomLeftRadius: e.shape.borderRadius,
				borderBottomRightRadius: e.shape.borderRadius
			},
			flexGrow: 1,
			backgroundColor: "white",
			overflow: a ? "auto" : "hidden",
			maxHeight: "100%",
			userSelect: "text"
		}),
		children: n
	});
}, Si = (t) => {
	let { children: n } = t, { variant: r, minimized: i, color: a } = vi();
	return /* @__PURE__ */ h(e, {
		sx: {
			display: i || !n ? "none" : "flex",
			flexDirection: "row",
			height: mi.footer,
			minHeight: mi.footer,
			maxHeight: mi.footer,
			borderTop: +(r === "bordered"),
			borderColor: "info.light",
			alignItems: "center",
			padding: 1,
			color: gi[a],
			userSelect: "text"
		},
		children: n
	});
}, Ci = class extends wn {
	constructor(e, t = {}) {
		super(e, t), this.isStandardWidget = !0, this.Header = () => null, this.Content = () => null, this.Footer = () => null, this.Render = (e) => /* @__PURE__ */ h(this.ContextProvider, { children: /* @__PURE__ */ h(yi, {
			...e,
			sx: {
				height: "100%",
				width: "100%"
			},
			closable: this.isClosable,
			color: this._color,
			variant: this._variant,
			Header: /* @__PURE__ */ h(this.Header, {}),
			Content: /* @__PURE__ */ h(this.Content, {}),
			Footer: this._useFooter ? /* @__PURE__ */ h(this.Footer, {}) : null
		}) }), this._color = t.color ?? "white", this._variant = t.variant ?? "bordered", this._useFooter = t.useFooter ?? !0;
	}
}, wi = () => {
	let { viewer: t } = P(), { t: r } = j("teiaviewer"), [i, a] = n.useState(Array.from(t.commandHistory.redoHistory)), [o, s] = n.useState(Array.from(t.commandHistory.undoHistory)), [l, u] = n.useState(0), d = (e) => {
		l === 0 ? e.undo() : e.execute();
	};
	c(() => {
		let e = () => {
			s(Array.from(t.commandHistory.undoHistory)), a(Array.from(t.commandHistory.redoHistory));
		};
		return t.signals.historyChanged.connect(e), () => {
			t.signals.historyChanged.disconnect(e);
		};
	}, []);
	let f = l === 0 ? o : i;
	return /* @__PURE__ */ g(e, {
		sx: { width: "100%" },
		children: [/* @__PURE__ */ g(e, {
			sx: {
				width: "100%",
				px: 2,
				py: 1,
				backgroundColor: (e) => e.palette.grey[200]
			},
			children: [/* @__PURE__ */ h("button", {
				style: {
					width: "50%",
					fontWeight: l === 0 ? "bold" : "normal"
				},
				onClick: () => u(0),
				"data-testid": "history-undo-tab",
				children: r("widgets.history_widget.undo_history.text")
			}), /* @__PURE__ */ h("button", {
				style: {
					width: "50%",
					fontWeight: l === 1 ? "bold" : "normal"
				},
				onClick: () => u(1),
				"data-testid": "history-redo-tab",
				children: r("widgets.history_widget.redo_history.text")
			})]
		}), /* @__PURE__ */ g(e, {
			sx: {
				overflow: "auto",
				height: "calc(100% - 32px)"
			},
			children: [f.length === 0 && /* @__PURE__ */ h(Ge, {
				"data-testid": "history-empty-alert",
				severity: "info",
				sx: {
					margin: "0.5rem",
					width: "auto"
				},
				children: r("widgets.history_widget.empty_history.text")
			}), /* @__PURE__ */ h("ul", { children: f.map((e, t) => /* @__PURE__ */ g("li", {
				"data-testid": "history-command-item",
				style: {
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					padding: "0.5rem"
				},
				children: [/* @__PURE__ */ h("p", { children: e.name }), /* @__PURE__ */ h(ze, {
					onClick: () => d(e),
					"data-testid": "history-command-delete-button",
					"aria-label": "delete",
					variant: "error",
					icon: Rr
				})]
			}, e.name + t)) }, f.length)]
		})]
	});
}, Ti = class extends Ci {
	constructor(e, t = {}) {
		super(e, {
			...t,
			color: "white",
			isResizable: !1,
			useFooter: !1,
			width: 340,
			height: 300,
			isScrollable: !0
		}), this.type = "CommandHistory", this.Header = Ei, this.Content = wi;
	}
}, Ei = () => {
	let { t: e } = j("teiaviewer");
	return /* @__PURE__ */ h(qr, {
		icon: nr,
		children: e("widgets.history_widget.title")
	});
}, Di = new D(), Oi = new je(), ki = (t) => {
	let { widget: r } = t, { viewer: i } = P(), { viewport: a } = Vt(), [o, s] = n.useState(!0), c = p(r.signals.onUpdateRectContent.subscribe, () => Ai(i, r));
	if (p(r.signals.onUpdateRect.subscribe, () => `${r.x} + ${r.y} + ${r.width} + ${r.height}`), n.useEffect(() => {
		let e = () => s(!1);
		return i.signals.onCameraMoveStart.connect(e), () => {
			i.signals.onCameraMoveStart.disconnect(e);
		};
	}, [i]), n.useEffect(() => {
		let e = () => s(!0);
		return i.signals.onCameraMoveEnd.connect(e), () => {
			i.signals.onCameraMoveEnd.disconnect(e);
		};
	}, [i]), !c || !o) return;
	if (c.getBoundingBox(Oi).getCenter(Di), Oi.isEmpty()) return /* @__PURE__ */ h(m, {});
	Di.project(a.camera);
	let l = a.renderer.canvas.clientWidth, u = a.renderer.canvas.clientHeight, d = r.x + r.width / 2, f = r.y + r.height / 2, _ = (Di.x + 1) / 2 * l, v = -((Di.y - 1) / 2) * u;
	return _ >= 0 && _ <= l && v >= 0 && v <= u ? /* @__PURE__ */ g(e, {
		component: "svg",
		sx: {
			position: "absolute",
			pointerEvents: "none",
			height: "100%",
			width: "100%"
		},
		children: [/* @__PURE__ */ h("line", {
			x1: d,
			y1: f,
			x2: _,
			y2: v,
			stroke: "white",
			strokeWidth: 3
		}), /* @__PURE__ */ h("circle", {
			cx: _,
			cy: v,
			r: 5,
			style: { fill: "white" }
		})]
	}) : /* @__PURE__ */ h(m, {});
};
function Ai(e, t) {
	if (t.uuid) {
		let n = e.scene.getObjectByUUID(t.uuid);
		if (n?.isSceneMesh) return n;
	}
	return null;
}
//#endregion
//#region src/components/TabView/TabBar.tsx
var ji = (e) => {
	let { tabs: t, selectedTabIndex: n, onTabSelected: r, scrollStep: i = 30 } = e, a = d(null), o = d(null), [s, c] = f({
		isAtTop: !0,
		isAtBottom: !1
	}), l = !1, u = a.current;
	u && (l = u.clientHeight < u.scrollHeight);
	let p = () => {
		if (!u) return !1;
		let e = u.clientHeight, t = u.scrollTop, n = u.scrollHeight;
		return e + t >= n - 3;
	}, m = () => {
		let e = a.current;
		e && c({
			isAtTop: e.scrollTop == 0,
			isAtBottom: p()
		});
	}, _ = () => {
		let e = a.current;
		e && e.scrollTop > 0 && e.scroll(0, e.scrollTop - i);
	}, v = () => {
		let e = a.current;
		e && (p() || e.scroll(0, e.scrollTop + i));
	};
	return bn({
		ref: o,
		onResize: () => m()
	}), /* @__PURE__ */ g(O, {
		direction: "column",
		sx: {
			position: "relative",
			top: "0",
			left: "0",
			height: "100%",
			gap: "2px",
			zIndex: 1,
			backgroundColor: (e) => e.palette.grey[200]
		},
		ref: o,
		children: [
			/* @__PURE__ */ h(Pi, {
				Icon: yr,
				disabled: s.isAtTop,
				sx: { ...!l && { display: "none" } },
				onClick: _
			}),
			/* @__PURE__ */ h(O, {
				ref: a,
				onScroll: m,
				direction: "column",
				sx: {
					overflow: "auto",
					gap: "2px",
					paddingRight: "2px",
					scrollbarWidth: "none",
					scrollBehavior: "smooth"
				},
				children: t.map((e, t) => /* @__PURE__ */ h(Mi, {
					tab: e,
					index: t,
					selectedTabIndex: n,
					onTabSelected: r
				}, e.id))
			}),
			/* @__PURE__ */ h(Ni, {
				hidden: s.isAtTop,
				position: "top"
			}),
			/* @__PURE__ */ h(Ni, {
				hidden: s.isAtBottom,
				position: "bottom"
			}),
			/* @__PURE__ */ h(Pi, {
				Icon: mr,
				disabled: s.isAtBottom,
				sx: {
					...!l && { display: "none" },
					marginTop: "auto"
				},
				onClick: v
			})
		]
	});
}, Mi = (e) => {
	let { index: t, tab: n, selectedTabIndex: r, onTabSelected: i } = e, a = t === r, o = n.id, s = n.tooltip ?? "";
	return /* @__PURE__ */ h(nt, {
		title: s,
		disableInteractive: !0,
		enterDelay: 1e3,
		slotProps: { popper: { modifiers: [{
			name: "offset",
			options: { offset: [0, -14] }
		}] } },
		children: /* @__PURE__ */ h(ze, {
			id: `tabBarItem-${o}`,
			"data-testid": "tab-bar-tab-button",
			icon: n.icon,
			disabled: n.disabled,
			onClick: () => {
				i(t);
			},
			sx: {
				display: "flex",
				width: "40px",
				height: "40px",
				backgroundColor: (e) => a ? e.palette.primary.main : e.palette.background.paper,
				color: (e) => a ? e.palette.background.paper : e.palette.primary.main,
				boxSizing: "border-box",
				borderRadius: "0",
				"&:hover": { backgroundColor: (e) => a ? e.palette.primary.main : e.palette.background.paper },
				"&.Mui-disabled": {
					color: (e) => e.palette.action.disabled,
					backgroundColor: (e) => e.palette.action.disabledBackground
				}
			},
			"aria-label": n.tooltip ?? "icon button"
		}, `tabBarItem-${t}-${o}`)
	}, `infoBoxTab-${t}-${o}`);
}, Ni = (t) => {
	let { position: n, hidden: r } = t;
	return /* @__PURE__ */ h(e, { sx: {
		display: r ? "none" : "inline",
		...n == "top" && { top: "20px" },
		...n == "bottom" && { bottom: "20px" },
		position: "absolute",
		width: "40px",
		height: "20px",
		background: `linear-gradient(to ${n},rgba(255, 255, 255, 0), rgba(255,255,255 ,1))`
	} });
}, Pi = (e) => {
	let { Icon: t, disabled: n, sx: r, onClick: i } = e;
	return /* @__PURE__ */ h(He, {
		variant: "info",
		onClick: i,
		disabled: n,
		"aria-label": "Scroll",
		sx: {
			...r,
			borderRadius: 0,
			background: "white",
			height: "20px",
			width: "40px",
			minWidth: "40px",
			color: "primary.main",
			"&:hover": { color: "primary.dark" }
		},
		children: /* @__PURE__ */ h(Be, { component: t })
	});
}, Fi = (t) => {
	let { t: r } = j("teiaviewer"), { tabs: i = [], defaultTabIndex: a = 0, overrideTabContent: o, overrideTitleContent: s, sx: c = {
		root: {},
		content: {}
	} } = t, [l, u] = n.useState(a);
	if (i.length === 0) return /* @__PURE__ */ h(Ge, {
		severity: "info",
		children: r("widgets.infobox_widget.alerts.no_tabs.text")
	});
	i.sort((e, t) => (e.order ?? 100) - (t.order ?? 100));
	let d = Math.max(0, Math.min(l, i.length - 1)), f = o ?? i[d].Content, p = s ?? i[d].Title;
	return /* @__PURE__ */ g(e, {
		sx: {
			height: "100%",
			width: "100%",
			display: "flex",
			...c.root
		},
		children: [/* @__PURE__ */ h(ji, {
			tabs: i,
			selectedTabIndex: d,
			onTabSelected: u
		}), /* @__PURE__ */ g("div", {
			style: {
				height: "100%",
				width: "calc(100% - 40px)",
				display: "flex",
				flexDirection: "column"
			},
			children: [/* @__PURE__ */ h(e, {
				sx: { padding: 1 },
				children: /* @__PURE__ */ h(p, {})
			}), /* @__PURE__ */ h(e, {
				sx: {
					flexGrow: 1,
					width: "100%",
					overflowY: "auto",
					overflowX: "hidden",
					...c.content
				},
				children: /* @__PURE__ */ h(f, {})
			})]
		})]
	});
}, Ii = () => {
	let { uuid: e, tabs: t } = Xr(), { viewer: n } = P(), [r, i] = f([]);
	c(() => {
		let r = !1;
		return (async () => {
			let a = await Promise.all(t.map(async (t) => t.hidden && await t.hidden(n, e) ? null : t));
			r || i(a.filter(Boolean));
		})(), () => {
			r = !0;
		};
	}, [
		n,
		e,
		t
	]);
	let a = null, o = null;
	return e || (a = Li, o = Ri), /* @__PURE__ */ h(Fi, {
		tabs: r,
		...a && { overrideTabContent: a },
		...o && { overrideTabTile: o },
		sx: { content: { padding: 1 } }
	});
}, Li = () => {
	let { t: e } = j("teiaviewer");
	return /* @__PURE__ */ h(Ge, {
		severity: "info",
		"data-testid": "infobox-no-selected-object-alert",
		children: e("widgets.infobox_widget.alerts.no_selected_objects.text")
	});
}, Ri = () => /* @__PURE__ */ h(m, { children: "InfoBox" }), zi = () => {
	let { isLocked: e, setIsLocked: t } = Xr(), n = e ? Qe : $e, { t: r } = j("teiaviewer");
	return /* @__PURE__ */ g(O, {
		direction: "row",
		sx: {
			width: 1,
			height: 1
		},
		alignItems: "center",
		justifyContent: "space-between",
		"data-testid": "infobox-footer",
		children: [/* @__PURE__ */ h(Bi, {}), /* @__PURE__ */ h(ze, {
			"aria-label": r("widgets.infobox_widget.lock_button.label"),
			title: r("widgets.infobox_widget.lock_button.title"),
			onClick: () => {
				t(!e);
			},
			icon: n,
			"data-testid": "infobox-lock-button"
		})]
	});
}, Bi = () => {
	let { t: e } = j("teiaviewer"), { viewer: t } = P();
	return t.scene.objectSelection.length > 0 ? e("widgets.infobox_widget.selected_objects.label", { count: t.scene.objectSelection.length }) : /* @__PURE__ */ h("div", {});
}, Vi = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", { d: "M12.01 7.5H12C11.5858 7.5 11.25 7.83579 11.25 8.25V8.26C11.25 8.67421 11.5858 9.01 12 9.01H12.01C12.4242 9.01 12.76 8.67421 12.76 8.26V8.25C12.76 7.83579 12.4242 7.5 12.01 7.5Z" }),
		/* @__PURE__ */ h("path", { d: "M11.59 11.92L11.63 11.9L10.92 14.74C10.61 15.98 11.9 17.02 13.05 16.45L13.09 16.43C13.46 16.24 13.61 15.79 13.43 15.42C13.24 15.05 12.79 14.9 12.42 15.08L12.38 15.1L13.09 12.26C13.4 11.02 12.11 9.98 10.96 10.55L10.92 10.57C10.55 10.76 10.4 11.21 10.58 11.58C10.76 11.95 11.22 12.1 11.59 11.92Z" }),
		/* @__PURE__ */ h("path", { d: "M21 2H3C2.45 2 2 2.45 2 3V21C2 21.55 2.45 22 3 22H21C21.55 22 22 21.55 22 21V3C22 2.45 21.55 2 21 2ZM20.5 20.5H3.5V3.5H20.5V20.5Z" })
	]
}), Hi = () => {
	let { t: e } = j("teiaviewer"), { viewer: t } = P(), { uuid: n } = Xr(), r = e("widgets.infobox_widget.title"), i = t.scene.getObjectByUUID(n);
	return i && i.name !== "" && (r = i.name), /* @__PURE__ */ h(qr, {
		icon: Vi,
		"data-testid": "infobox-header-title",
		sx: {
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis"
		},
		children: r
	});
}, Ui = class extends Ci {
	constructor(e, t = {}) {
		let { uuid: n, drawArrow: r = !0, getTabs: i, ...a } = t;
		super(e, {
			width: 400,
			height: 350,
			minWidth: 350,
			minHeight: 250,
			...a
		}), this.icon = { heroIcon: Ar }, this.type = "Infobox", this.drawArrow = !1, this._uuid = null, this.ContextProvider = ((e) => {
			let t = o((e) => {
				this.isLocked = e;
			}, []), n = this._getTabs, { _uuid: r, isLocked: i } = this, a = u(() => ({
				tabs: n(this.viewer, r),
				uuid: r ?? "",
				isLocked: i,
				setIsLocked: t
			}), [
				n,
				r,
				i,
				t
			]);
			return /* @__PURE__ */ h(Zr, {
				value: a,
				...e
			});
		}), this.Header = Hi, this.Content = Ii, this.Footer = zi, this.ExtraContent = () => this.drawArrow ? /* @__PURE__ */ h(ki, { widget: this }) : /* @__PURE__ */ h(m, {}), this._onSelectionChanged = () => {
			this.setUuid(this.viewer.scene.objectSelection.getLastUuid());
		}, this.drawArrow = r, this._uuid = n ?? e.scene.objectSelection.getLastUuid(), this._selectionChangeSignalConnection = this.viewer.signals.onObjectSelectionChanged.connect(this._onSelectionChanged), this.isLocked = t.locked ?? !1, this._getTabs = i ?? Wi;
	}
	get isLocked() {
		return super.isLocked;
	}
	set isLocked(e) {
		this._selectionChangeSignalConnection && (this._selectionChangeSignalConnection.enabled = !e), super.isLocked = e;
	}
	setUuid(e) {
		this._uuid = e, this.signals.onUpdateRectContent.emit();
	}
	get uuid() {
		return this._uuid;
	}
	dispose() {
		this._selectionChangeSignalConnection.disconnect();
	}
};
function Wi(e) {
	let t = e.getPlugin("Viewport");
	return Array.from(t.widgetController.content.infoboxTabs);
}
//#endregion
//#region src/widgets/notificationCenter/helpers.ts
function Gi(e, t) {
	switch (t) {
		case "success": return e.palette.success.main;
		case "warning": return e.palette.warning.main;
		case "error": return e.palette.error.main;
		default: return e.palette.info.main;
	}
}
function Ki(e) {
	switch (e) {
		case "success": return fr;
		case "warning": return Sr;
		case "error": return Wr;
		default: return Ar;
	}
}
//#endregion
//#region src/widgets/notificationCenter/NotificationCenterWidgetProvider.tsx
var qi = r(null), Ji = (e) => {
	let { children: t } = e, [n, r] = f([]), [i, a] = f({
		status: null,
		type: "all",
		unreadOnly: !1
	}), o = () => {
		let e;
		e = i.unreadOnly ? [...T.instance.getUnreadNotifications()] : [...T.instance.getNotifications()], i.status && (e = e.filter((e) => e.status === i.status)), i.type !== "all" && (e = e.filter((e) => e.type === i.type)), r(e);
	};
	c(() => {
		o();
	}, [i]);
	let s = u(() => ({
		setCurrentList: r,
		currentList: n,
		notificationFilter: i,
		setNotificationFilter: a,
		setListWithFilters: o
	}), [
		n,
		i,
		o
	]);
	return /* @__PURE__ */ h(qi.Provider, {
		value: s,
		children: t
	});
}, Yi = () => {
	let e = s(qi);
	if (e === null) throw Error("useNotificationCenterContext must be used within a NotificationCenterWidgetProvider");
	return e;
}, Xi = () => {
	let { setNotificationFilter: e } = Yi(), [t, n] = f(null), { t: r } = j("teiaviewer"), i = 0, a = 0, o = 0, s = 0;
	for (let e of T.instance.getNotifications()) switch (e.status) {
		case "info":
			s++;
			break;
		case "success":
			i++;
			break;
		case "error":
			o++;
			break;
		default: a++;
	}
	let c = (t) => {
		e((e) => ({
			...e,
			type: t ?? "all"
		}));
	};
	return /* @__PURE__ */ g(O, {
		direction: "row",
		alignItems: "center",
		justifyContent: "space-between",
		sx: {
			margin: "15px 10px",
			marginBottom: "10px"
		},
		children: [/* @__PURE__ */ h(k, {
			options: [...T.instance.types],
			sx: { minWidth: "200px" },
			onChange: c,
			defaultValue: "all",
			"data-testid": "notification-center-type-select"
		}), /* @__PURE__ */ g(O, {
			direction: "row",
			alignItems: "center",
			justifyContent: "space-between",
			sx: {
				borderBottom: "1px solid",
				borderColor: (e) => e.palette.info.light,
				width: "100%",
				paddingTop: 1,
				marginLeft: 5,
				"& div": { width: "100%" }
			},
			children: [
				/* @__PURE__ */ h(Zi, {
					status: "success",
					label: r("widgets.notification_center_widget.status_icons.success.label"),
					notificationNumber: i,
					index: 0,
					activeTab: t,
					setActiveTab: n
				}),
				/* @__PURE__ */ h(Zi, {
					status: "warning",
					label: r("widgets.notification_center_widget.status_icons.warning.label"),
					notificationNumber: a,
					index: 1,
					activeTab: t,
					setActiveTab: n
				}),
				/* @__PURE__ */ h(Zi, {
					status: "error",
					label: r("widgets.notification_center_widget.status_icons.error.label"),
					notificationNumber: o,
					index: 2,
					activeTab: t,
					setActiveTab: n
				}),
				/* @__PURE__ */ h(Zi, {
					status: "info",
					label: r("widgets.notification_center_widget.status_icons.info.label"),
					notificationNumber: s,
					index: 3,
					activeTab: t,
					setActiveTab: n
				})
			]
		})]
	});
}, Zi = (e) => {
	let { status: t, notificationNumber: n, activeTab: r, index: i, setActiveTab: a, label: o } = e, { setNotificationFilter: s } = Yi();
	return /* @__PURE__ */ h(nt, {
		title: o,
		children: /* @__PURE__ */ g(O, {
			direction: "row",
			justifyContent: "center",
			onClick: () => {
				if (r === i) {
					a(null), s((e) => ({
						...e,
						status: null
					}));
					return;
				}
				a(i), s((e) => ({
					...e,
					status: t
				}));
			},
			"data-testid": `notification-center-severity-${t}`,
			sx: {
				paddingBottom: 2,
				cursor: "pointer",
				borderBottom: "1px solid transparent",
				borderColor: (e) => r === i ? e.palette.primary.main : "transparent"
			},
			children: [/* @__PURE__ */ h(Be, {
				component: Ki(t),
				fontSize: "small",
				sx: { color: (e) => Gi(e, t) }
			}), /* @__PURE__ */ h("p", {
				style: { paddingLeft: 5 },
				children: n
			})]
		})
	});
}, Qi = (e) => {
	let { notification: t, index: n, checkedList: r, setCheckedList: i, setAllChecked: a } = e, { setListWithFilters: o } = Yi(), { t: s } = j("teiaviewer");
	return /* @__PURE__ */ g(O, {
		direction: "row",
		alignItems: "center",
		justifyContent: "space-between",
		sx: {
			margin: "5px 10px",
			padding: "5px 10px",
			borderRadius: "5px",
			cursor: "pointer",
			"&:hover": { backgroundColor: (e) => e.palette.grey[100] }
		},
		onClick: () => {
			T.instance.updateReadStatusNotifications(t, !0), o();
		},
		"data-testid": "notification-center-item",
		children: [/* @__PURE__ */ g(O, {
			direction: "row",
			alignItems: "flex-start",
			justifyContent: "space-between",
			children: [
				r[n] !== void 0 && /* @__PURE__ */ h(rt, {
					checked: r[n],
					sx: {
						padding: "2px",
						marginLeft: "7px"
					},
					onClick: (e) => {
						i((e) => {
							let t = [...e];
							return t[n] = !e[n], t[n] ? t.every((e) => e === !0) && a(!0) : a(!1), t;
						}), e.stopPropagation();
					},
					"data-testid": "notification-center-item-checkbox"
				}),
				t.status === "pending" ? /* @__PURE__ */ h(Le, {
					sx: {
						maxWidth: "20px",
						maxHeight: "20px",
						margin: "0px 2px"
					},
					"data-testid": "notification-center-item-pending-progress"
				}) : /* @__PURE__ */ h(Be, {
					component: Ki(t.status),
					fontSize: "small",
					sx: { color: (e) => Gi(e, t.status) }
				}),
				/* @__PURE__ */ g(O, {
					sx: {
						width: "100%",
						marginLeft: "10px",
						"& .date": { color: (e) => e.palette.info.main }
					},
					children: [/* @__PURE__ */ g("p", { children: [/* @__PURE__ */ h("span", {
						style: { fontWeight: t.read ? "normal" : "bold" },
						children: `${t.title} - `
					}), /* @__PURE__ */ h("span", {
						className: "date",
						children: ((e) => {
							let t = new Date(e);
							return new Intl.DateTimeFormat(Ue.language, {
								weekday: "short",
								day: "numeric",
								month: "short",
								hour: "2-digit",
								minute: "2-digit",
								second: "2-digit",
								hour12: !1
							}).format(t);
						})(t.timestamp)
					})] }), /* @__PURE__ */ h("p", {
						style: { whiteSpace: "pre-line" },
						children: t.message
					})]
				})
			]
		}), /* @__PURE__ */ g(O, {
			sx: {
				minWidth: "55px",
				marginLeft: "10px"
			},
			direction: "row",
			alignItems: "center",
			justifyContent: "flex-end",
			children: [!t.read && /* @__PURE__ */ h(Be, {
				component: Ze,
				sx: {
					color: (e) => e.palette.primary.main,
					height: "10px",
					width: "10px",
					marginRight: "10px",
					"& svg": { fill: "currentColor" }
				},
				"data-testid": "notification-center-item-unread-icon"
			}), /* @__PURE__ */ h(ze, {
				"aria-label": s("widgets.notification_center_widget.delete_icon.label"),
				variant: "error",
				onClick: (e) => {
					T.instance.removeNotifications(t.id), e.stopPropagation();
				},
				icon: en,
				"data-testid": "notification-center-item-delete-button"
			})]
		})]
	});
}, $i = () => {
	let { currentList: t, setCurrentList: n, notificationFilter: r, setNotificationFilter: i, setListWithFilters: a } = Yi(), { t: o } = j("teiaviewer"), [s, l] = f(!1), [u, p] = f(!1), [m, _] = f([]), v = d(null), [y, b] = f(10), x = (e) => {
		let t = e.target, n = t.scrollHeight;
		t.scrollTop + t.clientHeight === n && b((e) => e + 10);
	}, S = () => {
		p((e) => {
			let t = !e;
			return _((e) => Array(e.length).fill(t)), t;
		});
	}, C = (e, t) => {
		l(t), i((e) => ({
			...e,
			unreadOnly: t
		}));
	}, w = () => {
		let e = [], r = [];
		for (let n = 0; n < m.length; n++) m[n] ? r.push(t[n].id) : e.push(t[n]);
		n(e), T.instance.removeNotifications(r), e.length === 0 && p(!1);
	}, ee = () => {
		let e = [], n = !0;
		for (let r = 0; r < m.length; r++) m[r] && (e.length === 0 && (n = !t[r].read), t[r].read == n && (n = !0), e.push(t[r]));
		T.instance.updateReadStatusNotifications(e, n), a();
	};
	c(() => {
		_(Array(t.length).fill(!1)), p(!1);
	}, [t]), c(() => {
		v.current?.scrollTo({ top: 0 }), b(10);
	}, [r]);
	let te = t.slice(0, y), ne = m.every((e) => e === !1);
	return /* @__PURE__ */ g(e, {
		sx: {
			overflow: "hidden",
			height: "100%"
		},
		children: [/* @__PURE__ */ g(O, {
			direction: "row",
			alignContent: "center",
			justifyContent: "space-between",
			sx: {
				borderBottom: "1px solid",
				borderColor: (e) => e.palette.info.light,
				margin: "0px 10px",
				paddingBottom: "10px"
			},
			children: [/* @__PURE__ */ h(rt, {
				sx: { marginLeft: "10px" },
				checked: u,
				onClick: S,
				"data-testid": "notification-center-check-all-checkbox"
			}), /* @__PURE__ */ g(O, {
				direction: "row",
				alignContent: "center",
				justifyContent: "space-between",
				children: [
					/* @__PURE__ */ h(nt, {
						title: o("widgets.notification_center_widget.delete_icon.label"),
						sx: {
							margin: "0px 5px",
							padding: 0,
							color: (e) => e.palette.primary.main
						},
						children: /* @__PURE__ */ h(ze, {
							"aria-label": o("widgets.notification_center_widget.delete_icon.label"),
							variant: "info",
							onClick: w,
							disabled: ne,
							"data-testid": "notification-center-delete-button",
							icon: Rr
						})
					}),
					/* @__PURE__ */ h(nt, {
						title: o("widgets.notification_center_widget.mark_as_read.label"),
						sx: {
							margin: "0px 5px",
							padding: 0,
							color: (e) => e.palette.primary.main
						},
						children: /* @__PURE__ */ h(ze, {
							"aria-label": o("widgets.notification_center_widget.mark_as_read.label"),
							variant: "info",
							onClick: ee,
							disabled: ne,
							"data-testid": "notification-center-mark-as-read-button",
							icon: ir
						})
					}),
					/* @__PURE__ */ h(it, {
						label: o("widgets.notification_center_widget.not_read.label"),
						checked: s,
						onChange: C,
						"data-testid": "notification-center-unread-only-switch"
					})
				]
			})]
		}), /* @__PURE__ */ g(e, {
			ref: v,
			sx: {
				overflow: "auto",
				height: "calc(100% -  49px)"
			},
			onScroll: x,
			"data-testid": "notification-center-list",
			children: [te.length === 0 && /* @__PURE__ */ h(Ge, {
				severity: "info",
				sx: { margin: 2 },
				"data-testid": "notification-center-empty-alert",
				children: o("widgets.notification_center_widget.empty_list.text")
			}), te.map((e, t) => /* @__PURE__ */ h(Qi, {
				notification: e,
				index: t,
				checkedList: m,
				setCheckedList: _,
				setAllChecked: p
			}, e.id))]
		})]
	});
}, ea = () => {
	let { setListWithFilters: e, notificationFilter: t } = Yi();
	return c(() => {
		let t = () => {
			e();
		};
		return t(), T.instance.signals.onNotificationAdded.connect(t), T.instance.signals.onNotificationDeleted.connect(t), T.instance.signals.onNotificationDeletedAll.connect(t), () => {
			T.instance.signals.onNotificationAdded.disconnect(t), T.instance.signals.onNotificationDeleted.disconnect(t), T.instance.signals.onNotificationDeletedAll.disconnect(t);
		};
	}, [t]), /* @__PURE__ */ g(O, {
		sx: {
			overflow: "hidden",
			height: "100%"
		},
		children: [/* @__PURE__ */ h(Xi, {}), /* @__PURE__ */ h($i, {})]
	});
}, ta = class extends Ci {
	constructor(t, n = {}) {
		super(t, {
			...n,
			color: "white",
			isResizable: !0,
			useFooter: !0,
			width: 600,
			height: 430,
			minWidth: 360,
			minHeight: 275
		}), this.type = "NotificationCenter", this.Header = () => {
			let { t: e } = j("teiaviewer");
			return /* @__PURE__ */ h(qr, {
				icon: ir,
				children: e("widgets.notification_center_widget.title")
			});
		}, this.ContextProvider = (e) => /* @__PURE__ */ h(Ji, { ...e }), this.Content = ea, this.Footer = () => {
			let { t } = j("teiaviewer"), { currentList: n } = Yi();
			return /* @__PURE__ */ h(e, {
				sx: {
					width: 1,
					height: 1
				},
				"data-testid": "notification-center-footer",
				children: `${t("widgets.notification_center_widget.notification_number.text", { count: n.length })} ${T.instance.count}`
			});
		};
	}
}, na = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ g("g", {
		clipPath: "url(#clip0_977_2840)",
		children: [/* @__PURE__ */ h("path", { d: "M5.27779 12.1836L5.12481 12.2164L1.60625 12.8174L3.99931 15.7022L4.43639 14.5439L4.66587 14.5985C5.47448 14.8061 6.18475 14.97 7.01522 15.0902C7.01522 15.0902 7.01522 15.0902 7.02614 15.0902C7.05893 15.0902 7.02614 13.8992 6.97151 13.8882C6.33773 13.7899 5.8023 13.6369 5.22315 13.473C5.10296 13.4402 4.98276 13.4074 4.85163 13.3747L5.27779 12.1945V12.1836Z" }), /* @__PURE__ */ h("path", { d: "M22.424 14.3252C22.4134 14.2505 22.36 13.9624 22.36 13.9624C22.36 13.9624 22.1147 14.1545 22.072 14.1865L19.5117 16.2667C19.4477 16.3094 19.2237 16.5014 19.2237 16.5014C19.2237 16.5014 19.501 16.6081 19.565 16.6294L20.3758 16.9388C19.2023 18.955 17.4208 20.5232 15.3405 21.3553C14.5724 21.6753 13.7724 21.8887 12.9403 22.0167C12.9723 21.9847 13.0043 21.942 13.0256 21.8994C13.0363 21.878 13.0576 21.846 13.0683 21.8247C14.0604 20.1605 14.4551 18.3363 14.7325 16.5974C14.7858 16.2347 14.8071 16.0534 14.8285 15.776L14.8605 15.3386C14.8605 15.2746 14.1137 15.2639 14.1031 15.3599C14.0604 15.68 14.0391 15.936 13.9964 16.16L13.943 16.4587C13.655 18.0589 13.2283 19.9045 12.2575 21.3766C12.2042 21.462 12.1402 21.5367 12.0762 21.6113C11.9908 21.7073 11.9161 21.7927 11.8201 21.878L11.7561 21.9314C11.7561 21.9314 11.7241 21.9634 11.7135 21.974C11.6388 22.0274 11.5854 22.0701 11.5214 22.1127H11.4574C11.4361 22.1127 11.4148 22.1127 11.3934 22.1127C11.3401 22.1127 11.3081 22.1127 11.2654 22.1127H11.2121C11.1054 22.038 11.02 21.9634 10.9347 21.878L10.8707 21.8247C10.8173 21.782 10.7747 21.718 10.732 21.6647L10.6893 21.6113C10.3906 21.2593 10.1133 20.7899 9.84657 20.1818C9.3025 18.8483 8.9398 17.2695 8.72644 15.2106V15.1359L8.7051 15.0612V14.7945L8.68377 14.6772C8.66243 14.3572 8.64109 14.0585 8.61976 13.7704V13.237C8.54508 11.3701 8.63043 9.56727 8.87579 7.89241V7.79639L8.89712 7.68972C9.02514 6.84695 9.18516 6.04686 9.37718 5.28944L10.5613 5.71615L9.92124 1.74769L7.09425 4.1053C7.04091 4.15864 6.80622 4.33999 6.80622 4.33999C6.80622 4.33999 7.08358 4.44667 7.15826 4.46801L8.03302 4.79871C7.809 5.72682 7.64898 6.6976 7.52096 7.75372V7.88174L7.49963 7.93508C7.31827 9.5886 7.2756 11.3381 7.38228 13.141V13.4184L7.40362 13.5357V13.6957C7.43562 14.0158 7.46763 14.3358 7.49963 14.6559V14.7625L7.52096 14.9226V15.0399L7.5423 15.1893C7.73432 16.7148 8.06503 18.699 8.88646 20.5979C9.06781 20.9819 9.2705 21.3766 9.51586 21.75C9.55853 21.814 9.61187 21.878 9.65455 21.942C9.5692 21.9314 9.49453 21.91 9.40918 21.8994C8.85445 21.7927 8.35306 21.654 7.89434 21.4833C5.49406 20.6192 3.42449 18.8163 2.22968 16.5441C1.28024 14.7732 0.87486 12.6716 1.06688 10.6234C1.13089 10.538 1.20557 10.4634 1.28024 10.3887L1.32291 10.346C1.41892 10.25 1.51493 10.1647 1.61095 10.0793C1.99499 9.76996 2.47505 9.50326 3.13646 9.22589C3.87254 8.92719 4.6833 8.6925 5.69675 8.47914C5.85677 8.44714 5.95278 8.4258 6.03813 8.40447C6.21948 8.36179 6.30482 8.34046 6.65686 8.29779L6.80622 8.27645L6.98757 8.25512C7.00891 7.98842 7.07291 7.63638 7.07291 7.63638L6.76354 7.67905L6.60352 7.70038C6.26215 7.75372 6.14481 7.78573 5.96345 7.8284C5.86744 7.84973 5.75009 7.88174 5.56874 7.92441C4.55529 8.1591 3.69119 8.43647 2.94443 8.75651C2.26169 9.05521 1.7603 9.35391 1.34425 9.69528C1.28024 9.74862 1.21623 9.80196 1.15223 9.86597C1.1949 9.56727 1.2589 9.27923 1.32291 9.01254C1.96299 6.50558 3.57384 4.24398 5.73942 2.81448C7.44629 1.67302 9.52653 1.05428 11.5961 1.04361C11.6068 1.06495 11.6281 1.08628 11.6494 1.09695C11.6921 1.12896 11.7241 1.16096 11.7561 1.19296C11.7881 1.22497 11.8095 1.2463 11.8415 1.26764C11.9695 1.37432 12.0655 1.45966 12.1508 1.55567C12.5776 2.0464 12.8656 2.66513 13.0896 3.19853C13.3883 3.93461 13.623 4.74537 13.8364 5.75883C13.9324 6.21755 14.0177 6.71894 14.0924 7.31634C13.4096 7.27367 12.7269 7.25233 12.0442 7.25233C11.6921 7.25233 11.3401 7.25233 10.9987 7.263C10.3906 7.28434 10.3693 7.28434 9.77189 7.33768L9.5692 7.35901H9.41985L9.32384 7.99908L9.76122 7.97775C10.2093 7.94575 10.348 7.94575 10.636 7.94575H11.1694C12.1722 7.94575 13.1856 7.98842 14.1777 8.08443C14.2844 9.08721 14.3378 10.1007 14.3484 11.0928V11.2635C14.3484 11.9462 14.3271 12.3623 14.2951 13.013C14.2951 13.077 15.0098 13.0557 15.0098 12.949C15.0098 12.7996 15.0205 12.7036 15.0312 12.6183C15.0312 12.4796 15.0418 12.3623 15.0418 12.1276C15.0418 11.7755 15.0418 11.4235 15.0312 11.0821C14.9992 10.1007 14.9245 9.11922 14.7965 8.14844C15.3832 8.21244 15.8739 8.28712 16.3327 8.36179C17.9328 8.64983 19.7784 9.07654 21.2506 10.0473C21.3572 10.122 21.4639 10.2073 21.5706 10.2927C21.6026 10.3247 21.6239 10.346 21.6559 10.378L21.7093 10.4314L21.8266 10.5594C21.8266 10.5594 21.8693 10.6127 21.9013 10.6447L21.9546 10.7301C21.976 10.7514 21.9866 10.7834 21.9973 10.8154C21.976 10.8581 21.9546 10.9008 21.9333 10.9434C21.8586 11.0608 21.784 11.1675 21.7093 11.2635L21.6666 11.3061C21.6666 11.3061 21.5919 11.3915 21.5599 11.4341C21.2079 11.8075 20.6852 12.1382 19.9171 12.4689C18.5409 13.0237 16.9194 13.397 14.8071 13.6104H14.6045L14.4658 13.6317C13.4737 13.7064 12.5669 13.7491 11.7135 13.7491C10.86 13.7491 10.316 13.7277 9.36651 13.6424C9.36651 13.6424 9.35584 13.6424 9.34518 13.6424C9.29184 13.6424 9.2705 14.9759 9.37718 14.9759C10.0173 15.0186 10.2733 15.0186 10.924 15.0186C11.9908 15.0186 13.1323 14.9546 14.4231 14.8372H14.5724C14.6365 14.8159 14.7005 14.8159 14.7645 14.8052H14.8391L14.9352 14.7945C16.4607 14.6025 18.4449 14.2718 20.3438 13.4504C20.9412 13.1624 21.5599 12.853 22.0827 12.3623C22.1467 12.2982 22.2107 12.2342 22.2747 12.1596C22.296 12.1916 22.2533 12.5329 22.296 12.5543C22.3173 12.5543 22.6587 12.5116 22.6801 12.4796C22.7014 12.4476 22.7441 11.9675 22.7441 11.9249V11.7649C22.7441 11.6475 22.7547 11.5408 22.7547 11.4235C22.7547 11.0608 22.7227 10.6767 22.6694 10.2713C22.6694 10.2393 22.6587 10.186 22.6481 10.154C22.6374 10.0793 22.6267 10.0153 22.6161 9.95131V9.86597L22.584 9.79129V9.69528C22.5627 9.64194 22.552 9.57794 22.5414 9.5246C22.2 7.75372 21.4319 6.07886 20.3438 4.7027C18.6369 2.51578 16.0873 1.00094 13.335 0.542221C12.7269 0.435542 12.0975 0.382202 11.4574 0.382202C9.29184 0.382202 7.10492 1.02228 5.30204 2.18508C2.91243 3.68925 1.13089 6.1002 0.405472 8.82051C-0.341281 11.5408 -0.031912 14.5492 1.2589 17.0668C2.53905 19.6058 4.80065 21.6327 7.45696 22.6354C8.35306 22.9875 9.32384 23.2115 10.3373 23.3182C10.5613 23.3395 10.7747 23.3502 10.9987 23.3609H11.1694C11.3081 23.3822 11.4468 23.3822 11.5854 23.3822C11.7028 23.3822 11.8201 23.3822 11.9481 23.3715H12.1188L12.2789 23.3609C12.4175 23.3609 12.5669 23.3502 12.7056 23.3395C13.7937 23.2329 14.8498 22.9875 15.8313 22.5928C18.2955 21.654 20.3865 19.8298 21.7413 17.4615L22.6481 17.8029L23.0001 17.9416C23.0001 17.9416 22.9468 17.6429 22.9361 17.5682L22.4134 14.3145L22.424 14.3252ZM16.4607 7.60437C15.9379 7.5297 15.3832 7.46569 14.6791 7.40168C14.5831 6.74027 14.4764 6.18554 14.3591 5.68415C14.1244 4.6707 13.847 3.8066 13.527 3.05985C13.2923 2.52645 12.9616 1.85437 12.4815 1.32098C12.4175 1.2463 12.3322 1.17163 12.2575 1.10762C12.5776 1.12896 12.8976 1.16096 13.207 1.2143C15.7459 1.59834 17.9862 2.92116 19.7144 5.06541C20.7172 6.29222 21.4639 7.77506 21.8693 9.37525C21.8373 9.35391 21.8053 9.32191 21.7733 9.31124C21.752 9.30057 21.7199 9.27923 21.6986 9.26857C20.0344 8.27645 18.2102 7.88174 16.4713 7.60437H16.4607Z" })]
	}), /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", {
		id: "clip0_977_2840",
		children: /* @__PURE__ */ h("rect", {
			width: 23.5591,
			height: 23.57,
			transform: "translate(0 0.382202)"
		})
	}) })]
}), ra = (e) => /* @__PURE__ */ g("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", { d: "M13.2586 13.7295V12.9795H12.3086V13.7295H13.2586Z" }),
		/* @__PURE__ */ h("path", { d: "M12.2984 6.37984L5.64844 10.2598C5.47844 10.3598 5.36844 10.5498 5.36844 10.7498V17.0998L5.14844 17.1798L5.54844 18.0398L5.61844 18.0098L5.63844 18.0298L12.4284 21.9898C12.5384 22.0498 12.6684 22.0598 12.7884 22.0498C12.9084 22.0698 13.0284 22.0498 13.1484 21.9898L19.9384 18.0298L19.9584 18.0098L20.0284 18.0398L20.4384 17.1798L20.2184 17.0998V10.7498C20.2184 10.5498 20.1084 10.3598 19.9384 10.2598L13.2884 6.37984M15.2584 4.14984L12.8784 1.44984L12.7884 1.33984L12.6984 1.44984L10.3284 4.14984M18.9584 16.6598L18.4284 16.4598L18.1084 17.3098L18.5384 17.4698L13.2984 20.5298V15.0598L13.3284 15.0298L18.9584 11.7498V16.6598ZM6.59844 11.7498L12.2284 15.0298C12.2284 15.0298 12.2584 15.0498 12.2584 15.0598V20.5298L7.01844 17.4698L7.44844 17.3098L7.12844 16.4598L6.59844 16.6598V11.7498ZM12.2984 13.4898V13.7598L7.16844 10.7598L12.2984 7.76984V8.20984H13.2684V7.76984L18.3984 10.7598L13.2684 13.7598V13.4898H12.2984Z" }),
		/* @__PURE__ */ h("path", { d: "M12.7958 5.46973L11.1758 6.43973V6.44973L12.6658 7.01973L12.7758 6.96973L14.3458 6.32973L12.7958 5.46973Z" }),
		/* @__PURE__ */ h("path", { d: "M12.6658 7.0202L11.1758 6.4502L11.2358 8.0302L12.7758 8.8902V6.9702L12.6658 7.0202Z" }),
		/* @__PURE__ */ h("path", { d: "M14.3473 6.33008L12.7773 6.97008V8.89008L12.7973 8.91008L14.3773 8.03008L14.3573 6.33008H14.3473Z" }),
		/* @__PURE__ */ h("path", { d: "M19.327 9.0498L17.707 10.0198V10.0298L19.197 10.5998L19.307 10.5498L20.877 9.9098L19.327 9.0498Z" }),
		/* @__PURE__ */ h("path", { d: "M19.197 10.6003L17.707 10.0303L17.767 11.6103L19.307 12.4703V10.5503L19.197 10.6003Z" }),
		/* @__PURE__ */ h("path", { d: "M20.8786 9.91016L19.3086 10.5502V12.4702L19.3286 12.4902L20.9086 11.6102L20.8886 9.91016H20.8786Z" }),
		/* @__PURE__ */ h("path", { d: "M12.788 12.4902L11.168 13.4602V13.4702L12.658 14.0402L12.768 13.9902L14.338 13.3502L12.788 12.4902Z" }),
		/* @__PURE__ */ h("path", { d: "M12.658 14.0407L11.168 13.4707L11.228 15.0507L12.768 15.9107V13.9907L12.658 14.0407Z" }),
		/* @__PURE__ */ h("path", { d: "M14.3395 13.3506L12.7695 13.9906V15.9106L12.7895 15.9306L14.3595 15.0506L14.3495 13.3506H14.3395Z" }),
		/* @__PURE__ */ h("path", { d: "M6.04578 9.0498L4.42578 10.0198V10.0298L5.91578 10.5998L6.02578 10.5498L7.59578 9.9098L6.04578 9.0498Z" }),
		/* @__PURE__ */ h("path", { d: "M5.91578 10.6003L4.42578 10.0303L4.48578 11.6103L6.02578 12.4703V10.5503L5.91578 10.6003Z" }),
		/* @__PURE__ */ h("path", { d: "M7.59734 9.91016L6.02734 10.5502V12.4702L6.04734 12.4902L7.62734 11.6102L7.60734 9.91016H7.59734Z" }),
		/* @__PURE__ */ h("path", { d: "M19.327 15.4697L17.707 16.4497V16.4597L19.197 17.0197L19.307 16.9797L20.877 16.3397L19.327 15.4697Z" }),
		/* @__PURE__ */ h("path", { d: "M19.197 17.02L17.707 16.46L17.767 18.04L19.307 18.9V16.98L19.197 17.02Z" }),
		/* @__PURE__ */ h("path", { d: "M20.8786 16.3398L19.3086 16.9798V18.8998L19.3286 18.9098L20.9086 18.0398L20.8886 16.3398H20.8786Z" }),
		/* @__PURE__ */ h("path", { d: "M12.788 19.3994L11.168 20.3794V20.3894L12.658 20.9494L12.768 20.9094L14.338 20.2694L12.788 19.3994Z" }),
		/* @__PURE__ */ h("path", { d: "M12.658 20.9496L11.168 20.3896L11.228 21.9696L12.768 22.8296V20.9096L12.658 20.9496Z" }),
		/* @__PURE__ */ h("path", { d: "M14.3395 20.2695L12.7695 20.9095V22.8295L12.7895 22.8395L14.3595 21.9695L14.3495 20.2695H14.3395Z" }),
		/* @__PURE__ */ h("path", { d: "M6.04578 15.4697L4.42578 16.4497V16.4597L5.91578 17.0197L6.02578 16.9797L7.59578 16.3397L6.04578 15.4697Z" }),
		/* @__PURE__ */ h("path", { d: "M5.91578 17.02L4.42578 16.46L4.48578 18.04L6.02578 18.9V16.98L5.91578 17.02Z" }),
		/* @__PURE__ */ h("path", { d: "M7.59734 16.3398L6.02734 16.9798V18.8998L6.04734 18.9098L7.62734 18.0398L7.60734 16.3398H7.59734Z" }),
		/* @__PURE__ */ h("path", { d: "M20.7695 20.7897L24.3395 20.3497L24.4795 20.3297L24.4395 20.1997L23.5495 16.7197" }),
		/* @__PURE__ */ h("path", { d: "M2.02766 16.7197L1.13766 20.1997L1.09766 20.3297L1.23766 20.3497L4.80766 20.7897" })
	]
}), ia = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ h("g", {
		clipPath: "url(#clip0_973_2819)",
		children: /* @__PURE__ */ g("g", {
			clipPath: "url(#clip1_973_2819)",
			children: [
				/* @__PURE__ */ h("path", { d: "M12.5 13.5853V12.8353H11.55V13.5853H12.5Z" }),
				/* @__PURE__ */ h("path", { d: "M21.08 17.1453L21.1 17.1653V17.1553L21.08 17.1453Z" }),
				/* @__PURE__ */ h("path", { d: "M12.5 10.5753V9.82529H11.55V10.5753H12.5Z" }),
				/* @__PURE__ */ h("path", { d: "M12.5 12.0753V11.3353H11.55V12.0753H12.5Z" }),
				/* @__PURE__ */ h("path", { d: "M9.20123 16.2303L8.50978 16.4939L8.83397 17.3442L9.52542 17.0806L9.20123 16.2303Z" }),
				/* @__PURE__ */ h("path", { d: "M10.6193 15.6992L9.91846 15.9664L10.2426 16.8167L10.9434 16.5495L10.6193 15.6992Z" }),
				/* @__PURE__ */ h("path", { d: "M7.78789 16.7887L7.08705 17.0558L7.41109 17.9061L8.11193 17.639L7.78789 16.7887Z" }),
				/* @__PURE__ */ h("path", { d: "M21.16 17.1453V17.2253L21.11 17.1653L21.14 18.5853L19.68 18.0353L19.46 17.9553V11.6053C19.46 11.4053 19.35 11.2153 19.18 11.1153L12.53 7.23529V4.73529H14.5L12.12 2.03529L12.03 1.92529L11.94 2.03529L9.57 4.73529H11.54V7.23529L4.89 11.1153C4.72 11.2153 4.61 11.4053 4.61 11.6053V17.9553L4.39 18.0353L2.93 18.5853L2.96 17.1653L2.9 17.2253V17.1453L0 20.1653L2.82 21.0953V21.0753L2.9 21.0953L2.93 19.5953L4.79 18.8953L4.86 18.8653L4.88 18.8853L11.67 22.8453C11.78 22.9053 11.91 22.9153 12.03 22.9053C12.15 22.9253 12.27 22.9053 12.39 22.8453L19.18 18.8853C19.18 18.8853 19.19 18.8753 19.2 18.8653L19.27 18.8953L21.13 19.5953L21.16 21.0953L21.23 21.0753V21.0953L24.05 20.1653L21.15 17.1453H21.16ZM18.2 17.5153L17.67 17.3153L17.35 18.1653L17.78 18.3253L12.54 21.3853V15.9153L12.57 15.8853L18.2 12.6053V17.5153ZM5.85 12.6053L11.48 15.8853C11.48 15.8853 11.51 15.9053 11.51 15.9153V21.3853L6.27 18.3253L6.7 18.1653L6.38 17.3153L5.85 17.5153V12.6053ZM11.54 14.3453V14.6153L6.41 11.6153L11.54 8.62529V9.06529H12.51V8.62529L17.64 11.6153L12.51 14.6153V14.3453H11.54Z" }),
				/* @__PURE__ */ h("path", { d: "M14.8509 16.2378L14.5268 17.0881L15.2183 17.3516L15.5424 16.5013L14.8509 16.2378Z" }),
				/* @__PURE__ */ h("path", { d: "M13.4357 15.706L13.1115 16.5563L13.8123 16.8235L14.1365 15.9732L13.4357 15.706Z" }),
				/* @__PURE__ */ h("path", { d: "M16.2576 16.7825L15.9335 17.6328L16.6344 17.8999L16.9584 17.0495L16.2576 16.7825Z" })
			]
		})
	}), /* @__PURE__ */ g("defs", { children: [/* @__PURE__ */ h("clipPath", {
		id: "clip0_973_2819",
		children: /* @__PURE__ */ h("rect", {
			width: 24,
			height: 24,
			transform: "translate(0 0.952148)"
		})
	}), /* @__PURE__ */ h("clipPath", {
		id: "clip1_973_2819",
		children: /* @__PURE__ */ h("rect", {
			width: 24.05,
			height: 20.9875,
			transform: "translate(0 1.92529)"
		})
	})] })]
}), aa = class extends wn {
	constructor(t, n) {
		super(t, {
			width: 44,
			isResizable: !1,
			fitContent: !0,
			x: n.x,
			y: n.y
		}), this.isIconWidget = !0, this.IconsItems = () => [], this.AdditionalContent = () => /* @__PURE__ */ h(m, {}), this.Render = () => /* @__PURE__ */ h(this.ContextProvider, { children: /* @__PURE__ */ g(O, {
			direction: "column",
			alignItems: "center",
			justifyContent: "center",
			sx: {
				borderRadius: "12px",
				backgroundColor: (e) => e.palette.primary.main,
				padding: "2px",
				paddingTop: "0px",
				boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),\n              0px 1px 8px 0px rgba(0,0,0,0.12)"
			},
			children: [/* @__PURE__ */ h(e, {
				sx: {
					width: "100%",
					height: "12px",
					backgroundColor: "transparent",
					cursor: "pointer"
				},
				className: wn.DragHandleClassName
			}), /* @__PURE__ */ g(O, {
				direction: "column",
				alignItems: "center",
				justifyContent: "center",
				sx: {
					backgroundColor: "white",
					borderRadius: "10px",
					width: "100%",
					position: "relative"
				},
				children: [/* @__PURE__ */ h(this.AdditionalContent, {}), this.IconsItems().map((t, n) => /* @__PURE__ */ h(e, {
					sx: {
						backgroundColor: (e) => t.active ? e.palette.primary.light : "transparent",
						width: "100%",
						height: "100%",
						borderRadius: n === 0 ? "10px 10px 0px 0px" : n === this.IconsItems().length - 1 ? "0px 0px 10px 10px" : "0px"
					},
					children: /* @__PURE__ */ h(nt, {
						title: t.label,
						placement: "left",
						children: /* @__PURE__ */ h(ze, {
							onClick: () => t.onClick(),
							"data-testid": "icon-widget-item-button",
							"aria-label": t.label,
							icon: t.icon,
							sx: {
								margin: "3px",
								pointerEvents: t.disable ? "auto" : "none",
								"& svg": { fill: (e) => t.disable ? e.palette.primary.main : e.palette.grey[500] }
							}
						})
					})
				}, t.label))]
			})]
		}) });
	}
}, oa = (e) => /* @__PURE__ */ g("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("g", {
			clipPath: "url(#clip0_1528_6)",
			children: /* @__PURE__ */ g("g", {
				clipPath: "url(#clip1_1528_6)",
				children: [
					/* @__PURE__ */ h("path", {
						d: "M13.1094 12.7191V11.9691H12.1594V12.7191H13.1094Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M21.6894 16.2791L21.7094 16.2991V16.2891L21.6894 16.2791Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M13.1094 9.70908V8.95908H12.1594V9.70908H13.1094Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M13.1094 11.2091V10.4691H12.1594V11.2091H13.1094Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M9.8106 15.3641L9.11915 15.6277L9.44334 16.478L10.1348 16.2144L9.8106 15.3641Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M11.2286 14.833L10.5278 15.1002L10.852 15.9505L11.5528 15.6833L11.2286 14.833Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M8.39727 15.9225L7.69643 16.1896L8.02047 17.0399L8.72131 16.7728L8.39727 15.9225Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M21.7694 16.2791V16.3591L21.7194 16.2991L21.7494 17.7191L20.2894 17.1691L20.0694 17.0891V10.7391C20.0694 10.5391 19.9594 10.3491 19.7894 10.2491L13.1394 6.36908V3.86908H15.1094L12.7294 1.16908L12.6394 1.05908L12.5494 1.16908L10.1794 3.86908H12.1494V6.36908L5.49937 10.2491C5.32937 10.3491 5.21938 10.5391 5.21938 10.7391V17.0891L4.99937 17.1691L3.53938 17.7191L3.56938 16.2991L3.50938 16.3591V16.2791L0.609375 19.2991L3.42937 20.2291V20.2091L3.50938 20.2291L3.53938 18.7291L5.39937 18.0291L5.46938 17.9991L5.48938 18.0191L12.2794 21.9791C12.3894 22.0391 12.5194 22.0491 12.6394 22.0391C12.7594 22.0591 12.8794 22.0391 12.9994 21.9791L19.7894 18.0191C19.7894 18.0191 19.7994 18.0091 19.8094 17.9991L19.8794 18.0291L21.7394 18.7291L21.7694 20.2291L21.8394 20.2091V20.2291L24.6594 19.2991L21.7594 16.2791H21.7694ZM18.8094 16.6491L18.2794 16.4491L17.9594 17.2991L18.3894 17.4591L13.1494 20.5191V15.0491L13.1794 15.0191L18.8094 11.7391V16.6491ZM6.45937 11.7391L12.0894 15.0191C12.0894 15.0191 12.1194 15.0391 12.1194 15.0491V20.5191L6.87937 17.4591L7.30937 17.2991L6.98938 16.4491L6.45937 16.6491V11.7391ZM12.1494 13.4791V13.7491L7.01937 10.7491L12.1494 7.75908V8.19908H13.1194V7.75908L18.2494 10.7491L13.1194 13.7491V13.4791H12.1494Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M15.4603 15.3716L15.1362 16.2219L15.8277 16.4854L16.1518 15.6351L15.4603 15.3716Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M14.0451 14.8398L13.7209 15.6901L14.4217 15.9573L14.7459 15.107L14.0451 14.8398Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M16.8669 15.9163L16.5429 16.7666L17.2437 17.0337L17.5678 16.1833L16.8669 15.9163Z",
						fill: "#D9D9D9"
					})
				]
			})
		}),
		/* @__PURE__ */ h("mask", {
			id: "mask0_1528_6",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 25,
			height: 25,
			children: /* @__PURE__ */ h("g", {
				clipPath: "url(#clip2_1528_6)",
				children: /* @__PURE__ */ g("g", {
					clipPath: "url(#clip3_1528_6)",
					children: [
						/* @__PURE__ */ h("path", {
							d: "M13.1094 12.7191V11.9691H12.1594V12.7191H13.1094Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M21.6894 16.2791L21.7094 16.2991V16.2891L21.6894 16.2791Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M13.1094 9.70908V8.95908H12.1594V9.70908H13.1094Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M13.1094 11.2091V10.4691H12.1594V11.2091H13.1094Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M9.8106 15.3641L9.11915 15.6277L9.44334 16.478L10.1348 16.2144L9.8106 15.3641Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M11.2286 14.833L10.5278 15.1002L10.852 15.9505L11.5528 15.6833L11.2286 14.833Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M8.39727 15.9225L7.69643 16.1896L8.02047 17.0399L8.72131 16.7728L8.39727 15.9225Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M21.7694 16.2791V16.3591L21.7194 16.2991L21.7494 17.7191L20.2894 17.1691L20.0694 17.0891V10.7391C20.0694 10.5391 19.9594 10.3491 19.7894 10.2491L13.1394 6.36908V3.86908H15.1094L12.7294 1.16908L12.6394 1.05908L12.5494 1.16908L10.1794 3.86908H12.1494V6.36908L5.49937 10.2491C5.32937 10.3491 5.21938 10.5391 5.21938 10.7391V17.0891L4.99937 17.1691L3.53938 17.7191L3.56938 16.2991L3.50938 16.3591V16.2791L0.609375 19.2991L3.42937 20.2291V20.2091L3.50938 20.2291L3.53938 18.7291L5.39937 18.0291L5.46938 17.9991L5.48938 18.0191L12.2794 21.9791C12.3894 22.0391 12.5194 22.0491 12.6394 22.0391C12.7594 22.0591 12.8794 22.0391 12.9994 21.9791L19.7894 18.0191C19.7894 18.0191 19.7994 18.0091 19.8094 17.9991L19.8794 18.0291L21.7394 18.7291L21.7694 20.2291L21.8394 20.2091V20.2291L24.6594 19.2991L21.7594 16.2791H21.7694ZM18.8094 16.6491L18.2794 16.4491L17.9594 17.2991L18.3894 17.4591L13.1494 20.5191V15.0491L13.1794 15.0191L18.8094 11.7391V16.6491ZM6.45937 11.7391L12.0894 15.0191C12.0894 15.0191 12.1194 15.0391 12.1194 15.0491V20.5191L6.87937 17.4591L7.30937 17.2991L6.98938 16.4491L6.45937 16.6491V11.7391ZM12.1494 13.4791V13.7491L7.01937 10.7491L12.1494 7.75908V8.19908H13.1194V7.75908L18.2494 10.7491L13.1194 13.7491V13.4791H12.1494Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M15.4603 15.3716L15.1362 16.2219L15.8277 16.4854L16.1518 15.6351L15.4603 15.3716Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M14.0451 14.8398L13.7209 15.6901L14.4217 15.9573L14.7459 15.107L14.0451 14.8398Z",
							fill: "#E44D45"
						}),
						/* @__PURE__ */ h("path", {
							d: "M16.8669 15.9163L16.5429 16.7666L17.2437 17.0337L17.5678 16.1833L16.8669 15.9163Z",
							fill: "#E44D45"
						})
					]
				})
			})
		}),
		/* @__PURE__ */ h("g", {
			mask: "url(#mask0_1528_6)",
			children: /* @__PURE__ */ h("path", {
				d: "M-4.89062 17.9186L13.0489 26.7476V14L-4.89062 4.25781V17.9186Z",
				fill: "#E44D45"
			})
		}),
		/* @__PURE__ */ h("path", {
			d: "M12.5 14.5L6 11.5V17.5L12.5 21.5V14.5Z",
			fill: "#E44D45"
		}),
		/* @__PURE__ */ g("defs", { children: [
			/* @__PURE__ */ h("clipPath", {
				id: "clip0_1528_6",
				children: /* @__PURE__ */ h("rect", {
					width: 24,
					height: 24,
					transform: "translate(0.609375 0.0859375)"
				})
			}),
			/* @__PURE__ */ h("clipPath", {
				id: "clip1_1528_6",
				children: /* @__PURE__ */ h("rect", {
					width: 24.05,
					height: 20.9875,
					transform: "translate(0.609375 1.05908)"
				})
			}),
			/* @__PURE__ */ h("clipPath", {
				id: "clip2_1528_6",
				children: /* @__PURE__ */ h("rect", {
					width: 24,
					height: 24,
					transform: "translate(0.609375 0.0859375)"
				})
			}),
			/* @__PURE__ */ h("clipPath", {
				id: "clip3_1528_6",
				children: /* @__PURE__ */ h("rect", {
					width: 24.05,
					height: 20.9875,
					transform: "translate(0.609375 1.05908)"
				})
			})
		] })
	]
}), sa = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("g", {
			clipPath: "url(#clip0_1528_24)",
			children: /* @__PURE__ */ g("g", {
				clipPath: "url(#clip1_1528_24)",
				children: [
					/* @__PURE__ */ h("path", {
						d: "M12.5 12.6331V11.8831H11.55V12.6331H12.5Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M21.08 16.1931L21.1 16.2131V16.2031L21.08 16.1931Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M12.5 9.62314V8.87314H11.55V9.62314H12.5Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M12.5 11.1231V10.3831H11.55V11.1231H12.5Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M9.20123 15.2782L8.50978 15.5418L8.83397 16.3921L9.52542 16.1284L9.20123 15.2782Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M10.6193 14.7471L9.91846 15.0142L10.2426 15.8645L10.9434 15.5973L10.6193 14.7471Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M7.78789 15.8365L7.08705 16.1036L7.41109 16.954L8.11193 16.6869L7.78789 15.8365Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M21.16 16.1931V16.2731L21.11 16.2131L21.14 17.6331L19.68 17.0831L19.46 17.0031V10.6531C19.46 10.4531 19.35 10.2631 19.18 10.1631L12.53 6.28314V3.78314H14.5L12.12 1.08314L12.03 0.973145L11.94 1.08314L9.57 3.78314H11.54V6.28314L4.89 10.1631C4.72 10.2631 4.61 10.4531 4.61 10.6531V17.0031L4.39 17.0831L2.93 17.6331L2.96 16.2131L2.9 16.2731V16.1931L0 19.2131L2.82 20.1431V20.1231L2.9 20.1431L2.93 18.6431L4.79 17.9431L4.86 17.9131L4.88 17.9331L11.67 21.8931C11.78 21.9531 11.91 21.9631 12.03 21.9531C12.15 21.9731 12.27 21.9531 12.39 21.8931L19.18 17.9331C19.18 17.9331 19.19 17.9231 19.2 17.9131L19.27 17.9431L21.13 18.6431L21.16 20.1431L21.23 20.1231V20.1431L24.05 19.2131L21.15 16.1931H21.16ZM18.2 16.5631L17.67 16.3631L17.35 17.2131L17.78 17.3731L12.54 20.4331V14.9631L12.57 14.9331L18.2 11.6531V16.5631ZM5.85 11.6531L11.48 14.9331C11.48 14.9331 11.51 14.9531 11.51 14.9631V20.4331L6.27 17.3731L6.7 17.2131L6.38 16.3631L5.85 16.5631V11.6531ZM11.54 13.3931V13.6631L6.41 10.6631L11.54 7.67314V8.11314H12.51V7.67314L17.64 10.6631L12.51 13.6631V13.3931H11.54Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M14.8509 15.2856L14.5268 16.136L15.2183 16.3995L15.5424 15.5491L14.8509 15.2856Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M13.4357 14.7539L13.1115 15.6042L13.8123 15.8714L14.1365 15.0211L13.4357 14.7539Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M16.2576 15.8303L15.9335 16.6807L16.6344 16.9477L16.9584 16.0974L16.2576 15.8303Z",
						fill: "#D9D9D9"
					})
				]
			})
		}),
		/* @__PURE__ */ h("mask", {
			id: "mask0_1528_24",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ h("g", {
				clipPath: "url(#clip2_1528_24)",
				children: /* @__PURE__ */ g("g", {
					clipPath: "url(#clip3_1528_24)",
					children: [
						/* @__PURE__ */ h("path", {
							d: "M12.5 12.6331V11.8831H11.55V12.6331H12.5Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M21.08 16.1931L21.1 16.2131V16.2031L21.08 16.1931Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M12.5 9.62314V8.87314H11.55V9.62314H12.5Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M12.5 11.1231V10.3831H11.55V11.1231H12.5Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M9.20123 15.2782L8.50978 15.5418L8.83397 16.3921L9.52542 16.1284L9.20123 15.2782Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M10.6193 14.7471L9.91846 15.0142L10.2426 15.8645L10.9434 15.5973L10.6193 14.7471Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M7.78789 15.8365L7.08705 16.1036L7.41109 16.954L8.11193 16.6869L7.78789 15.8365Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M21.16 16.1931V16.2731L21.11 16.2131L21.14 17.6331L19.68 17.0831L19.46 17.0031V10.6531C19.46 10.4531 19.35 10.2631 19.18 10.1631L12.53 6.28314V3.78314H14.5L12.12 1.08314L12.03 0.973145L11.94 1.08314L9.57 3.78314H11.54V6.28314L4.89 10.1631C4.72 10.2631 4.61 10.4531 4.61 10.6531V17.0031L4.39 17.0831L2.93 17.6331L2.96 16.2131L2.9 16.2731V16.1931L0 19.2131L2.82 20.1431V20.1231L2.9 20.1431L2.93 18.6431L4.79 17.9431L4.86 17.9131L4.88 17.9331L11.67 21.8931C11.78 21.9531 11.91 21.9631 12.03 21.9531C12.15 21.9731 12.27 21.9531 12.39 21.8931L19.18 17.9331C19.18 17.9331 19.19 17.9231 19.2 17.9131L19.27 17.9431L21.13 18.6431L21.16 20.1431L21.23 20.1231V20.1431L24.05 19.2131L21.15 16.1931H21.16ZM18.2 16.5631L17.67 16.3631L17.35 17.2131L17.78 17.3731L12.54 20.4331V14.9631L12.57 14.9331L18.2 11.6531V16.5631ZM5.85 11.6531L11.48 14.9331C11.48 14.9331 11.51 14.9531 11.51 14.9631V20.4331L6.27 17.3731L6.7 17.2131L6.38 16.3631L5.85 16.5631V11.6531ZM11.54 13.3931V13.6631L6.41 10.6631L11.54 7.67314V8.11314H12.51V7.67314L17.64 10.6631L12.51 13.6631V13.3931H11.54Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M14.8509 15.2856L14.5268 16.136L15.2183 16.3995L15.5424 15.5491L14.8509 15.2856Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M13.4357 14.7539L13.1115 15.6042L13.8123 15.8714L14.1365 15.0211L13.4357 14.7539Z",
							fill: "#76B241"
						}),
						/* @__PURE__ */ h("path", {
							d: "M16.2576 15.8303L15.9335 16.6807L16.6344 16.9477L16.9584 16.0974L16.2576 15.8303Z",
							fill: "#76B241"
						})
					]
				})
			})
		}),
		/* @__PURE__ */ h("g", {
			mask: "url(#mask0_1528_24)",
			children: /* @__PURE__ */ h("path", {
				d: "M12.0703 15.3435L-4.20978 5.82629L12.0703 -3.55469L24.4877 7.75738L12.0703 15.3435Z",
				fill: "#76B241"
			})
		}),
		/* @__PURE__ */ h("path", {
			d: "M12.0625 7.29688L5.82031 10.7578L12.0625 14.6251L18.5041 10.7578L12.0625 7.29688Z",
			fill: "#76B241"
		}),
		/* @__PURE__ */ g("defs", { children: [
			/* @__PURE__ */ h("clipPath", {
				id: "clip0_1528_24",
				children: /* @__PURE__ */ h("rect", {
					width: 24,
					height: 24
				})
			}),
			/* @__PURE__ */ h("clipPath", {
				id: "clip1_1528_24",
				children: /* @__PURE__ */ h("rect", {
					width: 24.05,
					height: 20.9875,
					transform: "translate(0 0.973145)"
				})
			}),
			/* @__PURE__ */ h("clipPath", {
				id: "clip2_1528_24",
				children: /* @__PURE__ */ h("rect", {
					width: 24,
					height: 24
				})
			}),
			/* @__PURE__ */ h("clipPath", {
				id: "clip3_1528_24",
				children: /* @__PURE__ */ h("rect", {
					width: 24.05,
					height: 20.9875,
					transform: "translate(0 0.973145)"
				})
			})
		] })
	]
}), ca = (e) => /* @__PURE__ */ g("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("g", {
			clipPath: "url(#clip0_1528_39)",
			children: /* @__PURE__ */ g("g", {
				clipPath: "url(#clip1_1528_39)",
				children: [
					/* @__PURE__ */ h("path", {
						d: "M13.1094 12.7191V11.9691H12.1594V12.7191H13.1094Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M21.6894 16.2791L21.7094 16.2991V16.2891L21.6894 16.2791Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M13.1094 9.70908V8.95908H12.1594V9.70908H13.1094Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M13.1094 11.2091V10.4691H12.1594V11.2091H13.1094Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M9.8106 15.3641L9.11915 15.6277L9.44334 16.478L10.1348 16.2144L9.8106 15.3641Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M11.2286 14.833L10.5278 15.1002L10.852 15.9505L11.5528 15.6833L11.2286 14.833Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M8.39727 15.9225L7.69643 16.1896L8.02047 17.0399L8.72131 16.7728L8.39727 15.9225Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M21.7694 16.2791V16.3591L21.7194 16.2991L21.7494 17.7191L20.2894 17.1691L20.0694 17.0891V10.7391C20.0694 10.5391 19.9594 10.3491 19.7894 10.2491L13.1394 6.36908V3.86908H15.1094L12.7294 1.16908L12.6394 1.05908L12.5494 1.16908L10.1794 3.86908H12.1494V6.36908L5.49937 10.2491C5.32937 10.3491 5.21938 10.5391 5.21938 10.7391V17.0891L4.99937 17.1691L3.53938 17.7191L3.56938 16.2991L3.50938 16.3591V16.2791L0.609375 19.2991L3.42937 20.2291V20.2091L3.50938 20.2291L3.53938 18.7291L5.39937 18.0291L5.46938 17.9991L5.48938 18.0191L12.2794 21.9791C12.3894 22.0391 12.5194 22.0491 12.6394 22.0391C12.7594 22.0591 12.8794 22.0391 12.9994 21.9791L19.7894 18.0191C19.7894 18.0191 19.7994 18.0091 19.8094 17.9991L19.8794 18.0291L21.7394 18.7291L21.7694 20.2291L21.8394 20.2091V20.2291L24.6594 19.2991L21.7594 16.2791H21.7694ZM18.8094 16.6491L18.2794 16.4491L17.9594 17.2991L18.3894 17.4591L13.1494 20.5191V15.0491L13.1794 15.0191L18.8094 11.7391V16.6491ZM6.45937 11.7391L12.0894 15.0191C12.0894 15.0191 12.1194 15.0391 12.1194 15.0491V20.5191L6.87937 17.4591L7.30937 17.2991L6.98938 16.4491L6.45937 16.6491V11.7391ZM12.1494 13.4791V13.7491L7.01937 10.7491L12.1494 7.75908V8.19908H13.1194V7.75908L18.2494 10.7491L13.1194 13.7491V13.4791H12.1494Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M15.4603 15.3716L15.1362 16.2219L15.8277 16.4854L16.1518 15.6351L15.4603 15.3716Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M14.0451 14.8398L13.7209 15.6901L14.4217 15.9573L14.7459 15.107L14.0451 14.8398Z",
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ h("path", {
						d: "M16.8669 15.9163L16.5429 16.7666L17.2437 17.0337L17.5678 16.1833L16.8669 15.9163Z",
						fill: "#D9D9D9"
					})
				]
			})
		}),
		/* @__PURE__ */ h("mask", {
			id: "mask0_1528_39",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 25,
			height: 25,
			children: /* @__PURE__ */ h("g", {
				clipPath: "url(#clip2_1528_39)",
				children: /* @__PURE__ */ g("g", {
					clipPath: "url(#clip3_1528_39)",
					children: [
						/* @__PURE__ */ h("path", {
							d: "M13.1094 12.7191V11.9691H12.1594V12.7191H13.1094Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M21.6894 16.2791L21.7094 16.2991V16.2891L21.6894 16.2791Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M13.1094 9.70908V8.95908H12.1594V9.70908H13.1094Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M13.1094 11.2091V10.4691H12.1594V11.2091H13.1094Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M9.8106 15.3641L9.11915 15.6277L9.44334 16.478L10.1348 16.2144L9.8106 15.3641Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M11.2286 14.833L10.5278 15.1002L10.852 15.9505L11.5528 15.6833L11.2286 14.833Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M8.39727 15.9225L7.69643 16.1896L8.02047 17.0399L8.72131 16.7728L8.39727 15.9225Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M21.7694 16.2791V16.3591L21.7194 16.2991L21.7494 17.7191L20.2894 17.1691L20.0694 17.0891V10.7391C20.0694 10.5391 19.9594 10.3491 19.7894 10.2491L13.1394 6.36908V3.86908H15.1094L12.7294 1.16908L12.6394 1.05908L12.5494 1.16908L10.1794 3.86908H12.1494V6.36908L5.49937 10.2491C5.32937 10.3491 5.21938 10.5391 5.21938 10.7391V17.0891L4.99937 17.1691L3.53938 17.7191L3.56938 16.2991L3.50938 16.3591V16.2791L0.609375 19.2991L3.42937 20.2291V20.2091L3.50938 20.2291L3.53938 18.7291L5.39937 18.0291L5.46938 17.9991L5.48938 18.0191L12.2794 21.9791C12.3894 22.0391 12.5194 22.0491 12.6394 22.0391C12.7594 22.0591 12.8794 22.0391 12.9994 21.9791L19.7894 18.0191C19.7894 18.0191 19.7994 18.0091 19.8094 17.9991L19.8794 18.0291L21.7394 18.7291L21.7694 20.2291L21.8394 20.2091V20.2291L24.6594 19.2991L21.7594 16.2791H21.7694ZM18.8094 16.6491L18.2794 16.4491L17.9594 17.2991L18.3894 17.4591L13.1494 20.5191V15.0491L13.1794 15.0191L18.8094 11.7391V16.6491ZM6.45937 11.7391L12.0894 15.0191C12.0894 15.0191 12.1194 15.0391 12.1194 15.0491V20.5191L6.87937 17.4591L7.30937 17.2991L6.98938 16.4491L6.45937 16.6491V11.7391ZM12.1494 13.4791V13.7491L7.01937 10.7491L12.1494 7.75908V8.19908H13.1194V7.75908L18.2494 10.7491L13.1194 13.7491V13.4791H12.1494Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M15.4603 15.3716L15.1362 16.2219L15.8277 16.4854L16.1518 15.6351L15.4603 15.3716Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M14.0451 14.8398L13.7209 15.6901L14.4217 15.9573L14.7459 15.107L14.0451 14.8398Z",
							fill: "#3F8CE9"
						}),
						/* @__PURE__ */ h("path", {
							d: "M16.8669 15.9163L16.5429 16.7666L17.2437 17.0337L17.5678 16.1833L16.8669 15.9163Z",
							fill: "#3F8CE9"
						})
					]
				})
			})
		}),
		/* @__PURE__ */ h("g", {
			mask: "url(#mask0_1528_39)",
			children: /* @__PURE__ */ h("path", {
				d: "M12.0589 14.4254L12.2047 27.3831L28.5282 22.4401L24.8657 6.75745L12.0589 14.4254Z",
				fill: "#3F8CE9"
			})
		}),
		/* @__PURE__ */ h("path", {
			d: "M19.0156 11.0469L12.875 15.1094V21.347L19.0156 17.6816V11.0469Z",
			fill: "#3F8CE9"
		}),
		/* @__PURE__ */ g("defs", { children: [
			/* @__PURE__ */ h("clipPath", {
				id: "clip0_1528_39",
				children: /* @__PURE__ */ h("rect", {
					width: 24,
					height: 24,
					transform: "translate(0.609375 0.0859375)"
				})
			}),
			/* @__PURE__ */ h("clipPath", {
				id: "clip1_1528_39",
				children: /* @__PURE__ */ h("rect", {
					width: 24.05,
					height: 20.9875,
					transform: "translate(0.609375 1.05908)"
				})
			}),
			/* @__PURE__ */ h("clipPath", {
				id: "clip2_1528_39",
				children: /* @__PURE__ */ h("rect", {
					width: 24,
					height: 24,
					transform: "translate(0.609375 0.0859375)"
				})
			}),
			/* @__PURE__ */ h("clipPath", {
				id: "clip3_1528_39",
				children: /* @__PURE__ */ h("rect", {
					width: 24.05,
					height: 20.9875,
					transform: "translate(0.609375 1.05908)"
				})
			})
		] })
	]
}), la = (e) => {
	let { min: t = -Infinity, max: n = Infinity, step: r = 1, maxDigits: i = 2, value: a = 0, onChange: o, onBlur: s, defaultValue: l = 0, ...u } = e, [d, p] = f(a), m = (e) => {
		if (e === "") return p(null), null;
		let r = Number.parseFloat(Number.parseFloat(e).toFixed(ua(e, i))), a;
		return a = r < t ? t : r > n ? n : r, p(a), a;
	}, g = (e) => {
		let t = m(e.target.value);
		t !== null && o?.(t);
	}, _ = () => {
		d === null && (o?.(l), p(l)), s?.(d ?? l);
	};
	return c(() => {
		d !== a && m(a.toString());
	}, [a]), /* @__PURE__ */ h(qe, {
		...u,
		value: d ?? "",
		type: "number",
		onChange: g,
		onBlur: _,
		inputProps: {
			min: t,
			max: n,
			step: r
		}
	});
}, ua = (e, t) => {
	let n = e.split(".")[1]?.length;
	return Math.min(n, t);
}, da = /* @__PURE__ */ new D(), fa = /* @__PURE__ */ new D(), U = new Ie(), pa = new Ne(), ma = /* @__PURE__ */ new Fe(), ha = () => {
	let { viewer: t } = P(), [n, r] = f({
		x: 0,
		y: 0,
		z: 0
	}), [i, a] = f(Infinity), [o, s] = f(0), [l, u] = f(1), [p, _] = f(null), [v, y] = f(!0), b = d(null), x = d(null), S = (e, n) => {
		if (!p) return;
		let r = t.viewport?.transformController.mode;
		switch (p.getMatrix(ma), ma.decompose(da, U, fa), r) {
			case "translate":
				da[n] = e;
				break;
			case "rotate":
				pa.setFromQuaternion(U), pa[n] = Pe.degToRad(e), U.setFromEuler(pa);
				break;
			default: fa[n] = e;
		}
		ma.compose(da, U, fa), x.current &&= (clearTimeout(x.current), setTimeout(() => {
			b.current = null;
		}, 2e3)), b.current ? b.current.update(ma) : (b.current = new ve(t, p.uuid, ma), b.current.execute());
	};
	c(() => {
		let e = () => {
			let e = t.scene.objectSelection.getLastObject();
			if (!e) return;
			let n = t.viewport?.transformController.mode;
			switch (e.getMatrix(ma), _(e), ma.decompose(da, U, fa), n) {
				case "translate":
					r({
						x: da.x,
						y: da.y,
						z: da.z
					}), a(Infinity), s(-Infinity), u(1);
					break;
				case "rotate":
					pa.setFromQuaternion(U), r({
						x: Pe.radToDeg(pa.x),
						y: Pe.radToDeg(pa.y),
						z: Pe.radToDeg(pa.z)
					}), a(Infinity), s(-Infinity), u(1);
					break;
				default: r({
					x: fa.x,
					y: fa.y,
					z: fa.z
				}), a(Infinity), s(.01), u(.1);
			}
		};
		return e(), t.signals.onObjectSelectionChanged.connect(e), t.signals.onObjectsMoved.connect(e), t.viewport?.transformController.signals.onTransformGizmoUpdated.connect(e), () => {
			t.signals.onObjectSelectionChanged.disconnect(e), t.signals.onObjectsMoved.disconnect(e), t.viewport?.transformController.signals.onTransformGizmoUpdated.disconnect(e);
		};
	}, []);
	let C = t.viewport?.transformController.mode, w = C === "rotate" ? "calc(50% - 12px)" : "auto";
	return w = C === "translate" ? "12px" : w, /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ h(e, {
		onClick: () => y((e) => !e),
		"data-testid": "object-transform-toggle",
		sx: {
			borderTop: "10px solid transparent",
			borderBottom: "10px solid transparent",
			borderRight: (e) => `10px solid ${e.palette.primary.main}`,
			width: 0,
			height: 0,
			position: "absolute",
			left: "-12px",
			top: w,
			bottom: C === "scale" ? "10px" : "auto",
			cursor: "pointer"
		}
	}), !!v && /* @__PURE__ */ g(O, {
		sx: {
			position: "absolute",
			top: 0,
			bottom: 0,
			backgroundColor: "white",
			borderRadius: "12px",
			boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),\n              0px 1px 8px 0px rgba(0,0,0,0.12)",
			fontWeight: "bold",
			width: "170px",
			left: "-188px",
			padding: "5px"
		},
		direction: "column",
		alignItems: "center",
		justifyContent: "center",
		spacing: 1,
		"data-testid": "object-transform-axes",
		children: [
			/* @__PURE__ */ h(ga, {
				color: "#E44D45",
				Icon: oa,
				text: "X",
				value: n.x,
				onChange: (e) => S(e, "x"),
				max: i,
				min: o,
				step: l
			}),
			/* @__PURE__ */ h(ga, {
				color: "#76B241",
				Icon: sa,
				text: "Y",
				value: n.y,
				onChange: (e) => S(e, "y"),
				max: i,
				min: o,
				step: l
			}),
			/* @__PURE__ */ h(ga, {
				color: "#3F8CE9",
				Icon: ca,
				text: "Z",
				value: n.z,
				onChange: (e) => S(e, "z"),
				max: i,
				min: o,
				step: l
			})
		]
	})] });
}, ga = (e) => {
	let { color: t, Icon: n, text: r, value: i, onChange: a, max: o, step: s, min: c } = e;
	return /* @__PURE__ */ g(O, {
		direction: "row",
		justifyContent: "space-between",
		alignItems: "center",
		sx: {
			height: "30px",
			width: "100%"
		},
		"data-testid": `object-transform-axis-${r.toLowerCase()}`,
		children: [
			/* @__PURE__ */ h(n, {}),
			/* @__PURE__ */ h("p", {
				style: {
					color: t,
					paddingTop: "3px"
				},
				children: r
			}),
			/* @__PURE__ */ h(la, {
				value: i,
				onChange: a,
				min: c,
				max: o,
				step: s,
				sx: {
					width: "100px",
					"& input": { height: "14px" }
				}
			})
		]
	});
}, _a = class extends aa {
	constructor(e, t) {
		super(e, t), this.type = "ObjectTransform", this._setMode = (e) => {
			new _e(this.viewer, e).execute();
		}, this.IconsItems = () => this.viewer.viewport ? [
			{
				label: A("teiaviewer:widgets.object_translations.translate.label"),
				icon: ia,
				onClick: () => this._setMode("translate"),
				disable: this.viewer.viewport?.transformController.canTranslate,
				active: this.viewer.viewport?.transformController.mode === "translate"
			},
			{
				label: A("teiaviewer:widgets.object_translations.rotate.label"),
				icon: na,
				onClick: () => this._setMode("rotate"),
				disable: this.viewer.viewport?.transformController.canRotate,
				active: this.viewer.viewport?.transformController.mode === "rotate"
			},
			{
				label: A("teiaviewer:widgets.object_translations.scale.label"),
				icon: ra,
				onClick: () => this._setMode("scale"),
				disable: this.viewer.viewport?.transformController.canScale,
				active: this.viewer.viewport?.transformController.mode === "scale"
			}
		] : [], this.AdditionalContent = () => /* @__PURE__ */ h(ha, {}), this._setMode("translate"), e.viewport?.transformController.signals.onTransformGizmoUpdated.connect(() => {
			this.signals.onUpdateRectContent.emit();
		});
	}
}, va = r(null), ya = () => {
	let e = s(va);
	if (!e) throw Error("SettingsWidgetContext must be used in SettingsWidget");
	return e;
}, ba = va.Provider, xa = () => {
	let { tabs: e = [] } = ya();
	return /* @__PURE__ */ h(Fi, {
		tabs: e,
		sx: { content: { padding: 1 } }
	});
}, Sa = () => {
	let { t: e } = j("teiaviewer");
	return /* @__PURE__ */ h(qr, {
		icon: ti,
		children: e("widgets.settings_widget.title")
	});
}, Ca = class extends Ci {
	constructor(e, t = {}) {
		let { getTabs: n, ...r } = t;
		super(e, {
			color: "white",
			isResizable: !0,
			useFooter: !1,
			width: 300,
			height: 300,
			...r
		}), this.type = "Settings", this.Header = Sa, this.Content = xa, this.ContextProvider = ((e) => {
			let t = this._getTabs, n = u(() => ({ tabs: t(this.viewer) }), [t]);
			return /* @__PURE__ */ h(ba, {
				value: n,
				...e
			});
		}), this._getTabs = n ?? wa;
	}
};
function wa(e) {
	let t = e.getPlugin("Viewport");
	return Array.from(t.widgetController.content.settingsTabs);
}
//#endregion
//#region ../../resources/icons/TreeViewIcon.svg?react
var Ta = (e) => /* @__PURE__ */ h("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 21.333",
	width: 24,
	height: 21.333,
	...e,
	children: /* @__PURE__ */ h("path", { d: "M8.667 3.333c0 -1.104 0.896 -2 2 -2h2.667c1.104 0 2 0.896 2 2v2.667c0 1.104 -0.896 2 -2 2h-0.333v1.667h6.333c1.287 0 2.333 1.046 2.333 2.333v1.333h0.333c1.104 0 2 0.896 2 2v2.667c0 1.104 -0.896 2 -2 2h-2.667c-1.104 0 -2 -0.896 -2 -2v-2.667c0 -1.104 0.896 -2 2 -2h0.333v-1.333c0 -0.183 -0.15 -0.333 -0.333 -0.333H13v1.667h0.333c1.104 0 2 0.896 2 2v2.667c0 1.104 -0.896 2 -2 2h-2.667c-1.104 0 -2 -0.896 -2 -2v-2.667c0 -1.104 0.896 -2 2 -2h0.333v-1.667H4.667c-0.183 0 -0.333 0.15 -0.333 0.333v1.333h0.333c1.104 0 2 0.896 2 2v2.667c0 1.104 -0.896 2 -2 2H2c-1.104 0 -2 -0.896 -2 -2v-2.667c0 -1.104 0.896 -2 2 -2h0.333v-1.333c0 -1.287 1.046 -2.333 2.333 -2.333h6.333v-1.667h-0.333c-1.104 0 -2 -0.896 -2 -2z" })
}), Ea = (t) => {
	let { node: r, sx: a, onNodeExpanded: o, onNodeCollapsed: s, onLoadMoreChildren: c, getNodeIcon: l, getNodeMaxChildrenCount: u, getNodeDisplayChildrenCount: d, getNodeChildren: f, onNodeClick: p, isNodeExpandable: _, selectedNodes: v, NodeActions: y, expandedTreeNodes: b, autoScrollToLastSelected: x, showChildrenCountLabel: S, isNodeLoading: C, setExpandedNodes: w } = t, ee = n.useRef(null), te = b.has(r.uuid), { t: ne } = j("teiaviewer"), re = () => {
		te ? s?.(r) : o?.(r);
	}, ie = () => {
		c?.(r);
	}, ae = (e) => {
		let t = p?.(e, r);
		t && (t.expanded ? w((e) => {
			let t = new Set(e);
			return t.add(r.uuid), t;
		}) : w((e) => {
			let t = new Set(e);
			return t.delete(r.uuid), t;
		}));
	}, oe = f(r), se = u?.(r) ?? oe.length, ce = d?.(r) ?? oe.length, le = se > 0, ue = te ? mr : V, T = v?.has(r.uuid), de = new Set(oe.slice(0, Math.min(ce, oe.length)));
	if (v) for (let e of oe) v.has(e.uuid) && de.add(e);
	let fe = de.size < se && !C?.(r), E = /* @__PURE__ */ h(m, {});
	y && (E = y(r)), n.useEffect(() => {
		x && v && Array.from(v).pop() === r.uuid && ee.current?.scrollIntoView();
	}, [v]);
	let pe = l?.(r), me = _?.(r) ?? !0, he = C?.(r);
	return /* @__PURE__ */ g(e, {
		sx: a,
		ref: ee,
		children: [/* @__PURE__ */ g(e, {
			sx: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				position: "relative",
				borderRadius: "0.375rem",
				pl: le ? "0" : "1.75rem",
				"&:hover": { backgroundColor: (e) => T ? e.palette.primary.light : e.palette.grey[200] },
				backgroundColor: (e) => T ? e.palette.primary.light : "transparent",
				"&:before": {
					content: "\"\"",
					position: "absolute",
					left: "-1rem",
					top: "-0.125rem",
					width: "16px",
					height: "16px",
					borderLeft: "1px solid",
					borderBottom: "1px solid",
					borderLeftColor: "grey.300",
					borderBottomColor: "grey.300"
				}
			},
			className: "TreeViewNode",
			children: [
				!!me && !!le && /* @__PURE__ */ h(ze, {
					"aria-label": ne("components.treeView.tree_view_node.expand_node_button.label"),
					icon: ue,
					onClick: re,
					"data-testid": "tree-view-node-expand-button",
					sx: {
						cursor: "pointer",
						"& .MuiSvgIcon-root": {
							width: 16,
							height: 16
						}
					}
				}),
				/* @__PURE__ */ g(e, {
					sx: {
						display: "flex",
						flexWrap: "nowrap",
						cursor: "pointer",
						overflow: "hidden"
					},
					onClick: ae,
					children: [!!pe && /* @__PURE__ */ h(Be, {
						component: pe,
						sx: {
							fontSize: "22px",
							marginX: 1,
							color: (e) => e.palette.text.secondary
						}
					}), /* @__PURE__ */ g(Ve, {
						component: "span",
						sx: {
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							mr: 3
						},
						children: [r.name, !!me && !!le && !!S && /* @__PURE__ */ g(e, {
							component: "span",
							sx: {
								fontStyle: "italic",
								ml: 2
							},
							children: [
								"(",
								se,
								")"
							]
						})]
					})]
				}),
				/* @__PURE__ */ h(e, {
					sx: {
						display: "flex",
						ml: "auto"
					},
					children: E
				})
			]
		}), !!te && !!le && /* @__PURE__ */ g(e, {
			className: "TreeViewNodeChildren",
			sx: {
				paddingLeft: "1rem",
				marginLeft: "0.75rem",
				position: "relative",
				"&:before": {
					content: "\"\"",
					position: "absolute",
					left: 0,
					top: 0,
					width: "1px",
					height: "100%",
					borderLeft: "1px solid",
					borderColor: "grey.300"
				}
			},
			children: [
				de.map((e) => /* @__PURE__ */ i(Ea, {
					...t,
					node: e,
					key: e.uuid
				})),
				!!he && /* @__PURE__ */ h(Le, { size: "15px" }),
				!!fe && /* @__PURE__ */ h(He, {
					variant: "info",
					sx: { my: 1 },
					onClick: ie,
					"data-testid": "tree-view-node-load-more-button",
					children: ne("components.treeView.tree_view_node.load_more_button.label")
				})
			]
		})]
	});
}, Da = (t) => {
	let { sx: r = {}, nodes: i, onNodeExpanded: a, onNodeCollapsed: o, onLoadMoreRootNodes: s, getNodeChildren: c, getNodeParent: l, showRootLoadMore: u = !1, selectedNodes: d = /* @__PURE__ */ new Set(), autoExpandParentWithSelectedChildren: f, showChildrenCountLabel: p = !0, ...m } = t, [_, v] = n.useState(/* @__PURE__ */ new Set()), { t: y } = j("teiaviewer"), b = (e) => {
		v((t) => {
			let n = new Set(t);
			return n.add(e.uuid), n;
		}), a?.(e);
	}, x = (e) => {
		v((t) => {
			let n = new Set(t);
			return n.delete(e.uuid), n;
		}), o?.(e);
	}, S = () => (function* () {
		let e = Oa(i, c);
		for (let t of e) d.has(t.uuid) && (yield t);
	})(), C = () => {
		v((e) => {
			let t = new Set(e), n = S();
			for (let e of n) {
				let n = ka(e, l);
				for (let e of n) t.add(e.uuid);
			}
			return t;
		});
	};
	return n.useEffect(() => {
		f && d && C();
	}, [d]), /* @__PURE__ */ g(e, {
		sx: r.root,
		children: [i.map((e) => /* @__PURE__ */ h(Ea, {
			node: e,
			onNodeExpanded: b,
			onNodeCollapsed: x,
			getNodeChildren: c,
			getNodeParent: l,
			selectedNodes: d,
			expandedTreeNodes: _,
			showChildrenCountLabel: p,
			setExpandedNodes: v,
			sx: r.node,
			...m
		}, e.uuid)), !!u && /* @__PURE__ */ h(He, {
			variant: "info",
			sx: {
				marginX: 3,
				marginY: 2
			},
			onClick: s,
			"data-testid": "tree-view-load-more-roots-button",
			children: y("components.treeView.tree_view_node.load_more_button.label")
		})]
	});
};
function* Oa(e, t) {
	function* n(e) {
		yield e;
		let r = t(e);
		for (let e of r) yield* n(e);
	}
	for (let t of e) yield* n(t);
}
function* ka(e, t) {
	let n = t(e);
	n && (yield n, yield* ka(n, t));
}
//#endregion
//#region src/widgets/treeview/TreeViewWidgetContent.tsx
var Aa = () => {
	let { viewer: t } = P(), { t: n } = j("teiaviewer"), [r, i] = f({
		loading: t.sceneLoader.isRunning,
		progress: 0
	});
	c(() => {
		let e = () => {
			i({
				loading: !0,
				progress: 0
			});
		}, n = (e) => {
			i((t) => ({
				...t,
				progress: e.progress
			}));
		}, r = () => {
			i({
				loading: !1,
				progress: 1
			});
		};
		return t.signals.onLoadingStarted.connect(e), t.signals.onLoadingProgress.connect(n), t.signals.onLoadingFinished.connect(r), () => {
			t.signals.onLoadingStarted.disconnect(e), t.signals.onLoadingProgress.disconnect(n), t.signals.onLoadingFinished.disconnect(r);
		};
	}, [t]);
	let a;
	return a = t.scene.bimMeshController.roots.size === 0 ? /* @__PURE__ */ h(e, {
		sx: { paddingX: 3 },
		children: /* @__PURE__ */ h(Ge, {
			severity: "info",
			"data-testid": "tree-view-no-scene-alert",
			children: n("widgets.treeView.no_scene.text")
		})
	}) : r.loading ? /* @__PURE__ */ g(O, {
		sx: { paddingX: 3 },
		children: [/* @__PURE__ */ h(Ve, { children: n("widgets.treeView.computing_treeview.text") }), /* @__PURE__ */ h(Re, {
			variant: "determinate",
			value: r.progress * 100,
			"data-testid": "tree-view-loading-progress"
		})]
	}) : /* @__PURE__ */ h(ja, {}), /* @__PURE__ */ h(e, {
		sx: {
			width: 1,
			height: 1,
			padding: 1
		},
		alignItems: "center",
		justifyContent: "center",
		children: a
	});
}, ja = () => {
	let { viewer: e } = P(), [t] = un("Viewport", "treeViewPageSize"), [n, r] = f(/* @__PURE__ */ new Set()), [i, a] = f(t), { current: o } = d(/* @__PURE__ */ new Map()), s = (e) => cr, [l, u] = f(Ia([...e.scene.bimMeshController.roots])), p = () => {
		let t = /* @__PURE__ */ new Set(), n = e.scene.objectSelection.length, i = e.scene.objectSelection.getFirstUuid();
		n === 1 && i && t.add(i), r(t);
	};
	c(() => {
		let t = e.signals.onSceneGraphChanged.connect(() => {
			u(Ia([...e.scene.bimMeshController.roots]));
		});
		return () => {
			t.disconnect();
		};
	}, []), c(() => (e.signals.onObjectSelectionChanged.connect(p), () => {
		e.signals.onObjectSelectionChanged.disconnect(p);
	}), []);
	let m = (t, r) => {
		let i;
		if (ke(t)) {
			let e = new Set(n);
			e.has(r.uuid) ? e.delete(r.uuid) : e.add(r.uuid), i = Array.from(e);
		} else i = [r.uuid];
		new he(e, i).execute(), new y(e, i).execute();
	}, g = (e, t) => {
		o.set(e.uuid, t);
	}, _ = (e) => {
		let n = o.get(e.uuid);
		return n === void 0 && (o.set(e.uuid, t), n = t), n;
	}, v = () => {
		u((e) => [...e]);
	}, b = (e) => {
		g(e, t), v();
	}, x = (e) => {
		let n = _(e) + t;
		g(e, n), v();
	}, S = () => {
		a((e) => e + t);
	}, C = (e) => e.parent, w = (e) => Ia(e.children), ee = l.slice(0, i);
	return /* @__PURE__ */ h(Da, {
		sx: { root: {
			overflow: "auto",
			height: "100%",
			userSelect: "none"
		} },
		nodes: ee,
		onNodeCollapsed: b,
		getNodeIcon: s,
		getNodeDisplayChildrenCount: _,
		onLoadMoreChildren: x,
		onLoadMoreRootNodes: S,
		showRootLoadMore: i < l.length,
		onNodeClick: m,
		selectedNodes: n,
		NodeActions: Ma,
		autoExpandParentWithSelectedChildren: !0,
		autoScrollToLastSelected: !0,
		showChildrenCountLabel: !0,
		getNodeParent: C,
		getNodeChildren: w
	});
}, Ma = (e) => /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ h(Na, { object: e }), /* @__PURE__ */ h(Pa, { object: e })] }), Na = (e) => {
	let { object: t } = e, { viewer: n } = P(), [r, i] = f(t.visible);
	c(() => {
		let e = () => {
			i(t.visible);
		};
		return t.signals.onVisibilityChanged.connect(e), () => {
			t.signals.onVisibilityChanged.disconnect(e);
		};
	}, []);
	let a = (e) => e.children, o = (e) => e.parent, s = (e) => {
		if (i(e), e && t.parent) {
			let r = Fa(ka(t, o));
			new ye(n, r, e).execute();
		} else if (!e && t.parent) {
			let r = [], i = ka(t, o);
			for (let e of i) e.children.some((e) => e.visible && !r.includes(e.uuid)) || r.push(e.uuid);
			new ye(n, r, e).execute();
		}
	};
	return /* @__PURE__ */ h(ze, {
		variant: "info",
		onClick: () => {
			let e = Fa(Oa([t], a));
			new ye(n, e, !r).execute(), s(!r);
		},
		"aria-label": "change-item-visibility",
		"data-testid": "tree-view-visibility-button",
		icon: r ? Er : wr,
		sx: {
			padding: 0,
			fill: (e) => e.palette.info.dark
		}
	});
}, Pa = (e) => {
	let { object: t } = e, { viewer: n } = P();
	return /* @__PURE__ */ h(ze, {
		variant: "info",
		onClick: () => {
			new ie(n, [new he(n, [t.uuid]), new Un(n, "Infobox", { uuid: t.uuid })]).execute();
		},
		"aria-label": "open-item-infobox",
		"data-testid": "tree-view-infobox-button",
		icon: Ar,
		sx: {
			padding: 0,
			fill: (e) => e.palette.info.dark
		}
	});
};
function* Fa(e) {
	for (let t of e) yield t.uuid;
}
function Ia(e) {
	return e.sort((e, t) => e.name.localeCompare(t.name)), e;
}
//#endregion
//#region src/widgets/treeview/TreeViewWidget.tsx
var La = class extends Ci {
	constructor(e, t = {}) {
		super(e, {
			width: 300,
			height: 400,
			minWidth: 200,
			minHeight: 200,
			...t
		}), this.type = "TreeView", this.Header = () => {
			let { t: e } = j("teiaviewer");
			return /* @__PURE__ */ h(qr, {
				icon: Ta,
				"data-testid": "tree-view-title",
				sx: {
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis"
				},
				children: e("widgets.treeView.title")
			});
		}, this.Content = Aa;
	}
};
//#endregion
//#region src/widgets/base/setupWidgets.ts
function Ra(e) {
	let t = e.getPlugin("Viewport");
	t.widgetController.factory.registerWidget("Infobox", (t) => new Ui(e, {
		x: 200,
		y: 50,
		minWidth: 400,
		...t
	})), t.widgetController.factory.registerWidget("TreeView", (t) => new La(e, {
		x: 20,
		y: 50,
		width: 200,
		height: 300,
		...t
	})), t.widgetController.factory.registerWidget("CommandHistory", (t) => new Ti(e, {
		x: 40,
		y: 50,
		...t
	})), t.widgetController.factory.registerWidget("NotificationCenter", (t) => new ta(e, {
		x: 50,
		y: 50,
		...t
	})), t.widgetController.factory.registerWidget("Settings", (t) => new Ca(e, {
		x: 50,
		y: 50,
		...t
	})), t.widgetController.factory.registerWidget("ObjectTransform", (t) => {
		let { viewportRect: n } = t;
		return new _a(e, {
			x: n.width - 57,
			y: 150
		});
	});
}
//#endregion
//#region src/ViewportPlugin.tsx
var za = new zn(), Ba = new Vn(), Va = new Rn(), Ha = new Wn(), Ua = new Gn(), Wa = () => ({
	showObjectHierarchyBanner: new v(!0),
	showToolbar: new v(!0),
	disableToolbar: new v(!1, { saveToLocalStorage: !1 }),
	treeViewPageSize: new de(30, {
		min: 1,
		max: 30,
		step: 1
	})
}), Ga = Ce.Create("Viewport", Wa), Ka = class extends Ga {
	constructor(...e) {
		super(...e), this.wrappers = new fe(), this.spotlight = new Kn(), this.widgetController = new ui(), this.frameAlertController = new Ln(), this._setupViewport = () => {
			this.viewer.viewport?.shortcutController.addShortcut(Ua), this.viewer.viewport?.shortcutController.addShortcut(Ha);
		}, this._unsetupViewport = () => {
			this.viewer.viewport?.shortcutController.removeShortcut(Ua), this.viewer.viewport?.shortcutController.removeShortcut(Ha);
		}, this._onObjectDoubleClicked = (e) => {
			e.isBimMesh && new Un(this.viewer, "Infobox").execute();
		}, this._onObjectsTransformAttached = () => {
			new Un(this.viewer, "ObjectTransform").execute();
		}, this._onObjectsTransformDetached = () => {
			new Hn(this.viewer, "ObjectTransform").execute();
		};
	}
	onRegister() {
		Ra(this.viewer), this.viewer.signals.onObjectDoubleClicked.connect(this._onObjectDoubleClicked), this.viewer.signals.onObjectsTransformAttached.connect(this._onObjectsTransformAttached), this.viewer.signals.onObjectsTransformDetached.connect(this._onObjectsTransformDetached), this.viewer.signals.onViewportAdded.connect(this._setupViewport), this.viewer.behaviorController.addBehavior(Va), this.viewer.behaviorController.addBehavior(Ba), this.viewer.behaviorController.addBehavior(za), this._setupViewport();
	}
	onUnregister() {
		this.viewer.signals.onObjectDoubleClicked.disconnect(this._onObjectDoubleClicked), this.viewer.signals.onObjectsTransformAttached.disconnect(this._onObjectsTransformAttached), this.viewer.signals.onObjectsTransformDetached.disconnect(this._onObjectsTransformDetached), this.viewer.signals.onViewportAdded.disconnect(this._setupViewport), this.viewer.behaviorController.removeBehavior(Va), this.viewer.behaviorController.removeBehavior(Ba), this.viewer.behaviorController.removeBehavior(za), this._unsetupViewport();
	}
};
//#endregion
//#region ../../node_modules/tinycolor2/esm/tinycolor.js
function qa(e) {
	"@babel/helpers - typeof";
	return qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, qa(e);
}
var Ja = /^\s+/, Ya = /\s+$/;
function W(e, t) {
	if (e ||= "", t ||= {}, e instanceof W) return e;
	if (!(this instanceof W)) return new W(e, t);
	var n = Xa(e);
	this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
W.prototype = {
	isDark: function() {
		return this.getBrightness() < 128;
	},
	isLight: function() {
		return !this.isDark();
	},
	isValid: function() {
		return this._ok;
	},
	getOriginalInput: function() {
		return this._originalInput;
	},
	getFormat: function() {
		return this._format;
	},
	getAlpha: function() {
		return this._a;
	},
	getBrightness: function() {
		var e = this.toRgb();
		return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
	},
	getLuminance: function() {
		var e = this.toRgb(), t = e.r / 255, n = e.g / 255, r = e.b / 255, i = t <= .03928 ? t / 12.92 : ((t + .055) / 1.055) ** 2.4, a = n <= .03928 ? n / 12.92 : ((n + .055) / 1.055) ** 2.4, o = r <= .03928 ? r / 12.92 : ((r + .055) / 1.055) ** 2.4;
		return .2126 * i + .7152 * a + .0722 * o;
	},
	setAlpha: function(e) {
		return this._a = xo(e), this._roundA = Math.round(100 * this._a) / 100, this;
	},
	toHsv: function() {
		var e = eo(this._r, this._g, this._b);
		return {
			h: e.h * 360,
			s: e.s,
			v: e.v,
			a: this._a
		};
	},
	toHsvString: function() {
		var e = eo(this._r, this._g, this._b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), r = Math.round(e.v * 100);
		return this._a == 1 ? "hsv(" + t + ", " + n + "%, " + r + "%)" : "hsva(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
	},
	toHsl: function() {
		var e = Qa(this._r, this._g, this._b);
		return {
			h: e.h * 360,
			s: e.s,
			l: e.l,
			a: this._a
		};
	},
	toHslString: function() {
		var e = Qa(this._r, this._g, this._b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), r = Math.round(e.l * 100);
		return this._a == 1 ? "hsl(" + t + ", " + n + "%, " + r + "%)" : "hsla(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
	},
	toHex: function(e) {
		return no(this._r, this._g, this._b, e);
	},
	toHexString: function(e) {
		return "#" + this.toHex(e);
	},
	toHex8: function(e) {
		return ro(this._r, this._g, this._b, this._a, e);
	},
	toHex8String: function(e) {
		return "#" + this.toHex8(e);
	},
	toRgb: function() {
		return {
			r: Math.round(this._r),
			g: Math.round(this._g),
			b: Math.round(this._b),
			a: this._a
		};
	},
	toRgbString: function() {
		return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
	},
	toPercentageRgb: function() {
		return {
			r: Math.round(G(this._r, 255) * 100) + "%",
			g: Math.round(G(this._g, 255) * 100) + "%",
			b: Math.round(G(this._b, 255) * 100) + "%",
			a: this._a
		};
	},
	toPercentageRgbString: function() {
		return this._a == 1 ? "rgb(" + Math.round(G(this._r, 255) * 100) + "%, " + Math.round(G(this._g, 255) * 100) + "%, " + Math.round(G(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(G(this._r, 255) * 100) + "%, " + Math.round(G(this._g, 255) * 100) + "%, " + Math.round(G(this._b, 255) * 100) + "%, " + this._roundA + ")";
	},
	toName: function() {
		return this._a === 0 ? "transparent" : this._a < 1 ? !1 : yo[no(this._r, this._g, this._b, !0)] || !1;
	},
	toFilter: function(e) {
		var t = "#" + io(this._r, this._g, this._b, this._a), n = t, r = this._gradientType ? "GradientType = 1, " : "";
		if (e) {
			var i = W(e);
			n = "#" + io(i._r, i._g, i._b, i._a);
		}
		return "progid:DXImageTransform.Microsoft.gradient(" + r + "startColorstr=" + t + ",endColorstr=" + n + ")";
	},
	toString: function(e) {
		var t = !!e;
		e ||= this._format;
		var n = !1, r = this._a < 1 && this._a >= 0;
		return !t && r && (e === "hex" || e === "hex6" || e === "hex3" || e === "hex4" || e === "hex8" || e === "name") ? e === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (n = this.toRgbString()), e === "prgb" && (n = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (n = this.toHexString()), e === "hex3" && (n = this.toHexString(!0)), e === "hex4" && (n = this.toHex8String(!0)), e === "hex8" && (n = this.toHex8String()), e === "name" && (n = this.toName()), e === "hsl" && (n = this.toHslString()), e === "hsv" && (n = this.toHsvString()), n || this.toHexString());
	},
	clone: function() {
		return W(this.toString());
	},
	_applyModification: function(e, t) {
		var n = e.apply(null, [this].concat([].slice.call(t)));
		return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
	},
	lighten: function() {
		return this._applyModification(co, arguments);
	},
	brighten: function() {
		return this._applyModification(lo, arguments);
	},
	darken: function() {
		return this._applyModification(uo, arguments);
	},
	desaturate: function() {
		return this._applyModification(ao, arguments);
	},
	saturate: function() {
		return this._applyModification(oo, arguments);
	},
	greyscale: function() {
		return this._applyModification(so, arguments);
	},
	spin: function() {
		return this._applyModification(fo, arguments);
	},
	_applyCombination: function(e, t) {
		return e.apply(null, [this].concat([].slice.call(t)));
	},
	analogous: function() {
		return this._applyCombination(go, arguments);
	},
	complement: function() {
		return this._applyCombination(po, arguments);
	},
	monochromatic: function() {
		return this._applyCombination(_o, arguments);
	},
	splitcomplement: function() {
		return this._applyCombination(ho, arguments);
	},
	triad: function() {
		return this._applyCombination(mo, [3]);
	},
	tetrad: function() {
		return this._applyCombination(mo, [4]);
	}
}, W.fromRatio = function(e, t) {
	if (qa(e) == "object") {
		var n = {};
		for (var r in e) e.hasOwnProperty(r) && (n[r] = r === "a" ? e[r] : Do(e[r]));
		e = n;
	}
	return W(e, t);
};
function Xa(e) {
	var t = {
		r: 0,
		g: 0,
		b: 0
	}, n = 1, r = null, i = null, a = null, o = !1, s = !1;
	return typeof e == "string" && (e = Mo(e)), qa(e) == "object" && (jo(e.r) && jo(e.g) && jo(e.b) ? (t = Za(e.r, e.g, e.b), o = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : jo(e.h) && jo(e.s) && jo(e.v) ? (r = Do(e.s), i = Do(e.v), t = to(e.h, r, i), o = !0, s = "hsv") : jo(e.h) && jo(e.s) && jo(e.l) && (r = Do(e.s), a = Do(e.l), t = $a(e.h, r, a), o = !0, s = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = xo(n), {
		ok: o,
		format: e.format || s,
		r: Math.min(255, Math.max(t.r, 0)),
		g: Math.min(255, Math.max(t.g, 0)),
		b: Math.min(255, Math.max(t.b, 0)),
		a: n
	};
}
function Za(e, t, n) {
	return {
		r: G(e, 255) * 255,
		g: G(t, 255) * 255,
		b: G(n, 255) * 255
	};
}
function Qa(e, t, n) {
	e = G(e, 255), t = G(t, 255), n = G(n, 255);
	var r = Math.max(e, t, n), i = Math.min(e, t, n), a, o, s = (r + i) / 2;
	if (r == i) a = o = 0;
	else {
		var c = r - i;
		switch (o = s > .5 ? c / (2 - r - i) : c / (r + i), r) {
			case e:
				a = (t - n) / c + (t < n ? 6 : 0);
				break;
			case t:
				a = (n - e) / c + 2;
				break;
			case n: a = (e - t) / c + 4;
		}
		a /= 6;
	}
	return {
		h: a,
		s: o,
		l: s
	};
}
function $a(e, t, n) {
	var r, i, a;
	e = G(e, 360), t = G(t, 100), n = G(n, 100);
	function o(e, t, n) {
		return n < 0 && (n += 1), n > 1 && --n, n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
	}
	if (t === 0) r = i = a = n;
	else {
		var s = n < .5 ? n * (1 + t) : n + t - n * t, c = 2 * n - s;
		r = o(c, s, e + 1 / 3), i = o(c, s, e), a = o(c, s, e - 1 / 3);
	}
	return {
		r: r * 255,
		g: i * 255,
		b: a * 255
	};
}
function eo(e, t, n) {
	e = G(e, 255), t = G(t, 255), n = G(n, 255);
	var r = Math.max(e, t, n), i = Math.min(e, t, n), a, o, s = r, c = r - i;
	if (o = r === 0 ? 0 : c / r, r == i) a = 0;
	else {
		switch (r) {
			case e:
				a = (t - n) / c + (t < n ? 6 : 0);
				break;
			case t:
				a = (n - e) / c + 2;
				break;
			case n: a = (e - t) / c + 4;
		}
		a /= 6;
	}
	return {
		h: a,
		s: o,
		v: s
	};
}
function to(e, t, n) {
	e = G(e, 360) * 6, t = G(t, 100), n = G(n, 100);
	var r = Math.floor(e), i = e - r, a = n * (1 - t), o = n * (1 - i * t), s = n * (1 - (1 - i) * t), c = r % 6, l = [
		n,
		o,
		a,
		a,
		s,
		n
	][c], u = [
		s,
		n,
		n,
		o,
		a,
		a
	][c], d = [
		a,
		a,
		s,
		n,
		n,
		o
	][c];
	return {
		r: l * 255,
		g: u * 255,
		b: d * 255
	};
}
function no(e, t, n, r) {
	var i = [
		Eo(Math.round(e).toString(16)),
		Eo(Math.round(t).toString(16)),
		Eo(Math.round(n).toString(16))
	];
	return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function ro(e, t, n, r, i) {
	var a = [
		Eo(Math.round(e).toString(16)),
		Eo(Math.round(t).toString(16)),
		Eo(Math.round(n).toString(16)),
		Eo(Oo(r))
	];
	return i && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) && a[3].charAt(0) == a[3].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function io(e, t, n, r) {
	return [
		Eo(Oo(r)),
		Eo(Math.round(e).toString(16)),
		Eo(Math.round(t).toString(16)),
		Eo(Math.round(n).toString(16))
	].join("");
}
W.equals = function(e, t) {
	return !e || !t ? !1 : W(e).toRgbString() == W(t).toRgbString();
}, W.random = function() {
	return W.fromRatio({
		r: Math.random(),
		g: Math.random(),
		b: Math.random()
	});
};
function ao(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = W(e).toHsl();
	return n.s -= t / 100, n.s = So(n.s), W(n);
}
function oo(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = W(e).toHsl();
	return n.s += t / 100, n.s = So(n.s), W(n);
}
function so(e) {
	return W(e).desaturate(100);
}
function co(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = W(e).toHsl();
	return n.l += t / 100, n.l = So(n.l), W(n);
}
function lo(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = W(e).toRgb();
	return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), W(n);
}
function uo(e, t) {
	t = t === 0 ? 0 : t || 10;
	var n = W(e).toHsl();
	return n.l -= t / 100, n.l = So(n.l), W(n);
}
function fo(e, t) {
	var n = W(e).toHsl(), r = (n.h + t) % 360;
	return n.h = r < 0 ? 360 + r : r, W(n);
}
function po(e) {
	var t = W(e).toHsl();
	return t.h = (t.h + 180) % 360, W(t);
}
function mo(e, t) {
	if (isNaN(t) || t <= 0) throw Error("Argument to polyad must be a positive number");
	for (var n = W(e).toHsl(), r = [W(e)], i = 360 / t, a = 1; a < t; a++) r.push(W({
		h: (n.h + a * i) % 360,
		s: n.s,
		l: n.l
	}));
	return r;
}
function ho(e) {
	var t = W(e).toHsl(), n = t.h;
	return [
		W(e),
		W({
			h: (n + 72) % 360,
			s: t.s,
			l: t.l
		}),
		W({
			h: (n + 216) % 360,
			s: t.s,
			l: t.l
		})
	];
}
function go(e, t, n) {
	t ||= 6, n ||= 30;
	var r = W(e).toHsl(), i = 360 / n, a = [W(e)];
	for (r.h = (r.h - (i * t >> 1) + 720) % 360; --t;) r.h = (r.h + i) % 360, a.push(W(r));
	return a;
}
function _o(e, t) {
	t ||= 6;
	for (var n = W(e).toHsv(), r = n.h, i = n.s, a = n.v, o = [], s = 1 / t; t--;) o.push(W({
		h: r,
		s: i,
		v: a
	})), a = (a + s) % 1;
	return o;
}
W.mix = function(e, t, n) {
	n = n === 0 ? 0 : n || 50;
	var r = W(e).toRgb(), i = W(t).toRgb(), a = n / 100;
	return W({
		r: (i.r - r.r) * a + r.r,
		g: (i.g - r.g) * a + r.g,
		b: (i.b - r.b) * a + r.b,
		a: (i.a - r.a) * a + r.a
	});
}, W.readability = function(e, t) {
	var n = W(e), r = W(t);
	return (Math.max(n.getLuminance(), r.getLuminance()) + .05) / (Math.min(n.getLuminance(), r.getLuminance()) + .05);
}, W.isReadable = function(e, t, n) {
	var r = W.readability(e, t), i, a = !1;
	switch (i = No(n), i.level + i.size) {
		case "AAsmall":
		case "AAAlarge":
			a = r >= 4.5;
			break;
		case "AAlarge":
			a = r >= 3;
			break;
		case "AAAsmall": a = r >= 7;
	}
	return a;
}, W.mostReadable = function(e, t, n) {
	var r = null, i = 0, a, o, s, c;
	n ||= {}, o = n.includeFallbackColors, s = n.level, c = n.size;
	for (var l = 0; l < t.length; l++) a = W.readability(e, t[l]), a > i && (i = a, r = W(t[l]));
	return W.isReadable(e, r, {
		level: s,
		size: c
	}) || !o ? r : (n.includeFallbackColors = !1, W.mostReadable(e, ["#fff", "#000"], n));
};
var vo = W.names = {
	aliceblue: "f0f8ff",
	antiquewhite: "faebd7",
	aqua: "0ff",
	aquamarine: "7fffd4",
	azure: "f0ffff",
	beige: "f5f5dc",
	bisque: "ffe4c4",
	black: "000",
	blanchedalmond: "ffebcd",
	blue: "00f",
	blueviolet: "8a2be2",
	brown: "a52a2a",
	burlywood: "deb887",
	burntsienna: "ea7e5d",
	cadetblue: "5f9ea0",
	chartreuse: "7fff00",
	chocolate: "d2691e",
	coral: "ff7f50",
	cornflowerblue: "6495ed",
	cornsilk: "fff8dc",
	crimson: "dc143c",
	cyan: "0ff",
	darkblue: "00008b",
	darkcyan: "008b8b",
	darkgoldenrod: "b8860b",
	darkgray: "a9a9a9",
	darkgreen: "006400",
	darkgrey: "a9a9a9",
	darkkhaki: "bdb76b",
	darkmagenta: "8b008b",
	darkolivegreen: "556b2f",
	darkorange: "ff8c00",
	darkorchid: "9932cc",
	darkred: "8b0000",
	darksalmon: "e9967a",
	darkseagreen: "8fbc8f",
	darkslateblue: "483d8b",
	darkslategray: "2f4f4f",
	darkslategrey: "2f4f4f",
	darkturquoise: "00ced1",
	darkviolet: "9400d3",
	deeppink: "ff1493",
	deepskyblue: "00bfff",
	dimgray: "696969",
	dimgrey: "696969",
	dodgerblue: "1e90ff",
	firebrick: "b22222",
	floralwhite: "fffaf0",
	forestgreen: "228b22",
	fuchsia: "f0f",
	gainsboro: "dcdcdc",
	ghostwhite: "f8f8ff",
	gold: "ffd700",
	goldenrod: "daa520",
	gray: "808080",
	green: "008000",
	greenyellow: "adff2f",
	grey: "808080",
	honeydew: "f0fff0",
	hotpink: "ff69b4",
	indianred: "cd5c5c",
	indigo: "4b0082",
	ivory: "fffff0",
	khaki: "f0e68c",
	lavender: "e6e6fa",
	lavenderblush: "fff0f5",
	lawngreen: "7cfc00",
	lemonchiffon: "fffacd",
	lightblue: "add8e6",
	lightcoral: "f08080",
	lightcyan: "e0ffff",
	lightgoldenrodyellow: "fafad2",
	lightgray: "d3d3d3",
	lightgreen: "90ee90",
	lightgrey: "d3d3d3",
	lightpink: "ffb6c1",
	lightsalmon: "ffa07a",
	lightseagreen: "20b2aa",
	lightskyblue: "87cefa",
	lightslategray: "789",
	lightslategrey: "789",
	lightsteelblue: "b0c4de",
	lightyellow: "ffffe0",
	lime: "0f0",
	limegreen: "32cd32",
	linen: "faf0e6",
	magenta: "f0f",
	maroon: "800000",
	mediumaquamarine: "66cdaa",
	mediumblue: "0000cd",
	mediumorchid: "ba55d3",
	mediumpurple: "9370db",
	mediumseagreen: "3cb371",
	mediumslateblue: "7b68ee",
	mediumspringgreen: "00fa9a",
	mediumturquoise: "48d1cc",
	mediumvioletred: "c71585",
	midnightblue: "191970",
	mintcream: "f5fffa",
	mistyrose: "ffe4e1",
	moccasin: "ffe4b5",
	navajowhite: "ffdead",
	navy: "000080",
	oldlace: "fdf5e6",
	olive: "808000",
	olivedrab: "6b8e23",
	orange: "ffa500",
	orangered: "ff4500",
	orchid: "da70d6",
	palegoldenrod: "eee8aa",
	palegreen: "98fb98",
	paleturquoise: "afeeee",
	palevioletred: "db7093",
	papayawhip: "ffefd5",
	peachpuff: "ffdab9",
	peru: "cd853f",
	pink: "ffc0cb",
	plum: "dda0dd",
	powderblue: "b0e0e6",
	purple: "800080",
	rebeccapurple: "663399",
	red: "f00",
	rosybrown: "bc8f8f",
	royalblue: "4169e1",
	saddlebrown: "8b4513",
	salmon: "fa8072",
	sandybrown: "f4a460",
	seagreen: "2e8b57",
	seashell: "fff5ee",
	sienna: "a0522d",
	silver: "c0c0c0",
	skyblue: "87ceeb",
	slateblue: "6a5acd",
	slategray: "708090",
	slategrey: "708090",
	snow: "fffafa",
	springgreen: "00ff7f",
	steelblue: "4682b4",
	tan: "d2b48c",
	teal: "008080",
	thistle: "d8bfd8",
	tomato: "ff6347",
	turquoise: "40e0d0",
	violet: "ee82ee",
	wheat: "f5deb3",
	white: "fff",
	whitesmoke: "f5f5f5",
	yellow: "ff0",
	yellowgreen: "9acd32"
}, yo = W.hexNames = bo(vo);
function bo(e) {
	var t = {};
	for (var n in e) e.hasOwnProperty(n) && (t[e[n]] = n);
	return t;
}
function xo(e) {
	return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function G(e, t) {
	wo(e) && (e = "100%");
	var n = To(e);
	return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function So(e) {
	return Math.min(1, Math.max(0, e));
}
function Co(e) {
	return parseInt(e, 16);
}
function wo(e) {
	return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function To(e) {
	return typeof e == "string" && e.indexOf("%") != -1;
}
function Eo(e) {
	return e.length == 1 ? "0" + e : "" + e;
}
function Do(e) {
	return e <= 1 && (e = e * 100 + "%"), e;
}
function Oo(e) {
	return Math.round(parseFloat(e) * 255).toString(16);
}
function ko(e) {
	return Co(e) / 255;
}
var Ao = function() {
	var e = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)", t = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?", n = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?";
	return {
		CSS_UNIT: new RegExp(e),
		rgb: RegExp("rgb" + t),
		rgba: RegExp("rgba" + n),
		hsl: RegExp("hsl" + t),
		hsla: RegExp("hsla" + n),
		hsv: RegExp("hsv" + t),
		hsva: RegExp("hsva" + n),
		hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
		hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
		hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
		hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	};
}();
function jo(e) {
	return !!Ao.CSS_UNIT.exec(e);
}
function Mo(e) {
	e = e.replace(Ja, "").replace(Ya, "").toLowerCase();
	var t = !1;
	if (vo[e]) e = vo[e], t = !0;
	else if (e == "transparent") return {
		r: 0,
		g: 0,
		b: 0,
		a: 0,
		format: "name"
	};
	var n;
	return (n = Ao.rgb.exec(e)) ? {
		r: n[1],
		g: n[2],
		b: n[3]
	} : (n = Ao.rgba.exec(e)) ? {
		r: n[1],
		g: n[2],
		b: n[3],
		a: n[4]
	} : (n = Ao.hsl.exec(e)) ? {
		h: n[1],
		s: n[2],
		l: n[3]
	} : (n = Ao.hsla.exec(e)) ? {
		h: n[1],
		s: n[2],
		l: n[3],
		a: n[4]
	} : (n = Ao.hsv.exec(e)) ? {
		h: n[1],
		s: n[2],
		v: n[3]
	} : (n = Ao.hsva.exec(e)) ? {
		h: n[1],
		s: n[2],
		v: n[3],
		a: n[4]
	} : (n = Ao.hex8.exec(e)) ? {
		r: Co(n[1]),
		g: Co(n[2]),
		b: Co(n[3]),
		a: ko(n[4]),
		format: t ? "name" : "hex8"
	} : (n = Ao.hex6.exec(e)) ? {
		r: Co(n[1]),
		g: Co(n[2]),
		b: Co(n[3]),
		format: t ? "name" : "hex"
	} : (n = Ao.hex4.exec(e)) ? {
		r: Co(n[1] + "" + n[1]),
		g: Co(n[2] + "" + n[2]),
		b: Co(n[3] + "" + n[3]),
		a: ko(n[4] + "" + n[4]),
		format: t ? "name" : "hex8"
	} : (n = Ao.hex3.exec(e)) ? {
		r: Co(n[1] + "" + n[1]),
		g: Co(n[2] + "" + n[2]),
		b: Co(n[3] + "" + n[3]),
		format: t ? "name" : "hex"
	} : !1;
}
function No(e) {
	var t, n;
	return e ||= {
		level: "AA",
		size: "small"
	}, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
		level: t,
		size: n
	};
}
//#endregion
//#region src/components/ColorInput/ColorInput.tsx
var K = (e) => {
	let { color: t, onChange: n, error: r, useAlpha: i = !0, label: a, helperText: o, clearColorText: s = "Clear color" } = e, c = l(), [u, p] = f(null), m = d(null), _ = () => {
		p(m.current);
	}, v = () => {
		p(null);
	}, y = (e) => {
		i ? n?.(W(e.rgb).toHex8String()) : n?.(W(e.rgb).toHexString());
	}, b = (e) => {
		let t = i ? 9 : 7;
		n?.(e.target.value.slice(0, t));
	}, x = !!u, S = W(t).getAlpha() === 0, C;
	return o ? C = o : W(t).isValid() || (C = "Invalid color"), /* @__PURE__ */ g("div", {
		ref: m,
		children: [/* @__PURE__ */ h(qe, {
			error: r ?? !W(t).isValid(),
			helperText: C,
			value: t,
			onChange: b,
			label: a,
			sx: { "&:hover": { cursor: "pointer" } },
			InputProps: {
				inputProps: {
					"data-testid": "color-input-text-input",
					style: {
						paddingLeft: 5,
						width: 75
					}
				},
				startAdornment: /* @__PURE__ */ h(He, {
					variant: "info",
					"aria-describedby": c,
					"data-testid": "color-input-swatch-button",
					onClick: _,
					sx: {
						padding: 0,
						width: 26,
						minWidth: 26,
						height: 26,
						backgroundColor: t,
						border: S ? "1px solid lightgray" : "none",
						"&:hover": { backgroundColor: t }
					},
					children: /* @__PURE__ */ h("div", { style: {
						height: 30,
						width: 1,
						backgroundColor: "red",
						transform: "rotate(45deg)",
						display: S ? "inline" : "none"
					} })
				})
			}
		}), /* @__PURE__ */ h(M, {
			slotProps: { root: { sx: { zIndex: 99999 } } },
			id: c,
			open: x,
			anchorEl: u,
			onClose: v,
			anchorOrigin: {
				vertical: "bottom",
				horizontal: "left"
			},
			transformOrigin: {
				vertical: "top",
				horizontal: "left"
			},
			children: /* @__PURE__ */ h("div", {
				style: {
					width: "200px",
					height: i ? "296px" : "272px"
				},
				children: /* @__PURE__ */ h(Po, {
					color: t,
					onChange: y,
					useAlpha: i,
					clearColorText: s
				})
			})
		})]
	});
}, Po = ot((t) => {
	let { onChange: n, useAlpha: r, color: i, clearColorText: a } = t, [o, s] = f(W(i).toHexString()), [l, u] = f(W(i).getAlpha()), [d, p] = f(i), m = (e) => {
		let t = e;
		t.a === 0 && (t.a = 1), n?.(t), s(W(t).toHexString());
	}, _ = (e) => {
		n?.(e), u(W(e).getAlpha()), s(W(e).toHexString());
	}, v = () => {
		n?.({
			r: 0,
			g: 0,
			b: 0,
			a: 0
		});
	}, y = (e) => {
		n?.(W(e.target.value).toHex8String()), s(e.target.value), u(W(e.target.value).getAlpha());
	}, b = (e) => {
		u(e);
		let t = W(i).setAlpha(e ?? 1).toHex8String();
		n?.(t);
	};
	return c(() => {
		p(i);
	}, []), /* @__PURE__ */ g("div", {
		style: {
			display: "flex",
			flexDirection: "column",
			gap: "4px",
			padding: "4px"
		},
		children: [
			/* @__PURE__ */ h("div", {
				"data-testid": "color-input-saturation",
				style: {
					height: "100px",
					position: "relative"
				},
				children: /* @__PURE__ */ h(lt, {
					...t,
					onChange: m
				})
			}),
			/* @__PURE__ */ g(at, {
				container: !0,
				children: [/* @__PURE__ */ h(at, {
					size: { xs: r ? 6 : 12 },
					children: /* @__PURE__ */ h(e, {
						sx: {
							pr: .5,
							pt: 1.5,
							pl: r ? 0 : .5
						},
						children: /* @__PURE__ */ h(qe, {
							value: o,
							onChange: y,
							label: "hex color",
							"data-testid": "color-input-hex-input"
						})
					})
				}), !!r && /* @__PURE__ */ h(at, {
					size: { xs: 6 },
					children: /* @__PURE__ */ h(e, {
						sx: {
							pl: .5,
							pt: 1.5
						},
						children: /* @__PURE__ */ h(la, {
							"data-testid": "color-input-alpha-input",
							label: "alpha",
							value: l,
							onChange: b,
							min: 0,
							max: 1,
							step: .01,
							maxDigits: 2
						})
					})
				})]
			}),
			/* @__PURE__ */ h("div", {
				"data-testid": "color-input-hue",
				style: {
					height: "20px",
					position: "relative"
				},
				children: /* @__PURE__ */ h(ct, {
					...t,
					onChange: m
				})
			}),
			!!r && /* @__PURE__ */ h("div", {
				"data-testid": "color-input-alpha",
				style: {
					height: "20px",
					position: "relative"
				},
				children: /* @__PURE__ */ h(st, {
					...t,
					onChange: _
				})
			}),
			/* @__PURE__ */ g(e, {
				sx: {
					display: "grid",
					alignItems: "center",
					gridTemplateColumns: "1fr 1fr",
					columnGap: "6px",
					marginBottom: 2
				},
				children: [
					/* @__PURE__ */ h(Ve, {
						sx: {
							marginRight: "8px",
							fontSize: "12px"
						},
						children: "Current color:"
					}),
					/* @__PURE__ */ h(Ve, {
						sx: {
							marginRight: "8px",
							fontSize: "12px"
						},
						children: "New color:"
					}),
					/* @__PURE__ */ h(e, { sx: {
						backgroundColor: d,
						height: 25,
						width: "100%"
					} }),
					/* @__PURE__ */ h(e, { sx: {
						backgroundColor: i,
						height: 25,
						width: "100%"
					} })
				]
			}),
			/* @__PURE__ */ h(He, {
				variant: "secondary",
				"data-testid": "color-input-clear-button",
				onClick: v,
				children: a
			})
		]
	});
}), Fo = r(null), Io = Fo.Provider, Lo = () => {
	let e = s(Fo);
	if (!e) throw Error("Context not found");
	return e;
}, Ro = "dock-" + We(), zo = (e) => {
	let { children: t, sx: n } = e, [r, i] = f(null), a = (e) => r === e, o = (e, t) => {
		i(t ? e : null);
	}, s = u(() => ({
		closeAllMenus: () => i(null),
		isMenuOpened: a,
		setOpenMenu: o,
		container: "dock",
		isInsideMenu: !1,
		closeParentMenu: () => {},
		unregisterMenu: () => {},
		registerMenu: () => {},
		isToolbarDisabled: !1
	}), [r]);
	return /* @__PURE__ */ h(Io, {
		value: s,
		children: /* @__PURE__ */ h(O, {
			id: Ro,
			direction: "row",
			spacing: "10px",
			alignItems: "center",
			justifyItems: "center",
			justifyContent: "center",
			sx: {
				...n,
				gap: 2,
				zIndex: 20
			},
			children: t
		})
	});
}, Bo = (e) => {
	let { children: t, sx: n } = e, { t: r } = j("teiaviewer"), [i, a] = un("Viewport", "showToolbar"), [o] = un("Viewport", "disableToolbar"), [s, l] = f(/* @__PURE__ */ new Map()), d = !0;
	for (let e of s.values()) if (!e) {
		d = !1;
		break;
	}
	c(() => {
		b();
	}, [i]);
	let p = (e) => s.get(e) ?? !1, m = (e, t) => {
		l((n) => {
			let r = new Map(n);
			return r.set(e, t), r;
		});
	}, _ = (e) => {
		l((t) => {
			let n = new Map(t);
			return n.set(e, !1), n;
		});
	}, v = (e) => {
		l((t) => {
			let n = new Map(t);
			return n.delete(e), n;
		});
	}, y = () => {
		l((e) => {
			let t = new Map(e);
			for (let e of t.keys()) t.set(e, !0);
			return t;
		});
	}, b = () => {
		l((e) => {
			let t = new Map(e);
			for (let e of t.keys()) t.set(e, !1);
			return t;
		});
	}, x = () => {
		d ? b() : y();
	}, S = () => {
		a(!1);
	}, C = u(() => ({
		closeAllMenus: b,
		isMenuOpened: p,
		setOpenMenu: m,
		container: "toolbar",
		isToolbarDisabled: o,
		isInsideMenu: !1,
		closeParentMenu: () => {},
		registerMenu: _,
		unregisterMenu: v
	}), [s, o]), w = r("components.toolbar.expand_button.label"), ee = gr;
	return d && (w = r("components.toolbar.collapse_button.label"), ee = V), /* @__PURE__ */ h(Io, {
		value: C,
		children: /* @__PURE__ */ g(O, {
			direction: "column",
			spacing: "10px",
			alignItems: "center",
			justifyItems: "center",
			justifyContent: "center",
			sx: {
				...n,
				gap: 2,
				visibility: i ? "visible" : "hidden"
			},
			children: [/* @__PURE__ */ g(O, {
				direction: "row",
				children: [/* @__PURE__ */ h(nt, {
					title: w,
					placement: "top",
					children: /* @__PURE__ */ h(He, {
						variant: "info",
						"aria-label": w,
						"data-testid": "toolbar-expand-button",
						sx: {
							padding: 0,
							minWidth: 0,
							backgroundColor: "transparent",
							color: "info.dark",
							"&:hover": {
								backgroundColor: "transparent",
								color: "white"
							}
						},
						onClick: x,
						children: /* @__PURE__ */ h(Be, {
							component: ee,
							fontSize: "small"
						})
					})
				}), /* @__PURE__ */ h(nt, {
					title: r("components.toolbar.close_button.label"),
					placement: "top",
					children: /* @__PURE__ */ h(He, {
						variant: "info",
						"aria-label": r("components.toolbar.close_button.label"),
						"data-testid": "toolbar-close-button",
						sx: {
							padding: 0,
							minWidth: 0,
							backgroundColor: "transparent",
							color: "info.dark",
							"&:hover": {
								backgroundColor: "transparent",
								color: "white"
							}
						},
						onClick: S,
						children: /* @__PURE__ */ h(Be, {
							component: Kr,
							fontSize: "small"
						})
					})
				})]
			}), t]
		})
	});
}, q = a((t, n) => {
	let { id: r, icon: i, disabled: a = !1, onClick: o, sx: s, label: c, children: l, active: u, CustomButtonContent: f, hidden: p, ..._ } = t, { isInsideMenu: v, container: y, isToolbarDisabled: b } = Lo(), { current: x } = d(r ?? `ToolItem-${Pe.generateUUID()}`), S = y === "dock" || v, C = a || b, w = f ?? /* @__PURE__ */ h(Be, {
		className: "ToolbarItemButtonIcon",
		component: i,
		sx: {
			color: C ? "primary.light" : "primary.main",
			backgroundColor: "background.paper"
		}
	});
	return p ? /* @__PURE__ */ h(m, {}) : /* @__PURE__ */ g(e, {
		..._,
		className: "ToolbarItem",
		ref: n,
		sx: {
			position: "relative",
			"&:not(.ToolbarItem + .ToolbarItem) .ToolbarItemButton": {
				...S && {
					borderBottomLeftRadius: "10px",
					borderTopLeftRadius: "10px"
				},
				...!S && {
					borderTopRightRadius: "10px",
					borderTopLeftRadius: "10px"
				}
			},
			"&:not(:has(+ .ToolbarItem)) .ToolbarItemButton": {
				...S && {
					borderBottomRightRadius: "10px",
					borderTopRightRadius: "10px"
				},
				...!S && {
					borderBottomLeftRadius: "10px",
					borderBottomRightRadius: "10px"
				}
			},
			...s
		},
		children: [/* @__PURE__ */ h(nt, {
			title: c,
			placement: "top",
			disableInteractive: !0,
			children: /* @__PURE__ */ g(He, {
				className: "ToolbarItemButton",
				variant: "info",
				id: x,
				type: "button",
				onClick: o,
				disabled: C,
				sx: {
					display: "flex",
					position: "relative",
					minWidth: 44,
					minHeight: 44,
					height: 44,
					padding: 0,
					margin: 0,
					transition: "background-color 0s linear",
					backgroundColor: "background.paper",
					"&:hover": { backgroundColor: "info.light" },
					"&:hover > .ToolbarItemButtonIcon": { backgroundColor: "info.light" },
					borderRadius: 0
				},
				children: [w, !!u && /* @__PURE__ */ h(e, { sx: {
					position: "absolute",
					bottom: "4px",
					width: "15px",
					height: "3px",
					borderRadius: "10px",
					backgroundColor: "primary.main"
				} })]
			})
		}), l]
	});
}), Vo = (e) => {
	let { children: t, sx: n } = e, { container: r, isInsideMenu: i } = Lo();
	return /* @__PURE__ */ h(O, {
		direction: r === "dock" ? "row" : "column",
		className: "ToolbarItemGroup",
		alignItems: "center",
		justifyItems: "center",
		sx: {
			backgroundColor: "white",
			borderRadius: "10px",
			gap: r === "dock" || i ? "0px" : "1px",
			...n
		},
		children: t
	});
}, Ho = (e) => {
	let { children: t, disabled: n = !1, ...r } = e, { current: i } = d(`ToolbarItem-${Pe.generateUUID()}`), a = d(null), o = Lo(), { isToolbarDisabled: s, isMenuOpened: l, setOpenMenu: f, container: p, isInsideMenu: m, registerMenu: _, unregisterMenu: v } = o, y = l(i), b = p === "dock" || m;
	c(() => p === "toolbar" && !m ? (_(i), () => {
		v(i);
	}) : () => {}, []);
	let x = () => {
		f(i, !y);
	}, S = () => {
		f(i, !1);
	}, C = u(() => ({
		...o,
		isInsideMenu: !0,
		closeParentMenu: S
	}), [
		i,
		o,
		S
	]), w = n || s;
	return /* @__PURE__ */ g(q, {
		...r,
		disabled: w,
		id: i,
		ref: a,
		onClick: x,
		sx: { "&:hover #arrow": {
			backgroundColor: "info.light",
			visibility: w ? "hidden" : "visible"
		} },
		children: [/* @__PURE__ */ h(Uo, {
			sx: { visibility: y ? "visible" : "hidden" },
			placement: b ? "top" : "left"
		}), /* @__PURE__ */ h(Io, {
			value: C,
			children: /* @__PURE__ */ h(ut, {
				open: y,
				anchorEl: a.current,
				placement: b ? "top" : "left",
				modifiers: [{
					name: "offset",
					options: { offset: [0, 16] }
				}],
				children: /* @__PURE__ */ h(O, {
					direction: "row",
					alignItems: "center",
					sx: {
						backgroundColor: "background.paper",
						minHeight: "44px",
						height: "44px",
						borderRadius: "10px"
					},
					children: t
				})
			})
		})]
	});
}, Uo = (t) => {
	let { sx: n, placement: r } = t;
	return /* @__PURE__ */ h(e, {
		id: "arrow",
		sx: {
			transition: "background-color 0s linear",
			padding: 0,
			margin: 0,
			position: "absolute",
			width: 10,
			height: 10,
			...r === "top" && {
				top: 0,
				left: "50%"
			},
			...r === "left" && {
				top: "50%",
				left: 0
			},
			backgroundColor: "white",
			transform: "translate(-50%, -50%) rotate(45deg)",
			...n
		}
	});
}, Wo = (e) => {
	let { value: t = 30, color: n = "primary", className: r, showAdditionalInput: i = !1, onChange: a, min: o = 0, max: s = 100, step: c = 1, inputWidth: l = 100, maxDigits: u } = e, d = (e, t) => {
		Array.isArray(t) || a?.(t);
	}, f = (e) => {
		a?.(e);
	}, p = /* @__PURE__ */ h(dt, {
		color: n,
		onChange: d,
		value: t ?? 0,
		valueLabelDisplay: "auto",
		min: o,
		max: s,
		step: c
	});
	return i ? /* @__PURE__ */ g(at, {
		"data-testid": "slider-container",
		container: !0,
		spacing: 2,
		direction: "row",
		justifyContent: "space-between",
		alignItems: "center",
		className: r,
		children: [/* @__PURE__ */ h(at, { children: p }), /* @__PURE__ */ h(at, {
			width: l,
			children: /* @__PURE__ */ h(la, {
				"data-testid": "slider-input",
				value: t,
				onChange: f,
				step: c,
				max: s,
				min: o,
				maxDigits: u
			})
		})]
	}) : /* @__PURE__ */ h("div", {
		className: r,
		"data-testid": "slider-container",
		children: p
	});
}, Go = n.createContext(null), Ko = Go.Provider, qo = () => {
	let e = n.useContext(Go);
	if (!e) throw Error("AccordionSummary and AccordionDetails must be used inside the Accordion component.");
	return e;
}, Jo = () => {
	let { table: t } = qo(), n = t.getPageCount(), { pageIndex: r } = t.getState().pagination;
	return n > 0 ? /* @__PURE__ */ g(e, {
		component: "span",
		sx: { color: "grey.700" },
		children: [
			"Page",
			" ",
			/* @__PURE__ */ h(e, {
				component: "span",
				sx: {
					fontWeight: 600,
					color: "grey.900"
				},
				children: r + 1
			}),
			" ",
			"of",
			" ",
			/* @__PURE__ */ h(e, {
				component: "span",
				sx: {
					fontWeight: 600,
					color: "grey.900"
				},
				children: n
			})
		]
	}) : /* @__PURE__ */ h(e, {
		component: "span",
		sx: {
			fontWeight: 600,
			color: "grey.900"
		}
	});
};
//#endregion
//#region ../../node_modules/@heroicons/react/20/solid/esm/ChevronLeftIcon.js
function Yo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z",
		clipRule: "evenodd"
	}));
}
var Xo = /*#__PURE__*/ t.forwardRef(Yo);
//#endregion
//#region ../../node_modules/@heroicons/react/20/solid/esm/ChevronRightIcon.js
function Zo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z",
		clipRule: "evenodd"
	}));
}
var Qo = /*#__PURE__*/ t.forwardRef(Zo), $o = () => {
	let { table: e } = qo(), t = e.getPageCount(), { pageIndex: n } = e.getState().pagination, r = [n], i = e.getCanPreviousPage() ? 1 : 2;
	for (let e = 0; e < i; e++) {
		let i = n + e + 1;
		i < t && r.push(i);
	}
	let a = e.getCanNextPage() ? 1 : 2;
	for (let e = 0; e < a; e++) {
		let t = n - e - 1;
		t >= 0 && r.unshift(t);
	}
	return /* @__PURE__ */ g(ft, { children: [
		/* @__PURE__ */ h(He, {
			variant: "secondary",
			"data-testid": "table-previous-page-button",
			disabled: !e.getCanPreviousPage(),
			onClick: e.previousPage,
			children: /* @__PURE__ */ h(Xo, {})
		}),
		r.map((t) => /* @__PURE__ */ h(He, {
			variant: "secondary",
			"data-testid": "table-page-button",
			onClick: () => e.setPageIndex(t),
			sx: { ...n === t && {
				color: "primary.main",
				backgroundColor: "primary.light",
				"&:hover": {
					backgroundColor: (e) => N(e.palette.primary.light, .05),
					color: (e) => N(e.palette.primary.main, .05)
				}
			} },
			children: t + 1
		}, t)),
		/* @__PURE__ */ h(He, {
			variant: "secondary",
			"data-testid": "table-next-page-button",
			disabled: !e.getCanNextPage(),
			onClick: e.nextPage,
			children: /* @__PURE__ */ h(Qo, {})
		})
	] });
}, es = () => {
	let { table: e } = qo();
	return /* @__PURE__ */ h(mt, {
		value: e.getState().pagination.pageSize,
		onChange: (t, n) => {
			n && e.setPageSize(n);
		},
		id: "pageSize",
		disableClearable: !0,
		options: [
			5,
			10,
			20,
			30
		],
		renderInput: (e) => /* @__PURE__ */ h(qe, {
			...e,
			"data-testid": "table-page-size-input"
		}),
		getOptionLabel: String,
		sx: { "&& .MuiInputBase-root": { py: "1px" } }
	});
}, ts = (e) => {
	let { data: t, columns: r, children: i, pageSize: a = 10 } = e, [o, s] = n.useState({
		pageIndex: 0,
		pageSize: a
	}), c = vt({
		data: t,
		columns: r,
		state: { pagination: o },
		getCoreRowModel: gt(),
		onPaginationChange: s,
		getPaginationRowModel: _t()
	});
	return /* @__PURE__ */ h(Ko, {
		value: { table: c },
		children: i
	});
}, ns = (e) => {
	let { showColumnHeaders: t = !0, isDataLoading: n = !1 } = e, { table: r } = qo();
	return /* @__PURE__ */ g(yt, { children: [!!t && /* @__PURE__ */ h(rs, { table: r }), /* @__PURE__ */ h(is, {
		table: r,
		isDataLoading: n
	})] });
}, rs = (e) => {
	let { table: t } = e;
	return /* @__PURE__ */ h(St, {
		sx: {
			fontSize: "0.75rem",
			color: (e) => e.palette.grey[700],
			textTransform: "uppercase",
			bgcolor: (e) => e.palette.grey[50],
			"& > * + *": { borderTop: (e) => `8px solid ${e.palette.grey[200]}` }
		},
		children: t.getHeaderGroups().map((e) => /* @__PURE__ */ h(Ct, { children: e.headers.map((e) => /* @__PURE__ */ h(xt, {
			style: { padding: "0.25rem" },
			children: e.isPlaceholder ? null : ht(e.column.columnDef.header, e.getContext())
		}, e.id)) }, e.id))
	});
}, is = (e) => {
	let { table: t, isDataLoading: n } = e, { t: r } = j("teiaviewer");
	return /* @__PURE__ */ g(bt, { children: [
		!!n && /* @__PURE__ */ h(Ct, {
			sx: { backgroundColor: "white" },
			children: /* @__PURE__ */ h(xt, {
				colSpan: t.getAllFlatColumns().length,
				sx: {
					padding: 2,
					textAlign: "center"
				},
				children: /* @__PURE__ */ h(Le, {})
			})
		}, "loader-row"),
		t.getRowModel().rows.length === 0 && /* @__PURE__ */ h(Ct, {
			sx: { backgroundColor: "white" },
			children: /* @__PURE__ */ h(xt, {
				colSpan: t.getAllFlatColumns().length,
				sx: {
					padding: 2,
					textAlign: "center"
				},
				children: /* @__PURE__ */ h(Ge, {
					severity: "info",
					children: r("components.table.nodata_alert.text")
				})
			})
		}),
		t.getRowModel().rows.map((e) => /* @__PURE__ */ h(Ct, {
			sx: {
				backgroundColor: "white",
				"&:last-child td, &:last-child th": { border: 0 }
			},
			children: e.getVisibleCells().map((e, t) => /* @__PURE__ */ h(xt, {
				style: {
					padding: "0.25rem",
					width: t === 0 ? "33.3%" : "auto"
				},
				children: ht(e.column.columnDef.cell, e.getContext())
			}, e.id))
		}, e.id))
	] });
}, as = (e) => /* @__PURE__ */ h("svg", {
	id: "Calque_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...e,
	children: /* @__PURE__ */ g("g", { children: [
		/* @__PURE__ */ h("path", { d: "M6.6,16.2c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C7.4,16,6.9,16,6.6,16.2z" }),
		/* @__PURE__ */ h("path", { d: "M8.6,18.4c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C9.4,18.1,8.9,18.1,8.6,18.4z" }),
		/* @__PURE__ */ h("path", { d: "M6.3,18.6c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C7,18.3,6.6,18.3,6.3,18.6z" }),
		/* @__PURE__ */ h("path", { d: "M15.2,6.1c0.3-0.3,0.3-0.7,0-1c-0.3-0.3-0.7-0.3-1,0s-0.3,0.7,0,1C14.4,6.4,14.9,6.4,15.2,6.1z" }),
		/* @__PURE__ */ h("path", { d: "M22,2.5c-2.5-2.6-6.7-2.8-9.3-0.3L2.2,12.2c-2.6,2.5-2.8,6.7-0.3,9.3c2.5,2.6,6.7,2.8,9.3,0.3l10.5-9.9 C24.4,9.3,24.5,5.1,22,2.5z M20.7,10.7l-10.5,9.9c-2,1.9-5.3,1.8-7.2-0.2c-1.9-2-1.8-5.3,0.2-7.2l10.5-9.9c2-1.9,5.3-1.8,7.2,0.2 C22.9,5.6,22.8,8.8,20.7,10.7z" }),
		/* @__PURE__ */ h("path", { d: "M4.3,16.4c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C5,16.2,4.5,16.2,4.3,16.4z" }),
		/* @__PURE__ */ h("path", { d: "M4.6,14.1c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C5.3,13.8,4.9,13.8,4.6,14.1z" }),
		/* @__PURE__ */ h("path", { d: "M18.2,9.3c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C19,9,18.5,9,18.2,9.3z" }),
		/* @__PURE__ */ h("path", { d: "M18.6,6.9c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C19.3,6.7,18.9,6.7,18.6,6.9z" }),
		/* @__PURE__ */ h("path", { d: "M16.5,4.8c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C17.3,4.5,16.8,4.5,16.5,4.8z" }),
		/* @__PURE__ */ h("path", { d: "M13.7,7.7c-0.8-0.8-2-0.8-2.8-0.1L7.3,11c-0.8,0.8-0.8,2-0.1,2.8l2.5,2.7c0.8,0.8,2,0.8,2.8,0.1l3.6-3.4 c0.8-0.8,0.8-2,0.1-2.8L13.7,7.7z M15.1,12.1l-3.6,3.4c-0.2,0.2-0.5,0.2-0.7,0l-2.5-2.7c-0.2-0.2-0.2-0.5,0-0.7l3.6-3.4 c0.2-0.2,0.5-0.2,0.7,0l2.5,2.7C15.4,11.6,15.3,11.9,15.1,12.1z" }),
		/* @__PURE__ */ h("path", { d: "M16.2,7.2c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C17,6.9,16.5,6.9,16.2,7.2z" })
	] })
}), os = new Me(), ss = (e) => {
	let { value: t } = e;
	return /* @__PURE__ */ h(Ve, {
		sx: {
			fontSize: 13,
			overflow: "auto",
			wordBreak: "break-all"
		},
		children: t
	});
}, cs = (e) => {
	let { range: t } = e;
	return /* @__PURE__ */ h("p", { children: `${t.start} (${t.count})` });
}, ls = (e) => {
	let { value: t } = e;
	return /* @__PURE__ */ h("p", { children: t.toFixed(0) });
}, us = (e) => {
	let { value: t } = e;
	return /* @__PURE__ */ h("p", { children: t.toFixed(2) });
}, ds = (t) => {
	let { value: n, unit: r, hasPatchData: i } = t, { t: a } = j("teiaviewer");
	return /* @__PURE__ */ g(O, {
		direction: "row",
		sx: {
			width: 1,
			alignItems: "center",
			justifyContent: "space-between"
		},
		children: [/* @__PURE__ */ h(e, {
			sx: {
				display: "flex",
				flexDirection: "row",
				overflow: "auto",
				wordBreak: "break-all"
			},
			children: /* @__PURE__ */ g(Ve, {
				component: "span",
				sx: { fontSize: 13 },
				children: [n, !!r && /* @__PURE__ */ g(e, {
					component: "span",
					sx: {
						fontStyle: "italic",
						pl: 1
					},
					children: [
						"(",
						r,
						")"
					]
				})]
			})
		}), i === !0 && /* @__PURE__ */ h(e, {
			sx: {
				display: "flex",
				flexShrink: 0
			},
			children: /* @__PURE__ */ h(nt, {
				title: a("teia.widgets.infobox_widget.icon.tooltip"),
				placement: "top",
				children: /* @__PURE__ */ h(Be, {
					component: as,
					fontSize: "small",
					sx: {
						display: "block",
						fill: (e) => e.palette.secondary.dark,
						marginRight: "0.5rem",
						width: "20px"
					}
				})
			})
		})]
	});
}, fs = (t) => {
	let { color: n } = t;
	os.set(n);
	let r = "#" + os.getHexString();
	return /* @__PURE__ */ g(e, {
		sx: {
			display: "flex",
			alignItems: "center"
		},
		children: [/* @__PURE__ */ h("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			height: "1.2em",
			viewBox: "-25 -25 562 562",
			children: /* @__PURE__ */ h("circle", {
				fill: r,
				stroke: "black",
				strokeWidth: 50,
				cx: "256",
				cy: "256",
				r: "256"
			})
		}), /* @__PURE__ */ h(Ve, {
			sx: {
				fontSize: 13,
				ml: 2
			},
			children: r
		})]
	});
}, ps = (e) => /* @__PURE__ */ h("p", { children: e ? "True" : "False" }), ms = (t) => {
	let { children: n } = t;
	return /* @__PURE__ */ h(e, {
		sx: {
			px: 5,
			py: 2,
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between"
		},
		children: n
	});
}, hs = (t) => {
	let { children: n, sx: r } = t;
	return /* @__PURE__ */ h(e, {
		sx: {
			position: "relative",
			...r
		},
		children: n
	});
}, gs = {
	50: "#ffe7e6",
	100: "#ffcdcb",
	200: "#ffa39e",
	300: "#ff7973",
	400: "#ff4740",
	500: "#ff0a00",
	600: "#df1d15",
	700: "#cd0f08",
	800: "#af0a04",
	900: "#990500"
}, _s = {
	50: "#fbfcfe",
	100: "#e3e3e3",
	200: "#d5d5d5",
	300: "#c2c2c2",
	400: "#9f9f9f",
	500: "#7f7f7f",
	600: "#555e68",
	700: "#555555",
	800: "#2e2e2e",
	900: "#000000"
}, vs = {
	50: "#dee5ff",
	100: "#b6c5ff",
	200: "#89a1ff",
	300: "#5d7dff",
	400: "#2953ff",
	500: "#0032ff",
	600: "#0029d3",
	700: "#0021a8",
	800: "#001776",
	900: "#06184b"
}, ys = {
	50: "#d8ddeb",
	100: "#cbd1e4",
	200: "#b7c2e0",
	300: "#9ca9ce",
	400: "#cf91c5",
	500: "#6378b2",
	600: "#455da0",
	700: "#3c518b",
	800: "#2f4070",
	900: "#28365f"
}, bs = {
	50: "#e8ffed",
	100: "#ccffd8",
	200: "#96ffae",
	300: "#c5f07e",
	400: "#3fdf64",
	500: "#28c84d",
	600: "#1ab531",
	700: "#0ca42f",
	800: "#069527",
	900: "#037e20"
}, xs = {
	50: "#fff0e2",
	100: "#ffd9b6",
	200: "#ffbf83",
	300: "#ffa857",
	400: "#ff912c",
	500: "#ff7a00",
	600: "#eb6a0d",
	700: "#dc580d",
	800: "#c54f0c",
	900: "#b34809"
}, Ss = {
	primary: {
		main: vs[300],
		dark: vs[600],
		light: vs[50]
	},
	secondary: {
		main: ys[300],
		dark: ys[600],
		light: ys[50]
	},
	warning: {
		main: xs[500],
		dark: xs[700],
		light: xs[100]
	},
	success: {
		main: bs[600],
		dark: bs[800],
		light: bs[200]
	},
	error: {
		main: gs[500],
		dark: gs[700],
		light: gs[200]
	},
	info: {
		main: _s[400],
		dark: _s[500],
		light: _s[100]
	},
	background: { default: _s[50] },
	text: {
		primary: _s[800],
		secondary: _s[600],
		disabled: _s[300]
	},
	divider: "rgba(0, 0, 0, 0.12)",
	ia: {
		primary: vs[500],
		secondary: bs[500]
	},
	alert: {
		successStandardBackground: bs[50],
		errorStandardBackground: gs[50],
		warningStandardBackground: xs[50],
		infoStandardBackground: _s[100],
		successStandardColor: N(bs[200], .6),
		errorStandardColor: N(gs[200], .6),
		warningStandardColor: N(xs[100], .6),
		infoStandardColor: N(_s[100], .6)
	}
}, Cs = (e) => pt(e, { palette: Ss }), ws = class extends te {
	constructor(...e) {
		super(...e), this.isUndoable = !1, this.name = "CloseAllWidgetsCommand";
	}
	async _do() {
		this.viewer.getPlugin("Viewport").widgetController.clearAllWidgets();
	}
	async _undo() {
		throw new ue(this);
	}
}, Ts = (e) => /* @__PURE__ */ h("svg", {
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ h("path", { d: "M5 21.2867L5.31001 24L7.31887 22.1178L10.7538 12.8289C9.91054 12.6211 9.16652 12.2056 8.5589 11.6311L5 21.2867ZM15.4287 11.6311C14.8211 12.2056 14.0647 12.6211 13.2338 12.8289L16.6687 22.1178L18.6776 24L19 21.2867L15.4287 11.6311ZM15.7139 8.11111C15.7139 6.52222 14.6723 5.17778 13.2338 4.66444V2H10.7538V4.66444C9.31532 5.17778 8.27369 6.52222 8.27369 8.11111C8.27369 10.14 9.93534 11.7778 11.9938 11.7778C14.0523 11.7778 15.7139 10.14 15.7139 8.11111ZM11.9938 9.33333C11.3118 9.33333 10.7538 8.78333 10.7538 8.11111C10.7538 7.43889 11.3118 6.88889 11.9938 6.88889C12.6758 6.88889 13.2338 7.43889 13.2338 8.11111C13.2338 8.78333 12.6758 9.33333 11.9938 9.33333Z" })
}), Es = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ g("g", {
		clipPath: "url(#clip0_900_2925)",
		children: [
			/* @__PURE__ */ h("path", { d: "M6.21 20.2402L5.82 20.3902L3.8 21.1402L3.84 19.2102L0 23.2002L3.74 24.4302L3.78 22.4402L6.24 21.5202L6.44 21.4502L11.33 19.6102L9.98 18.8302L6.21 20.2402Z" }),
			/* @__PURE__ */ h("path", { d: "M22.74 14.0302C22.69 14.0302 22.64 14.0502 22.59 14.0602L22.54 14.0702L22.49 14.0902L19.18 15.3302L18.72 15.5102V16.8102L19.78 16.4002L22.95 15.2102L23.01 15.1902C23.21 15.0902 23.35 14.8902 23.35 14.6502C23.35 14.3102 23.08 14.0402 22.74 14.0402V14.0302Z" }),
			/* @__PURE__ */ h("path", { d: "M4.31 13.7202C4.31 14.1202 4.52 14.4802 4.86 14.6902L11.19 18.3802L12.54 19.1702L17.72 22.1902V8.7702L4.31 0.950195V13.7202ZM9.29 7.2902L11.09 9.9102L12.99 9.4502L15.89 11.2502L12.47 12.0002L15.35 16.8902L12.7 15.0902L10.99 12.3202L9.09 12.8002L6.05 11.0002L9.56 10.2202L6.02 5.4802L9.3 7.2802L9.29 7.2902Z" })
		]
	}), /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", {
		id: "clip0_900_2925",
		children: /* @__PURE__ */ h("rect", {
			width: 24,
			height: 24,
			transform: "translate(0 0.950195)"
		})
	}) })]
}), Ds = (e) => /* @__PURE__ */ g("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", { d: "M12.9501 3.31013L12.8001 3.21013H12.7901C12.6501 3.12013 12.4901 3.08013 12.3301 3.08013C12.1701 3.08013 12.0101 3.12013 11.8701 3.21013L11.7401 3.29013L1.3501 9.78013L12.3301 16.6401L12.9001 16.2801L23.3101 9.78013L12.9501 3.31013ZM13.3201 12.9901H11.4201L11.6201 10.0101L9.5901 6.34013H11.3601L12.5401 8.39013L13.8201 6.32013H15.5801L13.3401 10.0001L13.3201 12.9801V12.9901Z" }),
		/* @__PURE__ */ h("path", { d: "M12.8701 17.4902C12.6901 17.5602 12.5001 17.6002 12.3001 17.6002C12.0901 17.6002 11.8801 17.5502 11.6801 17.4702V19.4502L11.6601 19.8802H9.21008L12.3001 23.6102L15.5501 19.8802L12.8701 19.8802V17.4902Z" }),
		/* @__PURE__ */ h("path", { d: "M12.3001 1.76016V1.74016L12.8001 2.05016L12.9401 2.14016V0.740159C12.9201 0.500159 12.7801 0.28016 12.5601 0.19016C12.2501 0.0601597 11.8901 0.230159 11.7701 0.570159C11.7501 0.620159 11.7501 0.680159 11.7401 0.740159V2.11016L11.8001 2.07016L12.3001 1.76016Z" })
	]
}), Os = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", { d: "M0.87 14.0802L0.77 14.0502C0.72 14.0502 0.67 14.0302 0.62 14.0302C0.28 14.0302 0.01 14.3002 0.01 14.6402C0.01 14.8802 0.15 15.0802 0.35 15.1802L0.41 15.2002L3.58 16.3902L4.64 16.8002V15.5002L4.18 15.3202L0.87 14.0802Z" }),
		/* @__PURE__ */ h("path", { d: "M19.55 21.1402L17.53 20.3902L17.14 20.2402L13.37 18.8302L12.02 19.6102L16.92 21.4502L17.11 21.5202L19.57 22.4402L19.61 24.4302L23.35 23.2002L19.51 19.2102L19.55 21.1402Z" }),
		/* @__PURE__ */ h("path", { d: "M5.63 22.1802L10.81 19.1602L12.16 18.3702L18.49 14.6802C18.83 14.4802 19.04 14.1102 19.04 13.7102V0.950195L5.63 8.7702V22.1802ZM10.14 15.1302L13.15 9.8402L10.52 11.3702L10.68 9.7702L15.29 7.0902L15.41 8.2002L12.77 13.2902L15.88 11.4802L16.04 12.8902L10.01 16.4002L10.14 15.1302Z" })
	]
}), ks = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", { d: "M5 13.9502H3V15.9502H5V13.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M9 21.9502H7V23.9502H9V21.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M13 21.9502H11V23.9502H13V21.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M5 23.9502V21.9502H3C3 22.9502 4 23.9502 5 23.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M5 17.9502H3V19.9502H5V17.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M19 23.9502C20 23.9502 21 22.9502 21 21.9502H19V23.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M19 1.9502H5C3.9 1.9502 3 2.8502 3 3.9502V11.9502H7.98L9.18 10.7502L5.09 6.6502L4.8 6.3602V4.3502H8.01L11.79 8.1302L12.07 7.8502C12.02 7.6202 11.99 7.3802 11.99 7.1402C11.99 5.2702 13.52 3.7402 15.39 3.7402C17.26 3.7402 18.79 5.2702 18.79 7.1402C18.79 9.0102 17.26 10.5402 15.39 10.5402C15.15 10.5402 14.91 10.5102 14.68 10.4602L14.4 10.7402L14.68 11.0202C14.91 10.9702 15.15 10.9402 15.39 10.9402C16.33 10.9402 17.18 11.3202 17.8 11.9402H20.99V3.9502C20.99 2.9502 19.99 1.9502 18.99 1.9502H19Z" }),
		/* @__PURE__ */ h("path", { d: "M17 21.9502H15V23.9502H17V21.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M21 13.9502H19V15.9502H21V13.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M21 17.9502H19V19.9502H21V17.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M15.37 11.9502H14.21L14.42 12.1602C14.71 12.0302 15.03 11.9502 15.37 11.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M12.1 10.7502C12.1 10.5802 11.97 10.4502 11.8 10.4502C11.63 10.4502 11.5 10.5802 11.5 10.7502C11.5 10.9202 11.63 11.0502 11.8 11.0502C11.97 11.0502 12.1 10.9202 12.1 10.7502Z" }),
		/* @__PURE__ */ h("path", { d: "M15.4 14.5502C15.51 14.5502 15.6 14.4602 15.6 14.3502C15.6 14.2402 15.51 14.1502 15.4 14.1502C15.29 14.1502 15.2 14.2402 15.2 14.3502C15.2 14.4602 15.29 14.5502 15.4 14.5502Z" }),
		/* @__PURE__ */ h("path", { d: "M15.4 7.3502C15.5105 7.3502 15.6 7.26065 15.6 7.1502C15.6 7.03974 15.5105 6.9502 15.4 6.9502C15.2895 6.9502 15.2 7.03974 15.2 7.1502C15.2 7.26065 15.2895 7.3502 15.4 7.3502Z" }),
		/* @__PURE__ */ h("path", { d: "M13.22 13.3602C13.08 13.6602 13 13.9902 13 14.3402C13 15.6702 14.07 16.7402 15.4 16.7402C16.73 16.7402 17.8 15.6702 17.8 14.3402C17.8 13.0102 16.75 11.9702 15.44 11.9402H15.36C15.02 11.9402 14.7 12.0202 14.41 12.1502L14.2 11.9402H11.8L13.22 13.3602ZM15.4 13.1502C16.06 13.1502 16.6 13.6802 16.6 14.3502C16.6 15.0202 16.06 15.5502 15.4 15.5502C14.74 15.5502 14.2 15.0202 14.2 14.3502C14.2 13.6802 14.74 13.1502 15.4 13.1502Z" }),
		/* @__PURE__ */ h("path", { d: "M14.21 11.9502L13.01 10.7502L14.43 9.3302C14.73 9.4702 15.06 9.5502 15.41 9.5502C16.74 9.5502 17.81 8.4802 17.81 7.1502C17.81 5.8202 16.74 4.7502 15.41 4.7502C14.08 4.7502 13.01 5.8202 13.01 7.1502C13.01 7.5002 13.09 7.83019 13.23 8.1302L9.41 11.9502H14.21ZM15.4 5.9502C16.06 5.9502 16.6 6.4802 16.6 7.1502C16.6 7.8202 16.06 8.3502 15.4 8.3502C14.74 8.3502 14.2 7.8202 14.2 7.1502C14.2 6.4802 14.74 5.9502 15.4 5.9502ZM11.5 10.7502C11.5 10.5802 11.63 10.4502 11.8 10.4502C11.97 10.4502 12.1 10.5802 12.1 10.7502C12.1 10.9202 11.97 11.0502 11.8 11.0502C11.63 11.0502 11.5 10.9202 11.5 10.7502Z" }),
		/* @__PURE__ */ h("path", { d: "M15.4 11.9502C15.4 11.9502 15.38 11.9502 15.36 11.9502H15.44C15.44 11.9502 15.41 11.9502 15.4 11.9502Z" }),
		/* @__PURE__ */ h("path", { d: "M5.8 5.3502V5.9502L10 10.1502L11.2 8.9502L7.6 5.3502H5.8Z" })
	]
}), As = (e) => /* @__PURE__ */ h("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ h("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.0443 4.4502C14.0443 5.55476 13.1629 6.4502 12.0756 6.4502C10.9883 6.4502 10.1068 5.55476 10.1068 4.4502C10.1068 3.34563 10.9883 2.4502 12.0756 2.4502C13.1629 2.4502 14.0443 3.34563 14.0443 4.4502ZM14.4746 14.5446C15.14 14.4211 15.7139 13.8288 15.6456 13.0018L15.27 8.45407C15.1792 7.35529 14.2155 6.54802 13.1364 6.66678L12.8907 6.69383C12.577 6.72834 12.2869 6.87893 12.0756 7.11686C11.8643 6.87893 11.5741 6.72834 11.2605 6.69383L11.0147 6.66678C9.93562 6.54802 8.97197 7.35529 8.8812 8.45407L8.50554 13.0018C8.43722 13.8288 9.01114 14.4211 9.67657 14.5446L10.1169 19.5138C6.88619 19.7365 4.5 20.5191 4.5 21.4502C4.5 22.5548 7.85786 23.4502 12 23.4502C16.1421 23.4502 19.5 22.5548 19.5 21.4502C19.5 20.5335 17.1875 19.7609 14.0333 19.5246L14.4746 14.5446ZM10.2051 20.5101L10.2485 20.9999C10.3085 21.676 11.039 22.0604 11.6172 21.72C11.9007 21.5531 12.2504 21.5531 12.5339 21.72C13.1121 22.0604 13.8427 21.676 13.9026 20.9999L13.9451 20.5208C15.153 20.6106 16.2163 20.7811 17.0456 21.0022C17.5927 21.1481 17.9958 21.3051 18.2619 21.4502C17.9958 21.5953 17.5927 21.7523 17.0456 21.8982C15.7942 22.2319 14.0099 22.4502 12 22.4502C9.99008 22.4502 8.20578 22.2319 6.95436 21.8982C6.4073 21.7523 6.0042 21.5953 5.73805 21.4502C6.0042 21.3051 6.4073 21.1481 6.95436 21.0022C7.81788 20.7719 8.93512 20.5966 10.2051 20.5101ZM18.5554 21.2436C18.5554 21.2436 18.5534 21.2473 18.5469 21.2543C18.5516 21.2471 18.5554 21.2436 18.5554 21.2436ZM5.44464 21.2436C5.44464 21.2436 5.44836 21.2471 5.45311 21.2543C5.44656 21.2473 5.44464 21.2436 5.44464 21.2436ZM5.44464 21.6568C5.44464 21.6568 5.44656 21.6531 5.45311 21.6461C5.44836 21.6533 5.44464 21.6568 5.44464 21.6568ZM18.5469 21.6461C18.5534 21.6531 18.5554 21.6568 18.5554 21.6568C18.5554 21.6568 18.5516 21.6533 18.5469 21.6461Z"
	})
}), js = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.8335 2.03222C11.9491 1.98926 12.0741 1.98926 12.1897 2.03222L15.3409 3.20417C15.5331 3.27568 15.6753 3.45688 15.7125 3.67765L15.9905 5.33071C16.0359 5.60063 15.9153 5.87141 15.6943 5.99585L12.3307 7.88909C12.322 7.89589 12.3129 7.90243 12.3037 7.9087C12.2144 7.96923 12.1133 7.99978 12.012 7.99987C11.8933 8.00258 11.7765 7.96322 11.6795 7.88821L8.30517 5.98317C8.08143 5.85686 7.96122 5.58088 8.01125 5.3084L8.31247 3.66768C8.35221 3.45116 8.49318 3.27452 8.68235 3.20417L11.8335 2.03222ZM12.5707 6.36513L14.8146 5.10211L14.75 4.71832L12.5707 5.94686V6.36513ZM12.0116 4.87274L13.7224 3.90831L12.0116 3.27206L10.3008 3.90831L12.0116 4.87274ZM9.26188 4.71197L9.19175 5.09396L11.4525 6.37029V5.94686L9.26188 4.71197Z"
		}),
		/* @__PURE__ */ h("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.0754 8.28238C14.2544 8.00184 14.6329 7.91583 14.9207 8.09028L17.5172 9.66389L22.711 12.8208C22.8749 12.9203 22.9811 13.0891 22.9977 13.2766C23.0144 13.4639 22.9397 13.6482 22.7959 13.7737L12.4096 22.8473C12.1766 23.0508 11.8238 23.0509 11.5906 22.8475L1.20432 13.7831C1.06048 13.6575 0.98564 13.4734 1.00229 13.2859C1.01894 13.0984 1.12514 12.9295 1.28897 12.83L9.07936 8.09948C9.36721 7.92504 9.74565 8.01104 9.92464 8.29158C10.1036 8.57212 10.0154 8.94096 9.72753 9.11541L2.6322 13.4234L11.9998 21.5988L21.3682 13.4144L14.2725 9.10619C13.9847 8.93175 13.8964 8.56292 14.0754 8.28238Z"
		}),
		/* @__PURE__ */ h("path", { d: "M14.2715 11.5C14.972 11.5 15.5277 11.841 15.9004 12.3164C16.2662 12.7831 16.4653 13.3855 16.4961 13.9736C16.5268 14.5608 16.3914 15.1848 16.0244 15.6748C15.6443 16.1822 15.0481 16.5 14.2715 16.5C13.1061 16.4999 12.3922 15.7971 11.8779 15.0508C11.6655 15.3221 11.4422 15.5834 11.2041 15.8037C10.7949 16.1824 10.287 16.4999 9.67285 16.5C9.22552 16.5 8.66441 16.4397 8.21484 16.0889C7.73943 15.7179 7.50008 15.1155 7.5 14.2861C7.5 12.6431 8.46677 11.5 9.67285 11.5C10.4258 11.5001 10.9591 11.8932 11.3584 12.3682C11.5775 12.6288 11.7738 12.9391 11.957 13.249C12.1894 12.9292 12.4309 12.613 12.6797 12.3477C13.0865 11.9138 13.613 11.5001 14.2715 11.5ZM14.2715 12.5C14.047 12.5001 13.7719 12.6445 13.4092 13.0312C13.1125 13.3476 12.8244 13.7504 12.5107 14.1914C13.0077 14.9926 13.4869 15.4999 14.2715 15.5C14.7492 15.5 15.0419 15.3178 15.2236 15.0752C15.4184 14.8152 15.5186 14.4391 15.4971 14.0264C15.4756 13.6147 15.3352 13.2168 15.1133 12.9336C14.898 12.659 14.6162 12.5 14.2715 12.5ZM8.5 14.2861C8.50008 14.9268 8.67852 15.1814 8.83008 15.2998C9.00768 15.4384 9.28396 15.5 9.67285 15.5C9.92474 15.4999 10.1997 15.3717 10.5254 15.0703C10.7898 14.8256 11.0474 14.5028 11.3164 14.1377C11.0644 13.6984 10.8491 13.3156 10.5938 13.0117C10.3029 12.6657 10.0237 12.5001 9.67285 12.5C9.20648 12.5 8.5 12.9872 8.5 14.2861Z" })
	]
}), Ms = (e) => /* @__PURE__ */ h("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ h("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.63265 14.8205H3.67347V19.0513C3.67347 20.6799 4.93439 22 6.4898 22H21.1837C22.7391 22 24 20.6799 24 19.0513V8.79487C24 7.16634 22.7391 5.84615 21.1837 5.84615H17.1429V7.89744H21.1837C21.6571 7.89744 22.0408 8.29923 22.0408 8.79487V19.0513C22.0408 19.5469 21.6571 19.9487 21.1837 19.9487H6.4898C6.01641 19.9487 5.63265 19.5469 5.63265 19.0513V14.8205ZM2.81633 2C1.26091 2 0 3.32019 0 4.94872V10.0769C0 11.7055 1.26091 13.0256 2.81633 13.0256H12.6122C14.1677 13.0256 15.4286 11.7055 15.4286 10.0769V4.94872C15.4286 3.32019 14.1677 2 12.6122 2H2.81633Z"
	})
}), Ns = (e) => /* @__PURE__ */ h("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ g("g", {
		clipPath: "url(#clip0_576_9274)",
		children: [
			/* @__PURE__ */ h("path", { d: "M10.1188 6.53589H8.23767C7.71813 6.53589 7.29712 6.9569 7.29712 7.47644C7.29712 7.99599 7.71813 8.417 8.23767 8.417H10.1188C10.6383 8.417 11.0593 7.99599 11.0593 7.47644C11.0593 6.9569 10.6383 6.53589 10.1188 6.53589Z" }),
			/* @__PURE__ */ h("path", { d: "M15.7623 10.6562H13.8812C13.3617 10.6562 12.9407 11.0773 12.9407 11.5968C12.9407 12.1163 13.3617 12.5374 13.8812 12.5374H15.7623C16.2819 12.5374 16.7029 12.1163 16.7029 11.5968C16.7029 11.0773 16.2819 10.6562 15.7623 10.6562Z" }),
			/* @__PURE__ */ h("path", { d: "M10.1188 10.6562H8.23767C7.71813 10.6562 7.29712 11.0773 7.29712 11.5968C7.29712 12.1163 7.71813 12.5374 8.23767 12.5374H10.1188C10.6383 12.5374 11.0593 12.1163 11.0593 11.5968C11.0593 11.0773 10.6383 10.6562 10.1188 10.6562Z" }),
			/* @__PURE__ */ h("path", { d: "M20.6532 1H3.34692C2.05701 1 1 2.05701 1 3.34692V20.6443C1 21.9431 2.05701 22.9912 3.34692 22.9912H20.6443C21.9431 22.9912 22.9912 21.9342 22.9912 20.6443V3.34692C22.9912 2.04805 21.9342 1 20.6443 1H20.6532ZM19.3902 20.7339H4.60996C4.24269 20.7339 3.93813 20.4293 3.93813 20.062C3.93813 19.6948 4.24269 19.3902 4.60996 19.3902H5.28179V4.60996C4.91452 4.60996 4.60996 4.3054 4.60996 3.93813C4.60996 3.57087 4.91452 3.2663 5.28179 3.2663H18.7184C19.0856 3.2663 19.3902 3.57087 19.3902 3.93813C19.3902 4.3054 19.0856 4.60996 18.7184 4.60996V19.3902H19.3902C19.7575 19.3902 20.062 19.6948 20.062 20.062C20.062 20.4293 19.7575 20.7339 19.3902 20.7339Z" }),
			/* @__PURE__ */ h("path", { d: "M14.6873 16.7028C14.6873 16.3356 14.3828 16.031 14.0155 16.031H9.98457C9.6173 16.031 9.31274 16.3356 9.31274 16.7028V19.838H14.6873V16.7028Z" }),
			/* @__PURE__ */ h("path", { d: "M15.7623 6.53589H13.8812C13.3617 6.53589 12.9407 6.9569 12.9407 7.47644C12.9407 7.99599 13.3617 8.417 13.8812 8.417H15.7623C16.2819 8.417 16.7029 7.99599 16.7029 7.47644C16.7029 6.9569 16.2819 6.53589 15.7623 6.53589Z" })
		]
	})
}), Ps = (e) => /* @__PURE__ */ h("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ h("g", {
		clipPath: "url(#clip0_579_7465)",
		children: /* @__PURE__ */ h("path", { d: "M19.2917 20H18.5833V4.41667C18.9706 4.41667 19.2917 4.09556 19.2917 3.70833C19.2917 3.32111 18.9706 3 18.5833 3H4.41667C4.02944 3 3.70833 3.32111 3.70833 3.70833C3.70833 4.09556 4.02944 4.41667 4.41667 4.41667V20H3.70833C3.32111 20 3 20.3211 3 20.7083C3 21.0956 3.32111 21.4167 3.70833 21.4167H19.2917C19.6789 21.4167 20 21.0956 20 20.7083C20 20.3211 19.6789 20 19.2917 20ZM13.4833 6.44722H15.4667C16.0144 6.44722 16.4583 6.89111 16.4583 7.43889C16.4583 7.98667 16.0144 8.43056 15.4667 8.43056H13.4833C12.9356 8.43056 12.4917 7.98667 12.4917 7.43889C12.4917 6.89111 12.9356 6.44722 13.4833 6.44722ZM13.4833 10.7917H15.4667C16.0144 10.7917 16.4583 11.2356 16.4583 11.7833C16.4583 12.3311 16.0144 12.775 15.4667 12.775H13.4833C12.9356 12.775 12.4917 12.3311 12.4917 11.7833C12.4917 11.2356 12.9356 10.7917 13.4833 10.7917ZM7.53333 6.44722H9.51667C10.0644 6.44722 10.5083 6.89111 10.5083 7.43889C10.5083 7.98667 10.0644 8.43056 9.51667 8.43056H7.53333C6.98556 8.43056 6.54167 7.98667 6.54167 7.43889C6.54167 6.89111 6.98556 6.44722 7.53333 6.44722ZM6.54167 11.7833C6.54167 11.2356 6.98556 10.7917 7.53333 10.7917H9.51667C10.0644 10.7917 10.5083 11.2356 10.5083 11.7833C10.5083 12.3311 10.0644 12.775 9.51667 12.775H7.53333C6.98556 12.775 6.54167 12.3311 6.54167 11.7833ZM8.66667 20.4722V17.1667C8.66667 16.7794 8.98778 16.4583 9.375 16.4583H13.625C14.0122 16.4583 14.3333 16.7794 14.3333 17.1667V20.4722H8.66667Z" })
	})
}), Fs = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", { d: "M9.66904 10.1921H7.83827C6.9752 10.1921 6.26904 10.8983 6.26904 11.7614C6.26904 12.6244 6.9752 13.3306 7.83827 13.3306H9.66904C10.5321 13.3306 11.2383 12.6244 11.2383 11.7614C11.2383 10.8983 10.5321 10.1921 9.66904 10.1921ZM7.83827 11.4998H9.66904C9.81725 11.4998 9.93058 11.6132 9.93058 11.7614C9.93058 11.9096 9.81725 12.0229 9.66904 12.0229H7.83827C7.69007 12.0229 7.57674 11.9096 7.57674 11.7614C7.57674 11.6132 7.69007 11.4998 7.83827 11.4998Z" }),
		/* @__PURE__ */ h("path", { d: "M16.7307 11.7614C16.7307 10.8983 16.0246 10.1921 15.1615 10.1921H13.3307C12.4676 10.1921 11.7615 10.8983 11.7615 11.7614C11.7615 12.6244 12.4676 13.3306 13.3307 13.3306H15.1615C16.0246 13.3306 16.7307 12.6244 16.7307 11.7614ZM13.3307 11.4998H15.1615C15.3097 11.4998 15.423 11.6132 15.423 11.7614C15.423 11.9096 15.3097 12.0229 15.1615 12.0229H13.3307C13.1825 12.0229 13.0692 11.9096 13.0692 11.7614C13.0692 11.6132 13.1825 11.4998 13.3307 11.4998Z" }),
		/* @__PURE__ */ h("path", { d: "M18.6923 18.6923V5.44103C19.0933 5.20564 19.3462 4.77846 19.3462 4.30769C19.3462 3.5841 18.7621 3 18.0385 3H4.96154C4.23795 3 3.65385 3.5841 3.65385 4.30769C3.65385 4.77846 3.90667 5.20564 4.30769 5.44103V18.6923C3.5841 18.6923 3 19.2764 3 20C3 20.7236 3.5841 21.3077 4.30769 21.3077H18.6923C19.4159 21.3077 20 20.7236 20 20C20 19.2764 19.4159 18.6923 18.6923 18.6923ZM9.53846 16.7308H13.4615V20H9.53846V16.7308ZM13.4615 15.4231H9.53846C8.81487 15.4231 8.23077 16.0072 8.23077 16.7308V20H5.61538V4.30769H17.3846V20H14.7692V16.7308C14.7692 16.0072 14.1851 15.4231 13.4615 15.4231Z" }),
		/* @__PURE__ */ h("path", { d: "M9.66904 6.18237H7.83827C6.9752 6.18237 6.26904 6.88853 6.26904 7.7516C6.26904 8.61468 6.9752 9.32083 7.83827 9.32083H9.66904C10.5321 9.32083 11.2383 8.61468 11.2383 7.7516C11.2383 6.88853 10.5321 6.18237 9.66904 6.18237ZM7.83827 7.49007H9.66904C9.81725 7.49007 9.93058 7.6034 9.93058 7.7516C9.93058 7.89981 9.81725 8.01314 9.66904 8.01314H7.83827C7.69007 8.01314 7.57674 7.89981 7.57674 7.7516C7.57674 7.6034 7.69007 7.49007 7.83827 7.49007Z" }),
		/* @__PURE__ */ h("path", { d: "M13.3307 9.32083H15.1615C16.0246 9.32083 16.7307 8.61468 16.7307 7.7516C16.7307 6.88853 16.0246 6.18237 15.1615 6.18237H13.3307C12.4676 6.18237 11.7615 6.88853 11.7615 7.7516C11.7615 8.61468 12.4676 9.32083 13.3307 9.32083ZM15.1615 8.01314H13.3307C13.1825 8.01314 13.0692 7.89981 13.0692 7.7516C13.0692 7.6034 13.1825 7.49007 13.3307 7.49007H15.1615C15.3097 7.49007 15.423 7.6034 15.423 7.7516C15.423 7.89981 15.3097 8.01314 15.1615 8.01314Z" })
	]
}), Is = (e) => /* @__PURE__ */ g("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ h("path", { d: "M15.5314 11.1623C15.5314 10.5234 15.0168 10.0088 14.3779 10.0088H12.5146C11.8757 10.0088 11.3611 10.5234 11.3611 11.1623C11.3611 11.8012 11.8757 12.3158 12.5146 12.3158H14.3779C15.0168 12.3158 15.5314 11.8012 15.5314 11.1623Z" }),
		/* @__PURE__ */ h("path", { d: "M12.5146 8.23426H14.3779C15.0168 8.23426 15.5314 7.71962 15.5314 7.08075C15.5314 6.44189 15.0168 5.92725 14.3779 5.92725H12.5146C11.8757 5.92725 11.3611 6.44189 11.3611 7.08075C11.3611 7.71962 11.8757 8.23426 12.5146 8.23426Z" }),
		/* @__PURE__ */ h("path", { d: "M19.0009 0H9.76397V2.68855H3.55279C3.06477 2.68855 2.66548 3.08784 2.66548 3.57587C2.66548 3.98403 2.94942 4.33895 3.33097 4.43656V18.6602H2.88731C2.39929 18.6602 2 19.0595 2 19.5475C2 20.0355 2.39929 20.4348 2.88731 20.4348H9.76397V23.1233H19.0009C20.6513 23.1233 22 21.7835 22 20.1331V2.99911C22 1.34871 20.6602 0 19.0009 0ZM19.0009 21.7924H11.0949V20.4348H17.9716C18.4596 20.4348 18.8589 20.0355 18.8589 19.5475C18.8589 19.0595 18.4596 18.6602 17.9716 18.6602H17.5279V4.43656C17.9095 4.33895 18.1934 3.9929 18.1934 3.57587C18.1934 3.08784 17.7941 2.68855 17.3061 2.68855H11.0949V1.33097H19.0009C19.9148 1.33097 20.669 2.07631 20.669 2.99911V20.1331C20.669 21.047 19.9237 21.7924 19.0009 21.7924ZM13.0914 16.2201V19.1038H11.0949V15.7764H12.6477C12.8962 15.7764 13.0914 15.9716 13.0914 16.2201ZM12.6477 14.4454H11.0949V4.01952H16.197V19.1038H14.4224V16.2201C14.4224 15.244 13.6238 14.4454 12.6477 14.4454ZM7.76752 16.2201C7.76752 15.9716 7.96273 15.7764 8.21118 15.7764H9.76397V19.1038H7.76752V16.2201ZM8.34428 7.79059H6.48092C6.09051 7.79059 5.77107 7.47116 5.77107 7.08074C5.77107 6.69033 6.09051 6.3709 6.48092 6.3709H8.34428C8.73469 6.3709 9.05413 6.69033 9.05413 7.08074C9.05413 7.47116 8.73469 7.79059 8.34428 7.79059ZM6.48092 10.4525H8.34428C8.73469 10.4525 9.05413 10.772 9.05413 11.1624C9.05413 11.5528 8.73469 11.8722 8.34428 11.8722H6.48092C6.09051 11.8722 5.77107 11.5528 5.77107 11.1624C5.77107 10.772 6.09051 10.4525 6.48092 10.4525Z" })
	]
}), Ls = () => {
	let { viewer: e } = P(), [t, n] = f(e.scene.objectSelection);
	return c(() => {
		let t = () => {
			n(e.scene.objectSelection);
		};
		return e.signals.onObjectSelectionChanged.connect(t), () => {
			e.signals.onObjectSelectionChanged.disconnect(t);
		};
	}, [e]), { selection: t };
}, Rs = (e) => {
	let { viewer: t } = P();
	return sn(cn.default.get(t.settings, e));
}, zs = (e) => {
	let { plugin: t } = ln("Viewport"), [n, r] = f(!1);
	return c(() => {
		let n = () => {
			r(t.widgetController.hasWidgetOfType(e));
		};
		n();
		let i = t.widgetController.signals.onWidgetListUpdated.connect(n);
		return () => {
			i?.disconnect();
		};
	}, [t, e]), { isOpened: n };
}, Bs = () => {
	let t = T.instance, { t: n } = j("teiaviewer"), { viewer: r } = P(), { isOpened: i } = zs("NotificationCenter"), [a, o] = f([]), [s, l] = f(t.unreadCount), [u, p] = f("info"), [_, v] = f(t.isLoading), y = d(null), b = document.getElementById(Ro), x = /* @__PURE__ */ function(e) {
		return e[e.info = 0] = "info", e[e.pending = 1] = "pending", e[e.success = 2] = "success", e[e.warning = 3] = "warning", e[e.error = 4] = "error", e;
	}({}), S = () => {
		new Un(r, "NotificationCenter").execute(), o([]);
	}, C = (e) => {
		e.status === "pending" && t.closeNotification(e), o((t) => {
			let n = [...t];
			return n.remove(e), n;
		});
	}, w = () => {
		let e = "info";
		for (let t of T.instance.getNotifications()) {
			let n = x[t.status], r = x[e];
			n !== void 0 && r !== void 0 && n > r && (e = t.status);
		}
		p(e);
	};
	return c(() => {
		let e = (e) => {
			v(t.isLoading), !i && e.displayed && !e.definitlyClosed && (o((t) => {
				let n = t.filter((t) => t.id !== e.id);
				return n.length === 3 && n.shift(), n.push(e), n;
			}), setTimeout(() => {
				o((t) => {
					let n = [...t];
					return n.remove(e), n;
				});
			}, 5e3), l(T.instance.unreadCount), w());
		};
		return t.signals.onNotificationAdded.connect(e), () => {
			t.signals.onNotificationAdded.disconnect(e);
		};
	}, []), c(() => {
		let e = () => {
			l(t.unreadCount), w();
		};
		return t.signals.onNotificationDeleted.connect(e), t.signals.onNotificationDeletedAll.connect(e), () => {
			t.signals.onNotificationDeleted.disconnect(e), t.signals.onNotificationDeletedAll.disconnect(e);
		};
	}, []), c(() => {
		let e = (e) => {
			l(e), w();
		};
		return t.signals.onNotificationReadStatusUpdated.connect(e), () => {
			t.signals.onNotificationReadStatusUpdated.disconnect(e);
		};
	}, []), /* @__PURE__ */ g(m, { children: [!i && !!b && Et(/* @__PURE__ */ h(e, {
		sx: {
			position: "absolute",
			bottom: "45px",
			left: "0px"
		},
		children: a.map((e) => /* @__PURE__ */ h(Ge, {
			severity: e.status == "pending" ? "info" : e.status,
			sx: {
				paddingY: 0,
				width: "350px",
				color: "black",
				...e.status === "pending" && { "& .MuiAlert-icon": { display: "none" } }
			},
			closeText: n("widgets.notification_center_widget.close_icon.label"),
			onClose: () => C(e),
			"data-testid": "toolbar-notification-toast",
			children: e.status === "pending" ? /* @__PURE__ */ g(O, {
				direction: "row",
				spacing: 3,
				alignItems: "center",
				children: [/* @__PURE__ */ h(Le, { size: 20 }), /* @__PURE__ */ h("span", { children: e.message })]
			}) : e.message
		}, e.id))
	}), b), /* @__PURE__ */ g(q, {
		ref: y,
		active: i,
		label: n("toolbar.notificationCenter.tooltip"),
		"data-dd-action-name": "toolbar.notificationCenter",
		"data-testid": "toolbar-notification-center",
		icon: ir,
		onClick: S,
		children: [!!_ && /* @__PURE__ */ h(e, {
			sx: {
				position: "absolute",
				top: "7px",
				left: "7px",
				pointerEvents: "none"
			},
			"data-testid": "toolbar-notification-center-loading",
			children: /* @__PURE__ */ h(Le, { size: 30 })
		}), s > 0 && /* @__PURE__ */ h(e, {
			sx: {
				position: "absolute",
				top: "2px",
				right: "0px",
				zIndex: "1",
				justifyContent: "center",
				alignItems: "center",
				display: "flex",
				fontSize: s.toString().length > 1 ? "11px" : "13px",
				width: "17px",
				height: "17px",
				backgroundColor: (e) => Gi(e, u),
				color: "white",
				borderRadius: "100%",
				paddingLeft: "1px",
				pointerEvents: "none"
			},
			"data-testid": "toolbar-notification-center-badge",
			children: /* @__PURE__ */ h("p", { children: `${Math.min(s, 9)}${s > 9 ? "+" : ""}` })
		})]
	})] });
}, Vs = (e) => {
	let { viewer: t } = P(), [r, i] = n.useState(!1), [a, o] = n.useState(""), { useSearchHook: s = Hs } = e, { t: c } = j("teiaviewer"), l = s(a), u = () => {
		a !== "" && (i(!0), l().then(async (e) => {
			i(!1), new he(t, e).execute(), e.length > 0 && new y(t, e).execute(), t.viewport?.canvas.focus();
		}));
	};
	return /* @__PURE__ */ h(qe, {
		autoFocus: !0,
		value: a,
		name: "scene-local-search",
		"data-testid": "toolbar-search-input",
		onChange: (e) => {
			o(e.target.value);
		},
		onKeyDown: (e) => {
			e.key === "Enter" && u();
		},
		placeholder: c("toolbar.search.input.placeholder"),
		InputProps: {
			sx: { color: (e) => e.palette.grey[700] },
			startAdornment: /* @__PURE__ */ h(Dt, {
				position: "start",
				children: /* @__PURE__ */ h(Ir, { style: { height: "20px" } })
			}),
			endAdornment: /* @__PURE__ */ g(Dt, {
				position: "end",
				children: [
					a !== "" && /* @__PURE__ */ h(er, {
						style: {
							height: "23px",
							marginRight: "8px",
							cursor: "pointer"
						},
						onClick: () => o(""),
						"data-testid": "toolbar-search-clear-icon"
					}),
					/* @__PURE__ */ h(nt, {
						title: c("toolbar.search.input.tooltip"),
						placement: "bottom",
						children: /* @__PURE__ */ h(He, {
							variant: "info",
							sx: {
								height: "24px",
								fontSize: "12px"
							},
							onClick: u,
							"data-testid": "toolbar-search-button",
							children: c("toolbar.search.input.label")
						})
					}),
					!!r && /* @__PURE__ */ h(Le, {
						size: "15px",
						sx: { marginLeft: "7px" },
						"data-testid": "toolbar-search-progress"
					})
				]
			})
		}
	});
}, Hs = (e) => {
	let { viewer: t } = P();
	return async () => {
		let n = e.replaceAll(" ", "").split(";"), r = [], i = t.scene.bimMeshController.getAllObjects();
		for (let e of i) {
			let t = e.uuid + e.name;
			for (let i of n) t.includes(i) && r.push(e.uuid);
		}
		return r;
	};
}, Us = {
	ResetScene: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer");
		return /* @__PURE__ */ h(q, {
			icon: Or,
			label: t("toolbar.reset_scene.tooltip"),
			"data-dd-action-name": "toolbar.reset_scene",
			"data-testid": "toolbar-reset-scene",
			onClick: () => {
				new pe(e).execute();
			}
		});
	},
	CameraZoomIn: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer");
		return /* @__PURE__ */ h(q, {
			icon: Pr,
			label: t("toolbar.zoom_in.tooltip"),
			"data-dd-action-name": "toolbar.zoom_in",
			"data-testid": "toolbar-zoom-in",
			onClick: () => {
				new S(e).execute();
			}
		});
	},
	CameraZoomOut: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer");
		return /* @__PURE__ */ h(q, {
			icon: Mr,
			label: t("toolbar.zoom_out.tooltip"),
			"data-dd-action-name": "toolbar.zoom_out",
			"data-testid": "toolbar-zoom-out",
			onClick: () => {
				new C(e).execute();
			}
		});
	},
	ShowInfoBox: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer"), { isOpened: n } = zs("Infobox");
		return /* @__PURE__ */ h(q, {
			active: n,
			icon: Vi,
			label: t("toolbar.show_infobox.tooltip"),
			"data-dd-action-name": "toolbar.show_infobox",
			"data-testid": "toolbar-show-infobox",
			onClick: () => {
				new Un(e, "Infobox").execute();
			}
		});
	},
	UndoCommand: () => {
		let { viewer: e } = P(), [t, r] = n.useState(e.commandHistory.canUndo), { t: i } = j("teiaviewer"), [a, o] = n.useState(!1);
		return n.useEffect(() => {
			let t = () => {
				r(e.commandHistory.canUndo);
			};
			return e.signals.historyChanged.connect(t), () => {
				e.signals.historyChanged.disconnect(t);
			};
		}, [e]), /* @__PURE__ */ h(q, {
			disabled: a || !t,
			icon: Jn,
			label: i("toolbar.undo.tooltip"),
			"data-dd-action-name": "toolbar.undo",
			"data-testid": "toolbar-undo",
			onClick: async () => {
				o(!0), await e.commandHistory.undoLastCommand(), o(!1);
			}
		});
	},
	RedoCommand: () => {
		let { viewer: e } = P(), [t, r] = n.useState(e.commandHistory.canRedo), { t: i } = j("teiaviewer"), [a, o] = n.useState(!1);
		return n.useEffect(() => {
			let t = () => {
				r(e.commandHistory.canRedo);
			};
			return e.signals.historyChanged.connect(t), () => {
				e.signals.historyChanged.disconnect(t);
			};
		}, [e]), /* @__PURE__ */ h(q, {
			disabled: a || !t,
			icon: Xn,
			label: i("toolbar.redo.tooltip"),
			"data-dd-action-name": "toolbar.redo",
			"data-testid": "toolbar-redo",
			onClick: async () => {
				o(!0), await e.commandHistory.redoLastCommand(), o(!1);
			}
		});
	},
	Search: () => {
		let { t } = j("teiaviewer");
		return /* @__PURE__ */ h(Ho, {
			icon: Ir,
			label: t("toolbar.search.tooltip"),
			"data-dd-action-name": "toolbar.search",
			"data-testid": "toolbar-search",
			children: /* @__PURE__ */ h(e, {
				sx: { paddingX: 2 },
				children: /* @__PURE__ */ h(Vs, {})
			})
		});
	},
	ShowDevTools: () => {
		let { t: e } = j("teiaviewer"), [t] = Rs("debug"), [n, r] = Rs("dev.showDevTools");
		return /* @__PURE__ */ h(q, {
			active: n,
			hidden: !t,
			icon: or,
			label: e("toolbar.show_devtools.tooltip"),
			"data-dd-action-name": "toolbar.show_devtools",
			"data-testid": "toolbar-show-devtools",
			onClick: () => {
				r((e) => !e);
			}
		});
	},
	FocusObjects: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer");
		return /* @__PURE__ */ h(q, {
			icon: Qn,
			label: t("toolbar.focus_objects.tooltip"),
			"data-dd-action-name": "toolbar.focus_objects",
			"data-testid": "toolbar-focus-objects",
			onClick: () => {
				new b(e).execute();
			}
		});
	},
	ShowTreeView: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer"), { isOpened: n } = zs("TreeView");
		return /* @__PURE__ */ h(q, {
			active: n,
			icon: Ta,
			label: t("toolbar.show_treeview.tooltip"),
			"data-dd-action-name": "toolbar.show_treeview",
			"data-testid": "toolbar-show-treeview",
			onClick: () => {
				new Un(e, "TreeView").execute();
			}
		});
	},
	ScreenShot: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer");
		return /* @__PURE__ */ h(q, {
			icon: ur,
			label: t("toolbar.screenshot.tooltip"),
			"data-dd-action-name": "toolbar.screenshot",
			"data-testid": "toolbar-screenshot",
			onClick: () => {
				new re(e).execute();
			}
		});
	},
	RenderMode: () => {
		let { viewport: e } = Vt(), { viewer: t } = P(), [r, i] = n.useState(e.renderModeController.renderMode), { t: a } = j("teiaviewer");
		return n.useEffect(() => {
			let n = () => {
				i(e.renderModeController.renderMode);
			};
			return t.signals.onRenderModeChanged.connect(n), () => {
				t.signals.onRenderModeChanged.disconnect(n);
			};
		}, [t]), /* @__PURE__ */ g(Ho, {
			icon: Ns,
			label: a("toolbar.render_mode.selector.tooltip"),
			"data-dd-action-name": "toolbar.render_mode.selector",
			"data-testid": "toolbar-render-mode-selector",
			children: [
				/* @__PURE__ */ h(q, {
					icon: Ps,
					active: r === E.Textured,
					label: a("toolbar.render_mode.textured.tooltip"),
					"data-dd-action-name": "toolbar.render_mode.textured",
					"data-testid": "toolbar-render-mode-textured",
					onClick: () => {
						i(E.Textured), new xe(t, E.Textured).execute();
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: Ps,
					active: r === E.NoEdges,
					label: a("toolbar.render_mode.noEdges.tooltip"),
					"data-dd-action-name": "toolbar.render_mode.noEdges",
					"data-testid": "toolbar-render-mode-no-edges",
					onClick: () => {
						i(E.NoEdges), new xe(t, E.NoEdges).execute();
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: Fs,
					active: r === E.Wireframe,
					label: a("toolbar.render_mode.wireframe.tooltip"),
					"data-dd-action-name": "toolbar.render_mode.wireframe",
					"data-testid": "toolbar-render-mode-wireframe",
					onClick: () => {
						i(E.Wireframe), new xe(t, E.Wireframe).execute();
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: Is,
					active: r === E.XRay,
					label: a("toolbar.render_mode.xray.tooltip"),
					"data-dd-action-name": "toolbar.render_mode.xray",
					"data-testid": "toolbar-render-mode-xray",
					onClick: () => {
						i(E.XRay), new xe(t, E.XRay).execute();
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: Is,
					active: r === E.XRayNoEdges,
					label: a("toolbar.render_mode.xrayNoEdges.tooltip"),
					"data-dd-action-name": "toolbar.render_mode.xrayNoEdges",
					"data-testid": "toolbar-render-mode-xray-no-edges",
					onClick: () => {
						i(E.XRayNoEdges), new xe(t, E.XRayNoEdges).execute();
					}
				})
			]
		});
	},
	CameraMode: () => {
		let { viewport: e } = Vt(), { viewer: t } = P(), [r, i] = n.useState(e.cameraControls.getMode()), [a] = Rs("debug"), { t: o } = j("teiaviewer");
		return n.useEffect(() => {
			let n = () => {
				i(e.cameraControls.getMode());
			};
			return t.signals.onCameraModeChanged.connect(n), () => {
				t.signals.onCameraModeChanged.disconnect(n);
			};
		}, [e]), /* @__PURE__ */ g(Ho, {
			icon: Br,
			label: o("toolbar.camera_mode.selector.tooltip"),
			"data-dd-action-name": "toolbar.camera_mode.selector",
			"data-testid": "toolbar-camera-mode-selector",
			children: [
				/* @__PURE__ */ h(q, {
					icon: js,
					active: r === x.CursorOrbital,
					label: o("toolbar.camera_mode.default.tooltip"),
					onClick: () => {
						i(x.CursorOrbital), new ge(t, x.CursorOrbital).execute();
					},
					hidden: !a,
					"data-testid": "toolbar-camera-mode-cursor-orbital"
				}),
				/* @__PURE__ */ h(q, {
					icon: js,
					active: r === x.Orbital,
					label: o("toolbar.camera_mode.orbital.tooltip"),
					"data-dd-action-name": "toolbar.camera_mode.orbital",
					"data-testid": "toolbar-camera-mode-orbital",
					onClick: () => {
						i(x.Orbital), new ge(t, x.Orbital).execute();
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: As,
					active: r === x.FirstPerson,
					label: o("toolbar.camera_mode.fps.tooltip"),
					"data-dd-action-name": "toolbar.camera_mode.fps",
					"data-testid": "toolbar-camera-mode-fps",
					onClick: () => {
						i(x.FirstPerson), new ge(t, x.FirstPerson).execute();
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: Ts,
					active: r === x.FloorPlan,
					label: o("toolbar.camera_mode.floor_plan_on_click.tooltip"),
					onClick: () => {
						i(x.FloorPlan), new ge(t, x.FloorPlan).execute();
					},
					hidden: !a,
					"data-testid": "toolbar-camera-mode-floor-plan"
				})
			]
		});
	},
	ClippingPlanes: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer"), [r, i] = n.useState(!0), a = async (t) => {
			await new _(e, t, { selected: !0 }).execute();
		};
		return /* @__PURE__ */ g(Ho, {
			icon: ks,
			label: t("toolbar.clipping_planes.tooltip"),
			"data-dd-action-name": "toolbar.clipping_planes",
			"data-testid": "toolbar-clipping-planes",
			children: [
				/* @__PURE__ */ h(q, {
					icon: Es,
					label: t("toolbar.clipping_planes.add_plane_on_x_axis.tooltip"),
					"data-dd-action-name": "toolbar.clipping_planes.add_plane_on_x_axis",
					"data-testid": "toolbar-clipping-planes-add-plane-on-x-axis",
					onClick: () => {
						a(ee.x);
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: Ds,
					label: t("toolbar.clipping_planes.add_plane_on_y_axis.tooltip"),
					"data-dd-action-name": "toolbar.clipping_planes.add_plane_on_y_axis",
					"data-testid": "toolbar-clipping-planes-add-plane-on-y-axis",
					onClick: () => {
						a(ee.y);
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: Os,
					label: t("toolbar.clipping_planes.add_plane_on_z_axis.tooltip"),
					"data-dd-action-name": "toolbar.clipping_planes.add_plane_on_z_axis",
					"data-testid": "toolbar-clipping-planes-add-plane-on-z-axis",
					onClick: () => {
						a(ee.z);
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: r ? wr : Er,
					label: t("toolbar.clipping_planes.hide_show_all_planes.tooltip"),
					"data-dd-action-name": "toolbar.clipping_planes.hide_show_all_planes",
					"data-testid": "toolbar-clipping-planes-hide-show-all-planes",
					onClick: () => {
						new ye(e, e.scene.clippingPlaneController.getAllObjectUuids(), !r).execute(), i((e) => !e);
					}
				}),
				/* @__PURE__ */ h(q, {
					icon: Rr,
					label: t("toolbar.clipping_planes.delete_all_planes.tooltip"),
					"data-dd-action-name": "toolbar.clipping_planes.delete_all_planes",
					"data-testid": "toolbar-clipping-planes-delete-all-planes",
					onClick: () => {
						new w(e, e.scene.clippingPlaneController).execute(), i(!0);
					}
				})
			]
		});
	},
	IsolateObjects: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer");
		return /* @__PURE__ */ h(q, {
			icon: Ms,
			label: t("toolbar.isolate_object.tooltip"),
			"data-dd-action-name": "toolbar.isolate_object",
			"data-testid": "toolbar-isolate-object",
			onClick: () => {
				let t = e.scene.objectSelection.getUuids();
				new ae(e, t).toggle();
			}
		});
	},
	HideObjects: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer");
		return /* @__PURE__ */ h(q, {
			icon: wr,
			label: t("toolbar.hide_object.tooltip"),
			"data-dd-action-name": "toolbar.hide_object",
			"data-testid": "toolbar-hide-object",
			onClick: () => {
				let t = e.scene.objectSelection.getUuids();
				new ye(e, t, !1).toggle();
			}
		});
	},
	ShowCommandHistory: () => {
		let { viewer: e } = P(), { t } = j("teiaviewer"), [n] = Rs("debug"), { isOpened: r } = zs("CommandHistory");
		return /* @__PURE__ */ h(q, {
			active: r,
			hidden: !n,
			icon: nr,
			label: t("toolbar.show_history.tooltip"),
			"data-dd-action-name": "toolbar.show_history",
			"data-testid": "toolbar-show-history",
			onClick: () => {
				new Un(e, "CommandHistory").execute();
			}
		});
	},
	ShowSettingsWidget: () => {
		let { t: e } = j("teiaviewer"), { viewer: t } = P();
		return /* @__PURE__ */ h(q, {
			icon: ti,
			label: e("toolbar.show_settings.tooltip"),
			"data-dd-action-name": "toolbar.show_settings",
			"data-testid": "toolbar-show-settings",
			onClick: () => {
				new Un(t, "Settings").execute();
			}
		});
	},
	NotificationCenter: Bs,
	ShowToolbar: () => {
		let [e, t] = un("Viewport", "showToolbar"), n = Tt(), { t: r } = j("teiaviewer");
		return /* @__PURE__ */ h(q, {
			active: e,
			icon: Hr,
			label: r("toolbar.show_tools.label"),
			"data-dd-action-name": "toolbar.show_tools.label",
			"data-testid": "toolbar-show-tools",
			onClick: () => {
				t(!e);
			},
			sx: { "&:has(.ToolbarItemButton:hover) .ShowToolbarSvgIcon": {
				width: "15px",
				height: "15px"
			} },
			children: /* @__PURE__ */ h(wt, {
				className: "ShowToolbarSvgIcon",
				sx: {
					position: "absolute",
					top: 0,
					right: 0,
					pointerEvents: "none",
					width: "10px",
					height: "10px"
				},
				children: /* @__PURE__ */ h("polygon", {
					points: "0 0, 100 0, 100 100",
					fill: n.palette.primary.main
				})
			})
		});
	},
	SelectionInfoMenu: (e) => {
		let { children: t } = e, { selection: n } = Ls(), { t: r, i18n: i } = j("teiaviewer"), a = new Intl.NumberFormat(i.language).format(n.length);
		return /* @__PURE__ */ h(Ho, {
			icon: Ar,
			label: r("toolbar.selection_info.label"),
			"data-dd-action-name": "toolbar.selection_info.label",
			"data-testid": "toolbar-selection-info",
			CustomButtonContent: /* @__PURE__ */ g(O, {
				direction: "column",
				sx: {
					color: "text.primary",
					paddingX: 5,
					lineHeight: 1.4,
					textTransform: "none"
				},
				children: [/* @__PURE__ */ h("span", {
					style: {
						fontSize: 12,
						fontWeight: "bold"
					},
					children: n.length > 0 ? a : "-"
				}), /* @__PURE__ */ h("span", {
					style: {
						fontSize: 11,
						fontWeight: "normal"
					},
					children: r("toolbar.selection_info.object_count.text", { count: n.length })
				})]
			}),
			children: t
		});
	}
}, Ws = (e) => {
	let { viewer: t } = P(), [n, r] = f(() => t.hasPlugin(e));
	return c(() => {
		let n = () => {
			r(t.hasPlugin(e));
		};
		n();
		let i = t.signals.onPluginAdded.subscribe(n), a = t.signals.onPluginRemoved.subscribe(n);
		return () => {
			i(), a();
		};
	}, [t, e]), n;
};
//#endregion
export { ps as BooleanTableCell, cs as BufferRangeTableCell, Kt as CameraGizmo, ws as CloseAllWidgetsCommand, Hn as CloseWidgetCommand, K as ColorInput, fs as ColorTableCell, Ti as CommandHistoryWidget, Us as DefaultToolbarItems, zo as Dock, us as FloatTableCell, an as HierarchyBanner, aa as IconWidget, Jr as InfoBoxSearch, Ui as InfoBoxWidget, Zr as InfoBoxWidgetContextProvider, ls as IntegerTableCell, ni as KeyboardShortcutTag, Cs as LegacyViewerTheme, ta as NotificationCenterWidget, la as NumberField, Un as OpenWidgetCommand, Jo as PageIndicator, $o as PageNumberController, es as PageSizeController, Vs as SearchToolbarItemContent, Wa as Settings, Ca as SettingsWidget, Wo as Slider, Ci as StandardWidget, ss as StringCell, ji as TabBar, Fi as TabView, ts as Table, ns as TableBody, ms as TableFooter, hs as TableHeader, Bo as Toolbar, q as ToolbarItem, Io as ToolbarItemContextProvider, Vo as ToolbarItemGroup, Ho as ToolbarItemMenu, Da as TreeView, Ea as TreeViewNode, La as TreeViewWidget, ds as ValueWithUnitTableCell, Rt as ViewerContextProvider, Fn as ViewportContainer, Bt as ViewportContextProvider, Ka as ViewportPlugin, wn as Widget, ci as WidgetContentFactory, ui as WidgetController, li as WidgetFactory, qr as WidgetTitle, Cn as WidgetZIndex, ka as getAncestorNodes, Oa as getChildrenNodes, di as getWidgetContainerRect, Ro as idDock, Hs as useDefaulToolbarItemSearch, yn as useForceUpdate, Ws as useHasPlugin, Xr as useInfoboxWidgetContext, Lo as useToolbarItemContext, sn as useValueController, P as useViewerContext, ln as useViewerPlugin, un as useViewerPluginSettings, Ls as useViewerSelection, Rs as useViewerSettings, Vt as useViewportContext, zs as useWidgetInfo };

//# sourceMappingURL=exports.js.map